// Textos das telas/modais Aeros (header, Preferências, Relatórios, Ajuda,
// regras puras). Flat por idioma; mesclado em index.js. es/ar caem em en.
export const aerosExtra = {
  pt: {
    // ---- Tela Importar contatos de arquivo (/contacts/import) ----
    "aeros.contactImport.breadcrumb": "Contatos",
    "aeros.contactImport.pageTitle": "Importar contatos de arquivo",
    // ---- Tela Histórico de chamadas (/call-historicals · Wavoip) ----
    "aeros.calls.title": "Histórico de chamadas",
    "aeros.calls.subtitle": "Ligações de voz pelo WhatsApp (Wavoip) · tempo real",
    "aeros.calls.search": "Buscar nome ou telefone…",
    "aeros.calls.contact": "Contato",
    "aeros.calls.phone": "Telefone",
    "aeros.calls.dateTime": "Data/Hora",
    "aeros.calls.statusColumn": "Status",
    "aeros.calls.duration": "Duração",
    "aeros.calls.typeColumn": "Tipo",
    "aeros.calls.agent": "Atendente",
    "aeros.calls.actions": "Ações",
    "aeros.calls.loadMore": "Carregar mais",
    "aeros.calls.loading": "Carregando chamadas…",
    "aeros.calls.empty": "Nenhuma chamada registrada ainda.",
    "aeros.calls.emptySearch": "Nenhuma chamada encontrada para essa busca.",
    "aeros.calls.unavailableTitle": "Integração de voz indisponível",
    "aeros.calls.unavailableText": "Não foi possível consultar a Wavoip. Confira o token da integração de voz nas configurações da conexão.",
    "aeros.calls.download": "Baixar gravação",
    "aeros.calls.callBack": "Ligar para este contato",
    "aeros.calls.incomingCall": "Ligação recebida",
    "aeros.calls.unnamed": "Sem identificação",
    "aeros.calls.status.ended": "Finalizada",
    "aeros.calls.status.active": "Em andamento",
    "aeros.calls.status.ringing": "Chamando",
    "aeros.calls.status.busy": "Ocupado",
    "aeros.calls.status.noAnswer": "Não atendida",
    "aeros.calls.status.rejected": "Rejeitada",
    "aeros.calls.status.unknown": "Sem status",
    "aeros.calls.type.out": "Realizada",
    "aeros.calls.type.in": "Recebida",
    "aeros.calls.kpi.total": "Total de chamadas",
    "aeros.calls.kpi.served": "Atendidas",
    "aeros.calls.kpi.rejected": "Rejeitadas / não atendidas",
    "aeros.calls.kpi.finished": "Finalizadas",
    // ---- Tela Carteiras (/wallets) ----
    "aeros.wallets.title": "Carteiras",
    "aeros.wallets.subtitle": "Contatos com atendente e fila fixos",
    "aeros.wallets.search": "Buscar contato…",
    "aeros.wallets.filterUser": "Filtrar por usuário",
    "aeros.wallets.allUsers": "Todos os usuários",
    "aeros.wallets.contact": "Contato",
    "aeros.wallets.user": "Atendente",
    "aeros.wallets.queue": "Fila",
    "aeros.wallets.phone": "Telefone",
    "aeros.wallets.email": "E-mail",
    "aeros.wallets.actions": "Ações",
    "aeros.wallets.loading": "Carregando carteiras…",
    "aeros.wallets.empty": "Nenhum contato em carteira ainda.",
    "aeros.wallets.emptySearch": "Nenhum contato encontrado com esses filtros.",
    "aeros.wallets.edit": "Editar carteira",
    "aeros.wallets.remove": "Remover da carteira",
    "aeros.wallets.save": "Salvar",
    "aeros.wallets.editTitle": "Editar carteira",
    "aeros.wallets.noQueues": "Este atendente não está em nenhuma fila.",
    "aeros.wallets.confirmTitle": "Remover {{name}} da carteira?",
    "aeros.wallets.confirmMessage": "O contato volta a ser distribuído pelo rodízio normal da fila.",
    "aeros.wallets.deleteSuccess": "Contato removido da carteira.",
    "aeros.wallets.updateSuccess": "Carteira atualizada.",
    "aeros.wallets.selectUserAndQueue": "Selecione um atendente e uma fila.",
    "aeros.wallets.note": "Contatos em carteira voltam sempre para o mesmo atendente, ignorando o rodízio da fila.",
    // ---- Tela Conexões (/connections e /allConnections) ----
    "aeros.connections.needsAttention": "{{count}} conexões precisam de atenção",
    "aeros.connections.needsAttentionOne": "1 conexão precisa de atenção",
    "aeros.connections.companies": "{{count}} empresas na plataforma",
    "aeros.connections.companiesOne": "1 empresa na plataforma",
    "aeros.connections.manage": "Gerenciar conexões",
    "aeros.connections.super": "SUPER",
    "aeros.connections.status.connected": "Conectada",
    "aeros.connections.status.waiting": "Aguardando QR Code",
    "aeros.connections.status.disconnected": "Desconectada",
    "aeros.companies.status.active": "Ativa",
    "aeros.sms.status.paid": "Pago",
    "aeros.contactLists.title": "Listas de contatos",
    "aeros.contactLists.subtitle": "Públicos usados nas campanhas",
    "aeros.contactLists.search": "Buscar lista…",
    "aeros.contactLists.newList": "Nova lista",
    "aeros.contactLists.name": "Nome",
    "aeros.contactLists.contacts": "Contatos",
    "aeros.contactLists.createdAt": "Criada em",
    "aeros.contactLists.actions": "Ações",
    "aeros.contactLists.openContacts": "Ver contatos da lista",
    "aeros.contactLists.download": "Baixar planilha da lista",
    "aeros.contactLists.edit": "Renomear lista",
    "aeros.contactLists.delete": "Excluir lista",
    "aeros.contactLists.loading": "Carregando…",
    "aeros.contactLists.empty": "Nenhuma lista ainda. Crie a primeira para usar nas campanhas.",
    "aeros.contactLists.emptySearch": "Nenhuma lista encontrada com esse termo.",
    "aeros.contactLists.confirmTitle": "Excluir a lista {{name}}?",
    "aeros.contactLists.confirmMessage": "Os contatos da lista são apagados junto. As campanhas que já usaram esta lista continuam com o histórico delas.",
    "aeros.kanbanTags.title": "Tags do Kanban",
    "aeros.kanbanTags.subtitle": "Cada tag é uma coluna do board",
    "aeros.kanbanTags.backToBoard": "Voltar ao Kanban",
    "aeros.kanbanTags.newTag": "Nova tag",
    "aeros.kanbanTags.name": "Nome",
    "aeros.kanbanTags.ticketsColumn": "Tickets",
    "aeros.kanbanTags.order": "Ordem",
    "aeros.kanbanTags.actions": "Ações",
    "aeros.kanbanTags.edit": "Editar tag",
    "aeros.kanbanTags.delete": "Excluir tag",
    "aeros.kanbanTags.deleted": "Tag excluída",
    "aeros.kanbanTags.dragHandle": "Arrastar para reordenar",
    "aeros.kanbanTags.loading": "Carregando…",
    "aeros.kanbanTags.empty": "Nenhuma coluna no board ainda. Crie a primeira tag.",
    "aeros.kanbanTags.boardPreview": "Prévia do board",
    "aeros.kanbanTags.tickets": "{{count}} tickets",
    "aeros.kanbanTags.ticketOne": "1 ticket",
    "aeros.kanbanTags.confirmTitle": "Excluir a coluna {{name}}?",
    "aeros.kanbanTags.confirmMessage": "A coluna some do board. Os tickets não são excluídos — apenas deixam de estar nela.",
    "aeros.todo.title": "Tarefas",
    "aeros.todo.subtitle": "Anotações rápidas do seu dia — ficam salvas apenas neste navegador",
    "aeros.todo.placeholder": "Ex.: revisar tickets sem resposta da fila Comercial",
    "aeros.todo.add": "Adicionar",
    "aeros.todo.save": "Salvar",
    "aeros.todo.edit": "Editar tarefa",
    "aeros.todo.delete": "Excluir tarefa",
    "aeros.todo.confirmTitle": "Excluir esta tarefa?",
    "aeros.todo.markDone": "Marcar como concluída",
    "aeros.todo.markOpen": "Reabrir tarefa",
    "aeros.todo.pending": "{{count}} pendentes",
    "aeros.todo.pendingOne": "1 pendente",
    "aeros.todo.empty": "Nenhuma tarefa por aqui. Escreva a primeira acima.",
    "aeros.todo.localNote": "Como ficam no navegador, as tarefas não sincronizam entre dispositivos nem aparecem para outros usuários.",
    "aeros.smsPacks.newPack": "Novo pacote",
    "aeros.smsPacks.name": "Nome",
    "aeros.smsPacks.namePlaceholder": "ex.: Pacote 2.500",
    "aeros.smsPacks.quantity": "Quantidade",
    "aeros.smsPacks.quantityShort": "Qtd.",
    "aeros.smsPacks.value": "Valor (R$)",
    "aeros.smsPacks.perSms": "R$/SMS",
    "aeros.smsPacks.active": "Ativo",
    "aeros.smsPacks.create": "Criar pacote",
    "aeros.smsPacks.created": "Pacote criado",
    "aeros.smsPacks.empty": "Nenhum pacote cadastrado ainda.",
    "aeros.smsPacks.inactiveNote": "Pacotes inativos deixam de aparecer na tela de compra das empresas, mas permanecem no histórico.",
    "aeros.sms.title": "Créditos SMS",
    "aeros.sms.subtitle": "Saldo, recargas e histórico de consumo",
    "aeros.sms.buyCredits": "Comprar créditos",
    "aeros.sms.currentBalance": "Saldo atual",
    "aeros.sms.avgPerDay": "Consumo médio de {{count}} SMS por dia",
    "aeros.sms.avgPerDayShort": "{{count}}/dia em média",
    "aeros.sms.noUsageYet": "Sem consumo registrado ainda",
    "aeros.sms.noneThisMonth": "Nenhum envio neste mês",
    "aeros.sms.sentMonth": "Enviados no mês",
    "aeros.sms.investedMonth": "Investido no mês",
    "aeros.sms.rechargeCount": "{{count}} recargas",
    "aeros.sms.rechargeOne": "1 recarga",
    "aeros.sms.autonomy": "Autonomia",
    "aeros.sms.days": "{{count}} dias",
    "aeros.sms.dayOne": "1 dia",
    "aeros.sms.autonomyHint": "no ritmo atual de consumo",
    "aeros.sms.autonomyUnknown": "sem consumo para estimar",
    "aeros.sms.lowBalance": "No ritmo atual, o saldo acaba em {{count}} dias.",
    "aeros.sms.rechargeNow": "Recarregar agora",
    "aeros.sms.recharges": "Recargas",
    "aeros.sms.viaMercadoPago": "pagamento via Mercado Pago",
    "aeros.sms.filterAll": "Todas",
    "aeros.sms.date": "Data",
    "aeros.sms.package": "Pacote",
    "aeros.sms.quantity": "Quantidade",
    "aeros.sms.value": "Valor",
    "aeros.sms.statusColumn": "Status",
    "aeros.sms.loading": "Carregando…",
    "aeros.sms.noRecharges": "Nenhuma recarga ainda.",
    "aeros.sms.noRechargesFilter": "Nenhuma recarga com esse status.",
    "aeros.sms.webhookNote": "Recargas pagas entram automaticamente pelo webhook — sem precisar recarregar a página.",
    "aeros.sms.usage7days": "Consumo dos últimos 7 dias",
    "aeros.sms.noUsageData": "Sem consumo no período",
    "aeros.sms.whereUsed": "Onde os créditos foram usados",
    "aeros.sms.fractionNote": "Mensagens acima de 160 caracteres são cobradas em frações de 153.",
    "aeros.sms.status.pending": "Pendente",
    "aeros.sms.status.expired": "Expirado",
    "aeros.sms.status.unknown": "Desconhecido",
    "aeros.sms.weekday.0": "Dom",
    "aeros.sms.weekday.1": "Seg",
    "aeros.sms.weekday.2": "Ter",
    "aeros.sms.weekday.3": "Qua",
    "aeros.sms.weekday.4": "Qui",
    "aeros.sms.weekday.5": "Sex",
    "aeros.sms.weekday.6": "Sáb",
    "aeros.sms.origin.campanha": "Campanhas por SMS",
    "aeros.sms.origin.manual": "Envio manual pelo contato",
    "aeros.sms.origin.automacao": "Automações / fluxos",
    "aeros.sms.origin.outros": "Outros consumos",
    "aeros.dashboard.greeting.morning": "Bom dia",
    "aeros.dashboard.range.today": "Hoje",
    "aeros.dashboard.range.week": "7 dias",
    "aeros.dashboard.range.month": "30 dias",
    "aeros.dashboard.range.custom": "Personalizado",
    "aeros.dashboard.indicators": "Indicadores",
    "aeros.dashboard.export": "Exportar",
    "aeros.dashboard.filters": "Filtros",
    "aeros.dashboard.filterType": "Tipo de filtro",
    "aeros.dashboard.byDate": "Por data",
    "aeros.dashboard.quickFilter": "Filtro rápido",
    "aeros.dashboard.period": "Período",
    "aeros.dashboard.queue": "Fila",
    "aeros.dashboard.agent": "Atendente",
    "aeros.dashboard.allQueues": "Todas",
    "aeros.dashboard.allAgents": "Todos",
    "aeros.dashboard.queuesFilter": "Filas: {{value}}",
    "aeros.dashboard.clear": "Limpar",
    "aeros.dashboard.apply": "Filtrar",
    "aeros.dashboard.ticketsPerDay": "Total de atendimentos por dia",
    "aeros.dashboard.inPeriod": "({{count}} no período)",
    "aeros.dashboard.received": "Recebidos",
    "aeros.dashboard.resolved": "Resolvidos",
    "aeros.dashboard.noData": "Sem atendimentos no período",
    "aeros.dashboard.satisfaction": "Pesquisa de satisfação",
    "aeros.dashboard.score": "Score",
    "aeros.dashboard.promoters": "Promotores",
    "aeros.dashboard.passive": "Neutros",
    "aeros.dashboard.detractors": "Detratores",
    "aeros.dashboard.ratingIndex": "Índice de avaliação",
    "aeros.dashboard.totalTickets": "Total de atendimentos",
    "aeros.dashboard.waitingRating": "Aguardando avaliação",
    "aeros.dashboard.withoutRating": "Sem avaliação",
    "aeros.dashboard.rated": "Avaliados",
    "aeros.dashboard.agents": "Atendentes",
    "aeros.dashboard.fullReport": "Ver relatório completo",
    "aeros.dashboard.inService": "Em atend.",
    "aeros.dashboard.finished": "Finalizados",
    "aeros.dashboard.avgSupport": "T.M. atend.",
    "aeros.dashboard.avgWait": "T.M. espera",
    "aeros.dashboard.rating": "Avaliação",
    "aeros.dashboard.status": "Status",
    "aeros.dashboard.loading": "Carregando…",
    "aeros.dashboard.noAgents": "Nenhum atendente encontrado",
    "aeros.dashboard.kpi.Em Atendimento": "Em atendimento",
    "aeros.dashboard.kpi.Aguardando": "Aguardando",
    "aeros.dashboard.kpi.Finalizados": "Finalizados",
    "aeros.dashboard.kpi.Grupos": "Grupos",
    "aeros.dashboard.kpi.Novos Contatos": "Novos contatos",
    "aeros.dashboard.kpi.Atendentes Ativos": "Atendentes ativos",
    "aeros.dashboard.kpi.Mensagens Recebidas": "Mensagens recebidas",
    "aeros.dashboard.kpi.Mensagens Enviadas": "Mensagens enviadas",
    "aeros.dashboard.kpi.T.M. de Atendimento": "T.M. de atendimento",
    "aeros.dashboard.kpi.T.M. de Espera": "T.M. de espera",
    "aeros.dashboard.kpi.Tickets Ativos": "Tickets ativos",
    "aeros.dashboard.kpi.Tickets Passivos": "Tickets passivos",
    "aeros.dashboard.kpi.Créditos SMS": "Créditos SMS",
    "aeros.dashboard.greeting.afternoon": "Boa tarde",
    "aeros.dashboard.greeting.evening": "Boa noite",
    "aeros.dashboard.updatedNow": "atualizado agora",
    "aeros.dashboard.updatedSeconds": "atualizado há {{count}}s",
    "aeros.dashboard.updatedMinutes": "atualizado há {{count}} min",
    "aeros.dashboard.updatedHours": "atualizado há {{count}} h",
    "aeros.dashboard.onlineOf": "{{online}} online de {{total}}",
    "aeros.dashboard.agentStatus.online": "Online",
    "aeros.dashboard.agentStatus.busy": "Ocupado",
    "aeros.dashboard.agentStatus.offline": "Offline",
    "aeros.dashboard.delta.stable": "estável",
    "aeros.dashboard.delta.inPeriod": "no período",
    "aeros.dashboard.delta.lastHour": "na última hora",
    "aeros.dashboard.delta.onAverage": "na média",
    "aeros.dashboard.delta.vsAverage": "min vs. média",
    "aeros.dashboard.delta.today": "hoje",
    "aeros.dashboard.delta.offline": "{{count}} offline",
    "aeros.dashboard.delta.total": "{{value}} no total",
    "aeros.companies.status.inactive": "Inativa",
    "aeros.companies.status.expired": "Vencida",
    "aeros.companies.status.soon": "Vence logo",
    "aeros.companies.status.trial": "Trial",
    "aeros.companies.due.in": "em {{count}} dias",
    "aeros.companies.due.inOne": "em 1 dia",
    "aeros.companies.due.today": "vence hoje",
    "aeros.companies.due.late": "{{count}} dias em atraso",
    "aeros.companies.due.lateOne": "1 dia em atraso",
    "aeros.companies.due.disabled": "conta desativada",
    "aeros.companies.subtitle": "Contas, planos e faturamento da plataforma",
    "aeros.companies.searchPlaceholder": "Buscar empresa, e-mail…",
    "aeros.companies.filterStatus": "Filtrar por status",
    "aeros.companies.filter.all": "Status: Todos",
    "aeros.companies.plansButton": "Planos",
    "aeros.companies.newCompany": "Nova empresa",
    "aeros.companies.loading": "Carregando…",
    "aeros.companies.emptyTitle": "Nenhuma empresa encontrada",
    "aeros.companies.emptyText": "Ajuste a busca ou o filtro de status.",
    "aeros.companies.files": "{{count}} arq.",
    "aeros.companies.showing": "Mostrando {{shown}} de {{total}} empresas",
    "aeros.companies.prevPage": "Página anterior",
    "aeros.companies.nextPage": "Próxima página",
    "aeros.companies.legend": "Linhas em vermelho: vencimento ultrapassado. Empresas inativas ficam esmaecidas e sem login.",
    "aeros.companies.table.planValue": "Plano · Valor",
    "aeros.companies.table.company": "Empresa",
    "aeros.companies.table.status": "Status",
    "aeros.companies.table.usage": "Uso · SMS",
    "aeros.companies.table.actions": "Ações",
    "aeros.companies.actions.edit": "Editar empresa",
    "aeros.companies.actions.sms": "Créditos SMS",
    "aeros.companies.actions.delete": "Excluir empresa",
    "aeros.companies.kpi.activeInactive": "{{active}} ativas · {{inactive}} inativas",
    "aeros.companies.kpi.mrr": "MRR",
    "aeros.companies.kpi.mrrHint": "receita mensal recorrente",
    "aeros.companies.kpi.overdue": "Vencidas",
    "aeros.companies.kpi.overdueHint": "{{value}} em atraso",
    "aeros.companies.kpi.trial": "Em trial",
    "aeros.companies.kpi.trialHint": "{{count}} expiram esta semana",
    "aeros.companies.kpi.storage": "Armazenamento",
    "aeros.companies.confirm.title": "Excluir {{name}}?",
    "aeros.companies.confirm.message": "Todos os dados da empresa serão perdidos: usuários, conexões, tickets, contatos e arquivos ({{size}}). Essa ação não pode ser revertida.",
    "aeros.companies.confirm.action": "Excluir empresa",
    "aeros.companies.confirm.typedHint": "Digite o nome da empresa para confirmar",
    "aeros.companies.recurrence.MENSAL": "Mensal",
    "aeros.companies.recurrence.BIMESTRAL": "Bimestral",
    "aeros.companies.recurrence.TRIMESTRAL": "Trimestral",
    "aeros.companies.recurrence.SEMESTRAL": "Semestral",
    "aeros.companies.recurrence.ANUAL": "Anual",
    "aeros.companies.recurrenceFromPlan": "Definida pelo plano",
    "aeros.companies.modal.title": "Editar empresa",
    "aeros.companies.modal.save": "Salvar empresa",
    "aeros.companies.modal.saved": "Empresa salva",
    "aeros.companies.modal.accountData": "Dados da conta",
    "aeros.companies.modal.adminEmail": "E-mail do administrador",
    "aeros.companies.modal.newPassword": "Nova senha",
    "aeros.companies.modal.showPassword": "Mostrar senha",
    "aeros.companies.modal.hidePassword": "Ocultar senha",
    "aeros.companies.modal.clientSince": "cliente desde {{date}}",
    "aeros.companies.modal.connections": "{{count}} conexões",
    "aeros.companies.modal.connectionOne": "1 conexão",
    "aeros.companies.modal.users": "{{count}} usuários",
    "aeros.companies.modal.userOne": "1 usuário",
    "aeros.companies.modal.planLimits": "{{users}} usuários · {{connections}} conexões · {{queues}} filas",
    "aeros.companies.modal.campaigns": "Campanhas habilitadas",
    "aeros.companies.modal.campaignsHint": "Sobrescreve a permissão do plano para esta empresa",
    "aeros.companies.modal.billing": "Faturamento",
    "aeros.companies.subscription.column": "Assinatura",
    "aeros.companies.subscription.title": "Assinatura",
    "aeros.companies.subscription.none": "Sem assinatura vigente",
    "aeros.companies.subscription.plan": "Plano",
    "aeros.companies.subscription.periodMethod": "Período · meio",
    "aeros.companies.subscription.cycle": "Ciclo",
    "aeros.companies.subscription.status": "Status",
    "aeros.companies.subscription.cancel": "Cancelar assinatura",
    "aeros.companies.subscription.cancelTitle": "Cancelar a assinatura desta empresa?",
    "aeros.companies.subscription.cancelText": "A cobrança automática é encerrada e a empresa mantém o acesso até o fim do ciclo pago. Depois disso, plano, vencimento e recorrência voltam a ser editáveis.",
    "aeros.companies.subscription.cancelConfirm": "Cancelar assinatura",
    "aeros.companies.subscription.canceled": "Assinatura cancelada",
    "aeros.companies.managedBySubscription": "Plano, vencimento e recorrência são geridos pela assinatura. Cancele a assinatura para editá-los manualmente.",
    "aeros.companies.modal.paymentMethod": "Método de pagamento",
    "aeros.companies.modal.nextInvoice": "Próxima fatura",
    "aeros.companies.modal.dueOn": "vence {{date}}",
    "aeros.companies.modal.onTime": "em dia",
    "aeros.companies.modal.late": "em atraso",
    "aeros.companies.modal.lastPaid": "Última paga: {{date}}",
    "aeros.companies.modal.noPaid": "Nenhuma fatura paga ainda",
    "aeros.companies.modal.noOpenInvoice": "Nenhuma fatura em aberto",
    "aeros.companies.modal.disable": "Desativar empresa",
    "aeros.companies.modal.enable": "Reativar empresa",
    "aeros.companies.newModal.subtitle": "O e-mail e a senha padrão criam o primeiro usuário administrador.",
    "aeros.companies.newModal.active": "Ativo",
    "aeros.companies.newModal.note": "Plano, vencimento e recorrência são definidos depois, em Editar empresa.",
    "aeros.companies.sms.title": "Créditos SMS",
    "aeros.companies.sms.currentBalance": "Saldo atual: {{count}} SMS",
    "aeros.companies.sms.customAmount": "Quantidade personalizada",
    "aeros.companies.sms.amountPlaceholder": "ex.: 2500",
    "aeros.companies.sms.reason": "Motivo",
    "aeros.companies.sms.reasonRequired": "Informe o motivo do lançamento",
    "aeros.companies.sms.invalidAmount": "Informe uma quantidade maior que zero",
    "aeros.companies.sms.newBalance": "Novo saldo após a operação",
    "aeros.companies.sms.apply": "Aplicar créditos",
    "aeros.companies.sms.applied": "Créditos aplicados",
    "aeros.companies.sms.statement": "Extrato",
    "aeros.companies.sms.noEntries": "Nenhum lançamento encontrado.",
    "aeros.companies.sms.credit": "Crédito",
    "aeros.companies.sms.debit": "Débito",
    "aeros.plans.title": "Planos",
    "aeros.plans.newPlan": "Novo plano",
    "aeros.plans.editPlan": "Editar plano",
    "aeros.plans.name": "Nome",
    "aeros.plans.users": "usuários",
    "aeros.plans.connections": "conexões",
    "aeros.plans.queues": "filas",
    "aeros.plans.amount": "Valor (R$)",
    "aeros.plans.recurrence": "Recorrência",
    "aeros.plans.period.MENSAL": "/ mês",
    "aeros.plans.period.BIMESTRAL": "/ 2 meses",
    "aeros.plans.period.TRIMESTRAL": "/ trimestre",
    "aeros.plans.period.SEMESTRAL": "/ semestre",
    "aeros.plans.period.ANUAL": "/ ano",
    "aeros.plans.usersLabel": "Usuários",
    "aeros.plans.connectionsLabel": "Conexões",
    "aeros.plans.queuesLabel": "Filas",
    "aeros.plans.public": "Público",
    "aeros.plans.trial": "Trial",
    "aeros.plans.trialDays": "Trial {{count}}d",
    "aeros.plans.trialDaysField": "Dias de trial",
    "aeros.plans.featuresTitle": "Recursos incluídos",
    "aeros.plans.clear": "Limpar",
    "aeros.plans.save": "Salvar plano",
    "aeros.plans.saved": "Plano salvo",
    "aeros.plans.deleted": "Plano excluído",
    "aeros.plans.edit": "Editar plano",
    "aeros.plans.delete": "Excluir plano",
    "aeros.plans.nameRequired": "Informe o nome do plano",
    "aeros.plans.emptyTitle": "Nenhum plano cadastrado",
    "aeros.plans.usage": "{{count}} empresas neste plano",
    "aeros.plans.usageOne": "1 empresa neste plano",
    "aeros.plans.confirmTitle": "Excluir o plano {{name}}?",
    "aeros.plans.confirmMessage": "Hoje {{count}} empresa(s) usam este plano. Excluir não muda o plano delas, mas o limite deixa de existir e elas ficam sem plano na listagem.",
    "aeros.plans.feature.whatsapp": "WhatsApp",
    "aeros.plans.feature.whatsappOfficial": "WhatsApp Oficial",
    "aeros.plans.feature.facebook": "Facebook",
    "aeros.plans.feature.instagram": "Instagram",
    "aeros.plans.feature.campaigns": "Campanhas",
    "aeros.plans.feature.schedules": "Agendamentos",
    "aeros.plans.feature.internalChat": "Chat Interno",
    "aeros.plans.feature.externalApi": "API Externa",
    "aeros.plans.feature.kanban": "Kanban",
    "aeros.plans.feature.openAi": "Talk.Ai",
    "aeros.plans.feature.integrations": "Integrações",
    "aeros.plans.feature.wavoip": "Wavoip",
    "aeros.connections.channel.baileys": "WhatsApp (Baileys)",
    "aeros.connections.channel.official": "WhatsApp Oficial (Meta)",
    "aeros.connections.defaultOne": "conexão padrão",
    "aeros.connections.tabs.chatbot": "Chatbot",
    "aeros.connections.tabs.flow": "Fluxo Padrão",
    "aeros.connections.form.defaultHint": "Usada quando nenhuma outra é definida",
    "aeros.connections.form.officialHint": "Exibe os campos WABA / Phone ID",
    "aeros.connections.form.groupHint": "Recebe mensagens de grupos",
    "aeros.connections.form.importHint": "Cria tickets a partir do histórico do aparelho ao conectar",
    "aeros.connections.form.tokenRenew": "Gerar novo token",
    "aeros.connections.form.tokenCopy": "Copiar token",
    "aeros.connections.agents.title": "Agentes de IA",
    "aeros.connections.agents.hint": "Somente leitura: o vínculo do agente com a conexão e as filas é feito no Talk.ai.",
    "aeros.connections.agents.empty": "Nenhum agente de IA atende esta conexão.",
    "aeros.connections.agents.newConnection": "Salve a conexão para vincular agentes de IA a ela no Talk.ai.",
    "aeros.connections.agents.otherCompany": "Os agentes desta conexão são gerenciados no Talk.ai da empresa dona da conexão.",
    "aeros.connections.agents.loading": "Carregando agentes…",
    "aeros.connections.agents.preQueue": "Atende antes da distribuição",
    "aeros.connections.agents.manage": "Gerenciar em Talk.ai",
    "aeros.connections.form.closeIntegration": "Integração de encerramento",
    "aeros.connections.form.wavoipHint": "Token de voz para chamadas pelo WhatsApp",
    "aeros.connections.form.wavoipPlaceholder": "token wavoip",
    "aeros.connections.form.greetingHint": "Enviada ao abrir o ticket",
    "aeros.connections.form.complationHint": "Enviada ao resolver o atendimento",
    "aeros.connections.form.outOfHoursHint": "Exige horário de atendimento configurado",
    "aeros.connections.form.vacationHint": "Opcional; enviada durante o período de férias coletivas",
    "aeros.connections.bot.unitMin": "min",
    "aeros.connections.bot.unitTimes": "vezes",
    "aeros.connections.bot.newTicketHint": "Minutos após o encerramento para uma nova mensagem abrir outro ticket.",
    "aeros.connections.bot.maxTriesHint": "Quantas vezes o bot reenvia o menu antes de transferir.",
    "aeros.connections.bot.intervalHint": "Espera entre os reenvios do menu do chatbot.",
    "aeros.connections.bot.returnQueueHint": "Ticket sem resposta do atendente volta para a fila.",
    "aeros.connections.bot.expiresHint": "Expira o atendimento sem interação do cliente.",
    "aeros.connections.bot.whenExpiresHint": "Sem resposta do cliente ou de ambos os lados.",
    "aeros.connections.bot.expiresMessageHint": "Enviada ao expirar o atendimento.",
    "aeros.connections.bot.inactivityTitle": "Aviso de inatividade",
    "aeros.connections.bot.inactivityDesc": "Enviado antes de expirar, para tentar retomar a conversa.",
    "aeros.connections.bot.inactivityFlow": "Fluxo por inatividade",
    "aeros.connections.nps.expiresHint": "Exigido quando há mensagem de avaliação",
    "aeros.connections.nps.maxUseHint": "Quantas vezes a pesquisa é reenviada sem resposta",
    "aeros.connections.flow.newContactTitle": "Fluxo de boas-vindas",
    "aeros.connections.flow.newContactDesc": "Disparado na primeira mensagem de contatos novos, que ainda não estão na sua lista.",
    "aeros.connections.flow.knownContactTitle": "Fluxo para contato conhecido",
    "aeros.connections.flow.knownContactDesc": "Disparado na primeira mensagem de contatos que já existem na base.",
    "aeros.connections.qr.connection": "Conexão",
    "aeros.connections.qr.step1": "Abra o WhatsApp no celular",
    "aeros.connections.qr.step2": "Toque em Mais opções ou Configurações e selecione Dispositivos conectados",
    "aeros.connections.qr.step3": "Toque em Conectar dispositivo e aponte para esta tela",
    "aeros.connections.qr.autoRenew": "O código é renovado automaticamente enquanto esta janela estiver aberta.",
    "aeros.connections.qr.newCode": "Novo QR Code",
    "aeros.connections.confirm.disconnectTitle": "Desconectar {{name}}?",
    "aeros.connections.confirm.disconnectMessage": "Você tem certeza? Será necessário ler o QR Code novamente para retomar o envio e recebimento de mensagens.",
    "aeros.connections.confirm.disconnectAction": "Desconectar",
    "aeros.connections.confirm.deleteTitle": "Excluir a conexão {{name}}?",
    "aeros.connections.confirm.deleteMessage": "Você tem certeza? Essa ação não pode ser revertida. Tickets vinculados ficarão sem conexão.",
    "aeros.connections.confirm.deleteAction": "Excluir",
    "aeros.connections.confirm.closedImportedTitle": "Fechar os tickets importados de {{name}}?",
    "aeros.connections.confirm.closedImportedAction": "Fechar tickets",
    "aeros.connections.transfer.title": "Transferência de tickets",
    "aeros.connections.transfer.desc": "Selecione a conexão de origem (de onde os tickets saem) e a de destino. Todos os atendimentos ativos da origem serão movidos.",
    "aeros.connections.transfer.source": "Origem",
    "aeros.connections.transfer.target": "Destino",
    "aeros.connections.transfer.action": "Transferir",
    "aeros.connections.transfer.progressTitle": "Transferindo tickets",
    "aeros.connections.transfer.progressCount": "{{current}} de {{total}} tickets transferidos",
    "aeros.connections.transfer.progressWait": "Aguarde enquanto os tickets são transferidos…",
    "aeros.connections.transfer.preDeleteTitle": "Já transferiu os tickets desta conexão?",
    "aeros.connections.transfer.preDeleteMessage": "Antes de excluir, confirme que os tickets desta conexão já foram movidos para outra. Excluir sem transferir deixa os atendimentos sem conexão.",
    "aeros.connections.transfer.preDeleteConfirm": "Já transferi",
    "aeros.connections.transfer.preDeleteCancel": "Ainda não",
    "aeros.connections.templates.title": "Modelos sincronizados",
    "aeros.connections.templates.summary": "{{count}} modelo(s) na Meta",
    "aeros.connections.templates.removed": "{{count}} removido(s) da Pulse por não existirem mais na Meta",
    "aeros.connections.templates.name": "Nome",
    "aeros.connections.templates.category": "Categoria",
    "aeros.connections.templates.language": "Idioma",
    "aeros.connections.templates.status": "Status",
    "aeros.connections.all.title": "Gerenciar conexões",
    "aeros.connections.all.back": "Conexões",
    "aeros.connections.all.search": "Empresa ou número…",
    "aeros.connections.all.restartAll": "Reiniciar todas",
    "aeros.connections.all.restartOne": "Reiniciar conexão",
    "aeros.connections.all.details": "Ver detalhes da conexão",
    "aeros.connections.all.restarted": "Reinício solicitado",
    "aeros.connections.all.filterAll": "Status: Todos",
    "aeros.connections.all.filterConnected": "Status: Conectadas",
    "aeros.connections.all.filterProblem": "Status: Com problema",
    "aeros.connections.all.kpiCompanies": "Empresas",
    "aeros.connections.all.kpiConnections": "Conexões",
    "aeros.connections.all.kpiConnected": "Conectadas",
    "aeros.connections.all.kpiProblem": "Com problema",
    "aeros.connections.all.company": "Empresa",
    "aeros.connections.all.connection": "Conexão",
    "aeros.connections.all.number": "Número",
    "aeros.connections.all.status": "Status",
    "aeros.connections.all.channel": "Canal",
    "aeros.connections.all.updated": "Atualização",
    "aeros.connections.all.actions": "Ações",
    "aeros.connections.all.noCompany": "Sem empresa",
    "aeros.connections.all.empty.title": "Nenhuma conexão encontrada",
    "aeros.connections.all.empty.text": "Ajuste a busca ou o filtro de status.",
    // ---- Tela Filas & Chatbot (/queues) ----
    "aeros.queues.title": "Filas & Chatbot",
    "aeros.queues.subtitle": "Departamentos, roteamento e menus automáticos",
    "aeros.queues.search": "Buscar fila…",
    "aeros.queues.add": "Adicionar fila",
    "aeros.queues.kpi.queues": "Filas ativas",
    "aeros.queues.kpi.queuesHint": "{{count}} com chatbot",
    "aeros.queues.kpi.pending": "Tickets aguardando",
    "aeros.queues.kpi.pendingHint": "em todas as filas",
    "aeros.queues.table.id": "ID",
    "aeros.queues.table.name": "Nome",
    "aeros.queues.table.color": "Cor",
    "aeros.queues.table.order": "Ordem (bot)",
    "aeros.queues.table.greeting": "Mensagem de saudação",
    "aeros.queues.table.bot": "Chatbot · Horário",
    "aeros.queues.table.actions": "Ações",
    "aeros.queues.agents": "{{count}} atendentes",
    "aeros.queues.agentOne": "1 atendente",
    "aeros.queues.open": "{{count}} abertos",
    "aeros.queues.openOne": "1 aberto",
    "aeros.queues.options": "{{count}} opções",
    "aeros.queues.optionOne": "1 opção",
    "aeros.queues.noBot": "sem chatbot",
    "aeros.queues.noGreeting": "Sem mensagem de saudação",
    "aeros.queues.schedule.always": "24h",
    "aeros.queues.schedule.none": "Sem horário",
    "aeros.queues.weekdayShort.monday": "Seg",
    "aeros.queues.weekdayShort.tuesday": "Ter",
    "aeros.queues.weekdayShort.wednesday": "Qua",
    "aeros.queues.weekdayShort.thursday": "Qui",
    "aeros.queues.weekdayShort.friday": "Sex",
    "aeros.queues.weekdayShort.saturday": "Sáb",
    "aeros.queues.weekdayShort.sunday": "Dom",
    "aeros.queues.dragHandle": "Arrastar para reordenar",
    "aeros.queues.reorderHint": "A ordem define a sequência do menu inicial do bot. Arraste para reordenar.",
    "aeros.queues.reorderError": "Não foi possível salvar a nova ordem",
    "aeros.queues.actions.edit": "Editar fila",
    "aeros.queues.actions.delete": "Excluir fila",
    "aeros.queues.empty.title": "Nenhuma fila por aqui",
    "aeros.queues.empty.text": "Crie uma fila para direcionar os atendimentos por departamento.",
    "aeros.queues.delete.title": "Excluir a fila “{{name}}”?",
    "aeros.queues.delete.body": "Os atendimentos desta fila ficam sem departamento e o chatbot dela deixa de funcionar. Essa ação não pode ser desfeita.",
    "aeros.queues.delete.bodyOpen": "{{count}} atendimentos abertos ficam sem departamento e o chatbot desta fila deixa de funcionar. Essa ação não pode ser desfeita.",
    "aeros.queues.delete.confirm": "Excluir fila",
    "aeros.queues.delete.done": "Fila excluída",
    "aeros.queues.modal.add": "Nova fila",
    "aeros.queues.modal.edit": "Editar fila · {{name}}",
    "aeros.queues.modal.subtitleNew": "Departamento, roteamento e menu automático",
    "aeros.queues.modal.subtitle": "ID #{{id}} · {{count}} atendentes vinculados",
    "aeros.queues.modal.save": "Salvar fila",
    "aeros.queues.modal.saved": "Fila salva",
    "aeros.queues.tabs.data": "Dados da fila",
    "aeros.queues.tabs.bot": "Chatbot",
    "aeros.queues.tabs.schedules": "Horários de atendimento",
    "aeros.queues.form.name": "Nome",
    "aeros.queues.form.color": "Cor",
    "aeros.queues.form.order": "Ordem (bot)",
    "aeros.queues.form.closeTicket": "Encerrar ticket ao finalizar o bot",
    "aeros.queues.form.closeTicketHint": "Fecha o atendimento sem passar por atendente",
    "aeros.queues.form.rotate": "Rodízio de atendentes",
    "aeros.queues.form.rotateHint": "Redistribui tickets sem resposta",
    "aeros.queues.form.rotateTime": "Tempo de rodízio",
    "aeros.queues.form.rotateType": "Tipo de rodízio",
    "aeros.queues.form.random": "Aleatório",
    "aeros.queues.form.ordered": "Ordenado",
    "aeros.queues.form.integration": "Integração",
    "aeros.queues.form.integrationType": "Tipo (apenas SGP)",
    "aeros.queues.form.fileList": "Lista de arquivos",
    "aeros.queues.form.none": "Nenhuma",
    "aeros.queues.form.greeting": "Mensagem de saudação",
    "aeros.queues.form.outOfHours": "Mensagem fora do expediente",
    "aeros.queues.form.minutes": "minutos",
    "aeros.queues.bot.title": "Chatbot · {{count}} opções no menu inicial",
    "aeros.queues.bot.titleOne": "Chatbot · 1 opção no menu inicial",
    "aeros.queues.bot.titleEmpty": "Chatbot · nenhuma opção ainda",
    "aeros.queues.bot.list": "Opções do menu",
    "aeros.queues.bot.editing": "Editando opção {{n}}",
    "aeros.queues.bot.creating": "Nova opção",
    "aeros.queues.bot.optionTitle": "Título da opção",
    "aeros.queues.bot.type": "Tipo do menu",
    "aeros.queues.bot.types.text": "Texto",
    "aeros.queues.bot.types.user": "Atendente",
    "aeros.queues.bot.types.queue": "Fila",
    "aeros.queues.bot.types.integration": "Integração",
    "aeros.queues.bot.types.file": "Arquivo",
    "aeros.queues.bot.targetUser": "Atendente",
    "aeros.queues.bot.targetQueue": "Transferir para fila",
    "aeros.queues.bot.targetIntegration": "Integração",
    "aeros.queues.bot.targetFile": "Lista de arquivos",
    "aeros.queues.bot.currentQueue": "{{name}} (atual)",
    "aeros.queues.bot.message": "Mensagem",
    "aeros.queues.bot.closeAfter": "Encerrar ticket após esta opção",
    "aeros.queues.bot.discard": "Descartar",
    "aeros.queues.bot.saveOption": "Salvar opção",
    "aeros.queues.bot.addOption": "Adicionar opção",
    "aeros.queues.bot.empty": "Nenhuma opção no menu. Adicione a primeira.",
    "aeros.queues.bot.emptyEditor": "Escolha uma opção à esquerda ou adicione uma nova.",
    "aeros.queues.bot.subOptions": "Sub-opções",
    "aeros.queues.bot.subCount": "Abre submenu de {{count}} opções",
    "aeros.queues.bot.deleteOption": "Excluir opção",
    "aeros.queues.bot.deleteTitle": "Excluir a opção “{{name}}”?",
    "aeros.queues.bot.deleteBody": "As sub-opções abaixo dela também são removidas. Essa ação não pode ser desfeita.",
    "aeros.queues.bot.deleted": "Opção excluída",
    "aeros.queues.sub.levelMessage": "Mensagem do nível",
    "aeros.queues.sub.placeholder": "Digite o texto da opção",
    "aeros.queues.sub.preview": "Prévia no WhatsApp",
    "aeros.queues.sub.previewHint": "Digite o número da opção",
    "aeros.queues.sub.back": "Voltar",
    "aeros.queues.sub.done": "Concluir",
    "aeros.queues.schedules.startA": "Início A",
    "aeros.queues.schedules.endA": "Fim A",
    "aeros.queues.schedules.startB": "Início B",
    "aeros.queues.schedules.endB": "Fim B",
    "aeros.queues.schedules.hint": "Fora desses horários o contato recebe a mensagem de fora do expediente.",
    "aeros.queues.schedules.disabled": "Os horários estão configurados por empresa; mude em Configurações para editar por fila.",
    // ---- Painel ao Vivo (/moments) ----
    "aeros.moments.emptyFilter": "para esse filtro",
    "aeros.moments.yesterday": "Ontem",
    "aeros.moments.online": "Online",
    "aeros.moments.offline": "Offline",
    "aeros.moments.waiting": "Aguardando",
    "aeros.moments.waitingSubtitle": "Sem atendente atribuído",
    "aeros.moments.empty": "Sem atendimentos no momento",
    "aeros.moments.openTicket": "Acessar ticket",
    "aeros.moments.noQueue": "Sem fila",
    "aeros.moments.unreadAria": "{{count}} mensagens não lidas",
    // ---- Tela Integrações (/queue-integration) ----
    "aeros.integrations.noPermission": "Esta empresa não tem permissão para acessar esta página. Estamos lhe redirecionando.",
    "aeros.integrations.title": "Integrações",
    "aeros.integrations.subtitle": "Conecte bots e sistemas externos às suas conexões e filas",
    "aeros.integrations.search": "Buscar integração…",
    "aeros.integrations.new": "Nova integração",
    "aeros.integrations.idLabel": "ID {{id}}",
    "aeros.integrations.linkConnection": "Conexão {{name}}",
    "aeros.integrations.linkQueue": "Fila {{name}}",
    "aeros.integrations.noLinks": "Sem vínculo",
    "aeros.integrations.noEndpoint": "Sem endereço configurado",
    "aeros.integrations.internalFlow": "Fluxo interno do PULSE",
    "aeros.integrations.status.linked": "Ativa",
    "aeros.integrations.status.unlinked": "Sem vínculo",
    "aeros.integrations.linkHint": "Vincule em Conexões ou Filas",
    "aeros.integrations.actions.edit": "Editar integração",
    "aeros.integrations.actions.delete": "Excluir integração",
    "aeros.integrations.empty.title": "Nenhuma integração por aqui",
    "aeros.integrations.empty.text": "Conecte um bot ou um sistema externo para ele atender junto com a sua equipe.",
    "aeros.integrations.filters.all": "Todas",
    "aeros.integrations.filters.bot": "Bots",
    "aeros.integrations.filters.webhook": "Webhooks",
    "aeros.integrations.filters.system": "Sistemas",
    "aeros.integrations.filters.unlinked": "Sem vínculo",
    "aeros.integrations.types.typebot": "Typebot",
    "aeros.integrations.types.n8n": "n8n",
    "aeros.integrations.types.webhook": "Webhook",
    "aeros.integrations.types.dialogflow": "DialogFlow",
    "aeros.integrations.types.flowbuilder": "Flowbuilder",
    "aeros.integrations.types.sgp": "SGP",
    "aeros.integrations.docs.eyebrow": "Documentação",
    "aeros.integrations.docs.title": "Como cada integração funciona",
    "aeros.integrations.docs.intro": "Escolha o tipo de integração para ver o que o PULSE envia ou consome e o passo a passo de configuração do lado de fora.",
    "aeros.integrations.docs.copy": "Copiar exemplo",
    "aeros.integrations.docs.copied": "Copiado para a área de transferência",
    "aeros.integrations.modal.add": "Nova integração",
    "aeros.integrations.modal.edit": "Editar integração",
    "aeros.integrations.modal.subtitle": "Escolha o tipo e preencha as credenciais do sistema externo",
    "aeros.integrations.modal.type": "Tipo",
    "aeros.integrations.modal.name": "Nome",
    "aeros.integrations.modal.save": "Salvar integração",
    "aeros.integrations.modal.saved": "Integração salva",
    "aeros.integrations.modal.footerHint": "Vincule depois em Conexões ou Filas",
    "aeros.integrations.form.typebotUrl": "URL da API do Typebot",
    "aeros.integrations.form.typebotUrlHelper": "Sem barra no final",
    "aeros.integrations.form.typebotSlug": "Typebot · Slug",
    "aeros.integrations.form.typebotExpires": "Expira a sessão em (minutos)",
    "aeros.integrations.form.typebotDelay": "Intervalo entre mensagens (ms)",
    "aeros.integrations.form.typebotKeywordFinish": "Palavra para encerrar",
    "aeros.integrations.form.typebotKeywordRestart": "Palavra para reiniciar",
    "aeros.integrations.form.typebotUnknown": "Mensagem desconhecida",
    "aeros.integrations.form.typebotRestart": "Mensagem de reinício",
    "aeros.integrations.form.n8nUrl": "URL do N8N",
    "aeros.integrations.form.projectName": "Projeto (ID no Google Cloud)",
    "aeros.integrations.form.language": "Linguagem",
    "aeros.integrations.form.jsonContent": "JsonContent · chave da conta de serviço",
    "aeros.integrations.form.sgpIeSenha": "Usuário informa senha",
    "aeros.integrations.form.sgpUrl": "SGP URL",
    "aeros.integrations.form.sgpWidePayToken": "Widepay Token",
    "aeros.integrations.form.sgpWidePayHelper": "Preencha apenas se sua operação usa Widepay",
    "aeros.integrations.panel.typebot": "Como o PULSE fala com o Typebot",
    "aeros.integrations.panel.sgp": "Fluxo do autoatendimento",
    "aeros.integrations.panel.n8n": "Payload que o webhook recebe",
    "aeros.integrations.test.title": "Enviar evento de teste",
    "aeros.integrations.test.hint": "Dispara um POST com um payload de exemplo para a URL acima",
    "aeros.integrations.test.button": "Testar",
    "aeros.integrations.test.running": "Enviando…",
    "aeros.integrations.test.noResponse": "Sem resposta",
    "aeros.integrations.test.needsUrl": "Informe a URL antes de enviar o teste",
    "aeros.integrations.test.saveFirst": "Salve a integração antes de enviar o teste",
    "aeros.integrations.test.ok": "Webhook respondeu · {{result}}",
    "aeros.integrations.test.fail": "O webhook não aceitou o evento · {{result}}",
    "aeros.integrations.dialogflow.test": "Testar sessão",
    "aeros.integrations.dialogflow.ok": "Sessão testada com sucesso",
    "aeros.integrations.dialogflow.fail": "Não foi possível abrir a sessão",
    "aeros.integrations.delete.title": "Excluir a integração “{{name}}”?",
    "aeros.integrations.delete.body": "As conversas deixarão de ser encaminhadas para este sistema. Essa ação não pode ser desfeita.",
    "aeros.integrations.delete.bodyLinked": "{{links}} deixarão de encaminhar conversas para este sistema. Essa ação não pode ser desfeita.",
    "aeros.integrations.delete.confirm": "Excluir integração",
    "aeros.integrations.delete.done": "Integração excluída",
    // ---- Tela Talk.ai (/prompts) ----
    "aeros.talkai.noPermission": "Esta empresa não tem permissão para acessar esta página. Estamos lhe redirecionando.",
    "aeros.talkai.title": "Talk.ai",
    "aeros.talkai.count": "{{count}} agentes",
    "aeros.talkai.countOne": "1 agente",
    "aeros.talkai.subtitle": "Agentes de IA que atendem automaticamente por conexão e fila",
    "aeros.talkai.search": "Buscar agente ou setor…",
    "aeros.talkai.newAgent": "Novo agente",
    "aeros.talkai.footerNote": "Cada fila de uma conexão tem no máximo um agente. A IA transfere para um humano quando não encontra a resposta.",
    "aeros.talkai.kpi.activeAgents": "Agentes ativos",
    "aeros.talkai.table.agent": "Agente",
    "aeros.talkai.table.model": "Modelo",
    "aeros.talkai.table.maxTokens": "Máx. tokens",
    "aeros.talkai.table.knowledge": "Conhecimento",
    "aeros.talkai.table.actions": "Ações",
    "aeros.talkai.actions.simulate": "Ver simulação de conversa",
    "aeros.talkai.actions.edit": "Editar agente",
    "aeros.talkai.actions.delete": "Excluir agente",
    "aeros.talkai.empty.title": "Nenhum agente por aqui",
    "aeros.talkai.empty.text": "Crie um agente para o setor atender sozinho as perguntas mais comuns.",
    "aeros.talkai.tones.formal": "Formal",
    "aeros.talkai.tones.amigavel": "Amigável",
    "aeros.talkai.tones.descontraido": "Descontraído",
    "aeros.talkai.tones.tecnico": "Técnico",
    "aeros.talkai.knowledge.files": "{{count}} arquivos",
    "aeros.talkai.knowledge.fileOne": "1 arquivo",
    "aeros.talkai.knowledge.processing": "Processando",
    "aeros.talkai.knowledge.none": "Somente prompt",
    "aeros.talkai.simulation.defaultName": "Aero",
    "aeros.talkai.simulation.defaultQueue": "Atendimento",
    "aeros.talkai.simulation.greeting.formal": "Olá. Eu sou {{name}}, do atendimento.",
    "aeros.talkai.simulation.greeting.amigavel": "Oi! Eu sou o {{name}}, seu assistente por aqui.",
    "aeros.talkai.simulation.greeting.descontraido": "Opa! Aqui é o {{name}}, bora resolver isso.",
    "aeros.talkai.simulation.greeting.tecnico": "{{name}} aqui. Vamos diagnosticar.",
    "aeros.talkai.simulation.contact1": "Oi, minha internet tá caindo toda hora",
    "aeros.talkai.simulation.agent1": "Desliga o roteador da tomada, aguarda 30 segundos e liga de novo. Me avisa quando as luzes estabilizarem?",
    "aeros.talkai.simulation.contact2": "Já fiz isso e continua sem sinal",
    "aeros.talkai.simulation.defaultTransfer": "Vou te passar para um colega da equipe de {{queue}}, só um instante",
    "aeros.talkai.simulation.transferredByRule": "Transferido para {{queue}} · regra de transferência",
    "aeros.talkai.simulation.transferredNoAnswer": "Transferido para {{queue}} · a IA não encontrou a resposta",
    "aeros.talkai.simulation.title": "Simulação de conversa",
    "aeros.talkai.simulation.note": "Exemplo ilustrativo, montado a partir do tom e dos emojis escolhidos",
    "aeros.talkai.modal.add": "Novo agente",
    "aeros.talkai.modal.edit": "Editar agente",
    "aeros.talkai.modal.subtitle": "Configure como a IA se apresenta, o que ela sabe e quando transfere",
    "aeros.talkai.modal.name": "Nome do agente",
    "aeros.talkai.modal.saved": "Agente salvo",
    "aeros.talkai.modal.save": "Salvar agente",
    "aeros.talkai.modal.footerNote": "Alterações afetam novos atendimentos imediatamente",
    "aeros.talkai.tabs.personality": "Personalidade",
    "aeros.talkai.tabs.knowledge": "Conhecimento",
    "aeros.talkai.tabs.advanced": "Avançado",
    "aeros.talkai.form.agentName": "Nome que a IA usa",
    "aeros.talkai.form.tone": "Tom de voz",
    "aeros.talkai.form.useEmojis": "Usar emojis com moderação",
    "aeros.talkai.form.restrictions": "Restrições do negócio",
    "aeros.talkai.form.restrictionsHelper": "Regras que a IA nunca pode violar (ex.: não fale de preço)",
    "aeros.talkai.form.transferInstructions": "Quando transferir para um atendente",
    "aeros.talkai.form.transferInstructionsHelper": "Escreva quando a IA deve passar a conversa para um atendente (ex.: somente quando o contato pedir para falar com um atendente). Se ficar vazio, a IA decide sozinha se transfere.",
    "aeros.talkai.form.basePromptHelper": "Tudo o que a IA segue vem daqui e dos campos acima: o sistema não acrescenta nenhuma regra. Dica para WhatsApp: peça respostas curtas e sem títulos com # nem negrito com **.",
    "aeros.talkai.personalityLine.name": "Seu nome é {{name}}.",
    "aeros.talkai.personalityLine.tone.formal": "Use tom formal e profissional.",
    "aeros.talkai.personalityLine.tone.amigavel": "Use tom amigável e acolhedor.",
    "aeros.talkai.personalityLine.tone.descontraido": "Use tom descontraído e leve.",
    "aeros.talkai.personalityLine.tone.tecnico": "Use tom técnico e objetivo.",
    "aeros.talkai.personalityLine.emojisOn": "Você pode usar emojis com moderação.",
    "aeros.talkai.personalityLine.emojisOff": "Não use emojis.",
    "aeros.talkai.form.personalityHint": "Nome, tom e emojis viram linhas no início do prompt base, que você pode editar.",
    "aeros.talkai.blocks.restrictions": "Restrições do negócio",
    "aeros.talkai.blocks.transfer": "Quando transferir",
    "aeros.talkai.form.transferMessage": "Mensagem de transferência",
    "aeros.talkai.form.knowledgeText": "Conhecimento em texto",
    "aeros.talkai.form.knowledgeHelper": "Informações curtas e objetivas funcionam melhor. Para documentos longos, use os arquivos ao lado.",
    "aeros.talkai.form.apiKey": "Chave da API OpenAI",
    "aeros.talkai.form.model": "Modelo",
    "aeros.talkai.form.response": "Resposta",
    "aeros.talkai.form.responseText": "Texto",
    "aeros.talkai.form.voicePrefix": "Voz",
    "aeros.talkai.form.azureTitle": "Azure Speech · necessário para voz",
    "aeros.talkai.form.azureKey": "Chave",
    "aeros.talkai.form.azureRegion": "Região",
    "aeros.talkai.form.temperature": "Temperatura",
    "aeros.talkai.form.temperatureHint": "0 = previsível · 2 = criativo",
    "aeros.talkai.form.maxTokens": "Máx. tokens",
    "aeros.talkai.form.maxTokensHint": "Tamanho máximo da resposta",
    "aeros.talkai.form.maxMessages": "Máx. mensagens",
    "aeros.talkai.form.maxMessagesHint": "Histórico enviado à IA",
    "aeros.talkai.form.basePrompt": "Prompt base",
    "aeros.talkai.form.showKey": "Mostrar chave",
    "aeros.talkai.form.hideKey": "Ocultar chave",
    "aeros.talkai.files.title": "Arquivos importados",
    "aeros.talkai.files.counter": "· {{count}} de {{max}}",
    "aeros.talkai.files.import": "Importar",
    "aeros.talkai.files.dropTitle": "Arraste PDF, TXT ou DOCX aqui",
    "aeros.talkai.files.dropHint": "Até 10 MB por arquivo · o conteúdo é indexado automaticamente",
    "aeros.talkai.files.saveFirst": "Salve o agente antes de importar arquivos",
    "aeros.talkai.files.ready": "Pronto",
    "aeros.talkai.files.processing": "Processando",
    "aeros.talkai.files.failed": "Falhou",
    "aeros.talkai.files.delete": "Remover arquivo",
    "aeros.talkai.files.readyCount": "{{count}} arquivos prontos para uso",
    "aeros.talkai.files.readyCountOne": "1 arquivo pronto para uso",
    "aeros.talkai.files.failureLine": "{{name}} falhou: {{reason}}",
    "aeros.talkai.files.failureUnknown": "não foi possível indexar o arquivo",
    "aeros.talkai.files.uploaded": "Arquivo importado",
    "aeros.talkai.files.deleted": "Arquivo removido",
    "aeros.talkai.preview.title": "Prompt final montado",
    "aeros.talkai.preview.copy": "Copiar",
    "aeros.talkai.preview.copied": "Prompt copiado para a área de transferência",
    "aeros.talkai.preview.note": "Somente leitura · gerado pelo servidor na mesma ordem",
    "aeros.talkai.preview.tokens": "≈ {{count}} tokens de sistema por conversa",
    "aeros.talkai.preview.error": "Não foi possível montar a pré-visualização do prompt",
    "aeros.talkai.blocks.basePrompt": "Prompt base",
    "aeros.talkai.blocks.knowledge": "Base de conhecimento",
    "aeros.talkai.delete.title": "Excluir o agente “{{name}}”?",
    "aeros.talkai.delete.body": "O agente deixará de atender em {{vinculo}}. Essa ação não pode ser desfeita.",
    "aeros.talkai.delete.bodyFiles": "O agente deixará de atender em {{vinculo}} e os {{count}} arquivos da base de conhecimento serão removidos. Essa ação não pode ser desfeita.",
    "aeros.talkai.delete.confirm": "Excluir agente",
    "aeros.talkai.delete.done": "Agente excluído",
    "aeros.talkai.table.vinculo": "Conexão · Filas",
    "aeros.talkai.vinculo.pending": "Conexão pendente",
    "aeros.talkai.vinculo.pendingHint": "Agente antigo sem conexão: edite e escolha a conexão",
    "aeros.talkai.vinculo.preQueue": "antes da distribuição",
    "aeros.talkai.modal.connection": "Conexão",
    "aeros.talkai.modal.selectConnection": "Selecione a conexão",
    "aeros.talkai.modal.queues": "Filas",
    "aeros.talkai.modal.selectQueues": "Selecione as filas",
    "aeros.talkai.modal.selectConnectionFirst": "Escolha a conexão primeiro",
    "aeros.talkai.modal.noQueuesInConnection": "Esta conexão não tem filas",
    "aeros.talkai.modal.queueUsedBy": "Usada por {{name}}",
    "aeros.talkai.modal.queueOutside": "Fora desta conexão",
    "aeros.talkai.modal.preQueue": "Atender também antes da distribuição",
    "aeros.talkai.modal.preQueueHelp": "Responde a conversa antes de ela cair numa fila e, em conexão de fila única, também na fila que não tem agente próprio. Só vale em conexão sem menu de filas.",
    "aeros.talkai.modal.preQueueTaken": "Indisponível: o agente {{name}} já atende antes da distribuição nesta conexão",
    "aeros.talkai.modal.preQueueNoEffect": "Esta conexão tem menu de filas: a opção só terá efeito se a conexão ficar sem menu.",
    "aeros.talkai.modal.pendingWarning": "Agente sem conexão (cadastro antigo): escolha a conexão para salvar.",
    "aeros.talkai.modal.warnQueueIntegration": "Fila com integração ({{queues}}): a integração atende antes do agente.",
    "aeros.talkai.modal.warnQueueChatbot": "Fila com opções de chatbot ({{queues}}): o chatbot da fila responde e o agente não atende nela.",
    "aeros.talkai.modal.warnConnectionIntegration": "Esta conexão tem uma integração; ela pode atender antes do agente.",
    "aeros.talkai.modal.warnExtraConnections": "Ao salvar, este agente deixa de atender antes da distribuição em: {{connections}}.",
    "aeros.talkai.modal.warnOutsideQueues": "Filas que não estão mais nesta conexão serão removidas ao salvar: {{queues}}.",
    "aeros.talkai.modal.warningsLabel": "Avisos sobre conexão e filas",
    // ---- Tela Aniversários (/birthday-settings) ----
    "aeros.birthday.title": "Aniversários",
    "aeros.birthday.subtitle": "Parabéns automáticos para contatos e equipe",
    "aeros.birthday.save": "Salvar configurações",
    "aeros.birthday.saved": "Configurações salvas",
    "aeros.birthday.saveError": "Não foi possível salvar as configurações",
    "aeros.birthday.loadError": "Não foi possível carregar as configurações",
    "aeros.birthday.loading": "Carregando configurações…",
    "aeros.birthday.active": "Ativo",
    "aeros.birthday.inactive": "Inativo",
    "aeros.birthday.collapse": "Recolher seção",
    "aeros.birthday.expand": "Expandir seção",
    "aeros.birthday.nextSend.today": "Próximo envio hoje às {{time}} · {{count}} contatos",
    "aeros.birthday.nextSend.todayOne": "Próximo envio hoje às {{time}} · 1 contato",
    "aeros.birthday.nextSend.idle": "Próximo envio às {{time}} · ninguém hoje",
    "aeros.birthday.nextSend.disabled": "Envio automático desativado",
    "aeros.birthday.contacts.title": "Aniversários de contatos",
    "aeros.birthday.contacts.subtitle": "Envia parabéns pelo WhatsApp no dia do aniversário",
    "aeros.birthday.users.title": "Aniversários da equipe",
    "aeros.birthday.users.subtitle": "Mostra o modal de parabéns ao entrar no painel",
    "aeros.birthday.sendTime": "Horário de envio",
    "aeros.birthday.sendTimeHelper": "Horário de Brasília",
    "aeros.birthday.connection": "Conexão WhatsApp para envio",
    "aeros.birthday.connectionNone": "Conexão padrão da empresa",
    "aeros.birthday.connected": "Conectada",
    "aeros.birthday.disconnected": "Desconectada",
    "aeros.birthday.contactMessage": "Mensagem para contatos",
    "aeros.birthday.userMessage": "Mensagem para a equipe",
    "aeros.birthday.variableHint": "Clique em uma variável para inserir no cursor",
    "aeros.birthday.insertVariable": "Inserir {{variable}} na mensagem",
    "aeros.birthday.sentToday": "Enviado com sucesso para {{count}} contatos hoje",
    "aeros.birthday.sentTodayOne": "Enviado com sucesso para 1 contato hoje",
    "aeros.birthday.testMessage": "Testar mensagem",
    "aeros.birthday.announcement.title": "Criar informativo automático",
    "aeros.birthday.announcement.desc": "Publica um aviso no sino para toda a empresa no dia do aniversário",
    "aeros.birthday.preview.title": "Pré-visualização no WhatsApp",
    "aeros.birthday.preview.note": "Cada contato recebe no máximo uma mensagem por ano; reenvios manuais avisam se já foi enviada.",
    "aeros.birthday.preview.sampleName": "João Silva",
    "aeros.birthday.preview.empty": "Escreva a mensagem para ver a pré-visualização.",
    "aeros.birthday.upcoming.title": "Próximos aniversários",
    "aeros.birthday.upcoming.seeAll": "Ver todos",
    "aeros.birthday.upcoming.empty": "Nenhum aniversário nos próximos dias.",
    "aeros.birthday.upcoming.error": "Não foi possível carregar os próximos aniversários",
    "aeros.birthday.status.today": "Hoje",
    "aeros.birthday.status.sent": "Enviada",
    "aeros.birthday.status.scheduled": "Agendada",
    "aeros.birthday.type.user": "Equipe",
    "aeros.birthday.type.contact": "Contato",
    "aeros.birthday.age": "{{count}} anos",
    "aeros.birthday.ageOne": "1 ano",
    "aeros.birthday.kpi.contactsWithDate": "contatos com data",
    "aeros.birthday.kpi.sentThisYear": "enviadas em {{year}}",
    "aeros.birthday.kpi.responded": "responderam",
    "aeros.birthday.months.0": "jan",
    "aeros.birthday.months.1": "fev",
    "aeros.birthday.months.2": "mar",
    "aeros.birthday.months.3": "abr",
    "aeros.birthday.months.4": "mai",
    "aeros.birthday.months.5": "jun",
    "aeros.birthday.months.6": "jul",
    "aeros.birthday.months.7": "ago",
    "aeros.birthday.months.8": "set",
    "aeros.birthday.months.9": "out",
    "aeros.birthday.months.10": "nov",
    "aeros.birthday.months.11": "dez",
    "aeros.birthday.test.title": "Testar mensagem de aniversário",
    "aeros.birthday.test.subtitle": "Envia a mensagem de contatos agora, pela conexão {{connection}}",
    "aeros.birthday.test.subtitleDefault": "Envia a mensagem de contatos agora, pela conexão padrão",
    "aeros.birthday.test.contact": "Contato de teste",
    "aeros.birthday.test.searchPlaceholder": "Buscar contato pelo nome ou número…",
    "aeros.birthday.test.searching": "Buscando…",
    "aeros.birthday.test.noResults": "Nenhum contato encontrado",
    "aeros.birthday.test.noBirth": "sem nascimento",
    "aeros.birthday.test.idLabel": "ID {{id}}",
    "aeros.birthday.test.willSend": "Será enviado",
    "aeros.birthday.test.missingWarning": "{{vars}} fica vazio: o contato não tem data de nascimento cadastrada",
    "aeros.birthday.test.send": "Enviar teste",
    "aeros.birthday.test.sent": "Mensagem de teste enviada",
    "aeros.birthday.test.error": "Não foi possível enviar a mensagem de teste",
    "aeros.birthday.today.title": "Hoje tem aniversário!",
    "aeros.birthday.today.subtitleTeam": "{{count}} colega",
    "aeros.birthday.today.subtitleTeamMany": "{{count}} colegas",
    "aeros.birthday.today.subtitleContacts": "{{count}} contato",
    "aeros.birthday.today.subtitleContactsMany": "{{count}} contatos",
    "aeros.birthday.today.team": "Equipe",
    "aeros.birthday.today.contacts": "Contatos",
    "aeros.birthday.today.userAge": "Faz {{count}} anos hoje",
    "aeros.birthday.today.announcementPublished": "informativo publicado no sino",
    "aeros.birthday.today.greet": "Parabenizar",
    "aeros.birthday.today.greetError": "Não foi possível abrir a conversa",
    "aeros.birthday.today.alreadySent": "Já enviada",
    "aeros.birthday.today.sending": "Enviando…",
    "aeros.birthday.today.send": "Enviar parabéns",
    "aeros.birthday.today.sentAt": "enviada {{time}}",
    "aeros.birthday.today.sendError": "Não foi possível enviar os parabéns",
    "aeros.birthday.today.configure": "Configurar aniversários",
    "aeros.birthday.today.later": "Lembrar mais tarde",
    "aeros.birthday.today.gotIt": "Entendi",
    "aeros.birthday.today.empty": "Ninguém faz aniversário hoje.",
    // ---- Tela Uso da API (/messages-api) ----
    "aeros.api.title": "Uso da API",
    "aeros.api.subtitle": "Envie mensagens de texto e mídia a partir dos seus sistemas",
    "aeros.api.tokensButton": "Tokens das conexões",
    "aeros.api.noPermission": "Esta empresa não tem permissão para acessar esta página. Estamos lhe redirecionando.",
    "aeros.api.intro": "Todas as requisições usam o endpoint abaixo, autenticadas com o token da conexão (Bearer). O número deve estar no formato internacional, sem espaços ou símbolos.",
    "aeros.api.copyEndpoint": "Copiar endpoint",
    "aeros.api.copyExample": "Copiar exemplo de requisição",
    "aeros.api.copied": "Copiado para a área de transferência",
    "aeros.api.numberFormat": "Formato do número",
    "aeros.api.numberLegend": "país · DDD · número",
    "aeros.api.authorizationLine": "Authorization: Bearer (token cadastrado na conexão)",
    "aeros.api.kpiSends": "envios via API · {{days}} dias",
    "aeros.api.kpiText": "de texto",
    "aeros.api.kpiMedia": "com mídia",
    "aeros.api.method": "Método",
    "aeros.api.methodText": "Mensagem de texto",
    "aeros.api.methodTextIntro": "Corpo em JSON. Em conexões oficiais, informe templateName para enviar um template aprovado, dentro ou fora da janela de 24h.",
    "aeros.api.methodMedia": "Mensagem com mídia",
    "aeros.api.methodMediaIntro": "Corpo em multipart/form-data. O campo medias leva o arquivo; body vira a legenda.",
    "aeros.api.tabs.fields": "Campos",
    "aeros.api.testSend": "Testar envio",
    "aeros.api.testSendHint": "Envia de verdade pela conexão escolhida",
    "aeros.api.connection": "Conexão",
    "aeros.api.connectionNone": "Nenhuma conexão selecionada",
    "aeros.api.connectionHelper": "Selecionar uma conexão preenche o token cadastrado nela",
    "aeros.api.channelOfficial": "Oficial",
    "aeros.api.channelBaileys": "Baileys",
    "aeros.api.token": "Token",
    "aeros.api.number": "Número",
    "aeros.api.body": "Mensagem",
    "aeros.api.caption": "Legenda",
    "aeros.api.userId": "Usuário",
    "aeros.api.queueId": "Fila",
    "aeros.api.optional": "· opcional",
    "aeros.api.sendSignature": "Assinar com o atendente",
    "aeros.api.closeTicket": "Encerrar ticket após envio",
    "aeros.api.template": "Template",
    "aeros.api.templateNone": "Sem template (mensagem livre)",
    "aeros.api.templateHelper": "Com template, a mensagem vai dentro ou fora da janela de 24h e o corpo é ignorado",
    "aeros.api.templateMediaBadge": "mídia no cabeçalho",
    "aeros.api.templateHeaderMediaUrl": "URL da mídia do cabeçalho",
    "aeros.api.templateHeaderMediaUrlHelper": "URL http(s) pública do arquivo (PDF, imagem ou vídeo)",
    "aeros.api.templateParamHelper": "Aceita {nome}, {numero}, {email}",
    "aeros.api.variableOne": "variável",
    "aeros.api.variableMany": "variáveis",
    "aeros.api.fillTemplate": "Preencher template",
    "aeros.api.bodyIgnored": "Ignorada quando um template está selecionado",
    "aeros.api.file": "Arquivo",
    "aeros.api.fileHint": "Imagem, vídeo, PDF ou documento",
    "aeros.api.fileRequired": "Escolha um arquivo antes de enviar o teste",
    "aeros.api.noFile": "Nenhum arquivo selecionado",
    "aeros.api.unknownType": "tipo desconhecido",
    "aeros.api.chooseFile": "Escolher",
    "aeros.api.changeFile": "Trocar",
    "aeros.api.sendTest": "Enviar teste",
    "aeros.api.sendTemplate": "Enviar template",
    "aeros.api.lastTest": "Último teste: {{status}} · {{when}}",
    "aeros.api.smsEyebrow": "API de SMS",
    "aeros.api.smsTitle": "Envio de SMS",
    "aeros.api.smsIntro": "Três endpoints: enviar, consultar status e consultar saldo. Autentique com o token de SMS da empresa (botão Tokens), não com o token de uma conexão, e envie sempre o header X-Origin com o nome do seu sistema — sem ele a resposta é 400. Cada parte de SMS consome 1 crédito.",
    "aeros.api.smsAuthorizationLine": "Authorization: Bearer (token de SMS da empresa)",
    "aeros.api.smsSendLabel": "Enviar SMS",
    "aeros.api.smsStatusLabel": "Consultar status",
    "aeros.api.smsBalanceLabel": "Consultar saldo",
    "aeros.api.reference": "Referência",
    "aeros.api.responses": "Respostas e erros",
    "aeros.api.codes.400.title": "Requisição inválida",
    "aeros.api.codes.400.desc": "X-Origin ausente ou campo inválido; a resposta traz o motivo em error.",
    "aeros.api.codes.200.title": "Aceita pela Meta",
    "aeros.api.codes.200.desc": "Conexão oficial: a Meta aceitou a mensagem (status accepted) e a entrega é assíncrona; consulte a rota de status com o messageId. O texto de message não mudou e não garante entrega. Se a Meta recusar na hora, o envio volta como erro HTTP (nunca 200) com o motivo traduzido em error. Conexão QR Code: a mensagem entrou na fila da conexão, sem messageId.",
    "aeros.api.codes.401.title": "Sem token",
    "aeros.api.codes.401.desc": "Header Authorization ausente na requisição.",
    "aeros.api.codes.403.title": "Token inválido",
    "aeros.api.codes.403.desc": "O Bearer não corresponde a nenhuma conexão nem ao token de SMS da empresa (ou a empresa está inativa).",
    "aeros.api.codes.422.title": "Regra violada",
    "aeros.api.codes.422.desc": "Campo obrigatório faltando ou formato incorreto; a resposta indica qual.",
    "aeros.api.codes.402.title": "Licença vencida",
    "aeros.api.codes.402.desc": "A assinatura da empresa venceu (ERR_LICENSE_EXPIRED). A API volta a responder assim que o pagamento for confirmado em Assinatura.",
    "aeros.api.codes.429.title": "Limite atingido",
    "aeros.api.codes.429.desc": "Muitas requisições por minuto na conexão. Aguarde e reenvie.",
    "aeros.api.codes.404.title": "Mensagem não encontrada",
    "aeros.api.codes.404.desc": "Rota de status: messageId inexistente, de outra empresa ou de mensagem de outra conexão (ERR_NO_MESSAGE_FOUND).",
    "aeros.api.statusEyebrow": "Consulta",
    "aeros.api.statusTitle": "Status de uma mensagem",
    "aeros.api.statusIntro": "O 200 do envio significa aceita pela Meta: a entrega é assíncrona. Com o messageId devolvido no envio (conexão oficial) você descobre se a mensagem foi enviada, entregue, lida ou se falhou, e o motivo real da falha. Mesmo token (Bearer) e mesmo header X-Origin do envio. Conexões QR Code (Baileys) não devolvem messageId, então não têm esta consulta. No canal oficial, o primeiro estado que você costuma ver ao consultar é sent (accepted é momentâneo).",
    "aeros.api.statusLabel": "Consultar status da mensagem",
    "aeros.api.categories.conta.title": "Conta",
    "aeros.api.categories.conta.desc": "Problema na conta do WhatsApp Business, como pagamento pendente ou conta restrita. Resolva no Meta Business; o link de correção vem em failure.link.",
    "aeros.api.categories.contato.title": "Contato",
    "aeros.api.categories.contato.desc": "O destinatário não recebe a mensagem: número sem WhatsApp, contato que optou por não receber ou app desatualizado.",
    "aeros.api.categories.janela.title": "Janela de 24h",
    "aeros.api.categories.janela.desc": "Fora da janela de 24h só template aprovado entrega. Reenvie informando templateName.",
    "aeros.api.categories.template.title": "Template",
    "aeros.api.categories.template.desc": "Template inexistente, pausado, reprovado ou com parâmetros incorretos. Revise o template e os parâmetros.",
    "aeros.api.categories.limite.title": "Limite",
    "aeros.api.categories.limite.desc": "Limite de envios ou de qualidade da conta atingido, ou excesso de mensagens para o mesmo contato. Aguarde e reenvie.",
    "aeros.api.categories.midia.title": "Mídia",
    "aeros.api.categories.midia.desc": "A Meta não aceitou o arquivo: tipo, tamanho ou formato inválido, ou link inacessível.",
    "aeros.api.categories.desconhecido.title": "Desconhecido",
    "aeros.api.categories.desconhecido.desc": "Código sem tradução no catálogo. Leia failure.reasonOriginal (texto da Meta) e failure.code.",
    "aeros.api.result.successTitle": "Mensagem enviada",
    "aeros.api.result.errorTitle": "Requisição rejeitada",
    "aeros.api.result.noResponse": "Sem resposta",
    "aeros.api.result.response": "Resposta",
    "aeros.api.result.copy": "Copiar resposta",
    "aeros.api.result.close": "Fechar",
    "aeros.api.result.justNow": "agora",
    "aeros.api.result.minutesAgo": "há {{count}} min",
    "aeros.api.result.hoursAgo": "há {{count}} h",
    "aeros.api.result.hintNetwork": "A requisição não chegou ao servidor. Confira a conexão de rede e se o endereço da API está acessível.",
    "aeros.api.result.hint401": "O token não corresponde a nenhuma conexão. Copie o token pelo botão “Tokens das conexões”.",
    "aeros.api.result.hint422": "Algum campo obrigatório está faltando ou fora do formato. A resposta acima indica qual corrigir.",
    "aeros.api.result.hint429": "Limite de requisições da conexão atingido. Aguarde alguns instantes antes de reenviar.",
    "aeros.api.result.hint500": "A API respondeu com erro interno. Tente novamente; se persistir, avise o suporte.",
    "aeros.api.tokens.title": "Tokens das conexões",
    "aeros.api.tokens.subtitle": "Cada conexão tem seu próprio token, usado no cabeçalho Authorization. O token de SMS é um só, da empresa.",
    "aeros.api.tokens.empty": "Nenhuma conexão com token cadastrado.",
    "aeros.api.tokens.reveal": "Mostrar token",
    "aeros.api.tokens.hide": "Ocultar token",
    "aeros.api.tokens.copy": "Copiar token",
    "aeros.api.tokens.footerHint": "Guarde os tokens em variáveis de ambiente, nunca no código do cliente",
    "aeros.api.tokens.close": "Fechar",
    "aeros.api.tokens.sms.title": "Token de SMS",
    "aeros.api.tokens.sms.subtitle": "Token único da empresa para as rotas /api/sms — não depende de conexão.",
    "aeros.api.tokens.sms.empty": "Nenhum token de SMS gerado ainda.",
    "aeros.api.tokens.sms.generate": "Gerar token",
    "aeros.api.tokens.sms.regenerate": "Regerar",
    "aeros.api.tokens.sms.confirmTitle": "Regerar o token de SMS?",
    "aeros.api.tokens.sms.confirmBody": "O token atual para de funcionar imediatamente. Atualize todas as integrações que enviam SMS com o novo token.",
    "aeros.api.tokens.sms.generated": "Token de SMS gerado",
    "aeros.header.morning": "Bom dia",
    "aeros.header.afternoon": "Boa tarde",
    "aeros.header.evening": "Boa noite",
    "aeros.header.plan": "{{company}} · plano ativo até {{date}}",
    "aeros.header.connected": "Conectado",
    "aeros.header.reconnecting": "Reconectando…",
    "aeros.header.payInvoice": "Pagar fatura",
    "aeros.header.search": "Buscar ou ir para…",
    "aeros.header.searchPlaceholder": "Buscar tela, contato ou atendimento…",
    "aeros.header.searchAria": "Buscar",
    "aeros.header.nothingFound": "Nada encontrado para “{{q}}”.",
    "aeros.header.groups.screens": "Telas",
    "aeros.header.groups.contacts": "Contatos",
    "aeros.header.groups.tickets": "Atendimentos",
    "aeros.header.noContact": "Sem contato",
    "aeros.header.language": "Idioma",
    "aeros.header.languageHint": "Troca sem recarregar a página",
    "aeros.header.theme": "Tema",
    "aeros.header.light": "Claro",
    "aeros.header.dark": "Escuro",
    "aeros.header.system": "Sistema",
    "aeros.header.accent": "Cor de destaque",
    "aeros.header.customColor": "Cor personalizada",
    "aeros.header.sound": "Som das notificações",
    "aeros.header.volume": "Volume",
    "aeros.header.ringtone": "Toque padrão",
    "aeros.header.clickToTest": "Clique para testar",
    "aeros.header.testRingtone": "Testar toque",
    "aeros.header.browserNotifications": "Notificações do navegador",
    "aeros.header.blockedInBrowser": "Bloqueadas no navegador",
    "aeros.header.muteUntil": "Silenciar até",
    "aeros.header.mute": "Silenciar",
    "aeros.header.mutedUntil": "Silenciado até {{time}}",
    "aeros.header.unread": "Mensagens não lidas",
    "aeros.header.unreadTitle": "Não lidas",
    "aeros.header.tabs.mine": "Minhas",
    "aeros.header.tabs.queue": "Fila",
    "aeros.header.tabs.groups": "Grupos",
    "aeros.header.markAllRead": "Marcar todas como lidas",
    "aeros.header.seeAllTickets": "Ver todos os atendimentos",
    "aeros.header.announcements": "Informativos",
    "aeros.header.priority.high": "Alta",
    "aeros.header.priority.medium": "Média",
    "aeros.header.priority.low": "Baixa",
    "aeros.header.internalChat": "Chat interno",
    "aeros.header.newChat": "Nova conversa",
    "aeros.header.openInternalChat": "Abrir chat interno",
    "aeros.header.userMenu": "Menu do usuário",
    "aeros.header.online": "Online",
    "aeros.header.away": "Ausente",
    "aeros.header.myProfile": "Meu perfil",
    "aeros.header.preferences": "Preferências",
    "aeros.header.preferencesHint": "menu, tema, som",
    "aeros.header.helpTutorials": "Ajuda e tutoriais",
    "aeros.header.logout": "Sair",
    "aeros.header.close": "Fechar",
    "aeros.screens.dashboard": "Dashboard",
    "aeros.screens.tickets": "Atendimentos",
    "aeros.screens.moments": "Painel ao Vivo",
    "aeros.screens.kanban": "Kanban",
    "aeros.screens.schedules": "Agendamentos",
    "aeros.screens.quickMessages": "Respostas rápidas",
    "aeros.screens.contacts": "Contatos",
    "aeros.screens.tags": "Tags",
    "aeros.screens.chats": "Chat Interno",
    "aeros.screens.reports": "Relatórios",
    "aeros.screens.wallets": "Carteiras",
    "aeros.screens.helps": "Ajuda",
    "aeros.screens.campaigns": "Campanhas",
    "aeros.screens.flowbuilders": "Flowbuilder",
    "aeros.screens.prompts": "Open.Ai",
    "aeros.screens.users": "Usuários",
    "aeros.screens.connections": "Conexões",
    "aeros.screens.queues": "Filas & Chatbot",
    "aeros.screens.settings": "Configurações",
    "aeros.screens.financeiro": "Assinatura",
    "aeros.prefs.title": "Preferências",
    "aeros.prefs.subtitle": "Menu, aparência, som e idioma — valem só para você",
    "aeros.prefs.menu": "Menu lateral ao entrar",
    "aeros.prefs.menuOpen": "Aberto",
    "aeros.prefs.menuOpenDesc": "Mostra os nomes das telas",
    "aeros.prefs.menuClosed": "Recolhido",
    "aeros.prefs.menuClosedDesc": "Só ícones; mais espaço",
    "aeros.prefs.appearance": "Aparência",
    "aeros.prefs.done": "Concluído",
    "aeros.prefs.menuSaved": "Preferência de menu salva.",
    "aeros.reports.title": "Relatórios",
    "aeros.reports.tickets": "atendimentos",
    "aeros.reports.updatedNow": "atualizado agora",
    "aeros.reports.updatedMin": "atualizado há {{min}} min",
    "aeros.reports.updatedHour": "atualizado há {{h}} h",
    "aeros.reports.saveFilter": "Salvar filtro",
    "aeros.reports.saveCurrent": "Salvar filtro atual…",
    "aeros.reports.pdf": "PDF",
    "aeros.reports.exportXlsx": "Exportar XLSX",
    "aeros.reports.presets.today": "Hoje",
    "aeros.reports.presets.7d": "7 dias",
    "aeros.reports.presets.30d": "30 dias",
    "aeros.reports.presets.month": "Mês",
    "aeros.reports.dateFrom": "Data inicial",
    "aeros.reports.dateTo": "Data final",
    "aeros.reports.filters.period": "Período",
    "aeros.reports.filters.queue": "Fila",
    "aeros.reports.filters.user": "Atendente",
    "aeros.reports.filters.connection": "Conexão",
    "aeros.reports.filters.status": "Status",
    "aeros.reports.filters.wallet": "Carteira",
    "aeros.reports.filters.onlyRated": "Só avaliados",
    "aeros.reports.filters.search": "Busca",
    "aeros.reports.all": "Todos",
    "aeros.reports.allF": "Todas",
    "aeros.reports.clearFilters": "Limpar filtros",
    "aeros.reports.searchPlaceholder": "Buscar contato por nome ou número…",
    "aeros.reports.searchAria": "Buscar contato",
    "aeros.reports.status.open": "Aberto",
    "aeros.reports.status.pending": "Pendente",
    "aeros.reports.status.closed": "Resolvido",
    "aeros.reports.status.group": "Grupo",
    "aeros.reports.status.nps": "Avaliando",
    "aeros.reports.status.lgpd": "LGPD",
    "aeros.reports.pills.all": "Todos",
    "aeros.reports.pills.open": "Abertos",
    "aeros.reports.pills.pending": "Pendentes",
    "aeros.reports.pills.closed": "Resolvidos",
    "aeros.reports.kpis.total": "Atendimentos",
    "aeros.reports.kpis.resolution": "Taxa de resolução",
    "aeros.reports.kpis.wait": "T.M. espera",
    "aeros.reports.kpis.duration": "T.M. atendimento",
    "aeros.reports.kpis.nps": "NPS médio",
    "aeros.reports.kpis.rated": "{{rated}} avaliados · {{pct}}%",
    "aeros.reports.vsPrevious": "vs. período anterior",
    "aeros.reports.samePrevious": "= período anterior",
    "aeros.reports.summaryUnavailable": "resumo indisponível",
    "aeros.reports.columns.id": "ID",
    "aeros.reports.columns.contact": "Contato",
    "aeros.reports.columns.queue": "Fila",
    "aeros.reports.columns.user": "Atendente",
    "aeros.reports.columns.wallet": "Carteira",
    "aeros.reports.columns.status": "Status",
    "aeros.reports.columns.openClose": "Abertura → Fechamento",
    "aeros.reports.columns.duration": "Duração",
    "aeros.reports.columns.nps": "NPS",
    "aeros.reports.columns.sale": "Venda",
    "aeros.reports.columns.actions": "Ações",
    "aeros.reports.columns.connection": "Conexão",
    "aeros.reports.columns.number": "Número",
    "aeros.reports.columns.lastMessage": "Última mensagem",
    "aeros.reports.columns.opened": "Abertura",
    "aeros.reports.columns.closed": "Fechamento",
    "aeros.reports.columns.supportTime": "Tempo de atendimento",
    "aeros.reports.columns.saleValue": "Valor da venda",
    "aeros.reports.columns.noSaleReason": "Motivo da não venda",
    "aeros.reports.columns.soldLabel": "Finalizado com venda",
    "aeros.reports.noQueue": "Sem fila",
    "aeros.reports.stillOpen": "em aberto",
    "aeros.reports.notSold": "Não · {{reason}}",
    "aeros.reports.noReason": "sem motivo",
    "aeros.reports.yes": "Sim",
    "aeros.reports.no": "Não",
    "aeros.reports.empty": "Nenhum atendimento no período com estes filtros.",
    "aeros.reports.logs": "Logs do ticket",
    "aeros.reports.access": "Acessar ticket",
    "aeros.reports.perPage": "{{n}} por página",
    "aeros.reports.perPageAria": "Por página",
    "aeros.reports.showing": "Mostrando {{from}}–{{to}} de {{total}}",
    "aeros.reports.noResults": "Nenhum resultado",
    "aeros.reports.filterSaved": "Filtro salvo.",
    "aeros.reports.notInformed": "Não informado",
    "aeros.reports.sheetTitle": "Relatórios de Atendimentos",
    "aeros.reports.sheetStart": "Data inicial",
    "aeros.reports.sheetEnd": "Data final",
    "aeros.reports.sheetTickets": "RelatorioDeAtendimentos",
    "aeros.reports.sheetChats": "Conversas",
    "aeros.reports.transcript.ticket": "Ticket",
    "aeros.reports.transcript.contact": "Contato",
    "aeros.reports.transcript.datetime": "Data/hora",
    "aeros.reports.transcript.from": "De",
    "aeros.reports.transcript.message": "Mensagem",
    "aeros.reports.transcript.agent": "Atendente",
    "aeros.reports.transcript.customer": "Cliente",
    "aeros.reports.export.title": "Exportar relatório",
    "aeros.reports.export.xlsx": "Planilha XLSX",
    "aeros.reports.export.xlsxDesc": "Colunas escolhidas",
    "aeros.reports.export.pdf": "PDF resumido",
    "aeros.reports.export.pdfDesc": "KPIs + tabela",
    "aeros.reports.export.columns": "Colunas",
    "aeros.reports.export.transcript": "Incluir transcrição das conversas",
    "aeros.reports.export.transcriptDesc": "Aba extra na planilha; gera um arquivo maior",
    "aeros.reports.export.transcriptLimit": "Disponível para até {{limit}} atendimentos — reduza o período ou os filtros.",
    "aeros.reports.export.button": "Exportar {{count}} linhas",
    "aeros.reports.save.title": "Salvar filtro",
    "aeros.reports.save.subtitle": "Acesse esta visão com um clique",
    "aeros.reports.save.name": "Nome",
    "aeros.reports.save.namePlaceholder": "Ex.: Suporte · semana · resolvidos",
    "aeros.reports.save.nameAria": "Nome do filtro",
    "aeros.reports.save.weekly": "Enviar por e-mail toda segunda",
    "aeros.reports.save.noEmail": "Seu usuário não tem e-mail cadastrado",
    "aeros.reports.save.button": "Salvar",
    "aeros.reports.cancel": "Cancelar",
    "aeros.reports.ticket.wait": "Espera",
    "aeros.reports.ticket.duration": "Duração",
    "aeros.reports.ticket.messages": "Mensagens",
    "aeros.reports.ticket.reason": "Motivo",
    "aeros.reports.ticket.timeline": "Linha do tempo",
    "aeros.reports.ticket.chat": "Conversa",
    "aeros.reports.ticket.noEvents": "Nenhum evento registrado.",
    "aeros.reports.ticket.noMessages": "Sem mensagens neste ticket.",
    "aeros.reports.ticket.openInTickets": "Abrir em Atendimentos",
    "aeros.reports.ticket.exportPdf": "Exportar PDF",
    "aeros.reports.ticket.noContact": "Sem contato",
    "aeros.reports.ticket.sale": "Venda",
    "aeros.reportsNav.tickets": "Atendimentos",
    "aeros.reportsNav.reasons": "Motivos de finalização",
    "aeros.reportsNav.aria": "Relatórios",
    "aeros.reportsNav.api": "Uso da API",
    "aeros.apiReport.title": "Uso da API",
    "aeros.apiReport.calls": "chamadas",
    "aeros.apiReport.exportXlsx": "Exportar XLSX",
    "aeros.apiReport.exportTruncated": "Export limitado a {{max}} chamadas. Refine o período.",
    "aeros.apiReport.filters.connection": "Conexão",
    "aeros.apiReport.filters.origin": "Origem",
    "aeros.apiReport.filters.kind": "Tipo",
    "aeros.apiReport.filters.route": "Rota",
    "aeros.apiReport.filters.channel": "Canal",
    "aeros.apiReport.filters.all": "Todas",
    "aeros.apiReport.filters.allM": "Todos",
    "aeros.apiReport.searchPlaceholder": "Buscar por erro ou origem…",
    "aeros.apiReport.searchAria": "Buscar chamadas",
    "aeros.apiReport.clearFilters": "Limpar filtros",
    "aeros.apiReport.dateFrom": "Data inicial",
    "aeros.apiReport.dateTo": "Data final",
    "aeros.apiReport.pills.all": "Todas",
    "aeros.apiReport.pills.success": "Sucesso",
    "aeros.apiReport.pills.queued": "Na fila",
    "aeros.apiReport.pills.rejected": "Rejeitada 4xx",
    "aeros.apiReport.pills.error": "Erro 5xx",
    "aeros.apiReport.pills.failed": "Falhou no envio",
    "aeros.apiReport.pills.sent": "Enviada",
    "aeros.apiReport.kinds.text": "Texto",
    "aeros.apiReport.kinds.media": "Mídia",
    "aeros.apiReport.kinds.template": "Template",
    "aeros.apiReport.kinds.checkNumber": "Validar número",
    "aeros.apiReport.kinds.sms": "SMS",
    "aeros.apiReport.kinds.smsStatus": "Status de SMS",
    "aeros.apiReport.kinds.smsBalance": "Saldo de SMS",
    "aeros.apiReport.kinds.messageStatus": "Status da mensagem",
    "aeros.apiReport.channels.whatsapp": "QR Code",
    "aeros.apiReport.channels.whatsapp_oficial": "Oficial",
    "aeros.apiReport.channels.sms": "SMS",
    "aeros.apiReport.kpis.total": "Chamadas",
    "aeros.apiReport.kpis.successRate": "Taxa de sucesso",
    "aeros.apiReport.kpis.rejected": "Rejeitadas",
    "aeros.apiReport.kpis.error": "Erros",
    "aeros.apiReport.kpis.failed": "Falhas na fila",
    "aeros.apiReport.kpis.latency": "Latência média",
    "aeros.apiReport.kpis.p95": "p95 {{value}}",
    "aeros.apiReport.chart.title": "Chamadas por dia",
    "aeros.apiReport.chart.empty": "Sem chamadas no período",
    "aeros.apiReport.breakdown.connection": "Por conexão",
    "aeros.apiReport.breakdown.origin": "Por origem",
    "aeros.apiReport.breakdown.kind": "Por tipo",
    "aeros.apiReport.breakdown.errors": "Erros mais frequentes",
    "aeros.apiReport.breakdown.empty": "Nada no período",
    "aeros.apiReport.noOrigin": "Sem origem",
    "aeros.apiReport.columns.when": "Data/hora",
    "aeros.apiReport.columns.connection": "Conexão",
    "aeros.apiReport.columns.origin": "Origem",
    "aeros.apiReport.columns.route": "Rota",
    "aeros.apiReport.columns.kind": "Tipo",
    "aeros.apiReport.columns.number": "Número",
    "aeros.apiReport.columns.status": "HTTP",
    "aeros.apiReport.columns.outcome": "Resultado",
    "aeros.apiReport.columns.latency": "Latência",
    "aeros.apiReport.columns.error": "Erro",
    "aeros.apiReport.columns.ip": "IP",
    "aeros.apiReport.columns.userAgent": "User-Agent",
    "aeros.apiReport.columns.actions": "Ações",
    "aeros.apiReport.openTicket": "Abrir ticket",
    "aeros.apiReport.empty": "Nenhuma chamada com esses filtros",
    "aeros.apiReport.noResults": "Nenhum resultado",
    "aeros.apiReport.showing": "Mostrando {{from}}–{{to}} de {{total}}",
    "aeros.apiReport.perPage": "{{n}} por página",
    "aeros.apiReport.perPageAria": "Itens por página",
    "aeros.apiReport.prevPage": "Página anterior",
    "aeros.apiReport.nextPage": "Próxima página",
    "aeros.apiReport.sheetTitle": "Uso da API de mensagens",
    "aeros.apiReport.sheetStart": "Início",
    "aeros.apiReport.sheetEnd": "Fim",
    "aeros.apiReport.sheetCalls": "Chamadas",
    "aeros.apiReport.summaryUnavailable": "Resumo indisponível",
    "aeros.sales.title": "Motivos de finalização",
    "aeros.sales.subtitle": "Tickets encerrados no período, pela data de fechamento",
    "aeros.sales.selectPeriod": "Por favor, selecione o período",
    "aeros.sales.agent": "Atendente:",
    "aeros.sales.all": "Todos",
    "aeros.sales.generate": "Gerar relatório",
    "aeros.sales.generating": "Gerando…",
    "aeros.sales.emptyHint": "Selecione o período e clique em “Gerar relatório”.",
    "aeros.sales.finished": "Finalizados",
    "aeros.sales.withReason": "Com motivo",
    "aeros.sales.sales": "Vendas",
    "aeros.sales.totalValue": "Valor total",
    "aeros.sales.reasons": "Motivos",
    "aeros.sales.noSaleReasons": "Motivos de não venda",
    "aeros.sales.finishReason": "Motivo da finalização",
    "aeros.sales.noSaleReason": "Motivo da não venda",
    "aeros.sales.date": "Data",
    "aeros.sales.value": "Valor",
    "aeros.sales.byAgent": "Resumo por atendente",
    "aeros.helps.title": "Ajuda",
    "aeros.helps.video": "vídeo",
    "aeros.helps.videos": "vídeos",
    "aeros.helps.subtitle": "Tutoriais em vídeo para o time",
    "aeros.helps.managedIn": " · gerenciados em Configurações → Ajuda",
    "aeros.helps.search": "Buscar tutorial…",
    "aeros.helps.support": "Falar com suporte",
    "aeros.helps.emptyTitle": "Nenhum tutorial cadastrado",
    "aeros.helps.emptyAdmin": "Adicione vídeos do YouTube em Configurações → Ajuda para que apareçam aqui para todo o time.",
    "aeros.helps.emptyUser": "Peça a um administrador para cadastrar os vídeos em Configurações → Ajuda.",
    "aeros.helps.register": "Cadastrar tutorial",
    "aeros.helps.startHere": "Comece aqui",
    "aeros.helps.watch": "Assistir",
    "aeros.helps.seenBy": "Visto por {{seen}} de {{total}} usuários",
    "aeros.helps.moreHelp": "Precisa de mais ajuda?",
    "aeros.helps.docs": "Central de documentação",
    "aeros.helps.ticket": "Abrir chamado com o suporte",
    "aeros.helps.ticketSub": "Fale com a equipe Pulse",
    "aeros.helps.onboarding": "Assistente de onboarding",
    "aeros.helps.onboardingSub": "Tire dúvidas com o assistente do painel",
    "aeros.helps.notFound": "Nenhum tutorial encontrado para “{{q}}”.",
    "aeros.helps.all": "Todos",
    "aeros.helps.general": "Geral",
    "aeros.helps.youtube": "YouTube",
    "aeros.helps.next": "Próximo",
    "aeros.helpsManager.category": "Categoria",
    "aeros.helpsManager.categoryPlaceholder": "Ex.: Primeiros passos",
    "aeros.helpsManager.duration": "Duração",
    "aeros.helpsManager.featured": "Destaque \"Comece aqui\" na tela de Ajuda",
    "aeros.helpsManager.linksTitle": "Links de ajuda",
    "aeros.helpsManager.linksSubtitle": "Aparecem na tela de Ajuda para todo o time. Deixe em branco para ocultar.",
    "aeros.helpsManager.linkSupport": "Falar com suporte",
    "aeros.helpsManager.linkDocs": "Central de documentação",
    "aeros.helpsManager.linkTicket": "Abrir chamado com o suporte",
    "aeros.helpsManager.linkSaved": "Link salvo.",
    "aeros.helpsManager.linkError": "Não foi possível salvar o link.",
    "aeros.log.create": "Ticket criado",
    "aeros.log.chatBot": "ChatBot iniciado",
    "aeros.log.queue": "Fila definida: {{queue}}",
    "aeros.log.redirect": "Redirecionado para {{queue}}",
    "aeros.log.otherQueue": "outra fila",
    "aeros.log.openBy": "{{name}} iniciou o atendimento",
    "aeros.log.open": "Atendimento iniciado",
    "aeros.log.reopenBy": "{{name}} reabriu o ticket",
    "aeros.log.reopen": "Ticket reaberto",
    "aeros.log.accessBy": "{{name}} acessou o ticket",
    "aeros.log.access": "Ticket acessado",
    "aeros.log.transferedBy": "{{name}} transferiu o ticket",
    "aeros.log.transfered": "Ticket transferido",
    "aeros.log.receivedBy": "Recebido por {{name}}",
    "aeros.log.receivedIn": " em {{queue}}",
    "aeros.log.agent": "atendente",
    "aeros.log.pendingBy": "{{name}} devolveu para a fila",
    "aeros.log.pending": "Devolvido para a fila",
    "aeros.log.closedBy": "{{name}} encerrou o ticket",
    "aeros.log.closed": "Ticket encerrado",
    "aeros.log.clientClosed": "Cliente encerrou o ticket",
    "aeros.log.nps": "Pesquisa de satisfação enviada",
    "aeros.log.event": "Evento",
    "aeros.log.today": "Hoje",
    "aeros.log.yesterday": "Ontem",
    "aeros.tags.minutes": "minutos",
    "aeros.tags.hours": "horas",
    "aeros.tags.days": "dias",
    "aeros.tags.never": "Nunca",
    "aeros.tags.weekly": "Semanal",
    "aeros.tags.biweekly": "Quinzenal",
    "aeros.tags.monthly": "Mensal",
    "aeros.tags.quarterly": "Trimestral",
    "aeros.tags.agoToday": "hoje",
    "aeros.tags.agoDay": "há 1 dia",
    "aeros.tags.agoDays": "há {{n}} dias",
    "aeros.tags.agoWeeks": "há {{n}} sem",
    "aeros.tags.agoMonth": "há 1 mês",
    "aeros.tags.agoMonths": "há {{n}} meses",
    "aeros.tags.agoYears": "há {{n}} ano(s)",
    "aeros.contacts.colName": "Nome",
    "aeros.contacts.colWhatsapp": "WhatsApp",
    "aeros.contacts.colEmail": "E-mail",
    "aeros.contacts.colBirthDate": "Data de nascimento",
    "aeros.contacts.colTags": "Tags",
    "aeros.contacts.colWallet": "Carteira (e-mail)",
    "aeros.contacts.colExtra": "Info extra: <cabeçalho>",
    "aeros.contacts.sampleName": "Nome Contato",
    "aeros.contacts.deletedAll": "Todos os {{count}} contatos foram excluídos",
    "aeros.contacts.deleted": "{{count}} contatos excluídos com sucesso",
    "aeros.contacts.clearSelection": "Limpar seleção",
    "aeros.contacts.startTicket": "Iniciar atendimento",
    "aeros.contacts.sendSms": "Enviar SMS",
    "aeros.contacts.edit": "Editar",
    "aeros.contacts.editContact": "Editar contato",
    "aeros.contacts.delete": "Excluir",
    "aeros.contacts.deleteContact": "Excluir contato",
    "aeros.contacts.notFound": "Nenhum contato encontrado",
    "aeros.chat.you": "Você",
    "aeros.chat.youPrefix": "Você: …",
    "aeros.chat.user": "Usuário",
    "aeros.chat.video": "Vídeo",
    "aeros.chat.deleted": "Mensagem apagada",
    "aeros.chat.audio": "Áudio",
    "aeros.chat.image": "Imagem",
    "aeros.chat.file": "Arquivo",
    "aeros.chat.typingOne": "{{name}} está digitando…",
    "aeros.chat.typingMany": "{{names}} estão digitando…",
    "aeros.chat.and": " e ",
    "aeros.chat.someone": "Alguém",
    "aeros.chat.youTag": "(você)",
    "aeros.chat.admin": "Admin",
    "aeros.chat.weekdays": "Dom,Seg,Ter,Qua,Qui,Sex,Sáb",
    "aeros.chat.today": "Hoje",
    "aeros.chat.yesterday": "Ontem",
    "aeros.chat.back": "Voltar",
    "aeros.chat.more": "Mais",
    "aeros.chat.closeSearch": "Fechar busca",
    "aeros.chat.cancelRecording": "Cancelar gravação",
    "aeros.chat.sendAudio": "Enviar áudio",
    "aeros.chat.removeAttachment": "Remover anexo",
    "aeros.chat.sendAttachment": "Enviar anexo",
    "aeros.chat.cancelReply": "Cancelar resposta",
    "aeros.chat.removeTicket": "Remover ticket",
    "aeros.chat.emoji": "Emoji",
    "aeros.chat.attach": "Anexar",
    "aeros.chat.send": "Enviar",
    "aeros.chat.record": "Gravar áudio",
    "aeros.campaign.new": "Nova campanha",
    "aeros.campaign.edit": "Editar campanha",
    "aeros.campaign.readonly": "Visualizar campanha",
    "aeros.campaign.subtitle": "Disparo em massa por WhatsApp ou SMS",
    "aeros.campaign.steps.config": "Configuração",
    "aeros.campaign.steps.messages": "Mensagens",
    "aeros.campaign.steps.review": "Revisão",
    "aeros.campaign.name": "Nome",
    "aeros.campaign.namePlaceholder": "Ex.: Black Friday Fibra 2026",
    "aeros.campaign.contactList": "Lista de contatos",
    "aeros.campaign.orTag": "ou Tag",
    "aeros.campaign.none": "Nenhuma",
    "aeros.campaign.connection": "Conexão",
    "aeros.campaign.selectConnection": "Selecione a conexão",
    "aeros.campaign.scheduleFor": "Agendar para",
    "aeros.campaign.recurrenceTitle": "Recorrência",
    "aeros.campaign.recurrenceDesc": "Repete o disparo automaticamente",
    "aeros.campaign.type": "Tipo",
    "aeros.campaign.interval": "Intervalo",
    "aeros.campaign.endDate": "Data final",
    "aeros.campaign.optional": "opcional",
    "aeros.campaign.maxExecutions": "Máx. execuções",
    "aeros.campaign.dayOfMonth": "Dia do mês",
    "aeros.campaign.next": "Próximas: {{dates}} às {{time}}",
    "aeros.campaign.recurrence.minutely": "Por minuto",
    "aeros.campaign.recurrence.hourly": "Por hora",
    "aeros.campaign.recurrence.daily": "Diária",
    "aeros.campaign.recurrence.weekly": "Semanal",
    "aeros.campaign.recurrence.biweekly": "Quinzenal",
    "aeros.campaign.recurrence.monthly": "Mensal",
    "aeros.campaign.recurrence.yearly": "Anual",
    "aeros.campaign.weekdaysShort": "D,S,T,Q,Q,S,S",
    "aeros.campaign.weekdaysLong": "Dom,Seg,Ter,Qua,Qui,Sex,Sáb",
    "aeros.campaign.readConfirmation": "Confirmação de leitura",
    "aeros.campaign.enabled": "Habilitada",
    "aeros.campaign.disabled": "Desabilitada",
    "aeros.campaign.openTicket": "Abrir ticket",
    "aeros.campaign.yes": "Sim",
    "aeros.campaign.no": "Não",
    "aeros.campaign.ticketStatus": "Status do ticket",
    "aeros.campaign.ticketPending": "Pendente",
    "aeros.campaign.ticketOpen": "Aberto",
    "aeros.campaign.ticketClosed": "Fechado",
    "aeros.campaign.agent": "Atendente",
    "aeros.campaign.queue": "Fila",
    "aeros.campaign.messages": "Mensagens",
    "aeros.campaign.messagesHint": "· enviadas em rodízio para evitar bloqueio",
    "aeros.campaign.messagePlaceholder": "Escreva a mensagem… use {nome} para personalizar",
    "aeros.campaign.smsMessage": "Mensagem SMS",
    "aeros.campaign.attachment": "Anexo",
    "aeros.campaign.attachHint": "enviado antes do texto",
    "aeros.campaign.attach": "Anexar imagem ou arquivo",
    "aeros.campaign.removeAttachment": "Remover anexo",
    "aeros.campaign.confirmMessages": "Mensagens de confirmação",
    "aeros.campaign.confirmHint": "· resposta ao contato que confirmar",
    "aeros.campaign.preview": "Pré-visualização",
    "aeros.campaign.previewName": "Contato",
    "aeros.campaign.previewEmpty": "A mensagem aparece aqui como o contato vai receber.",
    "aeros.campaign.greetingMorning": "Bom dia",
    "aeros.campaign.greetingAfternoon": "Boa tarde",
    "aeros.campaign.greetingEvening": "Boa noite",
    "aeros.campaign.estimate": "{{contacts}} contatos · intervalo {{min}}–{{max}}s · ≈ {{time}} de envio",
    "aeros.campaign.estimateDays": "{{contacts}} contatos · {{perDay}} · ≈ {{days}} dias, termina {{end}}",
    "aeros.campaign.estimateNoDays": "Nenhum dia de envio marcado nas configurações — a campanha não vai disparar",
    "aeros.campaign.perDay": "{{n}} por dia",
    "aeros.campaign.withinWindow": "dentro da janela de envio",
    "aeros.campaign.at": "às",
    "aeros.campaign.cancel": "Cancelar",
    "aeros.campaign.close": "Fechar",
    "aeros.campaign.testMyNumber": "Testar no meu número",
    "aeros.campaign.testSent": "Mensagem de teste enviada para {{number}}.",
    "aeros.campaign.testNoNumber": "Seu usuário não tem WhatsApp cadastrado. Informe um número:",
    "aeros.campaign.testPrompt": "Número para o teste (com DDI e DDD)",
    "aeros.campaign.saveSchedule": "Salvar e agendar",
    "aeros.campaign.saveChanges": "Salvar alterações",
    "aeros.campaign.restart": "Reiniciar",
    "aeros.campaign.pause": "Pausar",
    "aeros.campaign.duplicate.action": "Duplicar campanha",
    "aeros.campaign.duplicate.copyName": "Cópia de {{name}}",
    "aeros.campaign.duplicate.success": "Campanha duplicada. Revise os campos e salve.",
    "aeros.campaign.resume": "Retomar",
    "aeros.campaign.export": "Exportar XLSX",
    "aeros.campaign.campaigns": "Campanhas",
    "aeros.campaign.status.inactive": "Inativa",
    "aeros.campaign.status.scheduled": "Programada",
    "aeros.campaign.status.running": "Em andamento",
    "aeros.campaign.status.cancelled": "Cancelada",
    "aeros.campaign.status.finished": "Finalizada",
    "aeros.campaign.progress": "Progresso do envio",
    "aeros.campaign.startedAt": "iniciado {{date}}",
    "aeros.campaign.eta": "previsão de término {{date}}",
    "aeros.campaign.of": "de",
    "aeros.campaign.delivered": "Entregues",
    "aeros.campaign.failed": "Falhas",
    "aeros.campaign.awaiting": "Aguardando",
    "aeros.campaign.queued": "Na fila",
    "aeros.campaign.pending": "Pendentes",
    "aeros.campaign.deliveryStatus": "Status de entrega",
    "aeros.campaign.deliveredPct": "entregues",
    "aeros.campaign.kpi.sent": "Enviadas",
    "aeros.campaign.kpi.sentSub": "de {{total}} na lista",
    "aeros.campaign.kpi.unique": "Destinatários únicos",
    "aeros.campaign.kpi.uniqueSub": "{{dup}} números duplicados",
    "aeros.campaign.kpi.delivered": "Entregues",
    "aeros.campaign.kpi.deliveredSub": "{{pct}}% das enviadas",
    "aeros.campaign.kpi.replied": "Responderam",
    "aeros.campaign.kpi.repliedSub": "{{pct}}% · {{confirmed}} confirmaram",
    "aeros.campaign.detail.connection": "Conexão",
    "aeros.campaign.detail.list": "Lista de contatos",
    "aeros.campaign.detail.tag": "Tag",
    "aeros.campaign.detail.schedule": "Agendamento",
    "aeros.campaign.detail.conclusion": "Conclusão",
    "aeros.campaign.detail.expected": "Prevista {{date}}",
    "aeros.campaign.detail.notFinished": "Ainda em andamento",
    "aeros.campaign.table.title": "Detalhes das mensagens",
    "aeros.campaign.table.all": "Todas",
    "aeros.campaign.table.search": "Buscar número…",
    "aeros.campaign.table.id": "ID",
    "aeros.campaign.table.recipient": "Destinatário",
    "aeros.campaign.table.message": "Mensagem",
    "aeros.campaign.table.sentAt": "Enviado em",
    "aeros.campaign.table.deliveredAt": "Entregue em",
    "aeros.campaign.table.status": "Status",
    "aeros.campaign.table.reason": "Motivo da falha",
    "aeros.campaign.table.empty": "Nenhum envio registrado ainda.",
    "aeros.campaign.table.range": "{{from}}–{{to}} de {{total}}",
    "aeros.campaign.shipping.delivered": "Entregue",
    "aeros.campaign.shipping.pending": "Pendente",
    "aeros.campaign.shipping.failed": "Falha",
    "aeros.campaign.shipping.queued": "Na fila",
    "aeros.campaign.exportOk": "Relatório gerado com {{count}} registros.",
    "aeros.campaign.exportEmpty": "Nenhum dado para exportar.",
    "aeros.campaign.exportError": "Erro ao gerar o relatório.",
    "aeros.campaign.confirmCancel.title": "Cancelar campanha em andamento?",
    "aeros.campaign.confirmCancel.text": "“{{name}}” já entregou {{delivered}} de {{total}} mensagens. As {{remaining}} restantes não serão enviadas. Você pode reiniciar depois pela lista.",
    "aeros.campaign.confirmCancel.keep": "Continuar enviando",
    "aeros.campaign.confirmCancel.confirm": "Cancelar campanha",
    "aeros.campaign.cancelScheduled": "Cancelar agendamento",
    "aeros.campaign.confirmCancel.titleScheduled": "Cancelar campanha agendada?",
    "aeros.campaign.confirmCancel.textScheduled": "“{{name}}” ainda não começou. Nenhuma mensagem será enviada. Para reagendar, edite a data e clique em Reiniciar.",
    "aeros.campaign.confirmCancel.keepScheduled": "Manter agendada",
    "aeros.campaign.stopRecurrence.title": "Interromper recorrência?",
    "aeros.campaign.stopRecurrence.textScheduled": "A campanha não terá execuções futuras e ficará como finalizada.",
    "aeros.campaign.stopRecurrence.textRunning": "A execução em andamento será cancelada agora e não haverá execuções futuras.",
    "aeros.campaign.stopRecurrence.confirm": "Interromper recorrência",
    "aeros.campaign.stopRecurrence.keep": "Manter recorrência",
    "aeros.campaign.stopRecurrence.action": "Interromper recorrência",
    "aeros.campaign.stopRecurrence.toast": "Recorrência interrompida.",
    "aeros.campaign.confirmDelete.title": "Excluir “{{name}}”?",
    "aeros.campaign.confirmDelete.text": "A campanha, suas {{executions}} execuções e o relatório de {{shipping}} envios serão apagados. Esta ação não pode ser desfeita.",
    "aeros.campaign.confirmDelete.textSimple": "A campanha e seu relatório serão apagados. Esta ação não pode ser desfeita.",
    "aeros.campaign.confirmDelete.confirm": "Excluir",
    "aeros.campaign.config.title": "Configurações de campanhas",
    "aeros.campaign.config.subtitle": "Intervalos e janela de envio · valem para todas as campanhas",
    "aeros.campaign.config.intervals": "Intervalos entre disparos",
    "aeros.campaign.config.risk": "Risco de bloqueio: {{level}}",
    "aeros.campaign.config.riskLow": "baixo",
    "aeros.campaign.config.riskMedium": "médio",
    "aeros.campaign.config.riskHigh": "alto",
    "aeros.campaign.config.random": "Intervalo randômico",
    "aeros.campaign.config.randomHint": "Espera aleatória até este valor entre cada mensagem.",
    "aeros.campaign.config.after": "Intervalo maior após",
    "aeros.campaign.config.afterHint": "A cada N mensagens, aplica a pausa longa abaixo.",
    "aeros.campaign.config.long": "Pausa longa",
    "aeros.campaign.config.longHint": "Reduz o risco de banimento em listas grandes.",
    "aeros.campaign.config.seconds": "{{n}} segundos",
    "aeros.campaign.config.messagesN": "{{n}} mensagens",
    "aeros.campaign.config.insight": "Com estes valores, 1.000 mensagens levam",
    "aeros.campaign.config.window": "Janela de envio",
    "aeros.campaign.config.windowHint": "· fora dela, a campanha espera e retoma sozinha; com limite, espalha as mensagens pelo dia",
    "aeros.campaign.config.start": "Início",
    "aeros.campaign.config.end": "Fim",
    "aeros.campaign.config.days": "Dias",
    "aeros.campaign.config.dailyLimit": "Mensagens por dia",
    "aeros.campaign.config.dailyLimitPlaceholder": "Sem limite",
    "aeros.campaign.config.dailyLimitOff": "Sem limite diário: a campanha usa os intervalos acima dentro da janela.",
    "aeros.campaign.config.dailyLimitSpread": "Até {{n}} por dia entre {{start}} e {{end}}: 1 mensagem a cada ≈ {{gap}}. Os intervalos acima não se aplicam.",
    "aeros.campaign.config.dailyLimitFloor": "O intervalo mínimo de {{min}}s prevalece: cabem {{fit}} mensagens por dia nessa janela.",
    "aeros.campaign.config.dailyLimitNoDays": "Nenhum dia marcado: as campanhas não vão disparar.",
    "aeros.campaign.config.dailyLimitNote": "Mudanças valem para campanhas iniciadas a partir de agora.",
    "aeros.campaign.config.channelWhatsapp": "WhatsApp",
    "aeros.campaign.config.channelSms": "SMS",
    "aeros.campaign.config.dailyLimitChannelAria": "Mensagens por dia no {{channel}}",
    "aeros.campaign.config.variables": "Variáveis personalizadas",
    "aeros.campaign.config.variablesHint": "Use {chave} nas mensagens; o valor é substituído no envio.",
    "aeros.campaign.config.key": "Chave",
    "aeros.campaign.config.value": "Valor",
    "aeros.campaign.config.add": "Adicionar",
    "aeros.campaign.config.save": "Salvar",
    // ---- Modal de campanha: template oficial (TemplateFields) ----
    "aeros.campaign.template.select": "Template aprovado",
    "aeros.campaign.template.mediaBadge": "mídia no cabeçalho",
    "aeros.campaign.template.mediaUrlLabel": "URL da mídia ({{tipo}})",
    "aeros.campaign.template.mediaUrlHelp": "URL pública http(s) da imagem, vídeo ou documento. A Meta baixa o arquivo desse link na hora do envio, uma vez por contato.",
    "aeros.campaign.template.mediaUrlRequired": "Este template tem mídia no cabeçalho: informe a URL pública do arquivo.",
    "aeros.campaign.template.mediaUrlInvalid": "A URL da mídia precisa começar com http:// ou https://.",
    "aeros.campaign.template.omitted": "{{count}} template(s) aprovado(s) não aparece(m) aqui: botão com URL variável não é suportado em campanha.",
    "aeros.campaign.template.emptyNoneUsable": "Esta conexão tem {{count}} template(s) aprovado(s), mas nenhum pode ser usado em campanha: todos têm botão com URL variável, que a campanha não preenche. Crie na Meta um template sem esse botão.",
    "aeros.campaign.template.emptySync": "Nenhum template aprovado foi encontrado nesta conexão. Sincronize os templates na tela de Conexões antes de criar a campanha.",
    "aeros.campaign.template.mixedFormats": "Este template mistura variáveis numeradas ({{numerada}}) com nomeadas ({{nomeada}}) no mesmo corpo. A Meta não aceita os dois formatos juntos — ajuste o template na Meta e sincronize novamente na tela de Conexões.",
    "aeros.campaign.template.paramLabel": "Valor de {{token}}",
    "aeros.campaign.template.paramHelp": "Texto fixo ou {nome}, {numero}, {email} — o nome vem da coluna da lista de contatos",
    "aeros.campaign.template.preview": "Prévia: {{texto}}",
    "aeros.campaign.template.uploadButton": "Enviar arquivo",
    "aeros.campaign.template.uploading": "Enviando…",
    "aeros.campaign.template.uploadHint.IMAGE": "JPG ou PNG até 5 MB. O arquivo fica público no servidor e a URL é preenchida acima.",
    "aeros.campaign.template.uploadHint.VIDEO": "MP4 até 16 MB. O arquivo fica público no servidor e a URL é preenchida acima.",
    "aeros.campaign.template.uploadHint.DOCUMENT": "PDF até 100 MB. O arquivo fica público no servidor e a URL é preenchida acima.",
    "aeros.campaign.template.uploadSuccess": "Arquivo enviado. A URL foi preenchida.",
    "aeros.flow.title": "Flowbuilder",
    "aeros.flow.tabs.flows": "Fluxos",
    "aeros.flow.tabs.phrases": "Frases gatilho",
    "aeros.flow.tabs.defaults": "Fluxo padrão",
    "aeros.flow.cancel": "Cancelar",
    "aeros.flow.save": "Salvar",
    "aeros.flow.create": "Criar",
    "aeros.flow.add": "Adicionar",
    "aeros.flow.edit": "Editar",
    "aeros.flow.delete": "Excluir",
    "aeros.flow.list.search": "Buscar fluxos…",
    "aeros.flow.list.new": "Novo fluxo",
    "aeros.flow.list.active": "Ativo",
    "aeros.flow.list.inactive": "Inativo",
    "aeros.flow.list.steps": "{{count}} etapa",
    "aeros.flow.list.steps_plural": "{{count}} etapas",
    "aeros.flow.list.empty": "Nenhum fluxo criado ainda",
    "aeros.flow.list.emptyHint": "Crie seu primeiro fluxo de conversa para automatizar atendimentos",
    "aeros.flow.list.emptySearch": "Nenhum fluxo encontrado",
    "aeros.flow.list.emptySearchHint": "Tente usar outros termos de pesquisa",
    "aeros.flow.list.createFirst": "Criar primeiro fluxo",
    "aeros.flow.list.editAria": "Renomear fluxo",
    "aeros.flow.list.duplicateAria": "Duplicar fluxo",
    "aeros.flow.list.deleteAria": "Excluir fluxo",
    "aeros.flow.list.duplicateTitle": "Duplicar “{{name}}”?",
    "aeros.flow.list.duplicateText": "Uma cópia do fluxo será criada para você editar.",
    "aeros.flow.list.duplicateConfirm": "Duplicar",
    "aeros.flow.list.duplicated": "Fluxo duplicado com sucesso",
    "aeros.flow.list.deleted": "Fluxo excluído com sucesso",
    "aeros.flow.delete.title": "Excluir “{{name}}”?",
    "aeros.flow.delete.usedBy": "Este fluxo é usado por {{count}} frase gatilho. Ela deixará de responder.",
    "aeros.flow.delete.usedBy_plural": "Este fluxo é usado por {{count}} frases gatilho. Elas deixarão de responder.",
    "aeros.flow.delete.irreversible": "Esta ação não pode ser desfeita.",
    "aeros.flow.delete.confirm": "Excluir fluxo",
    "aeros.flow.newFlow.title": "Novo fluxo",
    "aeros.flow.newFlow.editTitle": "Renomear fluxo",
    "aeros.flow.newFlow.name": "Nome",
    "aeros.flow.newFlow.namePlaceholder": "Ex.: Pesquisa de satisfação pós-venda",
    "aeros.flow.newFlow.startFrom": "Começar a partir de",
    "aeros.flow.newFlow.createOpen": "Criar e abrir editor",
    "aeros.flow.newFlow.nameRequired": "Digite um nome para o fluxo",
    "aeros.flow.newFlow.exists": "Já existe um fluxo com esse nome",
    "aeros.flow.newFlow.created": "Fluxo criado",
    "aeros.flow.newFlow.renamed": "Fluxo renomeado",
    "aeros.flow.templates.blank": "Em branco",
    "aeros.flow.templates.blankSub": "Só o nó de início",
    "aeros.flow.templates.welcome": "Boas-vindas",
    "aeros.flow.templates.welcomeSub": "Saudação + menu",
    "aeros.flow.templates.triage": "Triagem por fila",
    "aeros.flow.templates.triageSub": "Menu → filas",
    "aeros.flow.templates.nps": "Pesquisa NPS",
    "aeros.flow.templates.npsSub": "Nota + comentário",
    "aeros.flow.templates.welcomeMessage": "Olá, {nome}! 👋 Bem-vindo. Sou o assistente virtual.",
    "aeros.flow.templates.menuMessage": "Como posso ajudar hoje? Digite o número da opção:",
    "aeros.flow.templates.menuOption1": "Suporte técnico",
    "aeros.flow.templates.menuOption2": "Comercial / planos",
    "aeros.flow.templates.menuOption3": "Financeiro",
    "aeros.flow.templates.npsQuestion": "De 0 a 10, quanto você recomendaria nosso atendimento?",
    "aeros.flow.templates.npsComment": "Quer deixar um comentário? (opcional)",
    "aeros.flow.templates.npsThanks": "Obrigado pela sua resposta! 💜",
    "aeros.flow.phrases.search": "Buscar frase ou fluxo…",
    "aeros.flow.phrases.new": "Nova frase gatilho",
    "aeros.flow.phrases.info": "Quando um contato envia uma mensagem que combina com uma frase, o fluxo escolhido dispara na conexão.",
    "aeros.flow.phrases.infoExact": "exige a mensagem idêntica;",
    "aeros.flow.phrases.infoPartial": "aceita a frase em qualquer parte do texto.",
    "aeros.flow.phrases.col.name": "Nome",
    "aeros.flow.phrases.col.phrases": "Frases",
    "aeros.flow.phrases.col.flow": "Fluxo",
    "aeros.flow.phrases.col.connections": "Conexões",
    "aeros.flow.phrases.col.hits": "Disparos 7d",
    "aeros.flow.phrases.col.status": "Status",
    "aeros.flow.phrases.col.actions": "Ações",
    "aeros.flow.phrases.count": "{{count}} frase",
    "aeros.flow.phrases.count_plural": "{{count}} frases",
    "aeros.flow.phrases.exact": "Exata",
    "aeros.flow.phrases.partial": "Parcial",
    "aeros.flow.phrases.exactShort": "EX",
    "aeros.flow.phrases.partialShort": "PA",
    "aeros.flow.phrases.active": "Ativa",
    "aeros.flow.phrases.inactive": "Inativa",
    "aeros.flow.phrases.noConnection": "Nenhuma conexão",
    "aeros.flow.phrases.noFlow": "Fluxo removido",
    "aeros.flow.phrases.hitsUnavailable": "Contagem de disparos ainda não disponível",
    "aeros.flow.phrases.empty": "Nenhuma frase gatilho ainda",
    "aeros.flow.phrases.emptyHint": "Crie uma frase para disparar um fluxo quando o contato escrever.",
    "aeros.flow.phrases.emptySearch": "Nenhuma frase encontrada",
    "aeros.flow.phrases.deleted": "Frase gatilho excluída",
    "aeros.flow.phrases.deleteTitle": "Excluir “{{name}}”?",
    "aeros.flow.phrases.deleteText": "O fluxo deixa de disparar por essas frases. Esta ação não pode ser desfeita.",
    "aeros.flow.phrases.deleteConfirm": "Excluir frase",
    "aeros.flow.phraseModal.title": "Nova frase gatilho",
    "aeros.flow.phraseModal.editTitle": "Editar frase gatilho",
    "aeros.flow.phraseModal.subtitle": "Dispara um fluxo quando a mensagem combina",
    "aeros.flow.phraseModal.name": "Nome",
    "aeros.flow.phraseModal.namePlaceholder": "Ex.: Menu principal por palavra-chave",
    "aeros.flow.phraseModal.flow": "Fluxo",
    "aeros.flow.phraseModal.flowPlaceholder": "Escolha um fluxo",
    "aeros.flow.phraseModal.connections": "Conexões",
    "aeros.flow.phraseModal.connectionsPlaceholder": "Escolha as conexões",
    "aeros.flow.phraseModal.phrases": "Frases que disparam",
    "aeros.flow.phraseModal.addPhrase": "Adicionar frase",
    "aeros.flow.phraseModal.phrasePlaceholder": "Digite a frase ou palavra-chave",
    "aeros.flow.phraseModal.removePhrase": "Remover frase",
    "aeros.flow.phraseModal.hint": "Sem distinção de maiúsculas e acentos.",
    "aeros.flow.phraseModal.conflictA": "“{{text}}” já dispara",
    "aeros.flow.phraseModal.conflictB": "em {{connection}}. A frase mais recente tem prioridade.",
    "aeros.flow.phraseModal.required": "Preencha nome, fluxo, conexões e ao menos uma frase.",
    "aeros.flow.phraseModal.created": "Frase gatilho criada",
    "aeros.flow.phraseModal.updated": "Frase gatilho atualizada",
    "aeros.flow.phraseModal.saveError": "Erro ao salvar a frase gatilho",
    "aeros.flow.phraseModal.loadError": "Erro ao carregar a frase gatilho",
    "aeros.flow.defaults.title": "Fluxo padrão",
    "aeros.flow.defaults.subtitle": "Gatilhos automáticos da empresa",
    "aeros.flow.defaults.welcome": "Fluxo de boas-vindas",
    "aeros.flow.defaults.welcomeDesc": "Disparado só para novos contatos, que ainda não estão na sua lista.",
    "aeros.flow.defaults.reply": "Fluxo de resposta padrão",
    "aeros.flow.defaults.replyDesc": "Enviado a qualquer mensagem sem palavra-chave, se o atendimento estiver fechado há mais de 6h.",
    "aeros.flow.defaults.inactive": "Fluxo de inatividade",
    "aeros.flow.defaults.inactiveDesc": "Disparado quando o contato para de responder dentro de um fluxo.",
    "aeros.flow.defaults.none": "Nenhum fluxo",
    "aeros.flow.defaults.saved": "Fluxos padrões atualizados",
    "aeros.flow.editor.back": "Fluxos",
    "aeros.flow.editor.rename": "Renomear fluxo",
    "aeros.flow.editor.undo": "Desfazer",
    "aeros.flow.editor.redo": "Refazer",
    "aeros.flow.editor.test": "Testar fluxo",
    "aeros.flow.editor.versions": "Versões",
    "aeros.flow.editor.soon": "Em breve",
    "aeros.flow.editor.save": "Salvar fluxo",
    "aeros.flow.editor.saved": "Fluxo salvo com sucesso",
    "aeros.flow.editor.saveError": "Erro ao salvar o fluxo",
    "aeros.flow.editor.searchBlock": "Buscar bloco…",
    "aeros.flow.editor.addBlocks": "Adicionar blocos",
    "aeros.flow.editor.zoomIn": "Aproximar",
    "aeros.flow.editor.zoomOut": "Afastar",
    "aeros.flow.editor.fit": "Ajustar à tela",
    "aeros.flow.editor.unsaved": "Alterações não salvas",
    "aeros.flow.saved.never": "Nunca salvo",
    "aeros.flow.saved.now": "Salvo agora",
    "aeros.flow.saved.minutes": "Salvo há {{count}} min",
    "aeros.flow.saved.hours": "Salvo há {{count}} h",
    "aeros.flow.saved.days": "Salvo há {{count}} d",
    "aeros.flow.palette.messages": "Mensagens",
    "aeros.flow.palette.logic": "Lógica",
    "aeros.flow.palette.actions": "Ações",
    "aeros.flow.palette.ai": "IA",
    "aeros.flow.nodes.start": "Início",
    "aeros.flow.nodes.text": "Texto",
    "aeros.flow.nodes.menu": "Menu",
    "aeros.flow.nodes.content": "Conteúdo",
    "aeros.flow.nodes.image": "Imagem",
    "aeros.flow.nodes.audio": "Áudio",
    "aeros.flow.nodes.video": "Vídeo",
    "aeros.flow.nodes.condition": "Condição",
    "aeros.flow.nodes.randomizer": "Randomizador",
    "aeros.flow.nodes.interval": "Intervalo",
    "aeros.flow.nodes.input": "Entrada",
    "aeros.flow.nodes.variable": "Variável",
    "aeros.flow.nodes.switchFlow": "Trocar fluxo",
    "aeros.flow.nodes.ticket": "Ticket / Fila",
    "aeros.flow.nodes.attendant": "Atendente",
    "aeros.flow.nodes.tag": "Adicionar tag",
    "aeros.flow.nodes.removeTag": "Remover tag",
    "aeros.flow.nodes.http": "Requisição HTTP",
    "aeros.flow.nodes.openai": "OpenAI",
    "aeros.flow.nodes.gemini": "Gemini",
    "aeros.flow.nodes.unknown": "Bloco",
    "aeros.flow.node.actions": "Ações do bloco",
    "aeros.flow.node.duplicate": "Duplicar",
    "aeros.flow.node.delete": "Excluir",
    "aeros.flow.summary.start": "Gatilho do fluxo",
    "aeros.flow.summary.items": "{{count}} item",
    "aeros.flow.summary.items_plural": "{{count}} itens",
    "aeros.flow.summary.recorded": "gravado na hora",
    "aeros.flow.summary.interval": "Aguardar {{sec}} segundos",
    "aeros.flow.problems.count": "{{count}} problema",
    "aeros.flow.problems.count_plural": "{{count}} problemas",
    "aeros.flow.problems.goTo": "Ir para o nó",
    "aeros.flow.problems.noStart": "Fluxo sem nó de início",
    "aeros.flow.problems.unreachable": "{{node}} sem conexão de entrada",
    "aeros.flow.problems.dangling": "{{node}} sem saída conectada",
    "aeros.flow.problems.danglingLabel": "{{node}} sem saída “{{label}}”",
    "aeros.flow.panel.empty": "Selecione um bloco no canvas para ver as propriedades.",
    "aeros.flow.panel.nodeId": "nó #{{id}}",
    "aeros.flow.panel.options": "{{count}} opção",
    "aeros.flow.panel.options_plural": "{{count}} opções",
    "aeros.flow.panel.type": "Tipo",
    "aeros.flow.panel.summary": "Conteúdo",
    "aeros.flow.panel.editBlock": "Editar bloco",
    "aeros.flow.panel.noEditor": "Este bloco é editado direto no canvas.",
    "aeros.flow.panel.outputs": "Saídas",
    "aeros.flow.panel.connected": "conectada",
    "aeros.flow.panel.notConnected": "sem conexão",
    "aeros.flow.condition.title": "Condição",
    "aeros.flow.condition.addTitle": "Adicionar condição",
    "aeros.flow.condition.variable": "Variável",
    "aeros.flow.condition.variablePlaceholder": "{variavel}",
    "aeros.flow.condition.rule": "Regra",
    "aeros.flow.condition.value": "Valor",
    "aeros.flow.condition.valuePlaceholder": "Valor comparado",
    "aeros.flow.condition.true": "Verdadeiro",
    "aeros.flow.condition.false": "Falso",
    "aeros.flow.condition.noConnection": "sem conexão",
    "aeros.flow.condition.required": "Informe a variável a comparar",
    "aeros.flow.condition.ops.contains": "contém",
    "aeros.flow.condition.ops.startsWith": "começa com",
    "aeros.flow.condition.ops.endsWith": "termina com",
    "aeros.flow.condition.ops.isEmpty": "vazio",
    "aeros.flow.condition.ops.isNotEmpty": "não vazio",
    "aeros.flow.content.title": "Bloco de conteúdo",
    "aeros.flow.content.editTitle": "Editar bloco de conteúdo",
    "aeros.flow.content.subtitle": "Sequência de mensagens enviada de uma vez",
    "aeros.flow.content.addSection": "Adicionar",
    "aeros.flow.content.text": "Texto",
    "aeros.flow.content.image": "Imagem",
    "aeros.flow.content.audio": "Áudio",
    "aeros.flow.content.video": "Vídeo",
    "aeros.flow.content.document": "Documento",
    "aeros.flow.content.interval": "Intervalo",
    "aeros.flow.content.dropzone": "Clique em um tipo à esquerda para adicionar",
    "aeros.flow.content.footer": "{{count}} itens · ≈ {{sec}} s de envio",
    "aeros.flow.content.uploading": "Subindo os arquivos e criando o conteúdo…",
    "aeros.flow.content.remove": "Remover item",
    "aeros.flow.content.chooseFile": "Escolher arquivo",
    "aeros.flow.content.seconds": "segundos",
    "aeros.flow.content.recordedNow": "Enviar como gravado na hora",
    "aeros.flow.content.textPlaceholder": "Digite a mensagem…",
    "aeros.flow.content.variables": "Variáveis disponíveis",
    "aeros.flow.nodes.tagNotSelected": "Tag não selecionada",
    "aeros.flow.input.question": "Pergunta",
    "aeros.flow.input.noQuestion": "Pergunta não definida",
    "aeros.flow.input.variable": "Variável para armazenar a resposta",
    "aeros.flow.input.noVariable": "Variável não definida",
    "aeros.flow.input.value": "Valor: {{value}}",
    "aeros.flow.input.usingVariables": "Usando variáveis: {{names}}",
    "aeros.flow.variable.name": "Nome da variável",
    "aeros.flow.variable.value": "Valor",
    "aeros.flow.variable.valueHint": "Você pode usar valores fixos ou referências como ${outraVariavel}",
    "aeros.flow.variable.saveButton": "Salvar variável",
    "aeros.flow.variable.saved": "Salvo!",
    "aeros.flow.variable.savedToast": "Variável salva com sucesso!",
    "aeros.flow.http.presets": "Webhooks pré-configurados",
    "aeros.flow.http.presetPlaceholder": "Escolha uma configuração pronta…",
    "aeros.flow.http.presetSystem": "SISTEMA",
    "aeros.flow.http.usingPreset": "Usando preset: {{name}}",
    "aeros.flow.http.removePreset": "Remover",
    "aeros.flow.http.presetError": "Erro ao aplicar a configuração do preset",
    "aeros.flow.http.url": "URL",
    "aeros.flow.http.urlPreset": "URL (do preset)",
    "aeros.flow.http.urlPresetHint": "Você pode editar a URL base do preset se necessário",
    "aeros.flow.http.method": "Método",
    "aeros.flow.http.test": "Testar requisição",
    "aeros.flow.http.requestError": "Erro na requisição",
    "aeros.flow.http.response": "Resposta da API",
    "aeros.flow.http.fullResponse": "Ver resposta completa",
    "aeros.flow.http.fullResponseTitle": "Resposta completa da API",
    "aeros.flow.http.showAdvanced": "Mostrar avançado",
    "aeros.flow.http.hideAdvanced": "Ocultar avançado",
    "aeros.flow.http.advancedWarning": "Configurações avançadas podem sobrescrever as configurações do preset",
    "aeros.flow.http.timeout": "Timeout (ms)",
    "aeros.flow.http.queryParams": "Parâmetros de query",
    "aeros.flow.http.key": "Chave",
    "aeros.flow.http.value": "Valor",
    "aeros.flow.http.addParam": "Adicionar parâmetro",
    "aeros.flow.http.headers": "Cabeçalhos (JSON)",
    "aeros.flow.http.body": "Corpo da requisição (JSON)",
    "aeros.flow.http.editBody": "Editar corpo da requisição",
    "aeros.flow.http.close": "Fechar",
    "aeros.flow.http.mapShow": "Mapear variáveis da resposta",
    "aeros.flow.http.mapHide": "Ocultar variáveis da resposta",
    "aeros.flow.http.mapTitle": "Mapear dados da resposta para variáveis",
    "aeros.flow.http.pathPlaceholder": "Caminho, ex: data.user.id",
    "aeros.flow.http.variablePlaceholder": "Nome da variável, ex: userId",
    "aeros.flow.http.addVariable": "Adicionar variável",
    "aeros.flow.http.tips": "Dicas úteis",
    "aeros.flow.http.tipResponse": "A resposta completa da API é salva automaticamente na variável global apiResponse",
    "aeros.flow.http.tipVariables": "Use ${nomeDaVariavel} na URL e no corpo da requisição para incluir valores de variáveis",
    "aeros.flow.modals.text.addTitle": "Adicionar mensagem",
    "aeros.flow.modals.text.editTitle": "Editar mensagem",
    "aeros.flow.modals.text.message": "Mensagem",
    "aeros.flow.modals.interval.addTitle": "Adicionar intervalo",
    "aeros.flow.modals.interval.editTitle": "Editar intervalo",
    "aeros.flow.modals.interval.seconds": "Tempo em segundos",
    "aeros.flow.modals.interval.hint": "Pausa antes do próximo bloco. Máximo de 120 segundos.",
    "aeros.flow.modals.interval.errorEmpty": "Informe o valor do intervalo",
    "aeros.flow.modals.interval.errorMax": "Máximo de 120 segundos",
    "aeros.flow.modals.menu.addTitle": "Adicionar menu",
    "aeros.flow.modals.menu.editTitle": "Editar menu",
    "aeros.flow.modals.menu.type": "Tipo de menu",
    "aeros.flow.modals.menu.number": "Número",
    "aeros.flow.modals.menu.list": "Lista",
    "aeros.flow.modals.menu.button": "Botão",
    "aeros.flow.modals.menu.message": "Mensagem do menu",
    "aeros.flow.modals.menu.options": "Opções",
    "aeros.flow.modals.menu.optionPlaceholder": "Digite a opção",
    "aeros.flow.modals.menu.removeOption": "Remover opção",
    "aeros.flow.modals.image.addTitle": "Adicionar imagem",
    "aeros.flow.modals.image.editTitle": "Editar imagem",
    "aeros.flow.modals.image.dropHint": "PNG ou JPG até 2 MB",
    "aeros.flow.modals.image.tooLarge": "Arquivo muito grande! Máximo de 2 MB",
    "aeros.flow.modals.image.success": "Imagem adicionada com sucesso!",
    "aeros.flow.modals.audio.addTitle": "Adicionar áudio",
    "aeros.flow.modals.audio.editTitle": "Editar áudio",
    "aeros.flow.modals.audio.dropHint": "OGG ou MP3 até 5 MB",
    "aeros.flow.modals.audio.tooLarge": "Arquivo muito grande! Máximo de 5 MB",
    "aeros.flow.modals.audio.success": "Áudio adicionado com sucesso!",
    "aeros.flow.modals.audio.noHtml5": "Seu navegador não suporta áudio HTML5",
    "aeros.flow.modals.audio.recordedNowDesc": "O contato recebe como mensagem de voz gravada agora",
    "aeros.flow.modals.video.addTitle": "Adicionar vídeo",
    "aeros.flow.modals.video.editTitle": "Editar vídeo",
    "aeros.flow.modals.video.dropHint": "Apenas vídeos MP4 até 20 MB",
    "aeros.flow.modals.video.tooLarge": "Arquivo muito grande! Máximo de 20 MB",
    "aeros.flow.modals.video.success": "Vídeo adicionado com sucesso!",
    "aeros.flow.modals.video.noHtml5": "Seu navegador não suporta vídeo HTML5",
    "aeros.flow.modals.randomizer.addTitle": "Adicionar randomizador",
    "aeros.flow.modals.randomizer.editTitle": "Editar randomizador",
    "aeros.flow.modals.randomizer.label": "Percentual de cada saída",
    "aeros.flow.modals.randomizer.hint": "Saída A recebe {{a}}% dos contatos e saída B {{b}}%.",
    "aeros.flow.modals.randomizer.errorEmpty": "Informe um percentual maior que zero",
    "aeros.flow.modals.ticket.addTitle": "Adicionar fila",
    "aeros.flow.modals.ticket.editTitle": "Editar fila",
    "aeros.flow.modals.ticket.queue": "Fila de destino",
    "aeros.flow.modals.ticket.queuePlaceholder": "Selecione uma fila",
    "aeros.flow.modals.ticket.errorQueue": "Selecione uma fila",
    "aeros.flow.modals.tag.addTitle": "Adicionar tag",
    "aeros.flow.modals.tag.editTitle": "Editar tag",
    "aeros.flow.modals.tag.tag": "Tag",
    "aeros.flow.modals.tag.placeholder": "Selecione uma tag",
    "aeros.flow.modals.tag.none": "Nenhuma tag selecionada",
    "aeros.flow.modals.tag.error": "Selecione uma tag",
    "aeros.flow.modals.removeTag.addTitle": "Remover tag",
    "aeros.flow.modals.removeTag.editTitle": "Editar remoção de tag",
    "aeros.flow.modals.removeTag.tag": "Tag a remover",
    "aeros.flow.modals.removeTag.placeholder": "Selecione uma tag para remover",
    "aeros.flow.modals.removeTag.hint": "A tag selecionada será removida do contato quando o fluxo chegar neste bloco.",
    "aeros.flow.modals.removeTag.error": "Selecione uma tag para remover",
    "aeros.flow.modals.switchFlow.addTitle": "Adicionar troca de fluxo",
    "aeros.flow.modals.switchFlow.editTitle": "Editar troca de fluxo",
    "aeros.flow.modals.switchFlow.flow": "Fluxo de destino",
    "aeros.flow.modals.switchFlow.placeholder": "Escolha um fluxo",
    "aeros.flow.modals.switchFlow.hint": "A conversa sai deste fluxo e continua no fluxo escolhido.",
    "aeros.flow.modals.attendant.addTitle": "Adicionar atendente",
    "aeros.flow.modals.attendant.editTitle": "Editar atendente",
    "aeros.flow.modals.attendant.user": "Atendente",
    "aeros.flow.modals.attendant.placeholder": "Selecione um atendente",
    "aeros.flow.modals.attendant.error": "Selecione um atendente",
    "aeros.flow.modals.input.addTitle": "Adicionar entrada",
    "aeros.flow.modals.input.editTitle": "Editar entrada",
    "aeros.flow.modals.input.question": "Pergunta",
    "aeros.flow.modals.input.questionPlaceholder": "Ex.: Olá ${nome}, qual é a sua idade?",
    "aeros.flow.modals.input.questionHint": "Enviada ao contato. Clique numa variável para inserir no texto.",
    "aeros.flow.modals.input.variableName": "Nome da variável",
    "aeros.flow.modals.input.variablePlaceholder": "Ex.: idade_cliente",
    "aeros.flow.modals.input.variableHint": "Sem espaços ou caracteres especiais. A resposta do contato fica guardada aqui.",
    "aeros.flow.modals.input.howItWorks": "Como funciona",
    "aeros.flow.modals.input.howItWorksText": "Este bloco envia a pergunta e aguarda a resposta do contato. O valor é guardado na variável e o fluxo segue para o próximo bloco.",
    "aeros.flow.modals.trigger.loadError": "Erro ao carregar os fluxos disponíveis",
    "aeros.flow.modals.trigger.selectRequired": "Selecione um fluxo para disparar",
    "aeros.flow.modals.trigger.processing": "Disparando fluxo… O campo de mensagem fica desabilitado até terminar.",
    "aeros.flow.content.saved": "Conteúdo salvo com sucesso!",
    "aeros.flow.content.errors.emptyMessage": "Há um item de texto vazio.",
    "aeros.flow.content.errors.intervalRange": "O intervalo deve ser entre 1 e 120 segundos.",
    "aeros.flow.content.errors.fileTooLarge": "Arquivo muito grande! Máximo {{mb}} MB.",
    "aeros.flow.content.errors.emptyCards": "Remova os itens de mídia sem arquivo antes de salvar.",
    "aeros.flow.modals.openai.title": "Adicionar OpenAI",
    "aeros.flow.modals.openai.editTitle": "Editar OpenAI",
    "aeros.flow.modals.openai.subtitle": "Assistente de IA que conversa com o contato neste ponto do fluxo",
    "aeros.flow.modals.openai.basic": "Configurações básicas",
    "aeros.flow.modals.openai.name": "Nome do assistente",
    "aeros.flow.modals.openai.apiKey": "API Key OpenAI",
    "aeros.flow.modals.openai.model": "Modelo",
    "aeros.flow.modals.openai.prompt": "Prompt do sistema",
    "aeros.flow.modals.openai.promptPlaceholder": "Descreva como a IA deve se comportar, que informações deve coletar, como deve responder…",
    "aeros.flow.modals.openai.temperature": "Temperatura",
    "aeros.flow.modals.openai.temperatureHint": "0 = conservador, 2 = criativo",
    "aeros.flow.modals.openai.maxTokens": "Máx. tokens",
    "aeros.flow.modals.openai.maxTokensHint": "Tamanho máximo da resposta",
    "aeros.flow.modals.openai.maxMessages": "Máx. mensagens",
    "aeros.flow.modals.openai.maxMessagesHint": "Histórico de contexto",
    "aeros.flow.modals.openai.voiceSection": "Voz (opcional)",
    "aeros.flow.modals.openai.voice": "Tipo de resposta",
    "aeros.flow.modals.openai.voiceTextOnly": "Apenas texto",
    "aeros.flow.modals.openai.voiceKey": "Voice Key (Azure)",
    "aeros.flow.modals.openai.voiceKeyPlaceholder": "Chave do Azure Speech Service",
    "aeros.flow.modals.openai.voiceRegion": "Voice Region (Azure)",
    "aeros.flow.modals.openai.behavior": "Comportamento no fluxo",
    "aeros.flow.modals.openai.permanent": "Permanente — encerra o fluxo aqui",
    "aeros.flow.modals.openai.permanentDesc": "O contato conversa com a IA até pedir transferência ou encerrar",
    "aeros.flow.modals.openai.temporary": "Temporário — volta ao fluxo depois",
    "aeros.flow.modals.openai.temporaryDesc": "A IA executa uma tarefa específica e depois retorna ao fluxo",
    "aeros.flow.modals.openai.temporaryHint": "Configure quando a IA deve parar e retornar ao fluxo",
    "aeros.flow.modals.openai.maxInteractions": "Máximo de interações",
    "aeros.flow.modals.openai.maxInteractionsHint": "Mensagens antes de voltar ao fluxo (0 = ilimitado)",
    "aeros.flow.modals.openai.completionTimeout": "Timeout (minutos)",
    "aeros.flow.modals.openai.completionTimeoutHint": "Tempo limite antes de voltar ao fluxo (0 = sem limite)",
    "aeros.flow.modals.openai.keywords": "Palavras-chave para continuar o fluxo",
    "aeros.flow.modals.openai.keywordPlaceholder": "Digite uma palavra-chave",
    "aeros.flow.modals.openai.keywordsHint": "Quando o contato enviar uma dessas palavras, o fluxo continua automaticamente",
    "aeros.flow.modals.openai.objective": "Objetivo da IA",
    "aeros.flow.modals.openai.objectiveHint": "O que a IA deve completar (ex.: coletar nome, e-mail e telefone)",
    "aeros.flow.modals.openai.objectivePlaceholder": "Ex.: coletar dados do cliente, qualificar interesse, diagnosticar problema…",
    "aeros.flow.modals.openai.autoComplete": "Concluir ao atingir o objetivo",
    "aeros.flow.modals.openai.autoCompleteDesc": "A IA avalia se completou o objetivo e volta ao fluxo sozinha",
    "aeros.flow.modals.openai.queueId": "ID da fila (transferência)",
    "aeros.flow.modals.openai.queueIdHint": "Fila para onde transferir se o contato pedir atendente (0 = não transferir)",
    "aeros.flow.modals.openai.errors.tooShort": "Muito curto",
    "aeros.flow.modals.openai.errors.tooLong": "Muito longo",
    "aeros.flow.modals.openai.errors.required": "Obrigatório",
    "aeros.flow.modals.openai.errors.promptRequired": "Descreva o treinamento da IA",
    "aeros.flow.modals.openai.errors.invalidModel": "Modelo inválido",
    "aeros.flow.modals.openai.errors.modelRequired": "Informe o modelo",
    "aeros.flow.modals.openai.errors.minTokens": "Mínimo {{n}} tokens",
    "aeros.flow.modals.openai.errors.maxTokens": "Máximo {{n}} tokens",
    "aeros.flow.modals.openai.errors.min": "Mínimo {{n}}",
    "aeros.flow.modals.openai.errors.max": "Máximo {{n}}",
    "aeros.flow.modals.openai.errors.apiKeyRequired": "Informe a API Key",
    "aeros.flow.modals.openai.errors.voiceKeyRequired": "Voice Key é obrigatória para síntese de voz",
    "aeros.flow.modals.openai.errors.voiceRegionRequired": "Voice Region é obrigatória para síntese de voz",
    "aeros.flow.modals.openai.errors.keywordEmpty": "Palavra-chave não pode ficar vazia",
    "aeros.flow.modals.openai.errors.keywordsMin": "Informe pelo menos uma palavra-chave no modo temporário",
    "aeros.flow.modals.openai.errors.objectiveRequired": "Objetivo é obrigatório quando concluir automaticamente está ativo",
    "aeros.flow.modals.gemini.title": "Adicionar Gemini",
    "aeros.flow.modals.gemini.editTitle": "Editar Gemini",
    "aeros.flow.modals.gemini.subtitle": "Assistente Google Gemini que conversa com o contato neste ponto do fluxo",
    "aeros.flow.modals.gemini.basic": "Configurações básicas — Google Gemini",
    "aeros.flow.modals.gemini.apiKey": "API Key Google AI",
    "aeros.flow.modals.gemini.model": "Modelo Gemini",
    // ---- Campanhas: abas Listas e Arquivos (mockup derivado do design system) ----
    "contactLists.searchPlaceholder": "Buscar lista…",
    "contactLists.countOne": "{{count}} contato",
    "contactLists.countOther": "{{count}} contatos",
    "contactLists.dialog.subtitle": "Agrupa contatos para disparo em campanhas",
    "contactLists.dialog.addTitle": "Nova lista de contatos",
    "contactLists.dialog.editTitle": "Editar lista de contatos",
    "contactLists.actions.download": "Baixar contatos da lista",
    "contactLists.actions.contacts": "Ver contatos",
    "contactLists.actions.edit": "Editar lista",
    "contactLists.actions.delete": "Excluir lista",
    "contactLists.empty.title": "Nenhuma lista de contatos",
    "contactLists.empty.text": "Crie uma lista para escolher como destino de uma campanha.",
    "contactLists.empty.noResults": "Nenhuma lista encontrada para esta busca.",
    "contactListItems.table.status": "Status",
    "contactListItems.validity.valid": "Válido",
    "contactListItems.validity.invalid": "Inválido",
    "contactListItems.validity.unknown": "Não verificado",
    "contactListItems.validity.validHint": "Número com WhatsApp confirmado",
    "contactListItems.validity.invalidHint": "Número sem WhatsApp",
    "contactListItems.validity.unknownHint": "Não verificado: valida na hora com conexão QR Code, ou automaticamente após o primeiro disparo pelo canal oficial",
    "contactListItems.importing": "Importando…",
    "contactListItems.actions.edit": "Editar contato",
    "contactListItems.actions.delete": "Excluir contato",
    "contactListItems.downloadSample": "Clique aqui para baixar a planilha exemplo.",
    "contactListItems.modal.addTitle": "Novo contato",
    "contactListItems.modal.editTitle": "Editar contato",
    "contactListItems.modal.subtitle": "Entra na lista e recebe os disparos das campanhas dela",
    "contactListItems.notices.ignoredOne": "1 contato da planilha já existia na lista",
    "contactListItems.notices.ignoredOther": "{{count}} contatos da planilha já existiam na lista",
    "contactListItems.notices.invalidOne": "1 linha da planilha não foi importada",
    "contactListItems.notices.invalidOther": "{{count}} linhas da planilha não foram importadas",
    "contactListItems.notices.line": "Linha {{line}}",
    "contactListItems.notices.dismiss": "Dispensar aviso",
    "contactListItems.empty.title": "Lista sem contatos",
    "contactListItems.empty.text": "Importe uma planilha ou adicione contatos um a um.",
    "contactListItems.empty.noResults": "Nenhum contato encontrado para esta busca.",
    "files.searchPlaceholder": "Buscar lista de arquivos…",
    "files.countOne": "{{count}} arquivo",
    "files.countOther": "{{count}} arquivos",
    "files.actions.edit": "Editar lista de arquivos",
    "files.actions.delete": "Excluir lista de arquivos",
    "files.empty.title": "Nenhuma lista de arquivos",
    "files.empty.text": "Crie uma lista para anexar arquivos às mensagens das campanhas.",
    "files.empty.noResults": "Nenhuma lista encontrada para esta busca.",
    "fileModal.subtitle": "Arquivos enviados junto com a mensagem da campanha",
    "fileModal.form.emptyFiles": "Nenhum arquivo ainda. Use “Adicionar arquivo” para incluir o primeiro.",
    "fileModal.form.pickFile": "Escolher arquivo",
    "fileModal.form.removeFile": "Remover arquivo",
    "aeros.confirm.cancel": "Cancelar",
    "aeros.confirm.confirm": "Confirmar",
    "aeros.confirm.typedHint": "Digite {{word}} para confirmar",
    "contactLists.confirmDelete.title": "Excluir a lista “{{name}}”?",
    "contactLists.confirmDelete.text": "Os contatos da lista serão apagados junto. Campanhas que usam esta lista deixam de encontrar destinatários. Esta ação não pode ser desfeita.",
    "contactLists.confirmDelete.confirm": "Excluir lista",
    "contactListItems.confirmDelete.title": "Excluir “{{name}}” da lista?",
    "contactListItems.confirmDelete.text": "O contato sai desta lista e deixa de receber os disparos dela. Esta ação não pode ser desfeita.",
    "contactListItems.confirmDelete.confirm": "Excluir contato",
    "contactListItems.confirmImport.title": "Importar os contatos da planilha?",
    "contactListItems.confirmImport.text": "Os contatos da planilha entram nesta lista. Quem já estiver na lista é ignorado, e linhas com número inválido não são importadas.",
    "contactListItems.confirmImport.confirm": "Importar",
    "files.confirmDelete.title": "Excluir a lista de arquivos “{{name}}”?",
    "files.confirmDelete.text": "Os arquivos da lista serão apagados. Campanhas que usam esta lista passam a enviar só o texto. Esta ação não pode ser desfeita.",
    "files.confirmDelete.confirm": "Excluir lista",
    "contactListItems.toasts.noQrValidation": "Sem conexão QR Code, os números não foram validados agora. No canal oficial, a validação acontece automaticamente conforme a Meta confirma (ou rejeita) as entregas da primeira campanha.",
    "contactLists.dialog.nameRequired": "Informe um nome com pelo menos 2 caracteres",
    "contactLists.dialog.nameTooLong": "O nome deve ter no máximo 50 caracteres",
    "contactListItems.dialog.nameRequired": "Informe um nome com pelo menos 2 caracteres",
    "contactListItems.dialog.nameTooLong": "O nome deve ter no máximo 50 caracteres",
    "contactListItems.dialog.numberInvalid": "O número deve ter entre 8 e 50 caracteres",
    "contactListItems.dialog.emailInvalid": "E-mail inválido",
    "fileModal.form.nameRequired": "Informe um nome com pelo menos 3 caracteres",
    "fileModal.form.messageRequired": "Informe os detalhes da lista",
    // ---- Informativos, Login, Cadastro e Loading (mockup Aeros) ----
    "announcements.subtitle": "Avisos exibidos a todas as empresas no sino do painel",
    "announcements.superAdmin": "Super admin",
    "announcements.search": "Buscar informativo…",
    "announcements.priority.high": "Alta",
    "announcements.priority.medium": "Média",
    "announcements.priority.low": "Baixa",
    "announcements.filters.all": "Todos",
    "announcements.filters.active": "Ativos",
    "announcements.filters.inactive": "Inativos",
    "announcements.filters.high": "Alta prioridade",
    "announcements.filters.media": "Com anexo",
    "announcements.table.media": "Anexo",
    "announcements.table.published": "Publicado",
    "announcements.noMedia": "Sem anexo",
    "announcements.footNote": "Informativos ativos aparecem no sino de todos os usuários, ordenados por prioridade.",
    "announcements.actions.edit": "Editar informativo",
    "announcements.actions.delete": "Excluir informativo",
    "announcements.empty.title": "Nenhum informativo",
    "announcements.empty.text": "Crie um informativo para avisar todas as empresas pelo sino do painel.",
    "announcements.empty.noResults": "Nenhum informativo encontrado para este filtro.",
    "announcements.confirmDelete.title": "Excluir o informativo “{{name}}”?",
    "announcements.confirmDelete.text": "Ele sai imediatamente do sino de todas as empresas e a imagem anexada é apagada. Esta ação não pode ser desfeita.",
    "announcements.confirmDelete.confirm": "Excluir informativo",
    "announcements.dialog.subtitle": "Visível para todas as empresas enquanto estiver ativo",
    "announcements.dialog.charCount": "{{count}} caracteres",
    "announcements.dialog.image": "Imagem",
    "announcements.dialog.imageHint": "· PNG ou JPG",
    "announcements.dialog.imageChange": "Trocar",
    "announcements.dialog.imageRemove": "Remover imagem",
    "announcements.dialog.imagePick": "Escolher imagem",
    "announcements.dialog.lastEdit": "Última edição {{when}}",
    "announcements.dialog.save": "Salvar informativo",
    "announcements.dialog.previewTitle": "Como aparece no sino",
    "announcements.dialog.previewHint": "Prioridade Alta destaca o cartão em vermelho e o coloca no topo da lista.",
    "announcements.dialog.previewEmpty": "O título e o texto aparecem aqui conforme você escreve.",
    "announcements.dialog.titleRequired": "Informe o título",
    "announcements.dialog.textRequired": "Informe o texto do informativo",
    "announcements.bell.title": "Informativos",
    "announcements.when.now": "agora",
    "login.pageTitle": "Entrar",
    "login.pageSubtitle": "Use o e-mail cadastrado pela sua empresa.",
    "login.hero.eyebrow": "Central de atendimento",
    "login.hero.title": "Todo o atendimento da sua operação em um só lugar.",
    "login.hero.text": "WhatsApp, filas, campanhas, fluxos e agentes de IA trabalhando juntos, com visão em tempo real do que está acontecendo.",
    "login.hero.stat1Value": "1,2M",
    "login.hero.stat1Label": "mensagens/mês",
    "login.hero.stat2Value": "99,9%",
    "login.hero.stat2Label": "disponibilidade",
    "login.hero.stat3Value": "71%",
    "login.hero.stat3Label": "resolvidas pela IA",
    "login.forgotPassword": "Esqueci a senha",
    "login.rememberDevice": "Lembrar deste dispositivo por 30 dias",
    "login.noAccount": "Ainda não tem conta?",
    "login.createAccount": "Criar conta",
    "login.showPassword": "Mostrar senha",
    "login.hidePassword": "Ocultar senha",
    "login.toggleTheme": "Alternar tema",
    "login.twoFactor.title": "Verificação em duas etapas",
    "login.twoFactor.subtitle": "Digite o código de 6 dígitos do seu aplicativo autenticador.",
    "login.twoFactor.noApp": "Sem acesso ao aplicativo?",
    "login.twoFactor.useRecovery": "Usar código de recuperação",
    "login.deviceConfirm.title": "Confirme este dispositivo",
    "login.deviceConfirm.subtitle": "Enviamos um código de 6 dígitos para o seu e-mail.",
    "login.setup.mandatory": "Obrigatório pela sua empresa",
    "login.setup.title": "Ative a autenticação",
    "login.setup.subtitle": "Escaneie o QR code com Google Authenticator, Authy ou 1Password.",
    "login.setup.manual": "Ou digite a chave manualmente",
    "login.setup.copyKey": "Copiar chave",
    "login.setup.confirmCode": "Código de confirmação",
    "login.recovery.title": "Guarde seus códigos de recuperação",
    "login.reset.emailTitle": "Redefinir senha",
    "login.reset.emailSubtitle": "Digite o e-mail da sua conta. Enviaremos um código de 6 dígitos.",
    "login.reset.emailLabel": "E-mail",
    "login.reset.send": "Enviar código",
    "login.reset.codeTitle": "Digite o código",
    "login.reset.codeSubtitle": "Enviamos um código de 6 dígitos para o seu e-mail. Ele expira em 10 minutos.",
    "login.reset.verify": "Continuar",
    "login.reset.resend": "Reenviar código",
    "login.reset.resendIn": "Reenviar em {{seconds}}s",
    "login.reset.passwordTitle": "Nova senha",
    "login.reset.passwordSubtitle": "Escolha uma senha de pelo menos 5 caracteres.",
    "login.reset.passwordLabel": "Nova senha",
    "login.reset.confirmLabel": "Confirme a nova senha",
    "login.reset.mismatch": "As senhas não conferem.",
    "login.reset.totpLabel": "Código do autenticador",
    "login.reset.totpHint": "Sua conta tem verificação em duas etapas: confirme com o código do aplicativo.",
    "login.reset.submit": "Salvar nova senha",
    "login.reset.success": "Senha alterada. Entre com a senha nova.",
    "login.reset.back": "Voltar ao login",
    "signup.pageTitle": "Dados da empresa e do responsável",
    "signup.pageSubtitle": "Ao informar o CNPJ, buscamos a razão social automaticamente na Receita Federal.",
    "signup.hero.title": "Crie sua conta em menos de dois minutos.",
    "signup.steps.company.title": "Identifique a empresa",
    "signup.steps.company.desc": "CNPJ ou CPF, com preenchimento automático da razão social.",
    "signup.steps.owner.title": "Responsável e acesso",
    "signup.steps.owner.desc": "Nome, WhatsApp, e-mail e senha do primeiro administrador.",
    "signup.steps.plan.title": "Escolha o plano",
    "signup.steps.plan.desc": "Defina atendentes, conexões e filas. Você pode mudar depois.",
    "signup.form.document": "CPF ou CNPJ",
    "signup.form.companyName": "Nome da empresa",
    "signup.form.yourName": "Seu nome",
    "signup.form.whatsapp": "WhatsApp",
    "signup.form.plan": "Plano",
    "signup.documentValidating": "Consultando…",
    "signup.documentValidCnpj": "CNPJ válido · razão social preenchida",
    "signup.documentValidCpf": "CPF válido",
    "signup.password.empty": "Digite uma senha",
    "signup.password.weak": "Senha fraca",
    "signup.password.fair": "Senha razoável",
    "signup.password.good": "Senha boa",
    "signup.password.strong": "Senha forte",
    "signup.plan.meta": "{{users}} atendentes · {{connections}} WhatsApp · {{queues}} filas",
    "signup.termsPrefix": "Ao continuar você concorda com os ",
    "signup.termsLink": "Termos de uso",
    "signup.termsAnd": " e a ",
    "signup.privacyLink": "Política de privacidade",
    "signup.termsSuffix": ".",
    "signup.submit": "Criar conta",
    "signup.alreadyHave": "Já tem conta?",
    "signup.goLogin": "Entrar",
    "loading.saving": "Salvando alterações…",
    "loading.moment": "Isso leva só um instante",
    "announcements.toasts.forbidden": "Esta empresa não possui permissão para acessar essa página. Estamos lhe redirecionando.",
    "signup.toasts.documentInvalid": "CPF inválido.",
    "signup.toasts.documentNotFound": "Documento inválido ou não encontrado na Receita Federal.",
    "signup.toasts.documentError": "Erro ao validar o documento. Tente novamente.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "userModal.subtitleNew": "Novo acesso à plataforma",
    "userModal.idLabel": "ID {{id}}",
    "userModal.removePhoto": "Remover foto",
    "userModal.changePhoto": "Alterar foto",
    "userModal.passwordHint": "· deixe vazio para manter",
    "userModal.footerMeta": "Criada em {{created}}",
    "userModal.permissionGroups.tickets": "Atendimentos",
    "userModal.permissionGroups.modules": "Módulos",
    "userModal.permissionGroups.internal": "Comunicação interna",
    "userModal.permissions.allTicket": "Ver todos os atendimentos",
    "userModal.permissions.allowGroup": "Atender grupos",
    "userModal.permissions.allHistoric": "Ver histórico completo",
    "userModal.permissions.allowSeeMessagesInPendingTickets": "Ver mensagens em tickets pendentes",
    "userModal.permissions.userClosePendingTicket": "Encerrar tickets pendentes",
    "userModal.permissions.finalizacaoComValorVendaAtiva": "Finalização com valor de venda",
    "userModal.permissions.showDashboard": "Dashboard",
    "userModal.permissions.showContacts": "Contatos",
    "userModal.permissions.showCampaign": "Campanhas",
    "userModal.permissions.showFlow": "Flowbuilder",
    "userModal.permissions.allowConnections": "Conexões",
    "userModal.permissions.allowRealTime": "Painel em tempo real",
    "userModal.permissions.allUserChat": "Chat com todos os usuários",
    "userModal.permissionCount": "{{active}} de {{total}} permissões ativas",
    "userModal.security.devices": "Dispositivos confiáveis",
    "userModal.security.devicesEmpty": "Nenhum dispositivo confiável registrado.",
    "userModal.security.removeDevice": "Remover dispositivo",
    "userModal.security.deviceRemoved": "Dispositivo removido.",
    "userModal.security.lastUsed": "último acesso {{when}}",
    "userModal.security.endAllSessions": "Encerrar todas as sessões",
    "userModal.security.endAll": "Encerrar",
    "userModal.security.endAllConfirmTitle": "Encerrar todas as sessões de {{name}}?",
    "userModal.security.endAllConfirmText": "Todos os dispositivos confiáveis são removidos e as sessões abertas caem. No próximo login será pedida a confirmação por e-mail.",
    "userModal.security.endAllDone": "Sessões encerradas.",
    "userModal.security.removeDeviceTitle": "Remover “{{name}}”?",
    "userModal.security.removeDeviceText": "O dispositivo deixa de ser confiável. As demais sessões continuam abertas, e no próximo login neste aparelho será pedida a confirmação por e-mail.",
    "userModal.profileAdmin": "Admin",
    "userModal.profileUser": "Atendente",
    "userModal.themeLight": "Claro",
    "userModal.themeDark": "Escuro",
    "userModal.menuOpen": "Aberto",
    "userModal.menuClosed": "Fechado",
    "userModal.birthDateHint": "Usada nas notificações de aniversário",
    "users.confirmDelete.title": "Excluir {{name}}?",
    "users.confirmDelete.text": "Todos os dados do usuário serão perdidos e os atendimentos abertos em nome dele voltam para a fila. Esta ação não pode ser desfeita.",
    "users.confirmDelete.confirm": "Excluir usuário",
    "users.confirmChats.title": "Gerar chats para todos os usuários?",
    "users.confirmChats.text": "Cria um chat interno entre cada par de usuários que ainda não tem. Pode levar alguns minutos.",
    "users.confirmChats.confirm": "Gerar chats",
    "invoice.pay.title": "Pagar fatura",
    "invoice.pay.subtitle": "{{plan}} · vencimento em {{due}}",
    "invoice.pay.planSummary": "Resumo do plano",
    "invoice.pay.current": "Atual",
    "invoice.pay.users": "atendentes",
    "invoice.pay.connections": "conexões",
    "invoice.pay.queues": "filas",
    "invoice.pay.total": "Total",
    "invoice.pay.withPix": "Pague com Pix",
    "invoice.pay.copyCode": "Copiar",
    "invoice.pay.codeCopied": "Código Pix copiado.",
    "invoice.pay.waiting": "Aguardando pagamento · a licença renova automaticamente após a confirmação",
    "invoice.pay.validFor": "Código válido por",
    "invoice.pay.expired": "Código expirado · gere um novo",
    "invoice.pay.otherMethods": "ou pague com",
    "invoice.pay.generating": "Gerando cobrança…",
    "invoice.pay.payNow": "Realizar pagamento",
    "invoice.pay.waitingConfirmation": "Aguardando confirmação do pagamento…",
    "invoice.pay.mpUnavailable": "Pagamento online indisponível · fale com o suporte",
    "invoice.pay.renewed": "Sua licença foi renovada até {{date}}!",
    "smsCredits.title": "Comprar créditos SMS",
    "smsCredits.subtitle": "Saldo atual: {{balance}} SMS",
    "smsCredits.subtitleUnknown": "Saldo atual indisponível",
    "smsCredits.bestValue": "Melhor preço",
    "smsCredits.sms": "SMS",
    "smsCredits.perSms": "{{price}} por SMS",
    "smsCredits.empty": "Nenhum pacote disponível no momento.",
    "smsCredits.newBalance": "Novo saldo após a compra",
    "smsCredits.total": "Total",
    "smsCredits.footNote": "Créditos não expiram e são liberados após a confirmação do pagamento",
    "smsCredits.buy": "Pagar com Mercado Pago",
    "smsCredits.waiting": "Aguardando confirmação do pagamento… Você pode fechar esta janela — os créditos entram automaticamente.",
    "smsCredits.paid": "Pagamento confirmado! Créditos adicionados.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "userModal.form.birthDate": "Data de nascimento",
    "users.chatsDone": "Chats gerados com sucesso!",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "avatarUpload.invalidType": "Formato não suportado. Use JPG, PNG, GIF ou WebP.",
    "avatarUpload.tooLarge": "Arquivo muito grande. Tamanho máximo: 5 MB.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "smsCredits.avgUsage": "consumo médio {{avg}}/mês",
    "smsCredits.generatePix": "Gerar Pix",
    "smsCredits.copyCode": "Copiar",
    "smsCredits.codeCopied": "Código Pix copiado.",
    "smsCredits.waitingPix": "Aguardando o pagamento · os créditos entram automaticamente após a confirmação",
    "smsCredits.otherMethods": "Pagar de outra forma (cartão ou boleto)",
    // ---- Entrada de Atendimentos (/tickets) — painel do dia e cartao de contexto ----
    "aeros.ticketsEntry.greeting.morning": "Bom dia, {{name}}.",
    "aeros.ticketsEntry.greeting.afternoon": "Boa tarde, {{name}}.",
    "aeros.ticketsEntry.greeting.evening": "Boa noite, {{name}}.",
    "aeros.ticketsEntry.subtitle.waiting": "{{count}} pessoa aguardando nas suas filas",
    "aeros.ticketsEntry.subtitle.waiting_plural": "{{count}} pessoas aguardando nas suas filas",
    "aeros.ticketsEntry.newConversation": "Nova conversa",
    "aeros.ticketsEntry.pullNext": "Puxar próximo",
    "aeros.ticketsEntry.pullNextEmpty": "Nenhum atendimento aguardando nas suas filas.",
    "aeros.ticketsEntry.wait.now": "agora",
    "aeros.ticketsEntry.wait.minutes": "{{count}} min",
    "aeros.ticketsEntry.wait.hours": "{{count}} h",
    "aeros.ticketsEntry.wait.hoursMinutes": "{{hours}} h {{minutes}} min",
    "aeros.ticketsEntry.wait.days": "{{count}} d",
    "aeros.ticketsEntry.kpi.solvedToday": "Resolvidos hoje",
    "aeros.ticketsEntry.kpi.inService": "Em atendimento",
    "aeros.ticketsEntry.kpi.waiting": "Aguardando",
    "aeros.ticketsEntry.kpi.noReplyHint": "{{count}} sem resposta há {{minutes}} min",
    "aeros.ticketsEntry.kpi.noReplyHint_plural": "{{count}} sem resposta há {{minutes}} min",
    "aeros.ticketsEntry.kpi.oldestHint": "mais antigo: {{wait}}",
    "aeros.ticketsEntry.queues.title": "Suas filas agora",
    "aeros.ticketsEntry.queues.seeAll": "Ver todas",
    "aeros.ticketsEntry.queues.waiting": "aguardando",
    "aeros.ticketsEntry.queues.answer": "Atender",
    "aeros.ticketsEntry.queues.detail": "espera mais antiga {{wait}} · {{agents}} atendente online",
    "aeros.ticketsEntry.queues.detail_plural": "espera mais antiga {{wait}} · {{agents}} atendentes online",
    "aeros.ticketsEntry.queues.detailIdle": "sem ninguém aguardando · {{agents}} atendente online",
    "aeros.ticketsEntry.queues.detailIdle_plural": "sem ninguém aguardando · {{agents}} atendentes online",
    "aeros.ticketsEntry.queues.empty": "Você ainda não está em nenhuma fila.",
    "aeros.ticketsEntry.agenda.title": "Agenda de hoje",
    "aeros.ticketsEntry.agenda.empty": "Nenhum agendamento para hoje.",
    "aeros.ticketsEntry.attention.title": "Precisa de atenção",
    "aeros.ticketsEntry.attention.noReply": "{{count}} conversa sua sem resposta há mais de {{minutes}} minutos",
    "aeros.ticketsEntry.attention.noReply_plural": "{{count}} conversas suas sem resposta há mais de {{minutes}} minutos",
    "aeros.ticketsEntry.context.back": "Painel do dia",
    "aeros.ticketsEntry.context.waiting": "esperando",
    "aeros.ticketsEntry.context.since": "cliente desde {{year}}",
    "aeros.ticketsEntry.context.tickets": "{{count}} atendimento",
    "aeros.ticketsEntry.context.tickets_plural": "{{count}} atendimentos",
    "aeros.ticketsEntry.context.today": "hoje",
    "aeros.ticketsEntry.context.daysAgo": "há {{count}} dia",
    "aeros.ticketsEntry.context.daysAgo_plural": "há {{count}} dias",
    "aeros.ticketsEntry.context.lastMessage": "Última mensagem",
    "aeros.ticketsEntry.context.noMessage": "Nenhuma mensagem ainda.",
    "aeros.ticketsEntry.context.receivedAt": "recebida às {{time}} · {{channel}}",
    "aeros.ticketsEntry.context.lastContact": "Último contato",
    "aeros.ticketsEntry.context.firstContact": "primeiro atendimento",
    "aeros.ticketsEntry.context.viaChatbot": "Passou pelo chatbot",
    "aeros.ticketsEntry.context.transfer": "Transferir",
    "aeros.ticketsEntry.context.schedule": "Agendar",
    "aeros.ticketsEntry.context.accept": "Assumir atendimento",
    "aeros.ticketsEntry.context.acceptHint": "Assumir abre a conversa e move o ticket para \u201cAtendendo\u201d",
    // ---- Modais do "+" do atendimento (Templates, anexos, contato, câmera) ----
    "aeros.templateMeta.title": "Templates do WhatsApp",
    "aeros.templateMeta.subtitle": "{{count}} template aprovado nesta conexão",
    "aeros.templateMeta.subtitle_plural": "{{count}} templates aprovados nesta conexão",
    "aeros.templateMeta.search": "Buscar template pelo nome…",
    "aeros.templateMeta.empty": "Nenhum template aprovado para esta conexão.",
    "aeros.templateMeta.emptySearch": "Nenhum template encontrado para essa busca.",
    "aeros.templateMeta.back": "Voltar para a lista",
    "aeros.templateMeta.preview": "Prévia do template",
    "aeros.templateMeta.noContent": "Template sem conteúdo de texto.",
    "aeros.templateMeta.noVariables": "Este template não tem variáveis para preencher.",
    "aeros.templateMeta.filled": "{{filled}} de {{total}} variáveis preenchidas",
    "aeros.templateMeta.valuePlaceholder": "Valor que substitui a variável",
    "aeros.templateMeta.send": "Enviar",
    "aeros.templateMeta.imageUrl": "Insira a URL da imagem",
    "aeros.templateMeta.videoUrl": "Insira a URL do vídeo",
    "aeros.templateMeta.group.header": "Cabeçalho",
    "aeros.templateMeta.group.body": "Corpo",
    "aeros.templateMeta.group.footer": "Rodapé",
    "aeros.templateMeta.group.buttons": "Botões",
    "aeros.mediaUpload.title": "Enviar arquivos",
    "aeros.mediaUpload.subtitleOne": "Confira o arquivo e escreva uma legenda antes de enviar",
    "aeros.mediaUpload.subtitleMany": "{{total}} arquivos · a legenda é por arquivo",
    "aeros.mediaUpload.send": "Enviar",
    "aeros.mediaUpload.previous": "Arquivo anterior",
    "aeros.mediaUpload.next": "Próximo arquivo",
    "aeros.mediaUpload.captionLabel": "Legenda",
    "aeros.mediaUpload.captionPlaceholder": "Adicione uma legenda (opcional)",
    "aeros.mediaUpload.captionHint": "Enter envia · Shift+Enter quebra linha · ← → trocam de arquivo",
    "aeros.mediaUpload.noPreview": "Visualização não disponível",
    "aeros.mediaUpload.unknownType": "Tipo de arquivo desconhecido",
    "aeros.mediaUpload.imageAlt": "Imagem {{index}}",
    "aeros.sendContact.subtitle": "O contato vai como cartão (vCard) na conversa",
    "aeros.sendContact.placeholder": "Digite ao menos 3 letras do nome ou número",
    "aeros.sendContact.hint": "Não achou? Digite o nome completo para cadastrar um contato novo.",
    "aeros.sendContact.none": "Nenhum contato selecionado ainda.",
    "aeros.camera.title": "Câmera",
    "aeros.camera.subtitle": "A foto tirada abre a pré-visualização de envio",
    // ---- Leads (/leads) ----
    "aeros.leads.title": "Leads",
    "aeros.leads.subtitle": "Compre leads por nicho e cidade e converse pelo WhatsApp",
    "aeros.leads.buy": "Comprar leads",
    "aeros.leads.newSearch": "Nova busca",
    "aeros.leads.balance": "Saldo de leads",
    "aeros.leads.reserved": "{{count}} reservados em buscas na fila",
    "aeros.leads.available": "{{count}} disponíveis",
    "aeros.leads.unit": "leads",
    "aeros.leads.searches": "Buscas",
    "aeros.leads.searchesEmpty": "Nenhuma busca ainda. Compre leads e crie a primeira.",
    "aeros.leads.col.niche": "Nicho",
    "aeros.leads.col.city": "Cidade/UF",
    "aeros.leads.col.requested": "Pedidos",
    "aeros.leads.col.delivered": "Entregues",
    "aeros.leads.col.status": "Status",
    "aeros.leads.col.date": "Data",
    "aeros.leads.status.queued": "Na fila",
    "aeros.leads.status.running": "Buscando",
    "aeros.leads.status.processing": "Importando",
    "aeros.leads.status.done": "Concluída",
    "aeros.leads.status.failed": "Falhou",
    "aeros.leads.status.cancelled": "Cancelada",
    "aeros.leads.status.unknown": "Desconhecido",
    "aeros.leads.partial": "O Google Maps tinha menos resultados que o pedido; só o entregue foi debitado.",
    "aeros.leads.failedHint": "Serviço temporariamente indisponível. Nada foi debitado.",
    "aeros.leads.cancel": "Cancelar busca",
    "aeros.leads.cancelled": "Busca cancelada e saldo liberado.",
    "aeros.leads.leadsOf": "Leads da busca",
    "aeros.leads.selectSearch": "Selecione uma busca para ver os leads.",
    "aeros.leads.leadsEmpty": "Nenhum lead nesta busca.",
    "aeros.leads.searchPlaceholder": "Buscar por nome, telefone ou e-mail",
    "aeros.leads.columns": "Colunas",
    "aeros.leads.export": "Exportar CSV",
    "aeros.leads.lead.name": "Nome",
    "aeros.leads.lead.phone": "Telefone",
    "aeros.leads.lead.whatsapp": "WhatsApp",
    "aeros.leads.lead.email": "E-mail",
    "aeros.leads.lead.social": "Redes",
    "aeros.leads.lead.address": "Endereço",
    "aeros.leads.lead.site": "Site",
    "aeros.leads.lead.rating": "Nota",
    "aeros.leads.lead.reviews": "Avaliações",
    "aeros.leads.lead.maps": "Google Maps",
    "aeros.leads.lead.notes": "Observações",
    "aeros.leads.lead.notesCategory": "Categoria",
    "aeros.leads.lead.notesHours": "Horário",
    "aeros.leads.lead.notesDescription": "Descrição",
    "aeros.leads.whatsapp.yes": "Tem WhatsApp",
    "aeros.leads.whatsapp.no": "Sem WhatsApp",
    "aeros.leads.whatsapp.unknown": "WhatsApp não verificado",
    "aeros.leads.openTicket": "Conversar no WhatsApp",
    "aeros.leads.progress": "{{delivered}} de {{requested}} leads",
    "aeros.leads.finished": "Busca concluída: {{count}} leads entregues.",
    "aeros.leads.failedToast": "A busca falhou. Nada foi debitado.",
    "aeros.leads.loadMore": "Carregar mais",
    "aeros.leads.search.title": "Nova busca de leads",
    "aeros.leads.search.subtitle": "Nicho + cidade. Só leads com telefone e nunca repetidos contam.",
    "aeros.leads.search.niche": "Nicho",
    "aeros.leads.search.nichePlaceholder": "ex.: clínica odontológica",
    "aeros.leads.search.city": "Cidade",
    "aeros.leads.search.state": "UF",
    "aeros.leads.search.quantity": "Quantidade de leads",
    "aeros.leads.search.estimate": "Usa até {{quantity}} do seu saldo de {{balance}}.",
    "aeros.leads.search.insufficient": "Saldo insuficiente: você tem {{balance}} disponíveis.",
    "aeros.leads.search.repeated": "Você já buscou esse nicho nessa cidade em {{date}}. A maior parte viria repetida, por isso a busca fica bloqueada por {{days}} dias.",
    "aeros.leads.search.submit": "Iniciar busca",
    "aeros.leads.search.created": "Busca iniciada. Você será avisado quando terminar.",
    "aeros.leads.search.minMax": "Entre {{min}} e {{max}} leads",
    "aeros.leads.buyModal.title": "Comprar leads",
    "aeros.leads.buyModal.subtitle": "Saldo atual: {{balance}} leads",
    "aeros.leads.buyModal.subtitleUnknown": "Escolha um pacote",
    "aeros.leads.buyModal.perLead": "{{price}} por lead",
    "aeros.leads.buyModal.bestValue": "Melhor preço",
    "aeros.leads.buyModal.newBalance": "Novo saldo",
    "aeros.leads.buyModal.total": "Total",
    "aeros.leads.buyModal.generatePix": "Gerar Pix",
    "aeros.leads.buyModal.waiting": "Aguardando confirmação do pagamento…",
    "aeros.leads.buyModal.waitingPix": "Assim que o Pix for confirmado, o saldo entra sozinho.",
    "aeros.leads.buyModal.copyCode": "Copiar código",
    "aeros.leads.buyModal.codeCopied": "Código Pix copiado",
    "aeros.leads.buyModal.otherMethods": "Pagar com cartão ou boleto",
    "aeros.leads.buyModal.paid": "Pagamento confirmado! Leads creditados.",
    "aeros.leads.buyModal.empty": "Nenhum pacote disponível no momento.",
    "aeros.leads.buyModal.footNote": "Pagamento via Mercado Pago. Só leads entregues são debitados.",
    "aeros.leadsAdmin.tab": "Leads",
    "aeros.leadsAdmin.config": "Integração e limites",
    "aeros.leadsAdmin.apifyToken": "Token do Apify",
    "aeros.leadsAdmin.apifyTokenConfigured": "Token configurado. Cole um novo para substituir.",
    "aeros.leadsAdmin.apifyTokenMissing": "Sem token: as buscas usam o provedor de teste fora de produção e falham em produção.",
    "aeros.leadsAdmin.factor": "Fator de sobre-busca",
    "aeros.leadsAdmin.factorHint": "Quantos lugares pedir ao Apify por lead pedido (compensa sem telefone e repetidos).",
    "aeros.leadsAdmin.blockDays": "Dias de bloqueio de repetição",
    "aeros.leadsAdmin.maxPerSearch": "Máximo de leads por busca",
    "aeros.leadsAdmin.save": "Salvar",
    "aeros.leadsAdmin.saved": "Configuração salva",
    "aeros.leadsAdmin.packs": "Pacotes de leads",
    "aeros.leadsAdmin.newPack": "Novo pacote",
    "aeros.leadsAdmin.name": "Nome",
    "aeros.leadsAdmin.namePlaceholder": "ex.: 500 leads",
    "aeros.leadsAdmin.quantity": "Quantidade",
    "aeros.leadsAdmin.value": "Valor (R$)",
    "aeros.leadsAdmin.perLead": "R$/lead",
    "aeros.leadsAdmin.active": "Ativo",
    "aeros.leadsAdmin.create": "Criar pacote",
    "aeros.leadsAdmin.created": "Pacote criado",
    "aeros.leadsAdmin.packsEmpty": "Nenhum pacote cadastrado ainda.",
    "aeros.leadsAdmin.searches": "Buscas de todas as empresas",
    "aeros.leadsAdmin.company": "Empresa",
    "aeros.leadsAdmin.scraped": "Raspados",
    "aeros.leadsAdmin.cost": "Custo (USD)",
    "aeros.leadsAdmin.error": "Erro",
    "aeros.leadsAdmin.searchesEmpty": "Nenhuma busca ainda.",
    "mainDrawer.listItems.groupOverview": "Visão Geral",
    "mainDrawer.listItems.groupService": "Atendimento",
    "mainDrawer.listItems.groupCrm": "CRM & Prospecção",
    "mainDrawer.listItems.groupSystem": "Sistema & Conta",
    "mainDrawer.listItems.leads": "Base de Leads",
    "mainDrawer.listItems.creditosSms": "Créditos SMS",
    "mainDrawer.wallet.title": "Sua carteira",
    "mainDrawer.wallet.sms": "Envios SMS",
    "mainDrawer.wallet.leads": "Extração Leads",
    "mainDrawer.wallet.recharge": "Recarregar",
    "mainDrawer.wallet.buyMore": "Comprar mais",
  },
  en: {
    // ---- Tela Importar contatos de arquivo (/contacts/import) ----
    "aeros.contactImport.breadcrumb": "Contacts",
    "aeros.contactImport.pageTitle": "Import contacts from a file",
    // ---- Tela Histórico de chamadas (/call-historicals · Wavoip) ----
    "aeros.calls.title": "Call history",
    "aeros.calls.subtitle": "WhatsApp voice calls (Wavoip) · real time",
    "aeros.calls.search": "Search name or phone…",
    "aeros.calls.contact": "Contact",
    "aeros.calls.phone": "Phone",
    "aeros.calls.dateTime": "Date/Time",
    "aeros.calls.statusColumn": "Status",
    "aeros.calls.duration": "Duration",
    "aeros.calls.typeColumn": "Type",
    "aeros.calls.agent": "Agent",
    "aeros.calls.actions": "Actions",
    "aeros.calls.loadMore": "Load more",
    "aeros.calls.loading": "Loading calls…",
    "aeros.calls.empty": "No calls recorded yet.",
    "aeros.calls.emptySearch": "No calls found for this search.",
    "aeros.calls.unavailableTitle": "Voice integration unavailable",
    "aeros.calls.unavailableText": "Wavoip could not be reached. Check the voice integration token in the connection settings.",
    "aeros.calls.download": "Download recording",
    "aeros.calls.callBack": "Call this contact",
    "aeros.calls.incomingCall": "Incoming call",
    "aeros.calls.unnamed": "Unidentified",
    "aeros.calls.status.ended": "Ended",
    "aeros.calls.status.active": "In progress",
    "aeros.calls.status.ringing": "Ringing",
    "aeros.calls.status.busy": "Busy",
    "aeros.calls.status.noAnswer": "No answer",
    "aeros.calls.status.rejected": "Rejected",
    "aeros.calls.status.unknown": "No status",
    "aeros.calls.type.out": "Outgoing",
    "aeros.calls.type.in": "Incoming",
    "aeros.calls.kpi.total": "Total calls",
    "aeros.calls.kpi.served": "Answered",
    "aeros.calls.kpi.rejected": "Rejected / missed",
    "aeros.calls.kpi.finished": "Ended",
    // ---- Tela Carteiras (/wallets) ----
    "aeros.wallets.title": "Wallets",
    "aeros.wallets.subtitle": "Contacts with a fixed agent and queue",
    "aeros.wallets.search": "Search contact…",
    "aeros.wallets.filterUser": "Filter by user",
    "aeros.wallets.allUsers": "All users",
    "aeros.wallets.contact": "Contact",
    "aeros.wallets.user": "Agent",
    "aeros.wallets.queue": "Queue",
    "aeros.wallets.phone": "Phone",
    "aeros.wallets.email": "E-mail",
    "aeros.wallets.actions": "Actions",
    "aeros.wallets.loading": "Loading wallets…",
    "aeros.wallets.empty": "No contacts in a wallet yet.",
    "aeros.wallets.emptySearch": "No contacts match these filters.",
    "aeros.wallets.edit": "Edit wallet",
    "aeros.wallets.remove": "Remove from wallet",
    "aeros.wallets.save": "Save",
    "aeros.wallets.editTitle": "Edit wallet",
    "aeros.wallets.noQueues": "This agent is not in any queue.",
    "aeros.wallets.confirmTitle": "Remove {{name}} from the wallet?",
    "aeros.wallets.confirmMessage": "The contact goes back to the queue's normal round-robin.",
    "aeros.wallets.deleteSuccess": "Contact removed from the wallet.",
    "aeros.wallets.updateSuccess": "Wallet updated.",
    "aeros.wallets.selectUserAndQueue": "Select an agent and a queue.",
    "aeros.wallets.note": "Contacts in a wallet always return to the same agent, bypassing the queue's round-robin.",
    // ---- Tela Conexões (/connections e /allConnections) ----
    "aeros.connections.needsAttention": "{{count}} connections need attention",
    "aeros.connections.needsAttentionOne": "1 connection needs attention",
    "aeros.connections.companies": "{{count}} companies on the platform",
    "aeros.connections.companiesOne": "1 company on the platform",
    "aeros.connections.manage": "Manage connections",
    "aeros.connections.super": "SUPER",
    "aeros.connections.status.connected": "Connected",
    "aeros.connections.status.waiting": "Waiting for QR code",
    "aeros.connections.status.disconnected": "Disconnected",
    "aeros.companies.status.active": "Active",
    "aeros.sms.status.paid": "Paid",
    "aeros.contactLists.title": "Contact lists",
    "aeros.contactLists.subtitle": "Audiences used in campaigns",
    "aeros.contactLists.search": "Search list…",
    "aeros.contactLists.newList": "New list",
    "aeros.contactLists.name": "Name",
    "aeros.contactLists.contacts": "Contacts",
    "aeros.contactLists.createdAt": "Created on",
    "aeros.contactLists.actions": "Actions",
    "aeros.contactLists.openContacts": "View list contacts",
    "aeros.contactLists.download": "Download list spreadsheet",
    "aeros.contactLists.edit": "Rename list",
    "aeros.contactLists.delete": "Delete list",
    "aeros.contactLists.loading": "Loading…",
    "aeros.contactLists.empty": "No list yet. Create the first one to use in campaigns.",
    "aeros.contactLists.emptySearch": "No list found with that term.",
    "aeros.contactLists.confirmTitle": "Delete the list {{name}}?",
    "aeros.contactLists.confirmMessage": "The contacts in the list are deleted with it. Campaigns that already used this list keep their own history.",
    "aeros.kanbanTags.title": "Kanban tags",
    "aeros.kanbanTags.subtitle": "Each tag is a column on the board",
    "aeros.kanbanTags.backToBoard": "Back to Kanban",
    "aeros.kanbanTags.newTag": "New tag",
    "aeros.kanbanTags.name": "Name",
    "aeros.kanbanTags.ticketsColumn": "Tickets",
    "aeros.kanbanTags.order": "Order",
    "aeros.kanbanTags.actions": "Actions",
    "aeros.kanbanTags.edit": "Edit tag",
    "aeros.kanbanTags.delete": "Delete tag",
    "aeros.kanbanTags.deleted": "Tag deleted",
    "aeros.kanbanTags.dragHandle": "Drag to reorder",
    "aeros.kanbanTags.loading": "Loading…",
    "aeros.kanbanTags.empty": "No column on the board yet. Create the first tag.",
    "aeros.kanbanTags.boardPreview": "Board preview",
    "aeros.kanbanTags.tickets": "{{count}} tickets",
    "aeros.kanbanTags.ticketOne": "1 ticket",
    "aeros.kanbanTags.confirmTitle": "Delete the column {{name}}?",
    "aeros.kanbanTags.confirmMessage": "The column disappears from the board. Tickets are not deleted — they just stop being in it.",
    "aeros.todo.title": "Tasks",
    "aeros.todo.subtitle": "Quick notes for your day — saved in this browser only",
    "aeros.todo.placeholder": "e.g. review unanswered tickets in the Sales queue",
    "aeros.todo.add": "Add",
    "aeros.todo.save": "Save",
    "aeros.todo.edit": "Edit task",
    "aeros.todo.delete": "Delete task",
    "aeros.todo.confirmTitle": "Delete this task?",
    "aeros.todo.markDone": "Mark as done",
    "aeros.todo.markOpen": "Reopen task",
    "aeros.todo.pending": "{{count}} pending",
    "aeros.todo.pendingOne": "1 pending",
    "aeros.todo.empty": "No task here. Write the first one above.",
    "aeros.todo.localNote": "Because they live in the browser, tasks do not sync across devices and are not visible to other users.",
    "aeros.smsPacks.newPack": "New package",
    "aeros.smsPacks.name": "Name",
    "aeros.smsPacks.namePlaceholder": "e.g. Package 2,500",
    "aeros.smsPacks.quantity": "Quantity",
    "aeros.smsPacks.quantityShort": "Qty.",
    "aeros.smsPacks.value": "Amount (R$)",
    "aeros.smsPacks.perSms": "R$/SMS",
    "aeros.smsPacks.active": "Active",
    "aeros.smsPacks.create": "Create package",
    "aeros.smsPacks.created": "Package created",
    "aeros.smsPacks.empty": "No package registered yet.",
    "aeros.smsPacks.inactiveNote": "Inactive packages stop showing on the companies' purchase screen, but stay in the history.",
    "aeros.sms.title": "SMS credits",
    "aeros.sms.subtitle": "Balance, top-ups and usage history",
    "aeros.sms.buyCredits": "Buy credits",
    "aeros.sms.currentBalance": "Current balance",
    "aeros.sms.avgPerDay": "Average usage of {{count}} SMS per day",
    "aeros.sms.avgPerDayShort": "{{count}}/day on average",
    "aeros.sms.noUsageYet": "No usage recorded yet",
    "aeros.sms.noneThisMonth": "No messages sent this month",
    "aeros.sms.sentMonth": "Sent this month",
    "aeros.sms.investedMonth": "Spent this month",
    "aeros.sms.rechargeCount": "{{count}} top-ups",
    "aeros.sms.rechargeOne": "1 top-up",
    "aeros.sms.autonomy": "Runway",
    "aeros.sms.days": "{{count}} days",
    "aeros.sms.dayOne": "1 day",
    "aeros.sms.autonomyHint": "at the current usage rate",
    "aeros.sms.autonomyUnknown": "no usage to estimate from",
    "aeros.sms.lowBalance": "At the current rate, the balance runs out in {{count}} days.",
    "aeros.sms.rechargeNow": "Top up now",
    "aeros.sms.recharges": "Top-ups",
    "aeros.sms.viaMercadoPago": "paid through Mercado Pago",
    "aeros.sms.filterAll": "All",
    "aeros.sms.date": "Date",
    "aeros.sms.package": "Package",
    "aeros.sms.quantity": "Quantity",
    "aeros.sms.value": "Amount",
    "aeros.sms.statusColumn": "Status",
    "aeros.sms.loading": "Loading…",
    "aeros.sms.noRecharges": "No top-up yet.",
    "aeros.sms.noRechargesFilter": "No top-up with this status.",
    "aeros.sms.webhookNote": "Paid top-ups arrive automatically through the webhook — no need to reload the page.",
    "aeros.sms.usage7days": "Usage over the last 7 days",
    "aeros.sms.noUsageData": "No usage in the period",
    "aeros.sms.whereUsed": "Where the credits went",
    "aeros.sms.fractionNote": "Messages over 160 characters are charged in blocks of 153.",
    "aeros.sms.status.pending": "Pending",
    "aeros.sms.status.expired": "Expired",
    "aeros.sms.status.unknown": "Unknown",
    "aeros.sms.weekday.0": "Sun",
    "aeros.sms.weekday.1": "Mon",
    "aeros.sms.weekday.2": "Tue",
    "aeros.sms.weekday.3": "Wed",
    "aeros.sms.weekday.4": "Thu",
    "aeros.sms.weekday.5": "Fri",
    "aeros.sms.weekday.6": "Sat",
    "aeros.sms.origin.campanha": "SMS campaigns",
    "aeros.sms.origin.manual": "Manual send from the contact",
    "aeros.sms.origin.automacao": "Automations / flows",
    "aeros.sms.origin.outros": "Other usage",
    "aeros.dashboard.greeting.morning": "Good morning",
    "aeros.dashboard.range.today": "Today",
    "aeros.dashboard.range.week": "7 days",
    "aeros.dashboard.range.month": "30 days",
    "aeros.dashboard.range.custom": "Custom",
    "aeros.dashboard.indicators": "Indicators",
    "aeros.dashboard.export": "Export",
    "aeros.dashboard.filters": "Filters",
    "aeros.dashboard.filterType": "Filter type",
    "aeros.dashboard.byDate": "By date",
    "aeros.dashboard.quickFilter": "Quick filter",
    "aeros.dashboard.period": "Period",
    "aeros.dashboard.queue": "Queue",
    "aeros.dashboard.agent": "Agent",
    "aeros.dashboard.allQueues": "All",
    "aeros.dashboard.allAgents": "All",
    "aeros.dashboard.queuesFilter": "Queues: {{value}}",
    "aeros.dashboard.clear": "Clear",
    "aeros.dashboard.apply": "Filter",
    "aeros.dashboard.ticketsPerDay": "Total tickets per day",
    "aeros.dashboard.inPeriod": "({{count}} in the period)",
    "aeros.dashboard.received": "Received",
    "aeros.dashboard.resolved": "Resolved",
    "aeros.dashboard.noData": "No tickets in the period",
    "aeros.dashboard.satisfaction": "Satisfaction survey",
    "aeros.dashboard.score": "Score",
    "aeros.dashboard.promoters": "Promoters",
    "aeros.dashboard.passive": "Passives",
    "aeros.dashboard.detractors": "Detractors",
    "aeros.dashboard.ratingIndex": "Rating index",
    "aeros.dashboard.totalTickets": "Total tickets",
    "aeros.dashboard.waitingRating": "Awaiting rating",
    "aeros.dashboard.withoutRating": "Not rated",
    "aeros.dashboard.rated": "Rated",
    "aeros.dashboard.agents": "Agents",
    "aeros.dashboard.fullReport": "See full report",
    "aeros.dashboard.inService": "Open",
    "aeros.dashboard.finished": "Finished",
    "aeros.dashboard.avgSupport": "Avg. handling",
    "aeros.dashboard.avgWait": "Avg. wait",
    "aeros.dashboard.rating": "Rating",
    "aeros.dashboard.status": "Status",
    "aeros.dashboard.loading": "Loading…",
    "aeros.dashboard.noAgents": "No agent found",
    "aeros.dashboard.kpi.Em Atendimento": "In service",
    "aeros.dashboard.kpi.Aguardando": "Waiting",
    "aeros.dashboard.kpi.Finalizados": "Finished",
    "aeros.dashboard.kpi.Grupos": "Groups",
    "aeros.dashboard.kpi.Novos Contatos": "New contacts",
    "aeros.dashboard.kpi.Atendentes Ativos": "Active agents",
    "aeros.dashboard.kpi.Mensagens Recebidas": "Messages received",
    "aeros.dashboard.kpi.Mensagens Enviadas": "Messages sent",
    "aeros.dashboard.kpi.T.M. de Atendimento": "Avg. handling time",
    "aeros.dashboard.kpi.T.M. de Espera": "Avg. wait time",
    "aeros.dashboard.kpi.Tickets Ativos": "Active tickets",
    "aeros.dashboard.kpi.Tickets Passivos": "Passive tickets",
    "aeros.dashboard.kpi.Créditos SMS": "SMS credits",
    "aeros.dashboard.greeting.afternoon": "Good afternoon",
    "aeros.dashboard.greeting.evening": "Good evening",
    "aeros.dashboard.updatedNow": "updated just now",
    "aeros.dashboard.updatedSeconds": "updated {{count}}s ago",
    "aeros.dashboard.updatedMinutes": "updated {{count}} min ago",
    "aeros.dashboard.updatedHours": "updated {{count}} h ago",
    "aeros.dashboard.onlineOf": "{{online}} online of {{total}}",
    "aeros.dashboard.agentStatus.online": "Online",
    "aeros.dashboard.agentStatus.busy": "Busy",
    "aeros.dashboard.agentStatus.offline": "Offline",
    "aeros.dashboard.delta.stable": "steady",
    "aeros.dashboard.delta.inPeriod": "in the period",
    "aeros.dashboard.delta.lastHour": "in the last hour",
    "aeros.dashboard.delta.onAverage": "on average",
    "aeros.dashboard.delta.vsAverage": "min vs. average",
    "aeros.dashboard.delta.today": "today",
    "aeros.dashboard.delta.offline": "{{count}} offline",
    "aeros.dashboard.delta.total": "{{value}} in total",
    "aeros.companies.status.inactive": "Inactive",
    "aeros.companies.status.expired": "Overdue",
    "aeros.companies.status.soon": "Due soon",
    "aeros.companies.status.trial": "Trial",
    "aeros.companies.due.in": "in {{count}} days",
    "aeros.companies.due.inOne": "in 1 day",
    "aeros.companies.due.today": "due today",
    "aeros.companies.due.late": "{{count}} days overdue",
    "aeros.companies.due.lateOne": "1 day overdue",
    "aeros.companies.due.disabled": "account disabled",
    "aeros.companies.subtitle": "Accounts, plans and billing across the platform",
    "aeros.companies.searchPlaceholder": "Search company, e-mail…",
    "aeros.companies.filterStatus": "Filter by status",
    "aeros.companies.filter.all": "Status: All",
    "aeros.companies.plansButton": "Plans",
    "aeros.companies.newCompany": "New company",
    "aeros.companies.loading": "Loading…",
    "aeros.companies.emptyTitle": "No company found",
    "aeros.companies.emptyText": "Adjust the search or the status filter.",
    "aeros.companies.files": "{{count}} files",
    "aeros.companies.showing": "Showing {{shown}} of {{total}} companies",
    "aeros.companies.prevPage": "Previous page",
    "aeros.companies.nextPage": "Next page",
    "aeros.companies.legend": "Rows in red: past due date. Inactive companies are dimmed and cannot log in.",
    "aeros.companies.table.planValue": "Plan · Amount",
    "aeros.companies.table.company": "Company",
    "aeros.companies.table.status": "Status",
    "aeros.companies.table.usage": "Usage · SMS",
    "aeros.companies.table.actions": "Actions",
    "aeros.companies.actions.edit": "Edit company",
    "aeros.companies.actions.sms": "SMS credits",
    "aeros.companies.actions.delete": "Delete company",
    "aeros.companies.kpi.activeInactive": "{{active}} active · {{inactive}} inactive",
    "aeros.companies.kpi.mrr": "MRR",
    "aeros.companies.kpi.mrrHint": "monthly recurring revenue",
    "aeros.companies.kpi.overdue": "Overdue",
    "aeros.companies.kpi.overdueHint": "{{value}} past due",
    "aeros.companies.kpi.trial": "On trial",
    "aeros.companies.kpi.trialHint": "{{count}} expire this week",
    "aeros.companies.kpi.storage": "Storage",
    "aeros.companies.confirm.title": "Delete {{name}}?",
    "aeros.companies.confirm.message": "All company data will be lost: users, connections, tickets, contacts and files ({{size}}). This action cannot be undone.",
    "aeros.companies.confirm.action": "Delete company",
    "aeros.companies.confirm.typedHint": "Type the company name to confirm",
    "aeros.companies.recurrence.MENSAL": "Monthly",
    "aeros.companies.recurrence.BIMESTRAL": "Every 2 months",
    "aeros.companies.recurrence.TRIMESTRAL": "Quarterly",
    "aeros.companies.recurrence.SEMESTRAL": "Every 6 months",
    "aeros.companies.recurrence.ANUAL": "Yearly",
    "aeros.companies.recurrenceFromPlan": "Set by the plan",
    "aeros.companies.modal.title": "Edit company",
    "aeros.companies.modal.save": "Save company",
    "aeros.companies.modal.saved": "Company saved",
    "aeros.companies.modal.accountData": "Account data",
    "aeros.companies.modal.adminEmail": "Administrator e-mail",
    "aeros.companies.modal.newPassword": "New password",
    "aeros.companies.modal.showPassword": "Show password",
    "aeros.companies.modal.hidePassword": "Hide password",
    "aeros.companies.modal.clientSince": "customer since {{date}}",
    "aeros.companies.modal.connections": "{{count}} connections",
    "aeros.companies.modal.connectionOne": "1 connection",
    "aeros.companies.modal.users": "{{count}} users",
    "aeros.companies.modal.userOne": "1 user",
    "aeros.companies.modal.planLimits": "{{users}} users · {{connections}} connections · {{queues}} queues",
    "aeros.companies.modal.campaigns": "Campaigns enabled",
    "aeros.companies.modal.campaignsHint": "Overrides the plan permission for this company",
    "aeros.companies.modal.billing": "Billing",
    "aeros.companies.subscription.column": "Subscription",
    "aeros.companies.subscription.title": "Subscription",
    "aeros.companies.subscription.none": "No active subscription",
    "aeros.companies.subscription.plan": "Plan",
    "aeros.companies.subscription.periodMethod": "Period · method",
    "aeros.companies.subscription.cycle": "Cycle",
    "aeros.companies.subscription.status": "Status",
    "aeros.companies.subscription.cancel": "Cancel subscription",
    "aeros.companies.subscription.cancelTitle": "Cancel this company's subscription?",
    "aeros.companies.subscription.cancelText": "Automatic billing stops and the company keeps access until the end of the paid cycle. After that, plan, due date and recurrence become editable again.",
    "aeros.companies.subscription.cancelConfirm": "Cancel subscription",
    "aeros.companies.subscription.canceled": "Subscription canceled",
    "aeros.companies.managedBySubscription": "Plan, due date and recurrence are managed by the subscription. Cancel the subscription to edit them manually.",
    "aeros.companies.modal.paymentMethod": "Payment method",
    "aeros.companies.modal.nextInvoice": "Next invoice",
    "aeros.companies.modal.dueOn": "due {{date}}",
    "aeros.companies.modal.onTime": "on time",
    "aeros.companies.modal.late": "overdue",
    "aeros.companies.modal.lastPaid": "Last paid: {{date}}",
    "aeros.companies.modal.noPaid": "No invoice paid yet",
    "aeros.companies.modal.noOpenInvoice": "No open invoice",
    "aeros.companies.modal.disable": "Disable company",
    "aeros.companies.modal.enable": "Re-enable company",
    "aeros.companies.newModal.subtitle": "The e-mail and default password create the first administrator user.",
    "aeros.companies.newModal.active": "Active",
    "aeros.companies.newModal.note": "Plan, due date and recurrence are set later, in Edit company.",
    "aeros.companies.sms.title": "SMS credits",
    "aeros.companies.sms.currentBalance": "Current balance: {{count}} SMS",
    "aeros.companies.sms.customAmount": "Custom amount",
    "aeros.companies.sms.amountPlaceholder": "e.g. 2500",
    "aeros.companies.sms.reason": "Reason",
    "aeros.companies.sms.reasonRequired": "Enter the reason for this entry",
    "aeros.companies.sms.invalidAmount": "Enter an amount greater than zero",
    "aeros.companies.sms.newBalance": "New balance after the operation",
    "aeros.companies.sms.apply": "Apply credits",
    "aeros.companies.sms.applied": "Credits applied",
    "aeros.companies.sms.statement": "Statement",
    "aeros.companies.sms.noEntries": "No entries found.",
    "aeros.companies.sms.credit": "Credit",
    "aeros.companies.sms.debit": "Debit",
    "aeros.plans.title": "Plans",
    "aeros.plans.newPlan": "New plan",
    "aeros.plans.editPlan": "Edit plan",
    "aeros.plans.name": "Name",
    "aeros.plans.users": "users",
    "aeros.plans.connections": "connections",
    "aeros.plans.queues": "queues",
    "aeros.plans.amount": "Amount (R$)",
    "aeros.plans.recurrence": "Billing period",
    "aeros.plans.period.MENSAL": "/ month",
    "aeros.plans.period.BIMESTRAL": "/ 2 months",
    "aeros.plans.period.TRIMESTRAL": "/ quarter",
    "aeros.plans.period.SEMESTRAL": "/ 6 months",
    "aeros.plans.period.ANUAL": "/ year",
    "aeros.plans.usersLabel": "Users",
    "aeros.plans.connectionsLabel": "Connections",
    "aeros.plans.queuesLabel": "Queues",
    "aeros.plans.public": "Public",
    "aeros.plans.trial": "Trial",
    "aeros.plans.trialDays": "Trial {{count}}d",
    "aeros.plans.trialDaysField": "Trial days",
    "aeros.plans.featuresTitle": "Included features",
    "aeros.plans.clear": "Clear",
    "aeros.plans.save": "Save plan",
    "aeros.plans.saved": "Plan saved",
    "aeros.plans.deleted": "Plan deleted",
    "aeros.plans.edit": "Edit plan",
    "aeros.plans.delete": "Delete plan",
    "aeros.plans.nameRequired": "Enter the plan name",
    "aeros.plans.emptyTitle": "No plan registered",
    "aeros.plans.usage": "{{count}} companies on this plan",
    "aeros.plans.usageOne": "1 company on this plan",
    "aeros.plans.confirmTitle": "Delete the plan {{name}}?",
    "aeros.plans.confirmMessage": "{{count}} company(ies) use this plan today. Deleting does not change their plan, but the limits stop existing and they show up without a plan in the listing.",
    "aeros.plans.feature.whatsapp": "WhatsApp",
    "aeros.plans.feature.whatsappOfficial": "WhatsApp Official",
    "aeros.plans.feature.facebook": "Facebook",
    "aeros.plans.feature.instagram": "Instagram",
    "aeros.plans.feature.campaigns": "Campaigns",
    "aeros.plans.feature.schedules": "Schedules",
    "aeros.plans.feature.internalChat": "Internal chat",
    "aeros.plans.feature.externalApi": "External API",
    "aeros.plans.feature.kanban": "Kanban",
    "aeros.plans.feature.openAi": "Talk.Ai",
    "aeros.plans.feature.integrations": "Integrations",
    "aeros.plans.feature.wavoip": "Wavoip",
    "aeros.connections.channel.baileys": "WhatsApp (Baileys)",
    "aeros.connections.channel.official": "WhatsApp Official (Meta)",
    "aeros.connections.defaultOne": "default connection",
    "aeros.connections.tabs.chatbot": "Chatbot",
    "aeros.connections.tabs.flow": "Default flow",
    "aeros.connections.form.defaultHint": "Used when no other one is set",
    "aeros.connections.form.officialHint": "Shows the WABA / Phone ID fields",
    "aeros.connections.form.groupHint": "Receives messages from groups",
    "aeros.connections.form.importHint": "Creates tickets from the phone history on connect",
    "aeros.connections.form.tokenRenew": "Generate a new token",
    "aeros.connections.form.tokenCopy": "Copy token",
    "aeros.connections.agents.title": "AI agents",
    "aeros.connections.agents.hint": "Read only: the agent's link to the connection and queues is set in Talk.ai.",
    "aeros.connections.agents.empty": "No AI agent serves this connection.",
    "aeros.connections.agents.newConnection": "Save the connection to link AI agents to it in Talk.ai.",
    "aeros.connections.agents.otherCompany": "This connection's agents are managed in the Talk.ai of the company that owns it.",
    "aeros.connections.agents.loading": "Loading agents…",
    "aeros.connections.agents.preQueue": "Answers before distribution",
    "aeros.connections.agents.manage": "Manage in Talk.ai",
    "aeros.connections.form.closeIntegration": "Closing integration",
    "aeros.connections.form.wavoipHint": "Voice token for WhatsApp calls",
    "aeros.connections.form.wavoipPlaceholder": "wavoip token",
    "aeros.connections.form.greetingHint": "Sent when the ticket opens",
    "aeros.connections.form.complationHint": "Sent when the ticket is resolved",
    "aeros.connections.form.outOfHoursHint": "Requires business hours to be configured",
    "aeros.connections.form.vacationHint": "Optional; sent during the company holiday period",
    "aeros.connections.bot.unitMin": "min",
    "aeros.connections.bot.unitTimes": "times",
    "aeros.connections.bot.newTicketHint": "Minutes after closing for a new message to open another ticket.",
    "aeros.connections.bot.maxTriesHint": "How many times the bot resends the menu before transferring.",
    "aeros.connections.bot.intervalHint": "Wait between chatbot menu resends.",
    "aeros.connections.bot.returnQueueHint": "A ticket with no agent reply goes back to the queue.",
    "aeros.connections.bot.expiresHint": "Expires the ticket when the customer stops interacting.",
    "aeros.connections.bot.whenExpiresHint": "No reply from the customer, or from either side.",
    "aeros.connections.bot.expiresMessageHint": "Sent when the ticket expires.",
    "aeros.connections.bot.inactivityTitle": "Inactivity warning",
    "aeros.connections.bot.inactivityDesc": "Sent before expiring, to try to resume the conversation.",
    "aeros.connections.bot.inactivityFlow": "Inactivity flow",
    "aeros.connections.nps.expiresHint": "Required when there is a rating message",
    "aeros.connections.nps.maxUseHint": "How many times the survey is resent without an answer",
    "aeros.connections.flow.newContactTitle": "Welcome flow",
    "aeros.connections.flow.newContactDesc": "Triggered on the first message from new contacts, not yet in your list.",
    "aeros.connections.flow.knownContactTitle": "Known contact flow",
    "aeros.connections.flow.knownContactDesc": "Triggered on the first message from contacts already in your base.",
    "aeros.connections.qr.connection": "Connection",
    "aeros.connections.qr.step1": "Open WhatsApp on your phone",
    "aeros.connections.qr.step2": "Tap More options or Settings and select Linked devices",
    "aeros.connections.qr.step3": "Tap Link a device and point it at this screen",
    "aeros.connections.qr.autoRenew": "The code is refreshed automatically while this window is open.",
    "aeros.connections.qr.newCode": "New QR code",
    "aeros.connections.confirm.disconnectTitle": "Disconnect {{name}}?",
    "aeros.connections.confirm.disconnectMessage": "Are you sure? You will need to scan the QR code again to resume sending and receiving messages.",
    "aeros.connections.confirm.disconnectAction": "Disconnect",
    "aeros.connections.confirm.deleteTitle": "Delete the connection {{name}}?",
    "aeros.connections.confirm.deleteMessage": "Are you sure? This action cannot be undone. Linked tickets will be left without a connection.",
    "aeros.connections.confirm.deleteAction": "Delete",
    "aeros.connections.confirm.closedImportedTitle": "Close the imported tickets from {{name}}?",
    "aeros.connections.confirm.closedImportedAction": "Close tickets",
    "aeros.connections.transfer.title": "Ticket transfer",
    "aeros.connections.transfer.desc": "Pick the source connection (where the tickets come from) and the target one. Every open ticket on the source will be moved.",
    "aeros.connections.transfer.source": "Source",
    "aeros.connections.transfer.target": "Target",
    "aeros.connections.transfer.action": "Transfer",
    "aeros.connections.transfer.progressTitle": "Transferring tickets",
    "aeros.connections.transfer.progressCount": "{{current}} of {{total}} tickets transferred",
    "aeros.connections.transfer.progressWait": "Please wait while the tickets are transferred…",
    "aeros.connections.transfer.preDeleteTitle": "Have you already transferred this connection's tickets?",
    "aeros.connections.transfer.preDeleteMessage": "Before deleting, make sure this connection's tickets were moved to another one. Deleting without transferring leaves those tickets without a connection.",
    "aeros.connections.transfer.preDeleteConfirm": "Already transferred",
    "aeros.connections.transfer.preDeleteCancel": "Not yet",
    "aeros.connections.templates.title": "Synced templates",
    "aeros.connections.templates.summary": "{{count}} template(s) on Meta",
    "aeros.connections.templates.removed": "{{count}} removed from Pulse because they no longer exist on Meta",
    "aeros.connections.templates.name": "Name",
    "aeros.connections.templates.category": "Category",
    "aeros.connections.templates.language": "Language",
    "aeros.connections.templates.status": "Status",
    "aeros.connections.all.title": "Manage connections",
    "aeros.connections.all.back": "Connections",
    "aeros.connections.all.search": "Company or number…",
    "aeros.connections.all.restartAll": "Restart all",
    "aeros.connections.all.restartOne": "Restart connection",
    "aeros.connections.all.details": "View connection details",
    "aeros.connections.all.restarted": "Restart requested",
    "aeros.connections.all.filterAll": "Status: All",
    "aeros.connections.all.filterConnected": "Status: Connected",
    "aeros.connections.all.filterProblem": "Status: With problems",
    "aeros.connections.all.kpiCompanies": "Companies",
    "aeros.connections.all.kpiConnections": "Connections",
    "aeros.connections.all.kpiConnected": "Connected",
    "aeros.connections.all.kpiProblem": "With problems",
    "aeros.connections.all.company": "Company",
    "aeros.connections.all.connection": "Connection",
    "aeros.connections.all.number": "Number",
    "aeros.connections.all.status": "Status",
    "aeros.connections.all.channel": "Channel",
    "aeros.connections.all.updated": "Updated",
    "aeros.connections.all.actions": "Actions",
    "aeros.connections.all.noCompany": "No company",
    "aeros.connections.all.empty.title": "No connection found",
    "aeros.connections.all.empty.text": "Adjust the search or the status filter.",
    // ---- Tela Filas & Chatbot (/queues) ----
    "aeros.queues.title": "Queues & Chatbot",
    "aeros.queues.subtitle": "Departments, routing and automatic menus",
    "aeros.queues.search": "Search queue…",
    "aeros.queues.add": "Add queue",
    "aeros.queues.kpi.queues": "Active queues",
    "aeros.queues.kpi.queuesHint": "{{count}} with a chatbot",
    "aeros.queues.kpi.pending": "Waiting tickets",
    "aeros.queues.kpi.pendingHint": "across all queues",
    "aeros.queues.table.id": "ID",
    "aeros.queues.table.name": "Name",
    "aeros.queues.table.color": "Color",
    "aeros.queues.table.order": "Order (bot)",
    "aeros.queues.table.greeting": "Greeting message",
    "aeros.queues.table.bot": "Chatbot · Hours",
    "aeros.queues.table.actions": "Actions",
    "aeros.queues.agents": "{{count}} agents",
    "aeros.queues.agentOne": "1 agent",
    "aeros.queues.open": "{{count}} open",
    "aeros.queues.openOne": "1 open",
    "aeros.queues.options": "{{count}} options",
    "aeros.queues.optionOne": "1 option",
    "aeros.queues.noBot": "no chatbot",
    "aeros.queues.noGreeting": "No greeting message",
    "aeros.queues.schedule.always": "24/7",
    "aeros.queues.schedule.none": "No hours set",
    "aeros.queues.weekdayShort.monday": "Mon",
    "aeros.queues.weekdayShort.tuesday": "Tue",
    "aeros.queues.weekdayShort.wednesday": "Wed",
    "aeros.queues.weekdayShort.thursday": "Thu",
    "aeros.queues.weekdayShort.friday": "Fri",
    "aeros.queues.weekdayShort.saturday": "Sat",
    "aeros.queues.weekdayShort.sunday": "Sun",
    "aeros.queues.dragHandle": "Drag to reorder",
    "aeros.queues.reorderHint": "The order defines the bot's first menu. Drag to reorder.",
    "aeros.queues.reorderError": "Could not save the new order",
    "aeros.queues.actions.edit": "Edit queue",
    "aeros.queues.actions.delete": "Delete queue",
    "aeros.queues.empty.title": "No queues yet",
    "aeros.queues.empty.text": "Create a queue to route conversations by department.",
    "aeros.queues.delete.title": "Delete the queue “{{name}}”?",
    "aeros.queues.delete.body": "Its conversations lose their department and its chatbot stops working. This cannot be undone.",
    "aeros.queues.delete.bodyOpen": "{{count}} open conversations lose their department and this queue's chatbot stops working. This cannot be undone.",
    "aeros.queues.delete.confirm": "Delete queue",
    "aeros.queues.delete.done": "Queue deleted",
    "aeros.queues.modal.add": "New queue",
    "aeros.queues.modal.edit": "Edit queue · {{name}}",
    "aeros.queues.modal.subtitleNew": "Department, routing and automatic menu",
    "aeros.queues.modal.subtitle": "ID #{{id}} · {{count}} agents assigned",
    "aeros.queues.modal.save": "Save queue",
    "aeros.queues.modal.saved": "Queue saved",
    "aeros.queues.tabs.data": "Queue details",
    "aeros.queues.tabs.bot": "Chatbot",
    "aeros.queues.tabs.schedules": "Business hours",
    "aeros.queues.form.name": "Name",
    "aeros.queues.form.color": "Color",
    "aeros.queues.form.order": "Order (bot)",
    "aeros.queues.form.closeTicket": "Close the ticket when the bot finishes",
    "aeros.queues.form.closeTicketHint": "Ends the conversation without an agent",
    "aeros.queues.form.rotate": "Agent rotation",
    "aeros.queues.form.rotateHint": "Reassigns tickets with no reply",
    "aeros.queues.form.rotateTime": "Rotation time",
    "aeros.queues.form.rotateType": "Rotation type",
    "aeros.queues.form.random": "Random",
    "aeros.queues.form.ordered": "Ordered",
    "aeros.queues.form.integration": "Integration",
    "aeros.queues.form.integrationType": "Type (SGP only)",
    "aeros.queues.form.fileList": "File list",
    "aeros.queues.form.none": "None",
    "aeros.queues.form.greeting": "Greeting message",
    "aeros.queues.form.outOfHours": "Out-of-hours message",
    "aeros.queues.form.minutes": "minutes",
    "aeros.queues.bot.title": "Chatbot · {{count}} options in the first menu",
    "aeros.queues.bot.titleOne": "Chatbot · 1 option in the first menu",
    "aeros.queues.bot.titleEmpty": "Chatbot · no options yet",
    "aeros.queues.bot.list": "Menu options",
    "aeros.queues.bot.editing": "Editing option {{n}}",
    "aeros.queues.bot.creating": "New option",
    "aeros.queues.bot.optionTitle": "Option title",
    "aeros.queues.bot.type": "Menu type",
    "aeros.queues.bot.types.text": "Text",
    "aeros.queues.bot.types.user": "Agent",
    "aeros.queues.bot.types.queue": "Queue",
    "aeros.queues.bot.types.integration": "Integration",
    "aeros.queues.bot.types.file": "File",
    "aeros.queues.bot.targetUser": "Agent",
    "aeros.queues.bot.targetQueue": "Transfer to queue",
    "aeros.queues.bot.targetIntegration": "Integration",
    "aeros.queues.bot.targetFile": "File list",
    "aeros.queues.bot.currentQueue": "{{name}} (current)",
    "aeros.queues.bot.message": "Message",
    "aeros.queues.bot.closeAfter": "Close the ticket after this option",
    "aeros.queues.bot.discard": "Discard",
    "aeros.queues.bot.saveOption": "Save option",
    "aeros.queues.bot.addOption": "Add option",
    "aeros.queues.bot.empty": "No options in the menu. Add the first one.",
    "aeros.queues.bot.emptyEditor": "Pick an option on the left or add a new one.",
    "aeros.queues.bot.subOptions": "Sub-options",
    "aeros.queues.bot.subCount": "Opens a submenu with {{count}} options",
    "aeros.queues.bot.deleteOption": "Delete option",
    "aeros.queues.bot.deleteTitle": "Delete the option “{{name}}”?",
    "aeros.queues.bot.deleteBody": "The sub-options under it are removed too. This cannot be undone.",
    "aeros.queues.bot.deleted": "Option deleted",
    "aeros.queues.sub.levelMessage": "Message for this level",
    "aeros.queues.sub.placeholder": "Type the option text",
    "aeros.queues.sub.preview": "WhatsApp preview",
    "aeros.queues.sub.previewHint": "Type the option number",
    "aeros.queues.sub.back": "Back",
    "aeros.queues.sub.done": "Done",
    "aeros.queues.schedules.startA": "Start A",
    "aeros.queues.schedules.endA": "End A",
    "aeros.queues.schedules.startB": "Start B",
    "aeros.queues.schedules.endB": "End B",
    "aeros.queues.schedules.hint": "Outside these hours the contact gets the out-of-hours message.",
    "aeros.queues.schedules.disabled": "Hours are set per company; change it in Settings to edit them per queue.",
    // ---- Painel ao Vivo (/moments) ----
    "aeros.moments.emptyFilter": "for this filter",
    "aeros.moments.yesterday": "Yesterday",
    "aeros.moments.online": "Online",
    "aeros.moments.offline": "Offline",
    "aeros.moments.waiting": "Waiting",
    "aeros.moments.waitingSubtitle": "No agent assigned",
    "aeros.moments.empty": "No conversations right now",
    "aeros.moments.openTicket": "Open ticket",
    "aeros.moments.noQueue": "No queue",
    "aeros.moments.unreadAria": "{{count}} unread messages",
    // ---- Tela Integrações (/queue-integration) ----
    "aeros.integrations.noPermission": "This company is not allowed to access this page. Redirecting you.",
    "aeros.integrations.title": "Integrations",
    "aeros.integrations.subtitle": "Connect bots and external systems to your connections and queues",
    "aeros.integrations.search": "Search integration…",
    "aeros.integrations.new": "New integration",
    "aeros.integrations.idLabel": "ID {{id}}",
    "aeros.integrations.linkConnection": "Connection {{name}}",
    "aeros.integrations.linkQueue": "Queue {{name}}",
    "aeros.integrations.noLinks": "Not linked",
    "aeros.integrations.noEndpoint": "No address configured",
    "aeros.integrations.internalFlow": "Internal PULSE flow",
    "aeros.integrations.status.linked": "Active",
    "aeros.integrations.status.unlinked": "Not linked",
    "aeros.integrations.linkHint": "Link it under Connections or Queues",
    "aeros.integrations.actions.edit": "Edit integration",
    "aeros.integrations.actions.delete": "Delete integration",
    "aeros.integrations.empty.title": "No integrations yet",
    "aeros.integrations.empty.text": "Connect a bot or an external system so it answers alongside your team.",
    "aeros.integrations.filters.all": "All",
    "aeros.integrations.filters.bot": "Bots",
    "aeros.integrations.filters.webhook": "Webhooks",
    "aeros.integrations.filters.system": "Systems",
    "aeros.integrations.filters.unlinked": "Not linked",
    "aeros.integrations.types.typebot": "Typebot",
    "aeros.integrations.types.n8n": "n8n",
    "aeros.integrations.types.webhook": "Webhook",
    "aeros.integrations.types.dialogflow": "DialogFlow",
    "aeros.integrations.types.flowbuilder": "Flowbuilder",
    "aeros.integrations.types.sgp": "SGP",
    "aeros.integrations.docs.eyebrow": "Documentation",
    "aeros.integrations.docs.title": "How each integration works",
    "aeros.integrations.docs.intro": "Pick an integration type to see what PULSE sends or consumes, plus the step-by-step setup on the other side.",
    "aeros.integrations.docs.copy": "Copy example",
    "aeros.integrations.docs.copied": "Copied to the clipboard",
    "aeros.integrations.modal.add": "New integration",
    "aeros.integrations.modal.edit": "Edit integration",
    "aeros.integrations.modal.subtitle": "Pick the type and fill in the external system credentials",
    "aeros.integrations.modal.type": "Type",
    "aeros.integrations.modal.name": "Name",
    "aeros.integrations.modal.save": "Save integration",
    "aeros.integrations.modal.saved": "Integration saved",
    "aeros.integrations.modal.footerHint": "Link it afterwards under Connections or Queues",
    "aeros.integrations.form.typebotUrl": "Typebot API URL",
    "aeros.integrations.form.typebotUrlHelper": "No trailing slash",
    "aeros.integrations.form.typebotSlug": "Typebot · Slug",
    "aeros.integrations.form.typebotExpires": "Session expires after (minutes)",
    "aeros.integrations.form.typebotDelay": "Delay between messages (ms)",
    "aeros.integrations.form.typebotKeywordFinish": "Keyword to finish",
    "aeros.integrations.form.typebotKeywordRestart": "Keyword to restart",
    "aeros.integrations.form.typebotUnknown": "Unknown message",
    "aeros.integrations.form.typebotRestart": "Restart message",
    "aeros.integrations.form.n8nUrl": "N8N URL",
    "aeros.integrations.form.projectName": "Project (Google Cloud ID)",
    "aeros.integrations.form.language": "Language",
    "aeros.integrations.form.jsonContent": "JsonContent · service account key",
    "aeros.integrations.form.sgpIeSenha": "User provides the password",
    "aeros.integrations.form.sgpUrl": "SGP URL",
    "aeros.integrations.form.sgpWidePayToken": "Widepay token",
    "aeros.integrations.form.sgpWidePayHelper": "Only needed if your operation uses Widepay",
    "aeros.integrations.panel.typebot": "How PULSE talks to Typebot",
    "aeros.integrations.panel.sgp": "Self-service flow",
    "aeros.integrations.panel.n8n": "Payload the webhook receives",
    "aeros.integrations.test.title": "Send a test event",
    "aeros.integrations.test.hint": "Fires a POST with a sample payload to the URL above",
    "aeros.integrations.test.button": "Test",
    "aeros.integrations.test.running": "Sending…",
    "aeros.integrations.test.noResponse": "No response",
    "aeros.integrations.test.needsUrl": "Fill in the URL before sending the test",
    "aeros.integrations.test.saveFirst": "Save the integration before sending the test",
    "aeros.integrations.test.ok": "Webhook answered · {{result}}",
    "aeros.integrations.test.fail": "The webhook rejected the event · {{result}}",
    "aeros.integrations.dialogflow.test": "Test session",
    "aeros.integrations.dialogflow.ok": "Session tested successfully",
    "aeros.integrations.dialogflow.fail": "Could not open the session",
    "aeros.integrations.delete.title": "Delete the integration “{{name}}”?",
    "aeros.integrations.delete.body": "Conversations will no longer be forwarded to this system. This cannot be undone.",
    "aeros.integrations.delete.bodyLinked": "{{links}} will stop forwarding conversations to this system. This cannot be undone.",
    "aeros.integrations.delete.confirm": "Delete integration",
    "aeros.integrations.delete.done": "Integration deleted",
    // ---- Tela Talk.ai (/prompts) ----
    "aeros.talkai.noPermission": "This company is not allowed to access this page. Redirecting you.",
    "aeros.talkai.title": "Talk.ai",
    "aeros.talkai.count": "{{count}} agents",
    "aeros.talkai.countOne": "1 agent",
    "aeros.talkai.subtitle": "AI agents that answer automatically per connection and queue",
    "aeros.talkai.search": "Search agent or department…",
    "aeros.talkai.newAgent": "New agent",
    "aeros.talkai.footerNote": "Each queue of a connection has at most one agent. The AI hands over to a person when it cannot find the answer.",
    "aeros.talkai.kpi.activeAgents": "Active agents",
    "aeros.talkai.table.agent": "Agent",
    "aeros.talkai.table.model": "Model",
    "aeros.talkai.table.maxTokens": "Max tokens",
    "aeros.talkai.table.knowledge": "Knowledge",
    "aeros.talkai.table.actions": "Actions",
    "aeros.talkai.actions.simulate": "See a sample conversation",
    "aeros.talkai.actions.edit": "Edit agent",
    "aeros.talkai.actions.delete": "Delete agent",
    "aeros.talkai.empty.title": "No agents yet",
    "aeros.talkai.empty.text": "Create an agent so the department answers the most common questions on its own.",
    "aeros.talkai.tones.formal": "Formal",
    "aeros.talkai.tones.amigavel": "Friendly",
    "aeros.talkai.tones.descontraido": "Casual",
    "aeros.talkai.tones.tecnico": "Technical",
    "aeros.talkai.knowledge.files": "{{count}} files",
    "aeros.talkai.knowledge.fileOne": "1 file",
    "aeros.talkai.knowledge.processing": "Processing",
    "aeros.talkai.knowledge.none": "Prompt only",
    "aeros.talkai.simulation.defaultName": "Aero",
    "aeros.talkai.simulation.defaultQueue": "Support",
    "aeros.talkai.simulation.greeting.formal": "Hello. I am {{name}}, from the support team.",
    "aeros.talkai.simulation.greeting.amigavel": "Hi! I'm {{name}}, your assistant here.",
    "aeros.talkai.simulation.greeting.descontraido": "Hey! {{name}} here, let's sort this out.",
    "aeros.talkai.simulation.greeting.tecnico": "{{name}} here. Let's run a diagnosis.",
    "aeros.talkai.simulation.contact1": "Hi, my internet keeps dropping",
    "aeros.talkai.simulation.agent1": "Unplug the router, wait 30 seconds and plug it back in. Let me know when the lights settle?",
    "aeros.talkai.simulation.contact2": "Already did that and there's still no signal",
    "aeros.talkai.simulation.defaultTransfer": "I'll hand you over to someone from the {{queue}} team, one moment",
    "aeros.talkai.simulation.transferredByRule": "Handed over to {{queue}} · handover rule",
    "aeros.talkai.simulation.transferredNoAnswer": "Handed over to {{queue}} · the AI could not find the answer",
    "aeros.talkai.simulation.title": "Sample conversation",
    "aeros.talkai.simulation.note": "Illustrative example, built from the chosen tone and emoji setting",
    "aeros.talkai.modal.add": "New agent",
    "aeros.talkai.modal.edit": "Edit agent",
    "aeros.talkai.modal.subtitle": "Set how the AI introduces itself, what it knows and when it hands over",
    "aeros.talkai.modal.name": "Agent name",
    "aeros.talkai.modal.saved": "Agent saved",
    "aeros.talkai.modal.save": "Save agent",
    "aeros.talkai.modal.footerNote": "Changes affect new conversations immediately",
    "aeros.talkai.tabs.personality": "Personality",
    "aeros.talkai.tabs.knowledge": "Knowledge",
    "aeros.talkai.tabs.advanced": "Advanced",
    "aeros.talkai.form.agentName": "Name the AI goes by",
    "aeros.talkai.form.tone": "Tone of voice",
    "aeros.talkai.form.useEmojis": "Use emojis sparingly",
    "aeros.talkai.form.restrictions": "Business restrictions",
    "aeros.talkai.form.restrictionsHelper": "Rules the AI can never break (e.g. never discuss pricing)",
    "aeros.talkai.form.transferInstructions": "When to hand over to a person",
    "aeros.talkai.form.transferInstructionsHelper": "Write when the AI should hand the conversation to an agent (e.g. only when the contact asks to talk to an agent). If left empty, the AI decides on its own whether to transfer.",
    "aeros.talkai.form.basePromptHelper": "Everything the AI follows comes from here and the fields above: the system adds no rules. WhatsApp tip: ask for short replies without # headings or ** bold.",
    "aeros.talkai.personalityLine.name": "Your name is {{name}}.",
    "aeros.talkai.personalityLine.tone.formal": "Use a formal and professional tone.",
    "aeros.talkai.personalityLine.tone.amigavel": "Use a friendly and welcoming tone.",
    "aeros.talkai.personalityLine.tone.descontraido": "Use a relaxed and light tone.",
    "aeros.talkai.personalityLine.tone.tecnico": "Use a technical and objective tone.",
    "aeros.talkai.personalityLine.emojisOn": "You may use emojis sparingly.",
    "aeros.talkai.personalityLine.emojisOff": "Do not use emojis.",
    "aeros.talkai.form.personalityHint": "Name, tone and emojis become lines at the start of the base prompt, which you can edit.",
    "aeros.talkai.blocks.restrictions": "Business restrictions",
    "aeros.talkai.blocks.transfer": "When to transfer",
    "aeros.talkai.form.transferMessage": "Handover message",
    "aeros.talkai.form.knowledgeText": "Knowledge as text",
    "aeros.talkai.form.knowledgeHelper": "Short, objective notes work best. For long documents, use the files on the right.",
    "aeros.talkai.form.apiKey": "OpenAI API key",
    "aeros.talkai.form.model": "Model",
    "aeros.talkai.form.response": "Reply as",
    "aeros.talkai.form.responseText": "Text",
    "aeros.talkai.form.voicePrefix": "Voice",
    "aeros.talkai.form.azureTitle": "Azure Speech · required for voice",
    "aeros.talkai.form.azureKey": "Key",
    "aeros.talkai.form.azureRegion": "Region",
    "aeros.talkai.form.temperature": "Temperature",
    "aeros.talkai.form.temperatureHint": "0 = predictable · 2 = creative",
    "aeros.talkai.form.maxTokens": "Max tokens",
    "aeros.talkai.form.maxTokensHint": "Longest reply the AI may write",
    "aeros.talkai.form.maxMessages": "Max messages",
    "aeros.talkai.form.maxMessagesHint": "History sent to the AI",
    "aeros.talkai.form.basePrompt": "Base prompt",
    "aeros.talkai.form.showKey": "Show key",
    "aeros.talkai.form.hideKey": "Hide key",
    "aeros.talkai.files.title": "Imported files",
    "aeros.talkai.files.counter": "· {{count}} of {{max}}",
    "aeros.talkai.files.import": "Import",
    "aeros.talkai.files.dropTitle": "Drop a PDF, TXT or DOCX here",
    "aeros.talkai.files.dropHint": "Up to 10 MB per file · the content is indexed automatically",
    "aeros.talkai.files.saveFirst": "Save the agent before importing files",
    "aeros.talkai.files.ready": "Ready",
    "aeros.talkai.files.processing": "Processing",
    "aeros.talkai.files.failed": "Failed",
    "aeros.talkai.files.delete": "Remove file",
    "aeros.talkai.files.readyCount": "{{count}} files ready to use",
    "aeros.talkai.files.readyCountOne": "1 file ready to use",
    "aeros.talkai.files.failureLine": "{{name}} failed: {{reason}}",
    "aeros.talkai.files.failureUnknown": "the file could not be indexed",
    "aeros.talkai.files.uploaded": "File imported",
    "aeros.talkai.files.deleted": "File removed",
    "aeros.talkai.preview.title": "Assembled system prompt",
    "aeros.talkai.preview.copy": "Copy",
    "aeros.talkai.preview.copied": "Prompt copied to the clipboard",
    "aeros.talkai.preview.note": "Read-only · built by the server in this same order",
    "aeros.talkai.preview.tokens": "≈ {{count}} system tokens per conversation",
    "aeros.talkai.preview.error": "Could not build the prompt preview",
    "aeros.talkai.blocks.basePrompt": "Base prompt",
    "aeros.talkai.blocks.knowledge": "Knowledge base",
    "aeros.talkai.delete.title": "Delete the agent “{{name}}”?",
    "aeros.talkai.delete.body": "The agent will stop answering in {{vinculo}}. This cannot be undone.",
    "aeros.talkai.delete.bodyFiles": "The agent will stop answering in {{vinculo}} and the {{count}} knowledge base files will be removed. This cannot be undone.",
    "aeros.talkai.delete.confirm": "Delete agent",
    "aeros.talkai.delete.done": "Agent deleted",
    "aeros.talkai.table.vinculo": "Connection · Queues",
    "aeros.talkai.vinculo.pending": "Connection pending",
    "aeros.talkai.vinculo.pendingHint": "Old agent without a connection: edit it and choose the connection",
    "aeros.talkai.vinculo.preQueue": "before distribution",
    "aeros.talkai.modal.connection": "Connection",
    "aeros.talkai.modal.selectConnection": "Select the connection",
    "aeros.talkai.modal.queues": "Queues",
    "aeros.talkai.modal.selectQueues": "Select the queues",
    "aeros.talkai.modal.selectConnectionFirst": "Choose the connection first",
    "aeros.talkai.modal.noQueuesInConnection": "This connection has no queues",
    "aeros.talkai.modal.queueUsedBy": "Used by {{name}}",
    "aeros.talkai.modal.queueOutside": "Not in this connection",
    "aeros.talkai.modal.preQueue": "Also answer before distribution",
    "aeros.talkai.modal.preQueueHelp": "Answers the conversation before it lands in a queue and, on a single-queue connection, also in that queue when it has no agent of its own. Only works on a connection without a queue menu.",
    "aeros.talkai.modal.preQueueTaken": "Unavailable: agent {{name}} already answers before distribution on this connection",
    "aeros.talkai.modal.preQueueNoEffect": "This connection has a queue menu: the option only takes effect if the connection has no menu.",
    "aeros.talkai.modal.pendingWarning": "Agent without a connection (old record): choose the connection to save.",
    "aeros.talkai.modal.warnQueueIntegration": "Queue with an integration ({{queues}}): the integration answers before the agent.",
    "aeros.talkai.modal.warnQueueChatbot": "Queue with chatbot options ({{queues}}): the queue chatbot replies and the agent does not answer there.",
    "aeros.talkai.modal.warnConnectionIntegration": "This connection has an integration; it may answer before the agent.",
    "aeros.talkai.modal.warnExtraConnections": "When saved, this agent stops answering before distribution on: {{connections}}.",
    "aeros.talkai.modal.warnOutsideQueues": "Queues no longer in this connection will be removed when saved: {{queues}}.",
    "aeros.talkai.modal.warningsLabel": "Connection and queue warnings",
    // ---- Tela Aniversários (/birthday-settings) ----
    "aeros.birthday.title": "Birthdays",
    "aeros.birthday.subtitle": "Automatic wishes for contacts and the team",
    "aeros.birthday.save": "Save settings",
    "aeros.birthday.saved": "Settings saved",
    "aeros.birthday.saveError": "Could not save the settings",
    "aeros.birthday.loadError": "Could not load the settings",
    "aeros.birthday.loading": "Loading settings…",
    "aeros.birthday.active": "On",
    "aeros.birthday.inactive": "Off",
    "aeros.birthday.collapse": "Collapse section",
    "aeros.birthday.expand": "Expand section",
    "aeros.birthday.nextSend.today": "Next send today at {{time}} · {{count}} contacts",
    "aeros.birthday.nextSend.todayOne": "Next send today at {{time}} · 1 contact",
    "aeros.birthday.nextSend.idle": "Next send at {{time}} · nobody today",
    "aeros.birthday.nextSend.disabled": "Automatic sending is off",
    "aeros.birthday.contacts.title": "Contact birthdays",
    "aeros.birthday.contacts.subtitle": "Sends wishes over WhatsApp on the birthday",
    "aeros.birthday.users.title": "Team birthdays",
    "aeros.birthday.users.subtitle": "Shows the birthday modal when someone opens the panel",
    "aeros.birthday.sendTime": "Send time",
    "aeros.birthday.sendTimeHelper": "Brasília time",
    "aeros.birthday.connection": "WhatsApp connection used to send",
    "aeros.birthday.connectionNone": "Company default connection",
    "aeros.birthday.connected": "Connected",
    "aeros.birthday.disconnected": "Disconnected",
    "aeros.birthday.contactMessage": "Message for contacts",
    "aeros.birthday.userMessage": "Message for the team",
    "aeros.birthday.variableHint": "Click a variable to insert it at the cursor",
    "aeros.birthday.insertVariable": "Insert {{variable}} into the message",
    "aeros.birthday.sentToday": "Sent successfully to {{count}} contacts today",
    "aeros.birthday.sentTodayOne": "Sent successfully to 1 contact today",
    "aeros.birthday.testMessage": "Test message",
    "aeros.birthday.announcement.title": "Create an automatic announcement",
    "aeros.birthday.announcement.desc": "Publishes a company-wide notice in the bell on the birthday",
    "aeros.birthday.preview.title": "WhatsApp preview",
    "aeros.birthday.preview.note": "Each contact gets at most one message per year; manual resends warn if it already went out.",
    "aeros.birthday.preview.sampleName": "John Smith",
    "aeros.birthday.preview.empty": "Write the message to see the preview.",
    "aeros.birthday.upcoming.title": "Upcoming birthdays",
    "aeros.birthday.upcoming.seeAll": "See all",
    "aeros.birthday.upcoming.empty": "No birthdays in the coming days.",
    "aeros.birthday.upcoming.error": "Could not load the upcoming birthdays",
    "aeros.birthday.status.today": "Today",
    "aeros.birthday.status.sent": "Sent",
    "aeros.birthday.status.scheduled": "Scheduled",
    "aeros.birthday.type.user": "Team",
    "aeros.birthday.type.contact": "Contact",
    "aeros.birthday.age": "{{count}} years old",
    "aeros.birthday.ageOne": "1 year old",
    "aeros.birthday.kpi.contactsWithDate": "contacts with a date",
    "aeros.birthday.kpi.sentThisYear": "sent in {{year}}",
    "aeros.birthday.kpi.responded": "replied",
    "aeros.birthday.months.0": "jan",
    "aeros.birthday.months.1": "feb",
    "aeros.birthday.months.2": "mar",
    "aeros.birthday.months.3": "apr",
    "aeros.birthday.months.4": "may",
    "aeros.birthday.months.5": "jun",
    "aeros.birthday.months.6": "jul",
    "aeros.birthday.months.7": "aug",
    "aeros.birthday.months.8": "sep",
    "aeros.birthday.months.9": "oct",
    "aeros.birthday.months.10": "nov",
    "aeros.birthday.months.11": "dec",
    "aeros.birthday.test.title": "Test the birthday message",
    "aeros.birthday.test.subtitle": "Sends the contact message now, through the {{connection}} connection",
    "aeros.birthday.test.subtitleDefault": "Sends the contact message now, through the default connection",
    "aeros.birthday.test.contact": "Test contact",
    "aeros.birthday.test.searchPlaceholder": "Search a contact by name or number…",
    "aeros.birthday.test.searching": "Searching…",
    "aeros.birthday.test.noResults": "No contact found",
    "aeros.birthday.test.noBirth": "no birth date",
    "aeros.birthday.test.idLabel": "ID {{id}}",
    "aeros.birthday.test.willSend": "Will be sent",
    "aeros.birthday.test.missingWarning": "{{vars}} will come out empty: this contact has no birth date on file",
    "aeros.birthday.test.send": "Send test",
    "aeros.birthday.test.sent": "Test message sent",
    "aeros.birthday.test.error": "Could not send the test message",
    "aeros.birthday.today.title": "Someone has a birthday today!",
    "aeros.birthday.today.subtitleTeam": "{{count}} teammate",
    "aeros.birthday.today.subtitleTeamMany": "{{count}} teammates",
    "aeros.birthday.today.subtitleContacts": "{{count}} contact",
    "aeros.birthday.today.subtitleContactsMany": "{{count}} contacts",
    "aeros.birthday.today.team": "Team",
    "aeros.birthday.today.contacts": "Contacts",
    "aeros.birthday.today.userAge": "Turns {{count}} today",
    "aeros.birthday.today.announcementPublished": "announcement published in the bell",
    "aeros.birthday.today.greet": "Send wishes",
    "aeros.birthday.today.greetError": "Could not open the conversation",
    "aeros.birthday.today.alreadySent": "Already sent",
    "aeros.birthday.today.sending": "Sending…",
    "aeros.birthday.today.send": "Send wishes",
    "aeros.birthday.today.sentAt": "sent {{time}}",
    "aeros.birthday.today.sendError": "Could not send the birthday wishes",
    "aeros.birthday.today.configure": "Birthday settings",
    "aeros.birthday.today.later": "Remind me later",
    "aeros.birthday.today.gotIt": "Got it",
    "aeros.birthday.today.empty": "Nobody has a birthday today.",
    // ---- Tela Uso da API (/messages-api) ----
    "aeros.api.title": "API usage",
    "aeros.api.subtitle": "Send text and media messages from your own systems",
    "aeros.api.tokensButton": "Connection tokens",
    "aeros.api.noPermission": "This company is not allowed to access this page. Redirecting you.",
    "aeros.api.intro": "Every request uses the endpoint below, authenticated with the connection token (Bearer). The number must be in international format, with no spaces or symbols.",
    "aeros.api.copyEndpoint": "Copy endpoint",
    "aeros.api.copyExample": "Copy request example",
    "aeros.api.copied": "Copied to the clipboard",
    "aeros.api.numberFormat": "Number format",
    "aeros.api.numberLegend": "country · area · number",
    "aeros.api.authorizationLine": "Authorization: Bearer (token stored in the connection)",
    "aeros.api.kpiSends": "API sends · {{days}} days",
    "aeros.api.kpiText": "text",
    "aeros.api.kpiMedia": "with media",
    "aeros.api.method": "Method",
    "aeros.api.methodText": "Text message",
    "aeros.api.methodTextIntro": "JSON body. On official connections, pass templateName to send an approved template, inside or outside the 24h window.",
    "aeros.api.methodMedia": "Message with media",
    "aeros.api.methodMediaIntro": "multipart/form-data body. The medias field carries the file; body becomes the caption.",
    "aeros.api.tabs.fields": "Fields",
    "aeros.api.testSend": "Test send",
    "aeros.api.testSendHint": "Really sends through the chosen connection",
    "aeros.api.connection": "Connection",
    "aeros.api.connectionNone": "No connection selected",
    "aeros.api.connectionHelper": "Choosing a connection fills in the token stored in it",
    "aeros.api.channelOfficial": "Official",
    "aeros.api.channelBaileys": "Baileys",
    "aeros.api.token": "Token",
    "aeros.api.number": "Number",
    "aeros.api.body": "Message",
    "aeros.api.caption": "Caption",
    "aeros.api.userId": "User",
    "aeros.api.queueId": "Queue",
    "aeros.api.optional": "· optional",
    "aeros.api.sendSignature": "Sign with the agent name",
    "aeros.api.closeTicket": "Close the ticket after sending",
    "aeros.api.template": "Template",
    "aeros.api.templateNone": "No template (free message)",
    "aeros.api.templateHelper": "With a template the message goes inside or outside the 24h window and the body is ignored",
    "aeros.api.templateMediaBadge": "media in the header",
    "aeros.api.templateHeaderMediaUrl": "Header media URL",
    "aeros.api.templateHeaderMediaUrlHelper": "Public http(s) URL of the file (PDF, image or video)",
    "aeros.api.templateParamHelper": "Accepts {nome}, {numero}, {email}",
    "aeros.api.variableOne": "variable",
    "aeros.api.variableMany": "variables",
    "aeros.api.fillTemplate": "Fill in the template",
    "aeros.api.bodyIgnored": "Ignored while a template is selected",
    "aeros.api.file": "File",
    "aeros.api.fileHint": "Image, video, PDF or document",
    "aeros.api.fileRequired": "Choose a file before sending the test",
    "aeros.api.noFile": "No file selected",
    "aeros.api.unknownType": "unknown type",
    "aeros.api.chooseFile": "Choose",
    "aeros.api.changeFile": "Replace",
    "aeros.api.sendTest": "Send test",
    "aeros.api.sendTemplate": "Send template",
    "aeros.api.lastTest": "Last test: {{status}} · {{when}}",
    "aeros.api.smsEyebrow": "SMS API",
    "aeros.api.smsTitle": "Sending SMS",
    "aeros.api.smsIntro": "Three endpoints: send, check status and check balance. Authenticate with the company SMS token (Tokens button), not a connection token, and always send the X-Origin header with your system's name — without it the response is 400. Each SMS part uses 1 credit.",
    "aeros.api.smsAuthorizationLine": "Authorization: Bearer (company SMS token)",
    "aeros.api.smsSendLabel": "Send SMS",
    "aeros.api.smsStatusLabel": "Check status",
    "aeros.api.smsBalanceLabel": "Check balance",
    "aeros.api.reference": "Reference",
    "aeros.api.responses": "Responses and errors",
    "aeros.api.codes.400.title": "Bad request",
    "aeros.api.codes.400.desc": "X-Origin missing or invalid field; the response gives the reason in error.",
    "aeros.api.codes.200.title": "Accepted by Meta",
    "aeros.api.codes.200.desc": "Official connection: Meta accepted the message (status accepted) and delivery is asynchronous; check the status route with the messageId. The message text did not change and does not guarantee delivery. If Meta refuses it right away, the send returns an HTTP error (never 200) with the translated reason in error. QR Code connection: the message entered the connection queue, with no messageId.",
    "aeros.api.codes.401.title": "No token",
    "aeros.api.codes.401.desc": "Authorization header missing from the request.",
    "aeros.api.codes.403.title": "Invalid token",
    "aeros.api.codes.403.desc": "The Bearer matches no connection nor the company SMS token (or the company is inactive).",
    "aeros.api.codes.422.title": "Rule violated",
    "aeros.api.codes.422.desc": "A required field is missing or malformed; the response says which one.",
    "aeros.api.codes.402.title": "License expired",
    "aeros.api.codes.402.desc": "The company subscription has expired (ERR_LICENSE_EXPIRED). The API responds again as soon as the payment is confirmed in Subscription.",
    "aeros.api.codes.429.title": "Limit reached",
    "aeros.api.codes.429.desc": "Too many requests per minute on the connection. Wait and send again.",
    "aeros.api.codes.404.title": "Message not found",
    "aeros.api.codes.404.desc": "Status route: messageId does not exist, belongs to another company or to a message from another connection (ERR_NO_MESSAGE_FOUND).",
    "aeros.api.statusEyebrow": "Lookup",
    "aeros.api.statusTitle": "Message status",
    "aeros.api.statusIntro": "The 200 on send means accepted by Meta: delivery is asynchronous. With the messageId returned on send (official connection) you can tell whether the message was sent, delivered, read or failed, and the real reason for the failure. Same token (Bearer) and same X-Origin header as the send. QR Code (Baileys) connections do not return a messageId, so they have no such lookup. On the official channel, the first state you will usually see when querying is sent (accepted is momentary).",
    "aeros.api.statusLabel": "Check message status",
    "aeros.api.categories.conta.title": "Account",
    "aeros.api.categories.conta.desc": "Problem with the WhatsApp Business account, such as pending payment or a restricted account. Fix it in Meta Business; the fix link comes in failure.link.",
    "aeros.api.categories.contato.title": "Contact",
    "aeros.api.categories.contato.desc": "The recipient does not receive the message: number not on WhatsApp, contact who opted out, or outdated app.",
    "aeros.api.categories.janela.title": "24h window",
    "aeros.api.categories.janela.desc": "Outside the 24h window only an approved template is delivered. Resend with templateName.",
    "aeros.api.categories.template.title": "Template",
    "aeros.api.categories.template.desc": "Template missing, paused, rejected or with wrong parameters. Review the template and its parameters.",
    "aeros.api.categories.limite.title": "Limit",
    "aeros.api.categories.limite.desc": "Sending or account-quality limit reached, or too many messages to the same contact. Wait and resend.",
    "aeros.api.categories.midia.title": "Media",
    "aeros.api.categories.midia.desc": "Meta did not accept the file: invalid type, size or format, or an unreachable link.",
    "aeros.api.categories.desconhecido.title": "Unknown",
    "aeros.api.categories.desconhecido.desc": "Code with no translation in the catalog. Read failure.reasonOriginal (Meta text) and failure.code.",
    "aeros.api.result.successTitle": "Message sent",
    "aeros.api.result.errorTitle": "Request rejected",
    "aeros.api.result.noResponse": "No response",
    "aeros.api.result.response": "Response",
    "aeros.api.result.copy": "Copy response",
    "aeros.api.result.close": "Close",
    "aeros.api.result.justNow": "just now",
    "aeros.api.result.minutesAgo": "{{count}} min ago",
    "aeros.api.result.hoursAgo": "{{count}} h ago",
    "aeros.api.result.hintNetwork": "The request never reached the server. Check the network and whether the API address is reachable.",
    "aeros.api.result.hint401": "The token matches no connection. Copy it from the “Connection tokens” button.",
    "aeros.api.result.hint422": "A required field is missing or malformed. The response above says which one to fix.",
    "aeros.api.result.hint429": "The connection request limit was reached. Wait a moment before sending again.",
    "aeros.api.result.hint500": "The API answered with an internal error. Try again; if it persists, contact support.",
    "aeros.api.tokens.title": "Connection tokens",
    "aeros.api.tokens.subtitle": "Each connection has its own token, used in the Authorization header. The SMS token is a single one for the whole company.",
    "aeros.api.tokens.empty": "No connection has a token stored.",
    "aeros.api.tokens.reveal": "Show token",
    "aeros.api.tokens.hide": "Hide token",
    "aeros.api.tokens.copy": "Copy token",
    "aeros.api.tokens.footerHint": "Keep tokens in environment variables, never in client-side code",
    "aeros.api.tokens.close": "Close",
    "aeros.api.tokens.sms.title": "SMS token",
    "aeros.api.tokens.sms.subtitle": "A single company-wide token for the /api/sms routes — not tied to any connection.",
    "aeros.api.tokens.sms.empty": "No SMS token has been generated yet.",
    "aeros.api.tokens.sms.generate": "Generate token",
    "aeros.api.tokens.sms.regenerate": "Regenerate",
    "aeros.api.tokens.sms.confirmTitle": "Regenerate the SMS token?",
    "aeros.api.tokens.sms.confirmBody": "The current token stops working right away. Update every integration that sends SMS with the new token.",
    "aeros.api.tokens.sms.generated": "SMS token generated",
    "aeros.header.morning": "Good morning",
    "aeros.header.afternoon": "Good afternoon",
    "aeros.header.evening": "Good evening",
    "aeros.header.plan": "{{company}} · plan active until {{date}}",
    "aeros.header.connected": "Connected",
    "aeros.header.reconnecting": "Reconnecting…",
    "aeros.header.payInvoice": "Pay invoice",
    "aeros.header.search": "Search or go to…",
    "aeros.header.searchPlaceholder": "Search screen, contact or ticket…",
    "aeros.header.searchAria": "Search",
    "aeros.header.nothingFound": "Nothing found for “{{q}}”.",
    "aeros.header.groups.screens": "Screens",
    "aeros.header.groups.contacts": "Contacts",
    "aeros.header.groups.tickets": "Tickets",
    "aeros.header.noContact": "No contact",
    "aeros.header.language": "Language",
    "aeros.header.languageHint": "Switches without reloading the page",
    "aeros.header.theme": "Theme",
    "aeros.header.light": "Light",
    "aeros.header.dark": "Dark",
    "aeros.header.system": "System",
    "aeros.header.accent": "Accent color",
    "aeros.header.customColor": "Custom color",
    "aeros.header.sound": "Notification sound",
    "aeros.header.volume": "Volume",
    "aeros.header.ringtone": "Default ringtone",
    "aeros.header.clickToTest": "Click to test",
    "aeros.header.testRingtone": "Test ringtone",
    "aeros.header.browserNotifications": "Browser notifications",
    "aeros.header.blockedInBrowser": "Blocked in the browser",
    "aeros.header.muteUntil": "Mute until",
    "aeros.header.mute": "Mute",
    "aeros.header.mutedUntil": "Muted until {{time}}",
    "aeros.header.unread": "Unread messages",
    "aeros.header.unreadTitle": "Unread",
    "aeros.header.tabs.mine": "Mine",
    "aeros.header.tabs.queue": "Queue",
    "aeros.header.tabs.groups": "Groups",
    "aeros.header.markAllRead": "Mark all as read",
    "aeros.header.seeAllTickets": "See all tickets",
    "aeros.header.announcements": "Announcements",
    "aeros.header.priority.high": "High",
    "aeros.header.priority.medium": "Medium",
    "aeros.header.priority.low": "Low",
    "aeros.header.internalChat": "Internal chat",
    "aeros.header.newChat": "New conversation",
    "aeros.header.openInternalChat": "Open internal chat",
    "aeros.header.userMenu": "User menu",
    "aeros.header.online": "Online",
    "aeros.header.away": "Away",
    "aeros.header.myProfile": "My profile",
    "aeros.header.preferences": "Preferences",
    "aeros.header.preferencesHint": "menu, theme, sound",
    "aeros.header.helpTutorials": "Help & tutorials",
    "aeros.header.logout": "Sign out",
    "aeros.header.close": "Close",
    "aeros.screens.dashboard": "Dashboard",
    "aeros.screens.tickets": "Tickets",
    "aeros.screens.moments": "Live Panel",
    "aeros.screens.kanban": "Kanban",
    "aeros.screens.schedules": "Schedules",
    "aeros.screens.quickMessages": "Quick replies",
    "aeros.screens.contacts": "Contacts",
    "aeros.screens.tags": "Tags",
    "aeros.screens.chats": "Internal Chat",
    "aeros.screens.reports": "Reports",
    "aeros.screens.wallets": "Wallets",
    "aeros.screens.helps": "Help",
    "aeros.screens.campaigns": "Campaigns",
    "aeros.screens.flowbuilders": "Flowbuilder",
    "aeros.screens.prompts": "Open.Ai",
    "aeros.screens.users": "Users",
    "aeros.screens.connections": "Connections",
    "aeros.screens.queues": "Queues & Chatbot",
    "aeros.screens.settings": "Settings",
    "aeros.screens.financeiro": "Subscription",
    "aeros.prefs.title": "Preferences",
    "aeros.prefs.subtitle": "Menu, appearance, sound and language — only for you",
    "aeros.prefs.menu": "Sidebar on login",
    "aeros.prefs.menuOpen": "Open",
    "aeros.prefs.menuOpenDesc": "Shows the screen names",
    "aeros.prefs.menuClosed": "Collapsed",
    "aeros.prefs.menuClosedDesc": "Icons only; more space",
    "aeros.prefs.appearance": "Appearance",
    "aeros.prefs.done": "Done",
    "aeros.prefs.menuSaved": "Menu preference saved.",
    "aeros.reports.title": "Reports",
    "aeros.reports.tickets": "tickets",
    "aeros.reports.updatedNow": "updated just now",
    "aeros.reports.updatedMin": "updated {{min}} min ago",
    "aeros.reports.updatedHour": "updated {{h}} h ago",
    "aeros.reports.saveFilter": "Save filter",
    "aeros.reports.saveCurrent": "Save current filter…",
    "aeros.reports.pdf": "PDF",
    "aeros.reports.exportXlsx": "Export XLSX",
    "aeros.reports.presets.today": "Today",
    "aeros.reports.presets.7d": "7 days",
    "aeros.reports.presets.30d": "30 days",
    "aeros.reports.presets.month": "Month",
    "aeros.reports.dateFrom": "Start date",
    "aeros.reports.dateTo": "End date",
    "aeros.reports.filters.period": "Period",
    "aeros.reports.filters.queue": "Queue",
    "aeros.reports.filters.user": "Agent",
    "aeros.reports.filters.connection": "Connection",
    "aeros.reports.filters.status": "Status",
    "aeros.reports.filters.wallet": "Wallet",
    "aeros.reports.filters.onlyRated": "Rated only",
    "aeros.reports.filters.search": "Search",
    "aeros.reports.all": "All",
    "aeros.reports.allF": "All",
    "aeros.reports.clearFilters": "Clear filters",
    "aeros.reports.searchPlaceholder": "Search contact by name or number…",
    "aeros.reports.searchAria": "Search contact",
    "aeros.reports.status.open": "Open",
    "aeros.reports.status.pending": "Pending",
    "aeros.reports.status.closed": "Resolved",
    "aeros.reports.status.group": "Group",
    "aeros.reports.status.nps": "Rating",
    "aeros.reports.status.lgpd": "LGPD",
    "aeros.reports.pills.all": "All",
    "aeros.reports.pills.open": "Open",
    "aeros.reports.pills.pending": "Pending",
    "aeros.reports.pills.closed": "Resolved",
    "aeros.reports.kpis.total": "Tickets",
    "aeros.reports.kpis.resolution": "Resolution rate",
    "aeros.reports.kpis.wait": "Avg. wait",
    "aeros.reports.kpis.duration": "Avg. handling",
    "aeros.reports.kpis.nps": "Average NPS",
    "aeros.reports.kpis.rated": "{{rated}} rated · {{pct}}%",
    "aeros.reports.vsPrevious": "vs. previous period",
    "aeros.reports.samePrevious": "= previous period",
    "aeros.reports.summaryUnavailable": "summary unavailable",
    "aeros.reports.columns.id": "ID",
    "aeros.reports.columns.contact": "Contact",
    "aeros.reports.columns.queue": "Queue",
    "aeros.reports.columns.user": "Agent",
    "aeros.reports.columns.wallet": "Wallet",
    "aeros.reports.columns.status": "Status",
    "aeros.reports.columns.openClose": "Opened → Closed",
    "aeros.reports.columns.duration": "Duration",
    "aeros.reports.columns.nps": "NPS",
    "aeros.reports.columns.sale": "Sale",
    "aeros.reports.columns.actions": "Actions",
    "aeros.reports.columns.connection": "Connection",
    "aeros.reports.columns.number": "Number",
    "aeros.reports.columns.lastMessage": "Last message",
    "aeros.reports.columns.opened": "Opened",
    "aeros.reports.columns.closed": "Closed",
    "aeros.reports.columns.supportTime": "Handling time",
    "aeros.reports.columns.saleValue": "Sale value",
    "aeros.reports.columns.noSaleReason": "No-sale reason",
    "aeros.reports.columns.soldLabel": "Closed with sale",
    "aeros.reports.noQueue": "No queue",
    "aeros.reports.stillOpen": "still open",
    "aeros.reports.notSold": "No · {{reason}}",
    "aeros.reports.noReason": "no reason",
    "aeros.reports.yes": "Yes",
    "aeros.reports.no": "No",
    "aeros.reports.empty": "No tickets in the period with these filters.",
    "aeros.reports.logs": "Ticket logs",
    "aeros.reports.access": "Open ticket",
    "aeros.reports.perPage": "{{n}} per page",
    "aeros.reports.perPageAria": "Per page",
    "aeros.reports.showing": "Showing {{from}}–{{to}} of {{total}}",
    "aeros.reports.noResults": "No results",
    "aeros.reports.filterSaved": "Filter saved.",
    "aeros.reports.notInformed": "Not informed",
    "aeros.reports.sheetTitle": "Ticket Reports",
    "aeros.reports.sheetStart": "Start date",
    "aeros.reports.sheetEnd": "End date",
    "aeros.reports.sheetTickets": "TicketReport",
    "aeros.reports.sheetChats": "Conversations",
    "aeros.reports.transcript.ticket": "Ticket",
    "aeros.reports.transcript.contact": "Contact",
    "aeros.reports.transcript.datetime": "Date/time",
    "aeros.reports.transcript.from": "From",
    "aeros.reports.transcript.message": "Message",
    "aeros.reports.transcript.agent": "Agent",
    "aeros.reports.transcript.customer": "Customer",
    "aeros.reports.export.title": "Export report",
    "aeros.reports.export.xlsx": "XLSX spreadsheet",
    "aeros.reports.export.xlsxDesc": "Chosen columns",
    "aeros.reports.export.pdf": "Summary PDF",
    "aeros.reports.export.pdfDesc": "KPIs + table",
    "aeros.reports.export.columns": "Columns",
    "aeros.reports.export.transcript": "Include conversation transcripts",
    "aeros.reports.export.transcriptDesc": "Extra sheet in the file; makes it larger",
    "aeros.reports.export.transcriptLimit": "Available for up to {{limit}} tickets — narrow the period or filters.",
    "aeros.reports.export.button": "Export {{count}} rows",
    "aeros.reports.save.title": "Save filter",
    "aeros.reports.save.subtitle": "Open this view with one click",
    "aeros.reports.save.name": "Name",
    "aeros.reports.save.namePlaceholder": "E.g. Support · week · resolved",
    "aeros.reports.save.nameAria": "Filter name",
    "aeros.reports.save.weekly": "Email it every Monday",
    "aeros.reports.save.noEmail": "Your user has no email registered",
    "aeros.reports.save.button": "Save",
    "aeros.reports.cancel": "Cancel",
    "aeros.reports.ticket.wait": "Wait",
    "aeros.reports.ticket.duration": "Duration",
    "aeros.reports.ticket.messages": "Messages",
    "aeros.reports.ticket.reason": "Reason",
    "aeros.reports.ticket.timeline": "Timeline",
    "aeros.reports.ticket.chat": "Conversation",
    "aeros.reports.ticket.noEvents": "No events recorded.",
    "aeros.reports.ticket.noMessages": "No messages in this ticket.",
    "aeros.reports.ticket.openInTickets": "Open in Tickets",
    "aeros.reports.ticket.exportPdf": "Export PDF",
    "aeros.reports.ticket.noContact": "No contact",
    "aeros.reports.ticket.sale": "Sale",
    "aeros.reportsNav.tickets": "Tickets",
    "aeros.reportsNav.reasons": "Closing reasons",
    "aeros.reportsNav.aria": "Reports",
    "aeros.reportsNav.api": "API usage",
    "aeros.apiReport.title": "API usage",
    "aeros.apiReport.calls": "calls",
    "aeros.apiReport.exportXlsx": "Export XLSX",
    "aeros.apiReport.exportTruncated": "Export limited to {{max}} calls. Narrow the period.",
    "aeros.apiReport.filters.connection": "Connection",
    "aeros.apiReport.filters.origin": "Origin",
    "aeros.apiReport.filters.kind": "Type",
    "aeros.apiReport.filters.route": "Route",
    "aeros.apiReport.filters.channel": "Channel",
    "aeros.apiReport.filters.all": "All",
    "aeros.apiReport.filters.allM": "All",
    "aeros.apiReport.searchPlaceholder": "Search by error or origin…",
    "aeros.apiReport.searchAria": "Search calls",
    "aeros.apiReport.clearFilters": "Clear filters",
    "aeros.apiReport.dateFrom": "Start date",
    "aeros.apiReport.dateTo": "End date",
    "aeros.apiReport.pills.all": "All",
    "aeros.apiReport.pills.success": "Success",
    "aeros.apiReport.pills.queued": "Queued",
    "aeros.apiReport.pills.rejected": "Rejected 4xx",
    "aeros.apiReport.pills.error": "Error 5xx",
    "aeros.apiReport.pills.failed": "Failed to send",
    "aeros.apiReport.pills.sent": "Sent",
    "aeros.apiReport.kinds.text": "Text",
    "aeros.apiReport.kinds.media": "Media",
    "aeros.apiReport.kinds.template": "Template",
    "aeros.apiReport.kinds.checkNumber": "Check number",
    "aeros.apiReport.kinds.sms": "SMS",
    "aeros.apiReport.kinds.smsStatus": "SMS status",
    "aeros.apiReport.kinds.smsBalance": "SMS balance",
    "aeros.apiReport.kinds.messageStatus": "Message status",
    "aeros.apiReport.channels.whatsapp": "QR Code",
    "aeros.apiReport.channels.whatsapp_oficial": "Official",
    "aeros.apiReport.channels.sms": "SMS",
    "aeros.apiReport.kpis.total": "Calls",
    "aeros.apiReport.kpis.successRate": "Success rate",
    "aeros.apiReport.kpis.rejected": "Rejected",
    "aeros.apiReport.kpis.error": "Errors",
    "aeros.apiReport.kpis.failed": "Queue failures",
    "aeros.apiReport.kpis.latency": "Avg latency",
    "aeros.apiReport.kpis.p95": "p95 {{value}}",
    "aeros.apiReport.chart.title": "Calls per day",
    "aeros.apiReport.chart.empty": "No calls in the period",
    "aeros.apiReport.breakdown.connection": "By connection",
    "aeros.apiReport.breakdown.origin": "By origin",
    "aeros.apiReport.breakdown.kind": "By type",
    "aeros.apiReport.breakdown.errors": "Most frequent errors",
    "aeros.apiReport.breakdown.empty": "Nothing in the period",
    "aeros.apiReport.noOrigin": "No origin",
    "aeros.apiReport.columns.when": "Date/time",
    "aeros.apiReport.columns.connection": "Connection",
    "aeros.apiReport.columns.origin": "Origin",
    "aeros.apiReport.columns.route": "Route",
    "aeros.apiReport.columns.kind": "Type",
    "aeros.apiReport.columns.number": "Number",
    "aeros.apiReport.columns.status": "HTTP",
    "aeros.apiReport.columns.outcome": "Outcome",
    "aeros.apiReport.columns.latency": "Latency",
    "aeros.apiReport.columns.error": "Error",
    "aeros.apiReport.columns.ip": "IP",
    "aeros.apiReport.columns.userAgent": "User-Agent",
    "aeros.apiReport.columns.actions": "Actions",
    "aeros.apiReport.openTicket": "Open ticket",
    "aeros.apiReport.empty": "No calls match these filters",
    "aeros.apiReport.noResults": "No results",
    "aeros.apiReport.showing": "Showing {{from}}–{{to}} of {{total}}",
    "aeros.apiReport.perPage": "{{n}} per page",
    "aeros.apiReport.perPageAria": "Items per page",
    "aeros.apiReport.prevPage": "Previous page",
    "aeros.apiReport.nextPage": "Next page",
    "aeros.apiReport.sheetTitle": "Messages API usage",
    "aeros.apiReport.sheetStart": "Start",
    "aeros.apiReport.sheetEnd": "End",
    "aeros.apiReport.sheetCalls": "Calls",
    "aeros.apiReport.summaryUnavailable": "Summary unavailable",
    "aeros.sales.title": "Closing reasons",
    "aeros.sales.subtitle": "Tickets closed in the period, by closing date",
    "aeros.sales.selectPeriod": "Please select the period",
    "aeros.sales.agent": "Agent:",
    "aeros.sales.all": "All",
    "aeros.sales.generate": "Generate report",
    "aeros.sales.generating": "Generating…",
    "aeros.sales.emptyHint": "Select the period and click “Generate report”.",
    "aeros.sales.finished": "Closed",
    "aeros.sales.withReason": "With reason",
    "aeros.sales.sales": "Sales",
    "aeros.sales.totalValue": "Total value",
    "aeros.sales.reasons": "Reasons",
    "aeros.sales.noSaleReasons": "No-sale reasons",
    "aeros.sales.finishReason": "Closing reason",
    "aeros.sales.noSaleReason": "No-sale reason",
    "aeros.sales.date": "Date",
    "aeros.sales.value": "Value",
    "aeros.sales.byAgent": "Summary by agent",
    "aeros.helps.title": "Help",
    "aeros.helps.video": "video",
    "aeros.helps.videos": "videos",
    "aeros.helps.subtitle": "Video tutorials for the team",
    "aeros.helps.managedIn": " · managed in Settings → Help",
    "aeros.helps.search": "Search tutorial…",
    "aeros.helps.support": "Contact support",
    "aeros.helps.emptyTitle": "No tutorial registered",
    "aeros.helps.emptyAdmin": "Add YouTube videos in Settings → Help so they appear here for the whole team.",
    "aeros.helps.emptyUser": "Ask an administrator to register the videos in Settings → Help.",
    "aeros.helps.register": "Add tutorial",
    "aeros.helps.startHere": "Start here",
    "aeros.helps.watch": "Watch",
    "aeros.helps.seenBy": "Seen by {{seen}} of {{total}} users",
    "aeros.helps.moreHelp": "Need more help?",
    "aeros.helps.docs": "Documentation center",
    "aeros.helps.ticket": "Open a support ticket",
    "aeros.helps.ticketSub": "Talk to the Pulse team",
    "aeros.helps.onboarding": "Onboarding assistant",
    "aeros.helps.onboardingSub": "Ask the panel assistant",
    "aeros.helps.notFound": "No tutorial found for “{{q}}”.",
    "aeros.helps.all": "All",
    "aeros.helps.general": "General",
    "aeros.helps.youtube": "YouTube",
    "aeros.helps.next": "Next",
    "aeros.helpsManager.category": "Category",
    "aeros.helpsManager.categoryPlaceholder": "E.g. Getting started",
    "aeros.helpsManager.duration": "Duration",
    "aeros.helpsManager.featured": "Feature as \"Start here\" on the Help screen",
    "aeros.helpsManager.linksTitle": "Help links",
    "aeros.helpsManager.linksSubtitle": "Shown on the Help screen for the whole team. Leave blank to hide.",
    "aeros.helpsManager.linkSupport": "Contact support",
    "aeros.helpsManager.linkDocs": "Documentation center",
    "aeros.helpsManager.linkTicket": "Open a support ticket",
    "aeros.helpsManager.linkSaved": "Link saved.",
    "aeros.helpsManager.linkError": "Could not save the link.",
    "aeros.log.create": "Ticket created",
    "aeros.log.chatBot": "ChatBot started",
    "aeros.log.queue": "Queue set: {{queue}}",
    "aeros.log.redirect": "Redirected to {{queue}}",
    "aeros.log.otherQueue": "another queue",
    "aeros.log.openBy": "{{name}} started the ticket",
    "aeros.log.open": "Ticket started",
    "aeros.log.reopenBy": "{{name}} reopened the ticket",
    "aeros.log.reopen": "Ticket reopened",
    "aeros.log.accessBy": "{{name}} viewed the ticket",
    "aeros.log.access": "Ticket viewed",
    "aeros.log.transferedBy": "{{name}} transferred the ticket",
    "aeros.log.transfered": "Ticket transferred",
    "aeros.log.receivedBy": "Received by {{name}}",
    "aeros.log.receivedIn": " in {{queue}}",
    "aeros.log.agent": "agent",
    "aeros.log.pendingBy": "{{name}} returned it to the queue",
    "aeros.log.pending": "Returned to the queue",
    "aeros.log.closedBy": "{{name}} closed the ticket",
    "aeros.log.closed": "Ticket closed",
    "aeros.log.clientClosed": "Customer closed the ticket",
    "aeros.log.nps": "Satisfaction survey sent",
    "aeros.log.event": "Event",
    "aeros.log.today": "Today",
    "aeros.log.yesterday": "Yesterday",
    "aeros.tags.minutes": "minutes",
    "aeros.tags.hours": "hours",
    "aeros.tags.days": "days",
    "aeros.tags.never": "Never",
    "aeros.tags.weekly": "Weekly",
    "aeros.tags.biweekly": "Biweekly",
    "aeros.tags.monthly": "Monthly",
    "aeros.tags.quarterly": "Quarterly",
    "aeros.tags.agoToday": "today",
    "aeros.tags.agoDay": "1 day ago",
    "aeros.tags.agoDays": "{{n}} days ago",
    "aeros.tags.agoWeeks": "{{n}} wk ago",
    "aeros.tags.agoMonth": "1 month ago",
    "aeros.tags.agoMonths": "{{n}} months ago",
    "aeros.tags.agoYears": "{{n}} year(s) ago",
    "aeros.contacts.colName": "Name",
    "aeros.contacts.colWhatsapp": "WhatsApp",
    "aeros.contacts.colEmail": "Email",
    "aeros.contacts.colBirthDate": "Date of birth",
    "aeros.contacts.colTags": "Tags",
    "aeros.contacts.colWallet": "Wallet (email)",
    "aeros.contacts.colExtra": "Extra info: <header>",
    "aeros.contacts.sampleName": "Contact Name",
    "aeros.contacts.deletedAll": "All {{count}} contacts were deleted",
    "aeros.contacts.deleted": "{{count}} contacts deleted successfully",
    "aeros.contacts.clearSelection": "Clear selection",
    "aeros.contacts.startTicket": "Start ticket",
    "aeros.contacts.sendSms": "Send SMS",
    "aeros.contacts.edit": "Edit",
    "aeros.contacts.editContact": "Edit contact",
    "aeros.contacts.delete": "Delete",
    "aeros.contacts.deleteContact": "Delete contact",
    "aeros.contacts.notFound": "No contact found",
    "aeros.chat.you": "You",
    "aeros.chat.youPrefix": "You: …",
    "aeros.chat.user": "User",
    "aeros.chat.video": "Video",
    "aeros.chat.deleted": "Message deleted",
    "aeros.chat.audio": "Audio",
    "aeros.chat.image": "Image",
    "aeros.chat.file": "File",
    "aeros.chat.typingOne": "{{name}} is typing…",
    "aeros.chat.typingMany": "{{names}} are typing…",
    "aeros.chat.and": " and ",
    "aeros.chat.someone": "Someone",
    "aeros.chat.youTag": "(you)",
    "aeros.chat.admin": "Admin",
    "aeros.chat.weekdays": "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
    "aeros.chat.today": "Today",
    "aeros.chat.yesterday": "Yesterday",
    "aeros.chat.back": "Back",
    "aeros.chat.more": "More",
    "aeros.chat.closeSearch": "Close search",
    "aeros.chat.cancelRecording": "Cancel recording",
    "aeros.chat.sendAudio": "Send audio",
    "aeros.chat.removeAttachment": "Remove attachment",
    "aeros.chat.sendAttachment": "Send attachment",
    "aeros.chat.cancelReply": "Cancel reply",
    "aeros.chat.removeTicket": "Remove ticket",
    "aeros.chat.emoji": "Emoji",
    "aeros.chat.attach": "Attach",
    "aeros.chat.send": "Send",
    "aeros.chat.record": "Record audio",
    "aeros.campaign.new": "New campaign",
    "aeros.campaign.edit": "Edit campaign",
    "aeros.campaign.readonly": "View campaign",
    "aeros.campaign.subtitle": "Bulk sending via WhatsApp or SMS",
    "aeros.campaign.steps.config": "Setup",
    "aeros.campaign.steps.messages": "Messages",
    "aeros.campaign.steps.review": "Review",
    "aeros.campaign.name": "Name",
    "aeros.campaign.namePlaceholder": "E.g. Black Friday Fiber 2026",
    "aeros.campaign.contactList": "Contact list",
    "aeros.campaign.orTag": "or Tag",
    "aeros.campaign.none": "None",
    "aeros.campaign.connection": "Connection",
    "aeros.campaign.selectConnection": "Select the connection",
    "aeros.campaign.scheduleFor": "Schedule for",
    "aeros.campaign.recurrenceTitle": "Recurrence",
    "aeros.campaign.recurrenceDesc": "Repeats the sending automatically",
    "aeros.campaign.type": "Type",
    "aeros.campaign.interval": "Interval",
    "aeros.campaign.endDate": "End date",
    "aeros.campaign.optional": "optional",
    "aeros.campaign.maxExecutions": "Max. runs",
    "aeros.campaign.dayOfMonth": "Day of month",
    "aeros.campaign.next": "Next: {{dates}} at {{time}}",
    "aeros.campaign.recurrence.minutely": "Every minute",
    "aeros.campaign.recurrence.hourly": "Hourly",
    "aeros.campaign.recurrence.daily": "Daily",
    "aeros.campaign.recurrence.weekly": "Weekly",
    "aeros.campaign.recurrence.biweekly": "Biweekly",
    "aeros.campaign.recurrence.monthly": "Monthly",
    "aeros.campaign.recurrence.yearly": "Yearly",
    "aeros.campaign.weekdaysShort": "S,M,T,W,T,F,S",
    "aeros.campaign.weekdaysLong": "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
    "aeros.campaign.readConfirmation": "Read confirmation",
    "aeros.campaign.enabled": "Enabled",
    "aeros.campaign.disabled": "Disabled",
    "aeros.campaign.openTicket": "Open ticket",
    "aeros.campaign.yes": "Yes",
    "aeros.campaign.no": "No",
    "aeros.campaign.ticketStatus": "Ticket status",
    "aeros.campaign.ticketPending": "Pending",
    "aeros.campaign.ticketOpen": "Open",
    "aeros.campaign.ticketClosed": "Closed",
    "aeros.campaign.agent": "Agent",
    "aeros.campaign.queue": "Queue",
    "aeros.campaign.messages": "Messages",
    "aeros.campaign.messagesHint": "· rotated to avoid blocking",
    "aeros.campaign.messagePlaceholder": "Write the message… use {nome} to personalize",
    "aeros.campaign.smsMessage": "SMS message",
    "aeros.campaign.attachment": "Attachment",
    "aeros.campaign.attachHint": "sent before the text",
    "aeros.campaign.attach": "Attach image or file",
    "aeros.campaign.removeAttachment": "Remove attachment",
    "aeros.campaign.confirmMessages": "Confirmation messages",
    "aeros.campaign.confirmHint": "· reply to contacts who confirm",
    "aeros.campaign.preview": "Preview",
    "aeros.campaign.previewName": "Contact",
    "aeros.campaign.previewEmpty": "The message appears here as the contact will receive it.",
    "aeros.campaign.greetingMorning": "Good morning",
    "aeros.campaign.greetingAfternoon": "Good afternoon",
    "aeros.campaign.greetingEvening": "Good evening",
    "aeros.campaign.estimate": "{{contacts}} contacts · interval {{min}}–{{max}}s · ≈ {{time}} sending",
    "aeros.campaign.estimateDays": "{{contacts}} contacts · {{perDay}} · ≈ {{days}} days, ends {{end}}",
    "aeros.campaign.estimateNoDays": "No sending day selected in settings — the campaign will not send",
    "aeros.campaign.perDay": "{{n}} per day",
    "aeros.campaign.withinWindow": "within the sending window",
    "aeros.campaign.at": "at",
    "aeros.campaign.cancel": "Cancel",
    "aeros.campaign.close": "Close",
    "aeros.campaign.testMyNumber": "Test on my number",
    "aeros.campaign.testSent": "Test message sent to {{number}}.",
    "aeros.campaign.testNoNumber": "Your user has no WhatsApp registered. Enter a number:",
    "aeros.campaign.testPrompt": "Number for the test (with country and area code)",
    "aeros.campaign.saveSchedule": "Save and schedule",
    "aeros.campaign.saveChanges": "Save changes",
    "aeros.campaign.restart": "Restart",
    "aeros.campaign.pause": "Pause",
    "aeros.campaign.duplicate.action": "Duplicate campaign",
    "aeros.campaign.duplicate.copyName": "Copy of {{name}}",
    "aeros.campaign.duplicate.success": "Campaign duplicated. Review the fields and save.",
    "aeros.campaign.resume": "Resume",
    "aeros.campaign.export": "Export XLSX",
    "aeros.campaign.campaigns": "Campaigns",
    "aeros.campaign.status.inactive": "Inactive",
    "aeros.campaign.status.scheduled": "Scheduled",
    "aeros.campaign.status.running": "In progress",
    "aeros.campaign.status.cancelled": "Cancelled",
    "aeros.campaign.status.finished": "Finished",
    "aeros.campaign.progress": "Sending progress",
    "aeros.campaign.startedAt": "started {{date}}",
    "aeros.campaign.eta": "expected end {{date}}",
    "aeros.campaign.of": "of",
    "aeros.campaign.delivered": "Delivered",
    "aeros.campaign.failed": "Failed",
    "aeros.campaign.awaiting": "Awaiting",
    "aeros.campaign.queued": "Queued",
    "aeros.campaign.pending": "Pending",
    "aeros.campaign.deliveryStatus": "Delivery status",
    "aeros.campaign.deliveredPct": "delivered",
    "aeros.campaign.kpi.sent": "Sent",
    "aeros.campaign.kpi.sentSub": "of {{total}} in the list",
    "aeros.campaign.kpi.unique": "Unique recipients",
    "aeros.campaign.kpi.uniqueSub": "{{dup}} duplicate numbers",
    "aeros.campaign.kpi.delivered": "Delivered",
    "aeros.campaign.kpi.deliveredSub": "{{pct}}% of sent",
    "aeros.campaign.kpi.replied": "Replied",
    "aeros.campaign.kpi.repliedSub": "{{pct}}% · {{confirmed}} confirmed",
    "aeros.campaign.detail.connection": "Connection",
    "aeros.campaign.detail.list": "Contact list",
    "aeros.campaign.detail.tag": "Tag",
    "aeros.campaign.detail.schedule": "Schedule",
    "aeros.campaign.detail.conclusion": "Conclusion",
    "aeros.campaign.detail.expected": "Expected {{date}}",
    "aeros.campaign.detail.notFinished": "Still in progress",
    "aeros.campaign.table.title": "Message details",
    "aeros.campaign.table.all": "All",
    "aeros.campaign.table.search": "Search number…",
    "aeros.campaign.table.id": "ID",
    "aeros.campaign.table.recipient": "Recipient",
    "aeros.campaign.table.message": "Message",
    "aeros.campaign.table.sentAt": "Sent at",
    "aeros.campaign.table.deliveredAt": "Delivered at",
    "aeros.campaign.table.status": "Status",
    "aeros.campaign.table.reason": "Failure reason",
    "aeros.campaign.table.empty": "No sending recorded yet.",
    "aeros.campaign.table.range": "{{from}}–{{to}} of {{total}}",
    "aeros.campaign.shipping.delivered": "Delivered",
    "aeros.campaign.shipping.pending": "Pending",
    "aeros.campaign.shipping.failed": "Failed",
    "aeros.campaign.shipping.queued": "Queued",
    "aeros.campaign.exportOk": "Report generated with {{count}} records.",
    "aeros.campaign.exportEmpty": "No data to export.",
    "aeros.campaign.exportError": "Error generating the report.",
    "aeros.campaign.confirmCancel.title": "Cancel the running campaign?",
    "aeros.campaign.confirmCancel.text": "“{{name}}” has already delivered {{delivered}} of {{total}} messages. The remaining {{remaining}} will not be sent. You can restart it later from the list.",
    "aeros.campaign.confirmCancel.keep": "Keep sending",
    "aeros.campaign.confirmCancel.confirm": "Cancel campaign",
    "aeros.campaign.cancelScheduled": "Cancel schedule",
    "aeros.campaign.confirmCancel.titleScheduled": "Cancel the scheduled campaign?",
    "aeros.campaign.confirmCancel.textScheduled": "“{{name}}” has not started yet. No message will be sent. To reschedule, edit the date and click Restart.",
    "aeros.campaign.confirmCancel.keepScheduled": "Keep scheduled",
    "aeros.campaign.stopRecurrence.title": "Stop recurrence?",
    "aeros.campaign.stopRecurrence.textScheduled": "The campaign will have no future runs and will be marked as finished.",
    "aeros.campaign.stopRecurrence.textRunning": "The running execution will be cancelled now and there will be no future runs.",
    "aeros.campaign.stopRecurrence.confirm": "Stop recurrence",
    "aeros.campaign.stopRecurrence.keep": "Keep recurrence",
    "aeros.campaign.stopRecurrence.action": "Stop recurrence",
    "aeros.campaign.stopRecurrence.toast": "Recurrence stopped.",
    "aeros.campaign.confirmDelete.title": "Delete “{{name}}”?",
    "aeros.campaign.confirmDelete.text": "The campaign, its {{executions}} runs and the report of {{shipping}} sendings will be deleted. This action cannot be undone.",
    "aeros.campaign.confirmDelete.textSimple": "The campaign and its report will be deleted. This action cannot be undone.",
    "aeros.campaign.confirmDelete.confirm": "Delete",
    "aeros.campaign.config.title": "Campaign settings",
    "aeros.campaign.config.subtitle": "Intervals and sending window · apply to all campaigns",
    "aeros.campaign.config.intervals": "Intervals between sends",
    "aeros.campaign.config.risk": "Blocking risk: {{level}}",
    "aeros.campaign.config.riskLow": "low",
    "aeros.campaign.config.riskMedium": "medium",
    "aeros.campaign.config.riskHigh": "high",
    "aeros.campaign.config.random": "Random interval",
    "aeros.campaign.config.randomHint": "Random wait up to this value between each message.",
    "aeros.campaign.config.after": "Longer interval after",
    "aeros.campaign.config.afterHint": "Every N messages, applies the long pause below.",
    "aeros.campaign.config.long": "Long pause",
    "aeros.campaign.config.longHint": "Reduces ban risk on large lists.",
    "aeros.campaign.config.seconds": "{{n}} seconds",
    "aeros.campaign.config.messagesN": "{{n}} messages",
    "aeros.campaign.config.insight": "With these values, 1,000 messages take",
    "aeros.campaign.config.window": "Sending window",
    "aeros.campaign.config.windowHint": "· outside it, the campaign waits and resumes by itself; with a limit, it spreads messages across the day",
    "aeros.campaign.config.start": "Start",
    "aeros.campaign.config.end": "End",
    "aeros.campaign.config.days": "Days",
    "aeros.campaign.config.dailyLimit": "Messages per day",
    "aeros.campaign.config.dailyLimitPlaceholder": "No limit",
    "aeros.campaign.config.dailyLimitOff": "No daily limit: the campaign uses the intervals above within the window.",
    "aeros.campaign.config.dailyLimitSpread": "Up to {{n}} per day between {{start}} and {{end}}: 1 message every ≈ {{gap}}. The intervals above do not apply.",
    "aeros.campaign.config.dailyLimitFloor": "The minimum interval of {{min}}s prevails: {{fit}} messages fit per day in this window.",
    "aeros.campaign.config.dailyLimitNoDays": "No day selected: campaigns will not send.",
    "aeros.campaign.config.dailyLimitNote": "Changes apply to campaigns started from now on.",
    "aeros.campaign.config.channelWhatsapp": "WhatsApp",
    "aeros.campaign.config.channelSms": "SMS",
    "aeros.campaign.config.dailyLimitChannelAria": "Messages per day on {{channel}}",
    "aeros.campaign.config.variables": "Custom variables",
    "aeros.campaign.config.variablesHint": "Use {key} in messages; the value is replaced on sending.",
    "aeros.campaign.config.key": "Key",
    "aeros.campaign.config.value": "Value",
    "aeros.campaign.config.add": "Add",
    "aeros.campaign.config.save": "Save",
    // ---- Modal de campanha: template oficial (TemplateFields) ----
    "aeros.campaign.template.select": "Approved template",
    "aeros.campaign.template.mediaBadge": "media header",
    "aeros.campaign.template.mediaUrlLabel": "Media URL ({{tipo}})",
    "aeros.campaign.template.mediaUrlHelp": "Public http(s) URL of the image, video or document. Meta downloads the file from this link at send time, once per contact.",
    "aeros.campaign.template.mediaUrlRequired": "This template has a media header: enter the public URL of the file.",
    "aeros.campaign.template.mediaUrlInvalid": "The media URL must start with http:// or https://.",
    "aeros.campaign.template.omitted": "{{count}} approved template(s) not shown here: buttons with variable URL are not supported in campaigns.",
    "aeros.campaign.template.emptyNoneUsable": "This connection has {{count}} approved template(s), but none can be used in a campaign: all have a button with a variable URL, which campaigns do not fill. Create a template without that button in Meta.",
    "aeros.campaign.template.emptySync": "No approved template was found for this connection. Sync the templates on the Connections page before creating the campaign.",
    "aeros.campaign.template.mixedFormats": "This template mixes numbered ({{numerada}}) and named ({{nomeada}}) variables in the same body. Meta does not accept both formats together — fix the template in Meta and sync again on the Connections page.",
    "aeros.campaign.template.paramLabel": "Value for {{token}}",
    "aeros.campaign.template.paramHelp": "Fixed text or {nome}, {numero}, {email} — the name comes from the contact list column",
    "aeros.campaign.template.preview": "Preview: {{texto}}",
    "aeros.campaign.template.uploadButton": "Upload file",
    "aeros.campaign.template.uploading": "Uploading…",
    "aeros.campaign.template.uploadHint.IMAGE": "JPG or PNG up to 5 MB. The file becomes public on the server and the URL is filled in above.",
    "aeros.campaign.template.uploadHint.VIDEO": "MP4 up to 16 MB. The file becomes public on the server and the URL is filled in above.",
    "aeros.campaign.template.uploadHint.DOCUMENT": "PDF up to 100 MB. The file becomes public on the server and the URL is filled in above.",
    "aeros.campaign.template.uploadSuccess": "File uploaded. The URL has been filled in.",
    "aeros.flow.title": "Flowbuilder",
    "aeros.flow.tabs.flows": "Flows",
    "aeros.flow.tabs.phrases": "Trigger phrases",
    "aeros.flow.tabs.defaults": "Default flow",
    "aeros.flow.cancel": "Cancel",
    "aeros.flow.save": "Save",
    "aeros.flow.create": "Create",
    "aeros.flow.add": "Add",
    "aeros.flow.edit": "Edit",
    "aeros.flow.delete": "Delete",
    "aeros.flow.list.search": "Search flows…",
    "aeros.flow.list.new": "New flow",
    "aeros.flow.list.active": "Active",
    "aeros.flow.list.inactive": "Inactive",
    "aeros.flow.list.steps": "{{count}} step",
    "aeros.flow.list.steps_plural": "{{count}} steps",
    "aeros.flow.list.empty": "No flows created yet",
    "aeros.flow.list.emptyHint": "Create your first conversation flow to automate service",
    "aeros.flow.list.emptySearch": "No flows found",
    "aeros.flow.list.emptySearchHint": "Try other search terms",
    "aeros.flow.list.createFirst": "Create first flow",
    "aeros.flow.list.editAria": "Rename flow",
    "aeros.flow.list.duplicateAria": "Duplicate flow",
    "aeros.flow.list.deleteAria": "Delete flow",
    "aeros.flow.list.duplicateTitle": "Duplicate “{{name}}”?",
    "aeros.flow.list.duplicateText": "A copy of the flow will be created for you to edit.",
    "aeros.flow.list.duplicateConfirm": "Duplicate",
    "aeros.flow.list.duplicated": "Flow duplicated",
    "aeros.flow.list.deleted": "Flow deleted",
    "aeros.flow.delete.title": "Delete “{{name}}”?",
    "aeros.flow.delete.usedBy": "This flow is used by {{count}} trigger phrase. It will stop responding.",
    "aeros.flow.delete.usedBy_plural": "This flow is used by {{count}} trigger phrases. They will stop responding.",
    "aeros.flow.delete.irreversible": "This action cannot be undone.",
    "aeros.flow.delete.confirm": "Delete flow",
    "aeros.flow.newFlow.title": "New flow",
    "aeros.flow.newFlow.editTitle": "Rename flow",
    "aeros.flow.newFlow.name": "Name",
    "aeros.flow.newFlow.namePlaceholder": "E.g.: Post-sale satisfaction survey",
    "aeros.flow.newFlow.startFrom": "Start from",
    "aeros.flow.newFlow.createOpen": "Create and open editor",
    "aeros.flow.newFlow.nameRequired": "Enter a name for the flow",
    "aeros.flow.newFlow.exists": "A flow with this name already exists",
    "aeros.flow.newFlow.created": "Flow created",
    "aeros.flow.newFlow.renamed": "Flow renamed",
    "aeros.flow.templates.blank": "Blank",
    "aeros.flow.templates.blankSub": "Start node only",
    "aeros.flow.templates.welcome": "Welcome",
    "aeros.flow.templates.welcomeSub": "Greeting + menu",
    "aeros.flow.templates.triage": "Queue triage",
    "aeros.flow.templates.triageSub": "Menu → queues",
    "aeros.flow.templates.nps": "NPS survey",
    "aeros.flow.templates.npsSub": "Score + comment",
    "aeros.flow.templates.welcomeMessage": "Hi, {nome}! 👋 Welcome. I'm the virtual assistant.",
    "aeros.flow.templates.menuMessage": "How can I help today? Type the option number:",
    "aeros.flow.templates.menuOption1": "Technical support",
    "aeros.flow.templates.menuOption2": "Sales / plans",
    "aeros.flow.templates.menuOption3": "Billing",
    "aeros.flow.templates.npsQuestion": "From 0 to 10, how likely are you to recommend our service?",
    "aeros.flow.templates.npsComment": "Would you like to leave a comment? (optional)",
    "aeros.flow.templates.npsThanks": "Thanks for your answer! 💜",
    "aeros.flow.phrases.search": "Search phrase or flow…",
    "aeros.flow.phrases.new": "New trigger phrase",
    "aeros.flow.phrases.info": "When a contact sends a message that matches a phrase, the chosen flow starts on that connection.",
    "aeros.flow.phrases.infoExact": "requires the identical message;",
    "aeros.flow.phrases.infoPartial": "accepts the phrase anywhere in the text.",
    "aeros.flow.phrases.col.name": "Name",
    "aeros.flow.phrases.col.phrases": "Phrases",
    "aeros.flow.phrases.col.flow": "Flow",
    "aeros.flow.phrases.col.connections": "Connections",
    "aeros.flow.phrases.col.hits": "Hits 7d",
    "aeros.flow.phrases.col.status": "Status",
    "aeros.flow.phrases.col.actions": "Actions",
    "aeros.flow.phrases.count": "{{count}} phrase",
    "aeros.flow.phrases.count_plural": "{{count}} phrases",
    "aeros.flow.phrases.exact": "Exact",
    "aeros.flow.phrases.partial": "Partial",
    "aeros.flow.phrases.exactShort": "EX",
    "aeros.flow.phrases.partialShort": "PA",
    "aeros.flow.phrases.active": "Active",
    "aeros.flow.phrases.inactive": "Inactive",
    "aeros.flow.phrases.noConnection": "No connection",
    "aeros.flow.phrases.noFlow": "Flow removed",
    "aeros.flow.phrases.hitsUnavailable": "Hit count not available yet",
    "aeros.flow.phrases.empty": "No trigger phrases yet",
    "aeros.flow.phrases.emptyHint": "Create a phrase to start a flow when the contact writes it.",
    "aeros.flow.phrases.emptySearch": "No phrases found",
    "aeros.flow.phrases.deleted": "Trigger phrase deleted",
    "aeros.flow.phrases.deleteTitle": "Delete “{{name}}”?",
    "aeros.flow.phrases.deleteText": "The flow will no longer start from these phrases. This action cannot be undone.",
    "aeros.flow.phrases.deleteConfirm": "Delete phrase",
    "aeros.flow.phraseModal.title": "New trigger phrase",
    "aeros.flow.phraseModal.editTitle": "Edit trigger phrase",
    "aeros.flow.phraseModal.subtitle": "Starts a flow when the message matches",
    "aeros.flow.phraseModal.name": "Name",
    "aeros.flow.phraseModal.namePlaceholder": "E.g.: Main menu by keyword",
    "aeros.flow.phraseModal.flow": "Flow",
    "aeros.flow.phraseModal.flowPlaceholder": "Choose a flow",
    "aeros.flow.phraseModal.connections": "Connections",
    "aeros.flow.phraseModal.connectionsPlaceholder": "Choose connections",
    "aeros.flow.phraseModal.phrases": "Trigger phrases",
    "aeros.flow.phraseModal.addPhrase": "Add phrase",
    "aeros.flow.phraseModal.phrasePlaceholder": "Type the phrase or keyword",
    "aeros.flow.phraseModal.removePhrase": "Remove phrase",
    "aeros.flow.phraseModal.hint": "Case and accents are ignored.",
    "aeros.flow.phraseModal.conflictA": "“{{text}}” already triggers",
    "aeros.flow.phraseModal.conflictB": "on {{connection}}. The most recent phrase takes priority.",
    "aeros.flow.phraseModal.required": "Fill in name, flow, connections and at least one phrase.",
    "aeros.flow.phraseModal.created": "Trigger phrase created",
    "aeros.flow.phraseModal.updated": "Trigger phrase updated",
    "aeros.flow.phraseModal.saveError": "Error saving the trigger phrase",
    "aeros.flow.phraseModal.loadError": "Error loading the trigger phrase",
    "aeros.flow.defaults.title": "Default flow",
    "aeros.flow.defaults.subtitle": "Company automatic triggers",
    "aeros.flow.defaults.welcome": "Welcome flow",
    "aeros.flow.defaults.welcomeDesc": "Started only for new contacts, not yet in your list.",
    "aeros.flow.defaults.reply": "Default reply flow",
    "aeros.flow.defaults.replyDesc": "Sent for any message without a keyword, if the ticket has been closed for more than 6h.",
    "aeros.flow.defaults.inactive": "Inactivity flow",
    "aeros.flow.defaults.inactiveDesc": "Started when the contact stops replying inside a flow.",
    "aeros.flow.defaults.none": "No flow",
    "aeros.flow.defaults.saved": "Default flows updated",
    "aeros.flow.editor.back": "Flows",
    "aeros.flow.editor.rename": "Rename flow",
    "aeros.flow.editor.undo": "Undo",
    "aeros.flow.editor.redo": "Redo",
    "aeros.flow.editor.test": "Test flow",
    "aeros.flow.editor.versions": "Versions",
    "aeros.flow.editor.soon": "Coming soon",
    "aeros.flow.editor.save": "Save flow",
    "aeros.flow.editor.saved": "Flow saved",
    "aeros.flow.editor.saveError": "Error saving the flow",
    "aeros.flow.editor.searchBlock": "Search block…",
    "aeros.flow.editor.addBlocks": "Add blocks",
    "aeros.flow.editor.zoomIn": "Zoom in",
    "aeros.flow.editor.zoomOut": "Zoom out",
    "aeros.flow.editor.fit": "Fit to screen",
    "aeros.flow.editor.unsaved": "Unsaved changes",
    "aeros.flow.saved.never": "Never saved",
    "aeros.flow.saved.now": "Saved just now",
    "aeros.flow.saved.minutes": "Saved {{count}} min ago",
    "aeros.flow.saved.hours": "Saved {{count}} h ago",
    "aeros.flow.saved.days": "Saved {{count}} d ago",
    "aeros.flow.palette.messages": "Messages",
    "aeros.flow.palette.logic": "Logic",
    "aeros.flow.palette.actions": "Actions",
    "aeros.flow.palette.ai": "AI",
    "aeros.flow.nodes.start": "Start",
    "aeros.flow.nodes.text": "Text",
    "aeros.flow.nodes.menu": "Menu",
    "aeros.flow.nodes.content": "Content",
    "aeros.flow.nodes.image": "Image",
    "aeros.flow.nodes.audio": "Audio",
    "aeros.flow.nodes.video": "Video",
    "aeros.flow.nodes.condition": "Condition",
    "aeros.flow.nodes.randomizer": "Randomizer",
    "aeros.flow.nodes.interval": "Delay",
    "aeros.flow.nodes.input": "Input",
    "aeros.flow.nodes.variable": "Variable",
    "aeros.flow.nodes.switchFlow": "Switch flow",
    "aeros.flow.nodes.ticket": "Ticket / Queue",
    "aeros.flow.nodes.attendant": "Agent",
    "aeros.flow.nodes.tag": "Add tag",
    "aeros.flow.nodes.removeTag": "Remove tag",
    "aeros.flow.nodes.http": "HTTP request",
    "aeros.flow.nodes.openai": "OpenAI",
    "aeros.flow.nodes.gemini": "Gemini",
    "aeros.flow.nodes.unknown": "Block",
    "aeros.flow.node.actions": "Block actions",
    "aeros.flow.node.duplicate": "Duplicate",
    "aeros.flow.node.delete": "Delete",
    "aeros.flow.summary.start": "Flow trigger",
    "aeros.flow.summary.items": "{{count}} item",
    "aeros.flow.summary.items_plural": "{{count}} items",
    "aeros.flow.summary.recorded": "sent as recorded now",
    "aeros.flow.summary.interval": "Wait {{sec}} seconds",
    "aeros.flow.problems.count": "{{count}} issue",
    "aeros.flow.problems.count_plural": "{{count}} issues",
    "aeros.flow.problems.goTo": "Go to node",
    "aeros.flow.problems.noStart": "Flow has no start node",
    "aeros.flow.problems.unreachable": "{{node}} has no incoming connection",
    "aeros.flow.problems.dangling": "{{node}} has no connected output",
    "aeros.flow.problems.danglingLabel": "{{node}} output “{{label}}” not connected",
    "aeros.flow.panel.empty": "Select a block on the canvas to see its properties.",
    "aeros.flow.panel.nodeId": "node #{{id}}",
    "aeros.flow.panel.options": "{{count}} option",
    "aeros.flow.panel.options_plural": "{{count}} options",
    "aeros.flow.panel.type": "Type",
    "aeros.flow.panel.summary": "Content",
    "aeros.flow.panel.editBlock": "Edit block",
    "aeros.flow.panel.noEditor": "This block is edited directly on the canvas.",
    "aeros.flow.panel.outputs": "Outputs",
    "aeros.flow.panel.connected": "connected",
    "aeros.flow.panel.notConnected": "not connected",
    "aeros.flow.condition.title": "Condition",
    "aeros.flow.condition.addTitle": "Add condition",
    "aeros.flow.condition.variable": "Variable",
    "aeros.flow.condition.variablePlaceholder": "{variable}",
    "aeros.flow.condition.rule": "Rule",
    "aeros.flow.condition.value": "Value",
    "aeros.flow.condition.valuePlaceholder": "Compared value",
    "aeros.flow.condition.true": "True",
    "aeros.flow.condition.false": "False",
    "aeros.flow.condition.noConnection": "not connected",
    "aeros.flow.condition.required": "Enter the variable to compare",
    "aeros.flow.condition.ops.contains": "contains",
    "aeros.flow.condition.ops.startsWith": "starts with",
    "aeros.flow.condition.ops.endsWith": "ends with",
    "aeros.flow.condition.ops.isEmpty": "empty",
    "aeros.flow.condition.ops.isNotEmpty": "not empty",
    "aeros.flow.content.title": "Content block",
    "aeros.flow.content.editTitle": "Edit content block",
    "aeros.flow.content.subtitle": "Sequence of messages sent at once",
    "aeros.flow.content.addSection": "Add",
    "aeros.flow.content.text": "Text",
    "aeros.flow.content.image": "Image",
    "aeros.flow.content.audio": "Audio",
    "aeros.flow.content.video": "Video",
    "aeros.flow.content.document": "Document",
    "aeros.flow.content.interval": "Delay",
    "aeros.flow.content.dropzone": "Click a type on the left to add",
    "aeros.flow.content.footer": "{{count}} items · ≈ {{sec}} s to send",
    "aeros.flow.content.uploading": "Uploading files and creating the content…",
    "aeros.flow.content.remove": "Remove item",
    "aeros.flow.content.chooseFile": "Choose file",
    "aeros.flow.content.seconds": "seconds",
    "aeros.flow.content.recordedNow": "Send as recorded now",
    "aeros.flow.content.textPlaceholder": "Type the message…",
    "aeros.flow.content.variables": "Available variables",
    "aeros.flow.nodes.tagNotSelected": "No tag selected",
    "aeros.flow.input.question": "Question",
    "aeros.flow.input.noQuestion": "Question not set",
    "aeros.flow.input.variable": "Variable to store the answer",
    "aeros.flow.input.noVariable": "Variable not set",
    "aeros.flow.input.value": "Value: {{value}}",
    "aeros.flow.input.usingVariables": "Using variables: {{names}}",
    "aeros.flow.variable.name": "Variable name",
    "aeros.flow.variable.value": "Value",
    "aeros.flow.variable.valueHint": "You can use fixed values or references like ${otherVariable}",
    "aeros.flow.variable.saveButton": "Save variable",
    "aeros.flow.variable.saved": "Saved!",
    "aeros.flow.variable.savedToast": "Variable saved successfully!",
    "aeros.flow.http.presets": "Preconfigured webhooks",
    "aeros.flow.http.presetPlaceholder": "Pick a ready-made configuration…",
    "aeros.flow.http.presetSystem": "SYSTEM",
    "aeros.flow.http.usingPreset": "Using preset: {{name}}",
    "aeros.flow.http.removePreset": "Remove",
    "aeros.flow.http.presetError": "Failed to apply the preset configuration",
    "aeros.flow.http.url": "URL",
    "aeros.flow.http.urlPreset": "URL (from preset)",
    "aeros.flow.http.urlPresetHint": "You can edit the preset base URL if needed",
    "aeros.flow.http.method": "Method",
    "aeros.flow.http.test": "Test request",
    "aeros.flow.http.requestError": "Request failed",
    "aeros.flow.http.response": "API response",
    "aeros.flow.http.fullResponse": "View full response",
    "aeros.flow.http.fullResponseTitle": "Full API response",
    "aeros.flow.http.showAdvanced": "Show advanced",
    "aeros.flow.http.hideAdvanced": "Hide advanced",
    "aeros.flow.http.advancedWarning": "Advanced settings may override the preset configuration",
    "aeros.flow.http.timeout": "Timeout (ms)",
    "aeros.flow.http.queryParams": "Query parameters",
    "aeros.flow.http.key": "Key",
    "aeros.flow.http.value": "Value",
    "aeros.flow.http.addParam": "Add parameter",
    "aeros.flow.http.headers": "Headers (JSON)",
    "aeros.flow.http.body": "Request body (JSON)",
    "aeros.flow.http.editBody": "Edit request body",
    "aeros.flow.http.close": "Close",
    "aeros.flow.http.mapShow": "Map response variables",
    "aeros.flow.http.mapHide": "Hide response variables",
    "aeros.flow.http.mapTitle": "Map response data to variables",
    "aeros.flow.http.pathPlaceholder": "Path, e.g. data.user.id",
    "aeros.flow.http.variablePlaceholder": "Variable name, e.g. userId",
    "aeros.flow.http.addVariable": "Add variable",
    "aeros.flow.http.tips": "Useful tips",
    "aeros.flow.http.tipResponse": "The full API response is automatically saved to the global variable apiResponse",
    "aeros.flow.http.tipVariables": "Use ${variableName} in the URL and request body to include variable values",
    "aeros.flow.modals.text.addTitle": "Add message",
    "aeros.flow.modals.text.editTitle": "Edit message",
    "aeros.flow.modals.text.message": "Message",
    "aeros.flow.modals.interval.addTitle": "Add delay",
    "aeros.flow.modals.interval.editTitle": "Edit delay",
    "aeros.flow.modals.interval.seconds": "Time in seconds",
    "aeros.flow.modals.interval.hint": "Pause before the next block. Maximum of 120 seconds.",
    "aeros.flow.modals.interval.errorEmpty": "Enter the delay value",
    "aeros.flow.modals.interval.errorMax": "Maximum of 120 seconds",
    "aeros.flow.modals.menu.addTitle": "Add menu",
    "aeros.flow.modals.menu.editTitle": "Edit menu",
    "aeros.flow.modals.menu.type": "Menu type",
    "aeros.flow.modals.menu.number": "Number",
    "aeros.flow.modals.menu.list": "List",
    "aeros.flow.modals.menu.button": "Button",
    "aeros.flow.modals.menu.message": "Menu message",
    "aeros.flow.modals.menu.options": "Options",
    "aeros.flow.modals.menu.optionPlaceholder": "Type the option",
    "aeros.flow.modals.menu.removeOption": "Remove option",
    "aeros.flow.modals.image.addTitle": "Add image",
    "aeros.flow.modals.image.editTitle": "Edit image",
    "aeros.flow.modals.image.dropHint": "PNG or JPG up to 2 MB",
    "aeros.flow.modals.image.tooLarge": "File too large! Maximum 2 MB",
    "aeros.flow.modals.image.success": "Image added successfully!",
    "aeros.flow.modals.audio.addTitle": "Add audio",
    "aeros.flow.modals.audio.editTitle": "Edit audio",
    "aeros.flow.modals.audio.dropHint": "OGG or MP3 up to 5 MB",
    "aeros.flow.modals.audio.tooLarge": "File too large! Maximum 5 MB",
    "aeros.flow.modals.audio.success": "Audio added successfully!",
    "aeros.flow.modals.audio.noHtml5": "Your browser does not support HTML5 audio",
    "aeros.flow.modals.audio.recordedNowDesc": "The contact receives it as a voice message recorded just now",
    "aeros.flow.modals.video.addTitle": "Add video",
    "aeros.flow.modals.video.editTitle": "Edit video",
    "aeros.flow.modals.video.dropHint": "MP4 videos only, up to 20 MB",
    "aeros.flow.modals.video.tooLarge": "File too large! Maximum 20 MB",
    "aeros.flow.modals.video.success": "Video added successfully!",
    "aeros.flow.modals.video.noHtml5": "Your browser does not support HTML5 video",
    "aeros.flow.modals.randomizer.addTitle": "Add randomizer",
    "aeros.flow.modals.randomizer.editTitle": "Edit randomizer",
    "aeros.flow.modals.randomizer.label": "Percentage for each output",
    "aeros.flow.modals.randomizer.hint": "Output A gets {{a}}% of contacts and output B {{b}}%.",
    "aeros.flow.modals.randomizer.errorEmpty": "Enter a percentage greater than zero",
    "aeros.flow.modals.ticket.addTitle": "Add queue",
    "aeros.flow.modals.ticket.editTitle": "Edit queue",
    "aeros.flow.modals.ticket.queue": "Target queue",
    "aeros.flow.modals.ticket.queuePlaceholder": "Select a queue",
    "aeros.flow.modals.ticket.errorQueue": "Select a queue",
    "aeros.flow.modals.tag.addTitle": "Add tag",
    "aeros.flow.modals.tag.editTitle": "Edit tag",
    "aeros.flow.modals.tag.tag": "Tag",
    "aeros.flow.modals.tag.placeholder": "Select a tag",
    "aeros.flow.modals.tag.none": "No tag selected",
    "aeros.flow.modals.tag.error": "Select a tag",
    "aeros.flow.modals.removeTag.addTitle": "Remove tag",
    "aeros.flow.modals.removeTag.editTitle": "Edit tag removal",
    "aeros.flow.modals.removeTag.tag": "Tag to remove",
    "aeros.flow.modals.removeTag.placeholder": "Select a tag to remove",
    "aeros.flow.modals.removeTag.hint": "The selected tag will be removed from the contact when the flow reaches this block.",
    "aeros.flow.modals.removeTag.error": "Select a tag to remove",
    "aeros.flow.modals.switchFlow.addTitle": "Add flow switch",
    "aeros.flow.modals.switchFlow.editTitle": "Edit flow switch",
    "aeros.flow.modals.switchFlow.flow": "Target flow",
    "aeros.flow.modals.switchFlow.placeholder": "Choose a flow",
    "aeros.flow.modals.switchFlow.hint": "The conversation leaves this flow and continues in the chosen flow.",
    "aeros.flow.modals.attendant.addTitle": "Add agent",
    "aeros.flow.modals.attendant.editTitle": "Edit agent",
    "aeros.flow.modals.attendant.user": "Agent",
    "aeros.flow.modals.attendant.placeholder": "Select an agent",
    "aeros.flow.modals.attendant.error": "Select an agent",
    "aeros.flow.modals.input.addTitle": "Add input",
    "aeros.flow.modals.input.editTitle": "Edit input",
    "aeros.flow.modals.input.question": "Question",
    "aeros.flow.modals.input.questionPlaceholder": "E.g.: Hi ${nome}, how old are you?",
    "aeros.flow.modals.input.questionHint": "Sent to the contact. Click a variable to insert it into the text.",
    "aeros.flow.modals.input.variableName": "Variable name",
    "aeros.flow.modals.input.variablePlaceholder": "E.g.: customer_age",
    "aeros.flow.modals.input.variableHint": "No spaces or special characters. The contact's answer is stored here.",
    "aeros.flow.modals.input.howItWorks": "How it works",
    "aeros.flow.modals.input.howItWorksText": "This block sends the question and waits for the contact's answer. The value is stored in the variable and the flow moves on to the next block.",
    "aeros.flow.modals.trigger.loadError": "Error loading the available flows",
    "aeros.flow.modals.trigger.selectRequired": "Select a flow to trigger",
    "aeros.flow.modals.trigger.processing": "Triggering flow… The message field stays disabled until it finishes.",
    "aeros.flow.content.saved": "Content saved successfully!",
    "aeros.flow.content.errors.emptyMessage": "There is an empty text item.",
    "aeros.flow.content.errors.intervalRange": "The interval must be between 1 and 120 seconds.",
    "aeros.flow.content.errors.fileTooLarge": "File too large! Maximum {{mb}} MB.",
    "aeros.flow.content.errors.emptyCards": "Remove media items without a file before saving.",
    "aeros.flow.modals.openai.title": "Add OpenAI",
    "aeros.flow.modals.openai.editTitle": "Edit OpenAI",
    "aeros.flow.modals.openai.subtitle": "AI assistant that chats with the contact at this point of the flow",
    "aeros.flow.modals.openai.basic": "Basic settings",
    "aeros.flow.modals.openai.name": "Assistant name",
    "aeros.flow.modals.openai.apiKey": "OpenAI API Key",
    "aeros.flow.modals.openai.model": "Model",
    "aeros.flow.modals.openai.prompt": "System prompt",
    "aeros.flow.modals.openai.promptPlaceholder": "Describe how the AI should behave, what information to collect, how to reply…",
    "aeros.flow.modals.openai.temperature": "Temperature",
    "aeros.flow.modals.openai.temperatureHint": "0 = conservative, 2 = creative",
    "aeros.flow.modals.openai.maxTokens": "Max tokens",
    "aeros.flow.modals.openai.maxTokensHint": "Maximum reply length",
    "aeros.flow.modals.openai.maxMessages": "Max messages",
    "aeros.flow.modals.openai.maxMessagesHint": "Context history",
    "aeros.flow.modals.openai.voiceSection": "Voice (optional)",
    "aeros.flow.modals.openai.voice": "Reply type",
    "aeros.flow.modals.openai.voiceTextOnly": "Text only",
    "aeros.flow.modals.openai.voiceKey": "Voice Key (Azure)",
    "aeros.flow.modals.openai.voiceKeyPlaceholder": "Azure Speech Service key",
    "aeros.flow.modals.openai.voiceRegion": "Voice Region (Azure)",
    "aeros.flow.modals.openai.behavior": "Flow behavior",
    "aeros.flow.modals.openai.permanent": "Permanent — ends the flow here",
    "aeros.flow.modals.openai.permanentDesc": "The contact chats with the AI until asking for a transfer or ending",
    "aeros.flow.modals.openai.temporary": "Temporary — returns to the flow afterwards",
    "aeros.flow.modals.openai.temporaryDesc": "The AI performs a specific task and then returns to the flow",
    "aeros.flow.modals.openai.temporaryHint": "Configure when the AI should stop and return to the flow",
    "aeros.flow.modals.openai.maxInteractions": "Max interactions",
    "aeros.flow.modals.openai.maxInteractionsHint": "Messages before returning to the flow (0 = unlimited)",
    "aeros.flow.modals.openai.completionTimeout": "Timeout (minutes)",
    "aeros.flow.modals.openai.completionTimeoutHint": "Time limit before returning to the flow (0 = no limit)",
    "aeros.flow.modals.openai.keywords": "Keywords to continue the flow",
    "aeros.flow.modals.openai.keywordPlaceholder": "Type a keyword",
    "aeros.flow.modals.openai.keywordsHint": "When the contact sends one of these words, the flow continues automatically",
    "aeros.flow.modals.openai.objective": "AI objective",
    "aeros.flow.modals.openai.objectiveHint": "What the AI must complete (e.g. collect name, email and phone)",
    "aeros.flow.modals.openai.objectivePlaceholder": "E.g. collect customer data, qualify interest, diagnose an issue…",
    "aeros.flow.modals.openai.autoComplete": "Finish when the objective is reached",
    "aeros.flow.modals.openai.autoCompleteDesc": "The AI checks whether it completed the objective and returns to the flow on its own",
    "aeros.flow.modals.openai.queueId": "Queue ID (transfer)",
    "aeros.flow.modals.openai.queueIdHint": "Queue to transfer to if the contact asks for an agent (0 = do not transfer)",
    "aeros.flow.modals.openai.errors.tooShort": "Too short",
    "aeros.flow.modals.openai.errors.tooLong": "Too long",
    "aeros.flow.modals.openai.errors.required": "Required",
    "aeros.flow.modals.openai.errors.promptRequired": "Describe the AI training",
    "aeros.flow.modals.openai.errors.invalidModel": "Invalid model",
    "aeros.flow.modals.openai.errors.modelRequired": "Choose the model",
    "aeros.flow.modals.openai.errors.minTokens": "Minimum {{n}} tokens",
    "aeros.flow.modals.openai.errors.maxTokens": "Maximum {{n}} tokens",
    "aeros.flow.modals.openai.errors.min": "Minimum {{n}}",
    "aeros.flow.modals.openai.errors.max": "Maximum {{n}}",
    "aeros.flow.modals.openai.errors.apiKeyRequired": "Enter the API Key",
    "aeros.flow.modals.openai.errors.voiceKeyRequired": "Voice Key is required for speech synthesis",
    "aeros.flow.modals.openai.errors.voiceRegionRequired": "Voice Region is required for speech synthesis",
    "aeros.flow.modals.openai.errors.keywordEmpty": "Keyword cannot be empty",
    "aeros.flow.modals.openai.errors.keywordsMin": "Enter at least one keyword in temporary mode",
    "aeros.flow.modals.openai.errors.objectiveRequired": "Objective is required when auto-finish is on",
    "aeros.flow.modals.gemini.title": "Add Gemini",
    "aeros.flow.modals.gemini.editTitle": "Edit Gemini",
    "aeros.flow.modals.gemini.subtitle": "Google Gemini assistant that chats with the contact at this point of the flow",
    "aeros.flow.modals.gemini.basic": "Basic settings — Google Gemini",
    "aeros.flow.modals.gemini.apiKey": "Google AI API Key",
    "aeros.flow.modals.gemini.model": "Gemini model",
    // ---- Campanhas: abas Listas e Arquivos (mockup derivado do design system) ----
    "contactLists.searchPlaceholder": "Search list…",
    "contactLists.countOne": "{{count}} contact",
    "contactLists.countOther": "{{count}} contacts",
    "contactLists.dialog.subtitle": "Groups contacts to be targeted by campaigns",
    "contactLists.dialog.addTitle": "New contact list",
    "contactLists.dialog.editTitle": "Edit contact list",
    "contactLists.actions.download": "Download list contacts",
    "contactLists.actions.contacts": "View contacts",
    "contactLists.actions.edit": "Edit list",
    "contactLists.actions.delete": "Delete list",
    "contactLists.empty.title": "No contact lists",
    "contactLists.empty.text": "Create a list to use as a campaign target.",
    "contactLists.empty.noResults": "No list matches this search.",
    "contactListItems.table.status": "Status",
    "contactListItems.validity.valid": "Valid",
    "contactListItems.validity.invalid": "Invalid",
    "contactListItems.validity.unknown": "Not checked",
    "contactListItems.validity.validHint": "Number confirmed on WhatsApp",
    "contactListItems.validity.invalidHint": "Number has no WhatsApp",
    "contactListItems.validity.unknownHint": "Not checked: verified on the spot with a QR Code connection, or automatically after the first send through the official channel",
    "contactListItems.importing": "Importing…",
    "contactListItems.actions.edit": "Edit contact",
    "contactListItems.actions.delete": "Delete contact",
    "contactListItems.downloadSample": "Click here to download the sample spreadsheet.",
    "contactListItems.modal.addTitle": "New contact",
    "contactListItems.modal.editTitle": "Edit contact",
    "contactListItems.modal.subtitle": "Joins the list and receives its campaign sends",
    "contactListItems.notices.ignoredOne": "1 contact from the spreadsheet was already in the list",
    "contactListItems.notices.ignoredOther": "{{count}} contacts from the spreadsheet were already in the list",
    "contactListItems.notices.invalidOne": "1 spreadsheet row was not imported",
    "contactListItems.notices.invalidOther": "{{count}} spreadsheet rows were not imported",
    "contactListItems.notices.line": "Row {{line}}",
    "contactListItems.notices.dismiss": "Dismiss notice",
    "contactListItems.empty.title": "List has no contacts",
    "contactListItems.empty.text": "Import a spreadsheet or add contacts one by one.",
    "contactListItems.empty.noResults": "No contact matches this search.",
    "files.searchPlaceholder": "Search file list…",
    "files.countOne": "{{count}} file",
    "files.countOther": "{{count}} files",
    "files.actions.edit": "Edit file list",
    "files.actions.delete": "Delete file list",
    "files.empty.title": "No file lists",
    "files.empty.text": "Create a list to attach files to campaign messages.",
    "files.empty.noResults": "No list matches this search.",
    "fileModal.subtitle": "Files sent along with the campaign message",
    "fileModal.form.emptyFiles": "No files yet. Use “Add file” to include the first one.",
    "fileModal.form.pickFile": "Choose file",
    "fileModal.form.removeFile": "Remove file",
    "aeros.confirm.cancel": "Cancel",
    "aeros.confirm.confirm": "Confirm",
    "aeros.confirm.typedHint": "Type {{word}} to confirm",
    "contactLists.confirmDelete.title": "Delete the list “{{name}}”?",
    "contactLists.confirmDelete.text": "The list's contacts are deleted with it. Campaigns using this list will find no recipients. This action cannot be undone.",
    "contactLists.confirmDelete.confirm": "Delete list",
    "contactListItems.confirmDelete.title": "Remove “{{name}}” from the list?",
    "contactListItems.confirmDelete.text": "The contact leaves this list and stops receiving its sends. This action cannot be undone.",
    "contactListItems.confirmDelete.confirm": "Delete contact",
    "contactListItems.confirmImport.title": "Import the contacts from the spreadsheet?",
    "contactListItems.confirmImport.text": "Contacts from the spreadsheet join this list. Anyone already on the list is skipped, and rows with an invalid number are not imported.",
    "contactListItems.confirmImport.confirm": "Import",
    "files.confirmDelete.title": "Delete the file list “{{name}}”?",
    "files.confirmDelete.text": "The list's files are deleted. Campaigns using this list will send text only. This action cannot be undone.",
    "files.confirmDelete.confirm": "Delete list",
    "contactListItems.toasts.noQrValidation": "Without a QR Code connection, the numbers were not validated now. On the official channel, validation happens automatically as Meta confirms (or rejects) the first campaign's deliveries.",
    "contactLists.dialog.nameRequired": "Enter a name with at least 2 characters",
    "contactLists.dialog.nameTooLong": "The name must be at most 50 characters",
    "contactListItems.dialog.nameRequired": "Enter a name with at least 2 characters",
    "contactListItems.dialog.nameTooLong": "The name must be at most 50 characters",
    "contactListItems.dialog.numberInvalid": "The number must be between 8 and 50 characters",
    "contactListItems.dialog.emailInvalid": "Invalid e-mail",
    "fileModal.form.nameRequired": "Enter a name with at least 3 characters",
    "fileModal.form.messageRequired": "Enter the list details",
    // ---- Informativos, Login, Cadastro e Loading (mockup Aeros) ----
    "announcements.subtitle": "Notices shown to every company in the panel bell",
    "announcements.superAdmin": "Super admin",
    "announcements.search": "Search notice…",
    "announcements.priority.high": "High",
    "announcements.priority.medium": "Medium",
    "announcements.priority.low": "Low",
    "announcements.filters.all": "All",
    "announcements.filters.active": "Active",
    "announcements.filters.inactive": "Inactive",
    "announcements.filters.high": "High priority",
    "announcements.filters.media": "With attachment",
    "announcements.table.media": "Attachment",
    "announcements.table.published": "Published",
    "announcements.noMedia": "No attachment",
    "announcements.footNote": "Active notices appear in every user's bell, ordered by priority.",
    "announcements.actions.edit": "Edit notice",
    "announcements.actions.delete": "Delete notice",
    "announcements.empty.title": "No notices",
    "announcements.empty.text": "Create a notice to reach every company through the panel bell.",
    "announcements.empty.noResults": "No notice matches this filter.",
    "announcements.confirmDelete.title": "Delete the notice “{{name}}”?",
    "announcements.confirmDelete.text": "It leaves every company's bell immediately and the attached image is deleted. This action cannot be undone.",
    "announcements.confirmDelete.confirm": "Delete notice",
    "announcements.dialog.subtitle": "Visible to every company while it is active",
    "announcements.dialog.charCount": "{{count}} characters",
    "announcements.dialog.image": "Image",
    "announcements.dialog.imageHint": "· PNG or JPG",
    "announcements.dialog.imageChange": "Replace",
    "announcements.dialog.imageRemove": "Remove image",
    "announcements.dialog.imagePick": "Choose image",
    "announcements.dialog.lastEdit": "Last edited {{when}}",
    "announcements.dialog.save": "Save notice",
    "announcements.dialog.previewTitle": "How it looks in the bell",
    "announcements.dialog.previewHint": "High priority highlights the card in red and puts it at the top of the list.",
    "announcements.dialog.previewEmpty": "The title and text show up here as you type.",
    "announcements.dialog.titleRequired": "Enter the title",
    "announcements.dialog.textRequired": "Enter the notice text",
    "announcements.bell.title": "Notices",
    "announcements.when.now": "just now",
    "login.pageTitle": "Sign in",
    "login.pageSubtitle": "Use the e-mail your company registered.",
    "login.hero.eyebrow": "Customer service hub",
    "login.hero.title": "Your whole operation's support in one place.",
    "login.hero.text": "WhatsApp, queues, campaigns, flows and AI agents working together, with a real-time view of what is happening.",
    "login.hero.stat1Value": "1.2M",
    "login.hero.stat1Label": "messages/month",
    "login.hero.stat2Value": "99.9%",
    "login.hero.stat2Label": "uptime",
    "login.hero.stat3Value": "71%",
    "login.hero.stat3Label": "solved by AI",
    "login.forgotPassword": "Forgot password",
    "login.rememberDevice": "Remember this device for 30 days",
    "login.noAccount": "No account yet?",
    "login.createAccount": "Create account",
    "login.showPassword": "Show password",
    "login.hidePassword": "Hide password",
    "login.toggleTheme": "Toggle theme",
    "login.twoFactor.title": "Two-step verification",
    "login.twoFactor.subtitle": "Enter the 6-digit code from your authenticator app.",
    "login.twoFactor.noApp": "No access to the app?",
    "login.twoFactor.useRecovery": "Use a recovery code",
    "login.deviceConfirm.title": "Confirm this device",
    "login.deviceConfirm.subtitle": "We sent a 6-digit code to your e-mail.",
    "login.setup.mandatory": "Required by your company",
    "login.setup.title": "Turn on authentication",
    "login.setup.subtitle": "Scan the QR code with Google Authenticator, Authy or 1Password.",
    "login.setup.manual": "Or enter the key manually",
    "login.setup.copyKey": "Copy key",
    "login.setup.confirmCode": "Confirmation code",
    "login.recovery.title": "Save your recovery codes",
    "login.reset.emailTitle": "Reset password",
    "login.reset.emailSubtitle": "Enter your account e-mail. We'll send a 6-digit code.",
    "login.reset.emailLabel": "E-mail",
    "login.reset.send": "Send code",
    "login.reset.codeTitle": "Enter the code",
    "login.reset.codeSubtitle": "We sent a 6-digit code to your e-mail. It expires in 10 minutes.",
    "login.reset.verify": "Continue",
    "login.reset.resend": "Resend code",
    "login.reset.resendIn": "Resend in {{seconds}}s",
    "login.reset.passwordTitle": "New password",
    "login.reset.passwordSubtitle": "Choose a password with at least 5 characters.",
    "login.reset.passwordLabel": "New password",
    "login.reset.confirmLabel": "Confirm the new password",
    "login.reset.mismatch": "Passwords don't match.",
    "login.reset.totpLabel": "Authenticator code",
    "login.reset.totpHint": "Your account has two-step verification: confirm with the code from your app.",
    "login.reset.submit": "Save new password",
    "login.reset.success": "Password changed. Sign in with the new one.",
    "login.reset.back": "Back to login",
    "signup.pageTitle": "Company and owner details",
    "signup.pageSubtitle": "Enter the tax ID and we look up the legal name automatically.",
    "signup.hero.title": "Create your account in under two minutes.",
    "signup.steps.company.title": "Identify the company",
    "signup.steps.company.desc": "Tax ID, with the legal name filled in automatically.",
    "signup.steps.owner.title": "Owner and access",
    "signup.steps.owner.desc": "Name, WhatsApp, e-mail and password of the first administrator.",
    "signup.steps.plan.title": "Pick the plan",
    "signup.steps.plan.desc": "Set agents, connections and queues. You can change it later.",
    "signup.form.document": "Tax ID",
    "signup.form.companyName": "Company name",
    "signup.form.yourName": "Your name",
    "signup.form.whatsapp": "WhatsApp",
    "signup.form.plan": "Plan",
    "signup.documentValidating": "Checking…",
    "signup.documentValidCnpj": "Valid tax ID · legal name filled in",
    "signup.documentValidCpf": "Valid tax ID",
    "signup.password.empty": "Enter a password",
    "signup.password.weak": "Weak password",
    "signup.password.fair": "Fair password",
    "signup.password.good": "Good password",
    "signup.password.strong": "Strong password",
    "signup.plan.meta": "{{users}} agents · {{connections}} WhatsApp · {{queues}} queues",
    "signup.termsPrefix": "By continuing you agree to the ",
    "signup.termsLink": "Terms of use",
    "signup.termsAnd": " and the ",
    "signup.privacyLink": "Privacy policy",
    "signup.termsSuffix": ".",
    "signup.submit": "Create account",
    "signup.alreadyHave": "Already have an account?",
    "signup.goLogin": "Sign in",
    "loading.saving": "Saving changes…",
    "loading.moment": "This only takes a moment",
    "announcements.toasts.forbidden": "This company does not have permission to access this page. Redirecting you.",
    "signup.toasts.documentInvalid": "Invalid tax ID.",
    "signup.toasts.documentNotFound": "Tax ID invalid or not found at the tax authority.",
    "signup.toasts.documentError": "Could not validate the tax ID. Please try again.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "userModal.subtitleNew": "New platform access",
    "userModal.idLabel": "ID {{id}}",
    "userModal.removePhoto": "Remove photo",
    "userModal.changePhoto": "Change photo",
    "userModal.passwordHint": "· leave empty to keep",
    "userModal.footerMeta": "Created on {{created}}",
    "userModal.permissionGroups.tickets": "Tickets",
    "userModal.permissionGroups.modules": "Modules",
    "userModal.permissionGroups.internal": "Internal communication",
    "userModal.permissions.allTicket": "See all tickets",
    "userModal.permissions.allowGroup": "Handle groups",
    "userModal.permissions.allHistoric": "See full history",
    "userModal.permissions.allowSeeMessagesInPendingTickets": "See messages in pending tickets",
    "userModal.permissions.userClosePendingTicket": "Close pending tickets",
    "userModal.permissions.finalizacaoComValorVendaAtiva": "Closing with sale amount",
    "userModal.permissions.showDashboard": "Dashboard",
    "userModal.permissions.showContacts": "Contacts",
    "userModal.permissions.showCampaign": "Campaigns",
    "userModal.permissions.showFlow": "Flowbuilder",
    "userModal.permissions.allowConnections": "Connections",
    "userModal.permissions.allowRealTime": "Real-time panel",
    "userModal.permissions.allUserChat": "Chat with all users",
    "userModal.permissionCount": "{{active}} of {{total}} permissions active",
    "userModal.security.devices": "Trusted devices",
    "userModal.security.devicesEmpty": "No trusted device registered.",
    "userModal.security.removeDevice": "Remove device",
    "userModal.security.deviceRemoved": "Device removed.",
    "userModal.security.lastUsed": "last used {{when}}",
    "userModal.security.endAllSessions": "End all sessions",
    "userModal.security.endAll": "End",
    "userModal.security.endAllConfirmTitle": "End all sessions for {{name}}?",
    "userModal.security.endAllConfirmText": "Every trusted device is removed and open sessions are dropped. The next sign-in will ask for e-mail confirmation.",
    "userModal.security.endAllDone": "Sessions ended.",
    "userModal.security.removeDeviceTitle": "Remove “{{name}}”?",
    "userModal.security.removeDeviceText": "The device stops being trusted. Other sessions stay open, and the next sign-in on it will ask for e-mail confirmation.",
    "userModal.profileAdmin": "Admin",
    "userModal.profileUser": "Agent",
    "userModal.themeLight": "Light",
    "userModal.themeDark": "Dark",
    "userModal.menuOpen": "Open",
    "userModal.menuClosed": "Closed",
    "userModal.birthDateHint": "Used in birthday notifications",
    "users.confirmDelete.title": "Delete {{name}}?",
    "users.confirmDelete.text": "All of the user's data is lost and their open tickets return to the queue. This action cannot be undone.",
    "users.confirmDelete.confirm": "Delete user",
    "users.confirmChats.title": "Generate chats for all users?",
    "users.confirmChats.text": "Creates an internal chat between every pair of users that does not have one yet. It may take a few minutes.",
    "users.confirmChats.confirm": "Generate chats",
    "invoice.pay.title": "Pay invoice",
    "invoice.pay.subtitle": "{{plan}} · due on {{due}}",
    "invoice.pay.planSummary": "Plan summary",
    "invoice.pay.current": "Current",
    "invoice.pay.users": "agents",
    "invoice.pay.connections": "connections",
    "invoice.pay.queues": "queues",
    "invoice.pay.total": "Total",
    "invoice.pay.withPix": "Pay with Pix",
    "invoice.pay.copyCode": "Copy",
    "invoice.pay.codeCopied": "Pix code copied.",
    "invoice.pay.waiting": "Waiting for payment · the licence renews automatically once confirmed",
    "invoice.pay.validFor": "Code valid for",
    "invoice.pay.expired": "Code expired · generate a new one",
    "invoice.pay.otherMethods": "or pay with",
    "invoice.pay.generating": "Creating charge…",
    "invoice.pay.payNow": "Pay now",
    "invoice.pay.waitingConfirmation": "Waiting for payment confirmation…",
    "invoice.pay.mpUnavailable": "Online payment unavailable · contact support",
    "invoice.pay.renewed": "Your licence has been renewed until {{date}}!",
    "smsCredits.title": "Buy SMS credits",
    "smsCredits.subtitle": "Current balance: {{balance}} SMS",
    "smsCredits.subtitleUnknown": "Current balance unavailable",
    "smsCredits.bestValue": "Best value",
    "smsCredits.sms": "SMS",
    "smsCredits.perSms": "{{price}} per SMS",
    "smsCredits.empty": "No package available right now.",
    "smsCredits.newBalance": "New balance after purchase",
    "smsCredits.total": "Total",
    "smsCredits.footNote": "Credits never expire and are released once the payment is confirmed",
    "smsCredits.buy": "Pay with Mercado Pago",
    "smsCredits.waiting": "Waiting for payment confirmation… You can close this window — the credits arrive automatically.",
    "smsCredits.paid": "Payment confirmed! Credits added.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "userModal.form.birthDate": "Date of birth",
    "users.chatsDone": "Chats generated successfully!",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "avatarUpload.invalidType": "Unsupported format. Use JPG, PNG, GIF or WebP.",
    "avatarUpload.tooLarge": "File too large. Maximum size: 5 MB.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "smsCredits.avgUsage": "average use {{avg}}/month",
    "smsCredits.generatePix": "Generate Pix",
    "smsCredits.copyCode": "Copy",
    "smsCredits.codeCopied": "Pix code copied.",
    "smsCredits.waitingPix": "Waiting for payment · credits arrive automatically once confirmed",
    "smsCredits.otherMethods": "Pay another way (card or boleto)",
    // ---- Tickets entry (/tickets) — day panel and context card ----
    "aeros.ticketsEntry.greeting.morning": "Good morning, {{name}}.",
    "aeros.ticketsEntry.greeting.afternoon": "Good afternoon, {{name}}.",
    "aeros.ticketsEntry.greeting.evening": "Good evening, {{name}}.",
    "aeros.ticketsEntry.subtitle.waiting": "{{count}} person waiting in your queues",
    "aeros.ticketsEntry.subtitle.waiting_plural": "{{count}} people waiting in your queues",
    "aeros.ticketsEntry.newConversation": "New conversation",
    "aeros.ticketsEntry.pullNext": "Pull next",
    "aeros.ticketsEntry.pullNextEmpty": "No tickets waiting in your queues.",
    "aeros.ticketsEntry.wait.now": "just now",
    "aeros.ticketsEntry.wait.minutes": "{{count}} min",
    "aeros.ticketsEntry.wait.hours": "{{count}} h",
    "aeros.ticketsEntry.wait.hoursMinutes": "{{hours}} h {{minutes}} min",
    "aeros.ticketsEntry.wait.days": "{{count}} d",
    "aeros.ticketsEntry.kpi.solvedToday": "Solved today",
    "aeros.ticketsEntry.kpi.inService": "In progress",
    "aeros.ticketsEntry.kpi.waiting": "Waiting",
    "aeros.ticketsEntry.kpi.noReplyHint": "{{count}} unanswered for {{minutes}} min",
    "aeros.ticketsEntry.kpi.noReplyHint_plural": "{{count}} unanswered for {{minutes}} min",
    "aeros.ticketsEntry.kpi.oldestHint": "oldest: {{wait}}",
    "aeros.ticketsEntry.queues.title": "Your queues right now",
    "aeros.ticketsEntry.queues.seeAll": "See all",
    "aeros.ticketsEntry.queues.waiting": "waiting",
    "aeros.ticketsEntry.queues.answer": "Answer",
    "aeros.ticketsEntry.queues.detail": "longest wait {{wait}} · {{agents}} agent online",
    "aeros.ticketsEntry.queues.detail_plural": "longest wait {{wait}} · {{agents}} agents online",
    "aeros.ticketsEntry.queues.detailIdle": "nobody waiting · {{agents}} agent online",
    "aeros.ticketsEntry.queues.detailIdle_plural": "nobody waiting · {{agents}} agents online",
    "aeros.ticketsEntry.queues.empty": "You are not in any queue yet.",
    "aeros.ticketsEntry.agenda.title": "Today's schedule",
    "aeros.ticketsEntry.agenda.empty": "Nothing scheduled for today.",
    "aeros.ticketsEntry.attention.title": "Needs attention",
    "aeros.ticketsEntry.attention.noReply": "{{count}} of your conversations unanswered for over {{minutes}} minutes",
    "aeros.ticketsEntry.attention.noReply_plural": "{{count}} of your conversations unanswered for over {{minutes}} minutes",
    "aeros.ticketsEntry.context.back": "Day panel",
    "aeros.ticketsEntry.context.waiting": "waiting",
    "aeros.ticketsEntry.context.since": "customer since {{year}}",
    "aeros.ticketsEntry.context.tickets": "{{count}} ticket",
    "aeros.ticketsEntry.context.tickets_plural": "{{count}} tickets",
    "aeros.ticketsEntry.context.today": "today",
    "aeros.ticketsEntry.context.daysAgo": "{{count}} day ago",
    "aeros.ticketsEntry.context.daysAgo_plural": "{{count}} days ago",
    "aeros.ticketsEntry.context.lastMessage": "Last message",
    "aeros.ticketsEntry.context.noMessage": "No messages yet.",
    "aeros.ticketsEntry.context.receivedAt": "received at {{time}} · {{channel}}",
    "aeros.ticketsEntry.context.lastContact": "Last contact",
    "aeros.ticketsEntry.context.firstContact": "first ticket",
    "aeros.ticketsEntry.context.viaChatbot": "Went through the chatbot",
    "aeros.ticketsEntry.context.transfer": "Transfer",
    "aeros.ticketsEntry.context.schedule": "Schedule",
    "aeros.ticketsEntry.context.accept": "Take this ticket",
    "aeros.ticketsEntry.context.acceptHint": "Taking it opens the conversation and moves the ticket to \u201cIn progress\u201d",
    // ---- Modals from the ticket "+" menu (templates, files, contact, camera) ----
    "aeros.templateMeta.title": "WhatsApp templates",
    "aeros.templateMeta.subtitle": "{{count}} approved template on this connection",
    "aeros.templateMeta.subtitle_plural": "{{count}} approved templates on this connection",
    "aeros.templateMeta.search": "Search templates by name…",
    "aeros.templateMeta.empty": "No approved templates for this connection.",
    "aeros.templateMeta.emptySearch": "No templates found for this search.",
    "aeros.templateMeta.back": "Back to the list",
    "aeros.templateMeta.preview": "Template preview",
    "aeros.templateMeta.noContent": "This template has no text content.",
    "aeros.templateMeta.noVariables": "This template has no variables to fill in.",
    "aeros.templateMeta.filled": "{{filled}} of {{total}} variables filled in",
    "aeros.templateMeta.valuePlaceholder": "Value that replaces the variable",
    "aeros.templateMeta.send": "Send",
    "aeros.templateMeta.imageUrl": "Enter the image URL",
    "aeros.templateMeta.videoUrl": "Enter the video URL",
    "aeros.templateMeta.group.header": "Header",
    "aeros.templateMeta.group.body": "Body",
    "aeros.templateMeta.group.footer": "Footer",
    "aeros.templateMeta.group.buttons": "Buttons",
    "aeros.mediaUpload.title": "Send files",
    "aeros.mediaUpload.subtitleOne": "Check the file and write a caption before sending",
    "aeros.mediaUpload.subtitleMany": "{{total}} files · one caption per file",
    "aeros.mediaUpload.send": "Send",
    "aeros.mediaUpload.previous": "Previous file",
    "aeros.mediaUpload.next": "Next file",
    "aeros.mediaUpload.captionLabel": "Caption",
    "aeros.mediaUpload.captionPlaceholder": "Add a caption (optional)",
    "aeros.mediaUpload.captionHint": "Enter sends · Shift+Enter adds a line · ← → switch files",
    "aeros.mediaUpload.noPreview": "Preview not available",
    "aeros.mediaUpload.unknownType": "Unknown file type",
    "aeros.mediaUpload.imageAlt": "Image {{index}}",
    "aeros.sendContact.subtitle": "The contact is sent as a card (vCard) in the conversation",
    "aeros.sendContact.placeholder": "Type at least 3 letters of the name or number",
    "aeros.sendContact.hint": "Not there? Type the full name to create a new contact.",
    "aeros.sendContact.none": "No contact selected yet.",
    "aeros.camera.title": "Camera",
    "aeros.camera.subtitle": "The photo you take opens the send preview",
    // ---- Leads (/leads) ----
    "aeros.leads.title": "Leads",
    "aeros.leads.subtitle": "Buy leads by niche and city and chat on WhatsApp",
    "aeros.leads.buy": "Buy leads",
    "aeros.leads.newSearch": "New search",
    "aeros.leads.balance": "Lead balance",
    "aeros.leads.reserved": "{{count}} reserved by queued searches",
    "aeros.leads.available": "{{count}} available",
    "aeros.leads.unit": "leads",
    "aeros.leads.searches": "Searches",
    "aeros.leads.searchesEmpty": "No searches yet. Buy leads and create the first one.",
    "aeros.leads.col.niche": "Niche",
    "aeros.leads.col.city": "City/State",
    "aeros.leads.col.requested": "Requested",
    "aeros.leads.col.delivered": "Delivered",
    "aeros.leads.col.status": "Status",
    "aeros.leads.col.date": "Date",
    "aeros.leads.status.queued": "Queued",
    "aeros.leads.status.running": "Searching",
    "aeros.leads.status.processing": "Importing",
    "aeros.leads.status.done": "Done",
    "aeros.leads.status.failed": "Failed",
    "aeros.leads.status.cancelled": "Cancelled",
    "aeros.leads.status.unknown": "Unknown",
    "aeros.leads.partial": "Google Maps had fewer results than requested; only delivered leads were charged.",
    "aeros.leads.failedHint": "Service temporarily unavailable. Nothing was charged.",
    "aeros.leads.cancel": "Cancel search",
    "aeros.leads.cancelled": "Search cancelled and balance released.",
    "aeros.leads.leadsOf": "Leads of the search",
    "aeros.leads.selectSearch": "Select a search to see its leads.",
    "aeros.leads.leadsEmpty": "No leads in this search.",
    "aeros.leads.searchPlaceholder": "Search by name, phone or email",
    "aeros.leads.columns": "Columns",
    "aeros.leads.export": "Export CSV",
    "aeros.leads.lead.name": "Name",
    "aeros.leads.lead.phone": "Phone",
    "aeros.leads.lead.whatsapp": "WhatsApp",
    "aeros.leads.lead.email": "Email",
    "aeros.leads.lead.social": "Social",
    "aeros.leads.lead.address": "Address",
    "aeros.leads.lead.site": "Website",
    "aeros.leads.lead.rating": "Rating",
    "aeros.leads.lead.reviews": "Reviews",
    "aeros.leads.lead.maps": "Google Maps",
    "aeros.leads.lead.notes": "Notes",
    "aeros.leads.lead.notesCategory": "Category",
    "aeros.leads.lead.notesHours": "Hours",
    "aeros.leads.lead.notesDescription": "Description",
    "aeros.leads.whatsapp.yes": "Has WhatsApp",
    "aeros.leads.whatsapp.no": "No WhatsApp",
    "aeros.leads.whatsapp.unknown": "WhatsApp not verified",
    "aeros.leads.openTicket": "Chat on WhatsApp",
    "aeros.leads.progress": "{{delivered}} of {{requested}} leads",
    "aeros.leads.finished": "Search finished: {{count}} leads delivered.",
    "aeros.leads.failedToast": "The search failed. Nothing was charged.",
    "aeros.leads.loadMore": "Load more",
    "aeros.leads.search.title": "New lead search",
    "aeros.leads.search.subtitle": "Niche + city. Only leads with a phone number, never repeated, count.",
    "aeros.leads.search.niche": "Niche",
    "aeros.leads.search.nichePlaceholder": "e.g. dental clinic",
    "aeros.leads.search.city": "City",
    "aeros.leads.search.state": "State",
    "aeros.leads.search.quantity": "Number of leads",
    "aeros.leads.search.estimate": "Uses up to {{quantity}} of your {{balance}} balance.",
    "aeros.leads.search.insufficient": "Insufficient balance: you have {{balance}} available.",
    "aeros.leads.search.repeated": "You already searched this niche in this city on {{date}}. Most results would repeat, so it stays blocked for {{days}} days.",
    "aeros.leads.search.submit": "Start search",
    "aeros.leads.search.created": "Search started. You will be notified when it finishes.",
    "aeros.leads.search.minMax": "Between {{min}} and {{max}} leads",
    "aeros.leads.buyModal.title": "Buy leads",
    "aeros.leads.buyModal.subtitle": "Current balance: {{balance}} leads",
    "aeros.leads.buyModal.subtitleUnknown": "Choose a package",
    "aeros.leads.buyModal.perLead": "{{price}} per lead",
    "aeros.leads.buyModal.bestValue": "Best value",
    "aeros.leads.buyModal.newBalance": "New balance",
    "aeros.leads.buyModal.total": "Total",
    "aeros.leads.buyModal.generatePix": "Generate Pix",
    "aeros.leads.buyModal.waiting": "Waiting for payment confirmation…",
    "aeros.leads.buyModal.waitingPix": "Once the Pix is confirmed, the balance is credited automatically.",
    "aeros.leads.buyModal.copyCode": "Copy code",
    "aeros.leads.buyModal.codeCopied": "Pix code copied",
    "aeros.leads.buyModal.otherMethods": "Pay with card or bank slip",
    "aeros.leads.buyModal.paid": "Payment confirmed! Leads credited.",
    "aeros.leads.buyModal.empty": "No packages available right now.",
    "aeros.leads.buyModal.footNote": "Payment via Mercado Pago. Only delivered leads are charged.",
    "aeros.leadsAdmin.tab": "Leads",
    "aeros.leadsAdmin.config": "Integration and limits",
    "aeros.leadsAdmin.apifyToken": "Apify token",
    "aeros.leadsAdmin.apifyTokenConfigured": "Token configured. Paste a new one to replace it.",
    "aeros.leadsAdmin.apifyTokenMissing": "No token: searches use the test provider outside production and fail in production.",
    "aeros.leadsAdmin.factor": "Over-fetch factor",
    "aeros.leadsAdmin.factorHint": "How many places to request from Apify per requested lead (covers no-phone and repeats).",
    "aeros.leadsAdmin.blockDays": "Repeat block days",
    "aeros.leadsAdmin.maxPerSearch": "Max leads per search",
    "aeros.leadsAdmin.save": "Save",
    "aeros.leadsAdmin.saved": "Settings saved",
    "aeros.leadsAdmin.packs": "Lead packages",
    "aeros.leadsAdmin.newPack": "New package",
    "aeros.leadsAdmin.name": "Name",
    "aeros.leadsAdmin.namePlaceholder": "e.g. 500 leads",
    "aeros.leadsAdmin.quantity": "Quantity",
    "aeros.leadsAdmin.value": "Price (R$)",
    "aeros.leadsAdmin.perLead": "R$/lead",
    "aeros.leadsAdmin.active": "Active",
    "aeros.leadsAdmin.create": "Create package",
    "aeros.leadsAdmin.created": "Package created",
    "aeros.leadsAdmin.packsEmpty": "No packages yet.",
    "aeros.leadsAdmin.searches": "Searches across all companies",
    "aeros.leadsAdmin.company": "Company",
    "aeros.leadsAdmin.scraped": "Scraped",
    "aeros.leadsAdmin.cost": "Cost (USD)",
    "aeros.leadsAdmin.error": "Error",
    "aeros.leadsAdmin.searchesEmpty": "No searches yet.",
    "mainDrawer.listItems.groupOverview": "Overview",
    "mainDrawer.listItems.groupService": "Service",
    "mainDrawer.listItems.groupCrm": "CRM & Prospecting",
    "mainDrawer.listItems.groupSystem": "System & Account",
    "mainDrawer.listItems.leads": "Lead Base",
    "mainDrawer.listItems.creditosSms": "SMS Credits",
    "mainDrawer.wallet.title": "Your wallet",
    "mainDrawer.wallet.sms": "SMS sends",
    "mainDrawer.wallet.leads": "Lead extraction",
    "mainDrawer.wallet.recharge": "Top up",
    "mainDrawer.wallet.buyMore": "Buy more",
  },
  es: {
    // ---- Tela Importar contatos de arquivo (/contacts/import) ----
    "aeros.contactImport.breadcrumb": "Contactos",
    "aeros.contactImport.pageTitle": "Importar contactos desde un archivo",
    // ---- Tela Histórico de chamadas (/call-historicals · Wavoip) ----
    "aeros.calls.title": "Historial de llamadas",
    "aeros.calls.subtitle": "Llamadas de voz por WhatsApp (Wavoip) · tiempo real",
    "aeros.calls.search": "Buscar nombre o teléfono…",
    "aeros.calls.contact": "Contacto",
    "aeros.calls.phone": "Teléfono",
    "aeros.calls.dateTime": "Fecha/Hora",
    "aeros.calls.statusColumn": "Estado",
    "aeros.calls.duration": "Duración",
    "aeros.calls.typeColumn": "Tipo",
    "aeros.calls.agent": "Agente",
    "aeros.calls.actions": "Acciones",
    "aeros.calls.loadMore": "Cargar más",
    "aeros.calls.loading": "Cargando llamadas…",
    "aeros.calls.empty": "Todavía no hay llamadas registradas.",
    "aeros.calls.emptySearch": "No se encontraron llamadas para esta búsqueda.",
    "aeros.calls.unavailableTitle": "Integración de voz no disponible",
    "aeros.calls.unavailableText": "No fue posible consultar Wavoip. Revisa el token de la integración de voz en la configuración de la conexión.",
    "aeros.calls.download": "Descargar grabación",
    "aeros.calls.callBack": "Llamar a este contacto",
    "aeros.calls.incomingCall": "Llamada recibida",
    "aeros.calls.unnamed": "Sin identificación",
    "aeros.calls.status.ended": "Finalizada",
    "aeros.calls.status.active": "En curso",
    "aeros.calls.status.ringing": "Llamando",
    "aeros.calls.status.busy": "Ocupado",
    "aeros.calls.status.noAnswer": "No contestada",
    "aeros.calls.status.rejected": "Rechazada",
    "aeros.calls.status.unknown": "Sin estado",
    "aeros.calls.type.out": "Realizada",
    "aeros.calls.type.in": "Recibida",
    "aeros.calls.kpi.total": "Total de llamadas",
    "aeros.calls.kpi.served": "Contestadas",
    "aeros.calls.kpi.rejected": "Rechazadas / no contestadas",
    "aeros.calls.kpi.finished": "Finalizadas",
    // ---- Tela Carteiras (/wallets) ----
    "aeros.wallets.title": "Carteras",
    "aeros.wallets.subtitle": "Contactos con agente y cola fijos",
    "aeros.wallets.search": "Buscar contacto…",
    "aeros.wallets.filterUser": "Filtrar por usuario",
    "aeros.wallets.allUsers": "Todos los usuarios",
    "aeros.wallets.contact": "Contacto",
    "aeros.wallets.user": "Agente",
    "aeros.wallets.queue": "Cola",
    "aeros.wallets.phone": "Teléfono",
    "aeros.wallets.email": "Correo",
    "aeros.wallets.actions": "Acciones",
    "aeros.wallets.loading": "Cargando carteras…",
    "aeros.wallets.empty": "Todavía no hay contactos en cartera.",
    "aeros.wallets.emptySearch": "Ningún contacto coincide con estos filtros.",
    "aeros.wallets.edit": "Editar cartera",
    "aeros.wallets.remove": "Quitar de la cartera",
    "aeros.wallets.save": "Guardar",
    "aeros.wallets.editTitle": "Editar cartera",
    "aeros.wallets.noQueues": "Este agente no está en ninguna cola.",
    "aeros.wallets.confirmTitle": "¿Quitar a {{name}} de la cartera?",
    "aeros.wallets.confirmMessage": "El contacto vuelve a la distribución normal de la cola.",
    "aeros.wallets.deleteSuccess": "Contacto quitado de la cartera.",
    "aeros.wallets.updateSuccess": "Cartera actualizada.",
    "aeros.wallets.selectUserAndQueue": "Selecciona un agente y una cola.",
    "aeros.wallets.note": "Los contactos en cartera vuelven siempre al mismo agente, ignorando la rotación de la cola.",
    // ---- Tela Conexões (/connections e /allConnections) ----
    "aeros.connections.needsAttention": "{{count}} conexiones necesitan atención",
    "aeros.connections.needsAttentionOne": "1 conexión necesita atención",
    "aeros.connections.companies": "{{count}} empresas en la plataforma",
    "aeros.connections.companiesOne": "1 empresa en la plataforma",
    "aeros.connections.manage": "Gestionar conexiones",
    "aeros.connections.super": "SUPER",
    "aeros.connections.status.connected": "Conectada",
    "aeros.connections.status.waiting": "Esperando código QR",
    "aeros.connections.status.disconnected": "Desconectada",
    "aeros.companies.status.active": "Activa",
    "aeros.sms.status.paid": "Pagado",
    "aeros.contactLists.title": "Listas de contactos",
    "aeros.contactLists.subtitle": "Públicos usados en las campañas",
    "aeros.contactLists.search": "Buscar lista…",
    "aeros.contactLists.newList": "Nueva lista",
    "aeros.contactLists.name": "Nombre",
    "aeros.contactLists.contacts": "Contactos",
    "aeros.contactLists.createdAt": "Creada el",
    "aeros.contactLists.actions": "Acciones",
    "aeros.contactLists.openContacts": "Ver contactos de la lista",
    "aeros.contactLists.download": "Descargar planilla de la lista",
    "aeros.contactLists.edit": "Renombrar lista",
    "aeros.contactLists.delete": "Eliminar lista",
    "aeros.contactLists.loading": "Cargando…",
    "aeros.contactLists.empty": "Ninguna lista todavía. Crea la primera para usar en las campañas.",
    "aeros.contactLists.emptySearch": "Ninguna lista encontrada con ese término.",
    "aeros.contactLists.confirmTitle": "¿Eliminar la lista {{name}}?",
    "aeros.contactLists.confirmMessage": "Los contactos de la lista se eliminan con ella. Las campañas que ya la usaron conservan su historial.",
    "aeros.kanbanTags.title": "Tags del Kanban",
    "aeros.kanbanTags.subtitle": "Cada tag es una columna del tablero",
    "aeros.kanbanTags.backToBoard": "Volver al Kanban",
    "aeros.kanbanTags.newTag": "Nueva tag",
    "aeros.kanbanTags.name": "Nombre",
    "aeros.kanbanTags.ticketsColumn": "Tickets",
    "aeros.kanbanTags.order": "Orden",
    "aeros.kanbanTags.actions": "Acciones",
    "aeros.kanbanTags.edit": "Editar tag",
    "aeros.kanbanTags.delete": "Eliminar tag",
    "aeros.kanbanTags.deleted": "Tag eliminada",
    "aeros.kanbanTags.dragHandle": "Arrastra para reordenar",
    "aeros.kanbanTags.loading": "Cargando…",
    "aeros.kanbanTags.empty": "Ninguna columna en el tablero todavía. Crea la primera tag.",
    "aeros.kanbanTags.boardPreview": "Vista previa del tablero",
    "aeros.kanbanTags.tickets": "{{count}} tickets",
    "aeros.kanbanTags.ticketOne": "1 ticket",
    "aeros.kanbanTags.confirmTitle": "¿Eliminar la columna {{name}}?",
    "aeros.kanbanTags.confirmMessage": "La columna desaparece del tablero. Los tickets no se eliminan — solo dejan de estar en ella.",
    "aeros.todo.title": "Tareas",
    "aeros.todo.subtitle": "Notas rápidas de tu día — se guardan solo en este navegador",
    "aeros.todo.placeholder": "Ej.: revisar tickets sin respuesta de la cola Comercial",
    "aeros.todo.add": "Agregar",
    "aeros.todo.save": "Guardar",
    "aeros.todo.edit": "Editar tarea",
    "aeros.todo.delete": "Eliminar tarea",
    "aeros.todo.confirmTitle": "¿Eliminar esta tarea?",
    "aeros.todo.markDone": "Marcar como completada",
    "aeros.todo.markOpen": "Reabrir tarea",
    "aeros.todo.pending": "{{count}} pendientes",
    "aeros.todo.pendingOne": "1 pendiente",
    "aeros.todo.empty": "Ninguna tarea por aquí. Escribe la primera arriba.",
    "aeros.todo.localNote": "Como viven en el navegador, las tareas no se sincronizan entre dispositivos ni aparecen para otros usuarios.",
    "aeros.smsPacks.newPack": "Nuevo paquete",
    "aeros.smsPacks.name": "Nombre",
    "aeros.smsPacks.namePlaceholder": "ej.: Paquete 2.500",
    "aeros.smsPacks.quantity": "Cantidad",
    "aeros.smsPacks.quantityShort": "Cant.",
    "aeros.smsPacks.value": "Valor (R$)",
    "aeros.smsPacks.perSms": "R$/SMS",
    "aeros.smsPacks.active": "Activo",
    "aeros.smsPacks.create": "Crear paquete",
    "aeros.smsPacks.created": "Paquete creado",
    "aeros.smsPacks.empty": "Ningún paquete registrado todavía.",
    "aeros.smsPacks.inactiveNote": "Los paquetes inactivos dejan de aparecer en la pantalla de compra de las empresas, pero permanecen en el historial.",
    "aeros.sms.title": "Créditos SMS",
    "aeros.sms.subtitle": "Saldo, recargas e historial de consumo",
    "aeros.sms.buyCredits": "Comprar créditos",
    "aeros.sms.currentBalance": "Saldo actual",
    "aeros.sms.avgPerDay": "Consumo medio de {{count}} SMS por día",
    "aeros.sms.avgPerDayShort": "{{count}}/día en promedio",
    "aeros.sms.noUsageYet": "Sin consumo registrado todavía",
    "aeros.sms.noneThisMonth": "Ningún envío este mes",
    "aeros.sms.sentMonth": "Enviados en el mes",
    "aeros.sms.investedMonth": "Invertido en el mes",
    "aeros.sms.rechargeCount": "{{count}} recargas",
    "aeros.sms.rechargeOne": "1 recarga",
    "aeros.sms.autonomy": "Autonomía",
    "aeros.sms.days": "{{count}} días",
    "aeros.sms.dayOne": "1 día",
    "aeros.sms.autonomyHint": "al ritmo actual de consumo",
    "aeros.sms.autonomyUnknown": "sin consumo para estimar",
    "aeros.sms.lowBalance": "Al ritmo actual, el saldo se acaba en {{count}} días.",
    "aeros.sms.rechargeNow": "Recargar ahora",
    "aeros.sms.recharges": "Recargas",
    "aeros.sms.viaMercadoPago": "pago vía Mercado Pago",
    "aeros.sms.filterAll": "Todas",
    "aeros.sms.date": "Fecha",
    "aeros.sms.package": "Paquete",
    "aeros.sms.quantity": "Cantidad",
    "aeros.sms.value": "Valor",
    "aeros.sms.statusColumn": "Estado",
    "aeros.sms.loading": "Cargando…",
    "aeros.sms.noRecharges": "Ninguna recarga todavía.",
    "aeros.sms.noRechargesFilter": "Ninguna recarga con ese estado.",
    "aeros.sms.webhookNote": "Las recargas pagadas entran automáticamente por el webhook — sin necesidad de recargar la página.",
    "aeros.sms.usage7days": "Consumo de los últimos 7 días",
    "aeros.sms.noUsageData": "Sin consumo en el período",
    "aeros.sms.whereUsed": "Dónde se usaron los créditos",
    "aeros.sms.fractionNote": "Los mensajes de más de 160 caracteres se cobran en bloques de 153.",
    "aeros.sms.status.pending": "Pendiente",
    "aeros.sms.status.expired": "Expirado",
    "aeros.sms.status.unknown": "Desconocido",
    "aeros.sms.weekday.0": "Dom",
    "aeros.sms.weekday.1": "Lun",
    "aeros.sms.weekday.2": "Mar",
    "aeros.sms.weekday.3": "Mié",
    "aeros.sms.weekday.4": "Jue",
    "aeros.sms.weekday.5": "Vie",
    "aeros.sms.weekday.6": "Sáb",
    "aeros.sms.origin.campanha": "Campañas por SMS",
    "aeros.sms.origin.manual": "Envío manual desde el contacto",
    "aeros.sms.origin.automacao": "Automatizaciones / flujos",
    "aeros.sms.origin.outros": "Otros consumos",
    "aeros.dashboard.greeting.morning": "Buenos días",
    "aeros.dashboard.range.today": "Hoy",
    "aeros.dashboard.range.week": "7 días",
    "aeros.dashboard.range.month": "30 días",
    "aeros.dashboard.range.custom": "Personalizado",
    "aeros.dashboard.indicators": "Indicadores",
    "aeros.dashboard.export": "Exportar",
    "aeros.dashboard.filters": "Filtros",
    "aeros.dashboard.filterType": "Tipo de filtro",
    "aeros.dashboard.byDate": "Por fecha",
    "aeros.dashboard.quickFilter": "Filtro rápido",
    "aeros.dashboard.period": "Período",
    "aeros.dashboard.queue": "Cola",
    "aeros.dashboard.agent": "Agente",
    "aeros.dashboard.allQueues": "Todas",
    "aeros.dashboard.allAgents": "Todos",
    "aeros.dashboard.queuesFilter": "Colas: {{value}}",
    "aeros.dashboard.clear": "Limpiar",
    "aeros.dashboard.apply": "Filtrar",
    "aeros.dashboard.ticketsPerDay": "Total de atenciones por día",
    "aeros.dashboard.inPeriod": "({{count}} en el período)",
    "aeros.dashboard.received": "Recibidos",
    "aeros.dashboard.resolved": "Resueltos",
    "aeros.dashboard.noData": "Sin atenciones en el período",
    "aeros.dashboard.satisfaction": "Encuesta de satisfacción",
    "aeros.dashboard.score": "Score",
    "aeros.dashboard.promoters": "Promotores",
    "aeros.dashboard.passive": "Neutros",
    "aeros.dashboard.detractors": "Detractores",
    "aeros.dashboard.ratingIndex": "Índice de evaluación",
    "aeros.dashboard.totalTickets": "Total de atenciones",
    "aeros.dashboard.waitingRating": "Esperando evaluación",
    "aeros.dashboard.withoutRating": "Sin evaluación",
    "aeros.dashboard.rated": "Evaluados",
    "aeros.dashboard.agents": "Agentes",
    "aeros.dashboard.fullReport": "Ver informe completo",
    "aeros.dashboard.inService": "En atenc.",
    "aeros.dashboard.finished": "Finalizados",
    "aeros.dashboard.avgSupport": "T.M. atenc.",
    "aeros.dashboard.avgWait": "T.M. espera",
    "aeros.dashboard.rating": "Evaluación",
    "aeros.dashboard.status": "Estado",
    "aeros.dashboard.loading": "Cargando…",
    "aeros.dashboard.noAgents": "Ningún agente encontrado",
    "aeros.dashboard.kpi.Em Atendimento": "En atención",
    "aeros.dashboard.kpi.Aguardando": "Esperando",
    "aeros.dashboard.kpi.Finalizados": "Finalizados",
    "aeros.dashboard.kpi.Grupos": "Grupos",
    "aeros.dashboard.kpi.Novos Contatos": "Nuevos contactos",
    "aeros.dashboard.kpi.Atendentes Ativos": "Agentes activos",
    "aeros.dashboard.kpi.Mensagens Recebidas": "Mensajes recibidos",
    "aeros.dashboard.kpi.Mensagens Enviadas": "Mensajes enviados",
    "aeros.dashboard.kpi.T.M. de Atendimento": "T.M. de atención",
    "aeros.dashboard.kpi.T.M. de Espera": "T.M. de espera",
    "aeros.dashboard.kpi.Tickets Ativos": "Tickets activos",
    "aeros.dashboard.kpi.Tickets Passivos": "Tickets pasivos",
    "aeros.dashboard.kpi.Créditos SMS": "Créditos SMS",
    "aeros.dashboard.greeting.afternoon": "Buenas tardes",
    "aeros.dashboard.greeting.evening": "Buenas noches",
    "aeros.dashboard.updatedNow": "actualizado ahora",
    "aeros.dashboard.updatedSeconds": "actualizado hace {{count}}s",
    "aeros.dashboard.updatedMinutes": "actualizado hace {{count}} min",
    "aeros.dashboard.updatedHours": "actualizado hace {{count}} h",
    "aeros.dashboard.onlineOf": "{{online}} en línea de {{total}}",
    "aeros.dashboard.agentStatus.online": "En línea",
    "aeros.dashboard.agentStatus.busy": "Ocupado",
    "aeros.dashboard.agentStatus.offline": "Desconectado",
    "aeros.dashboard.delta.stable": "estable",
    "aeros.dashboard.delta.inPeriod": "en el período",
    "aeros.dashboard.delta.lastHour": "en la última hora",
    "aeros.dashboard.delta.onAverage": "en la media",
    "aeros.dashboard.delta.vsAverage": "min vs. media",
    "aeros.dashboard.delta.today": "hoy",
    "aeros.dashboard.delta.offline": "{{count}} desconectados",
    "aeros.dashboard.delta.total": "{{value}} en total",
    "aeros.companies.status.inactive": "Inactiva",
    "aeros.companies.status.expired": "Vencida",
    "aeros.companies.status.soon": "Vence pronto",
    "aeros.companies.status.trial": "Trial",
    "aeros.companies.due.in": "en {{count}} días",
    "aeros.companies.due.inOne": "en 1 día",
    "aeros.companies.due.today": "vence hoy",
    "aeros.companies.due.late": "{{count}} días de atraso",
    "aeros.companies.due.lateOne": "1 día de atraso",
    "aeros.companies.due.disabled": "cuenta desactivada",
    "aeros.companies.subtitle": "Cuentas, planes y facturación de la plataforma",
    "aeros.companies.searchPlaceholder": "Buscar empresa, correo…",
    "aeros.companies.filterStatus": "Filtrar por estado",
    "aeros.companies.filter.all": "Estado: Todos",
    "aeros.companies.plansButton": "Planes",
    "aeros.companies.newCompany": "Nueva empresa",
    "aeros.companies.loading": "Cargando…",
    "aeros.companies.emptyTitle": "No se encontró ninguna empresa",
    "aeros.companies.emptyText": "Ajusta la búsqueda o el filtro de estado.",
    "aeros.companies.files": "{{count}} arch.",
    "aeros.companies.showing": "Mostrando {{shown}} de {{total}} empresas",
    "aeros.companies.prevPage": "Página anterior",
    "aeros.companies.nextPage": "Página siguiente",
    "aeros.companies.legend": "Filas en rojo: vencimiento superado. Las empresas inactivas se ven atenuadas y sin acceso.",
    "aeros.companies.table.planValue": "Plan · Valor",
    "aeros.companies.table.company": "Empresa",
    "aeros.companies.table.status": "Estado",
    "aeros.companies.table.usage": "Uso · SMS",
    "aeros.companies.table.actions": "Acciones",
    "aeros.companies.actions.edit": "Editar empresa",
    "aeros.companies.actions.sms": "Créditos SMS",
    "aeros.companies.actions.delete": "Eliminar empresa",
    "aeros.companies.kpi.activeInactive": "{{active}} activas · {{inactive}} inactivas",
    "aeros.companies.kpi.mrr": "MRR",
    "aeros.companies.kpi.mrrHint": "ingreso mensual recurrente",
    "aeros.companies.kpi.overdue": "Vencidas",
    "aeros.companies.kpi.overdueHint": "{{value}} en atraso",
    "aeros.companies.kpi.trial": "En trial",
    "aeros.companies.kpi.trialHint": "{{count}} expiran esta semana",
    "aeros.companies.kpi.storage": "Almacenamiento",
    "aeros.companies.confirm.title": "¿Eliminar {{name}}?",
    "aeros.companies.confirm.message": "Se perderán todos los datos de la empresa: usuarios, conexiones, tickets, contactos y archivos ({{size}}). Esta acción no se puede revertir.",
    "aeros.companies.confirm.action": "Eliminar empresa",
    "aeros.companies.confirm.typedHint": "Escribe el nombre de la empresa para confirmar",
    "aeros.companies.recurrence.MENSAL": "Mensual",
    "aeros.companies.recurrence.BIMESTRAL": "Bimestral",
    "aeros.companies.recurrence.TRIMESTRAL": "Trimestral",
    "aeros.companies.recurrence.SEMESTRAL": "Semestral",
    "aeros.companies.recurrence.ANUAL": "Anual",
    "aeros.companies.recurrenceFromPlan": "Definida por el plan",
    "aeros.companies.modal.title": "Editar empresa",
    "aeros.companies.modal.save": "Guardar empresa",
    "aeros.companies.modal.saved": "Empresa guardada",
    "aeros.companies.modal.accountData": "Datos de la cuenta",
    "aeros.companies.modal.adminEmail": "Correo del administrador",
    "aeros.companies.modal.newPassword": "Nueva contraseña",
    "aeros.companies.modal.showPassword": "Mostrar contraseña",
    "aeros.companies.modal.hidePassword": "Ocultar contraseña",
    "aeros.companies.modal.clientSince": "cliente desde {{date}}",
    "aeros.companies.modal.connections": "{{count}} conexiones",
    "aeros.companies.modal.connectionOne": "1 conexión",
    "aeros.companies.modal.users": "{{count}} usuarios",
    "aeros.companies.modal.userOne": "1 usuario",
    "aeros.companies.modal.planLimits": "{{users}} usuarios · {{connections}} conexiones · {{queues}} colas",
    "aeros.companies.modal.campaigns": "Campañas habilitadas",
    "aeros.companies.modal.campaignsHint": "Sobrescribe el permiso del plan para esta empresa",
    "aeros.companies.modal.billing": "Facturación",
    "aeros.companies.subscription.column": "Suscripción",
    "aeros.companies.subscription.title": "Suscripción",
    "aeros.companies.subscription.none": "Sin suscripción vigente",
    "aeros.companies.subscription.plan": "Plan",
    "aeros.companies.subscription.periodMethod": "Período · medio",
    "aeros.companies.subscription.cycle": "Ciclo",
    "aeros.companies.subscription.status": "Estado",
    "aeros.companies.subscription.cancel": "Cancelar suscripción",
    "aeros.companies.subscription.cancelTitle": "¿Cancelar la suscripción de esta empresa?",
    "aeros.companies.subscription.cancelText": "El cobro automático se detiene y la empresa mantiene el acceso hasta el final del ciclo pagado. Después, plan, vencimiento y recurrencia vuelven a ser editables.",
    "aeros.companies.subscription.cancelConfirm": "Cancelar suscripción",
    "aeros.companies.subscription.canceled": "Suscripción cancelada",
    "aeros.companies.managedBySubscription": "El plan, el vencimiento y la recurrencia los gestiona la suscripción. Cancele la suscripción para editarlos manualmente.",
    "aeros.companies.modal.paymentMethod": "Método de pago",
    "aeros.companies.modal.nextInvoice": "Próxima factura",
    "aeros.companies.modal.dueOn": "vence {{date}}",
    "aeros.companies.modal.onTime": "al día",
    "aeros.companies.modal.late": "en atraso",
    "aeros.companies.modal.lastPaid": "Última pagada: {{date}}",
    "aeros.companies.modal.noPaid": "Ninguna factura pagada aún",
    "aeros.companies.modal.noOpenInvoice": "Ninguna factura abierta",
    "aeros.companies.modal.disable": "Desactivar empresa",
    "aeros.companies.modal.enable": "Reactivar empresa",
    "aeros.companies.newModal.subtitle": "El correo y la contraseña predeterminada crean el primer usuario administrador.",
    "aeros.companies.newModal.active": "Activo",
    "aeros.companies.newModal.note": "El plan, el vencimiento y la recurrencia se definen después, en Editar empresa.",
    "aeros.companies.sms.title": "Créditos SMS",
    "aeros.companies.sms.currentBalance": "Saldo actual: {{count}} SMS",
    "aeros.companies.sms.customAmount": "Cantidad personalizada",
    "aeros.companies.sms.amountPlaceholder": "ej.: 2500",
    "aeros.companies.sms.reason": "Motivo",
    "aeros.companies.sms.reasonRequired": "Informa el motivo del registro",
    "aeros.companies.sms.invalidAmount": "Informa una cantidad mayor que cero",
    "aeros.companies.sms.newBalance": "Nuevo saldo tras la operación",
    "aeros.companies.sms.apply": "Aplicar créditos",
    "aeros.companies.sms.applied": "Créditos aplicados",
    "aeros.companies.sms.statement": "Extracto",
    "aeros.companies.sms.noEntries": "Ningún registro encontrado.",
    "aeros.companies.sms.credit": "Crédito",
    "aeros.companies.sms.debit": "Débito",
    "aeros.plans.title": "Planes",
    "aeros.plans.newPlan": "Nuevo plan",
    "aeros.plans.editPlan": "Editar plan",
    "aeros.plans.name": "Nombre",
    "aeros.plans.users": "usuarios",
    "aeros.plans.connections": "conexiones",
    "aeros.plans.queues": "colas",
    "aeros.plans.amount": "Valor (R$)",
    "aeros.plans.recurrence": "Periodicidad",
    "aeros.plans.period.MENSAL": "/ mes",
    "aeros.plans.period.BIMESTRAL": "/ 2 meses",
    "aeros.plans.period.TRIMESTRAL": "/ trimestre",
    "aeros.plans.period.SEMESTRAL": "/ semestre",
    "aeros.plans.period.ANUAL": "/ año",
    "aeros.plans.usersLabel": "Usuarios",
    "aeros.plans.connectionsLabel": "Conexiones",
    "aeros.plans.queuesLabel": "Colas",
    "aeros.plans.public": "Público",
    "aeros.plans.trial": "Trial",
    "aeros.plans.trialDays": "Trial {{count}}d",
    "aeros.plans.trialDaysField": "Días de trial",
    "aeros.plans.featuresTitle": "Recursos incluidos",
    "aeros.plans.clear": "Limpiar",
    "aeros.plans.save": "Guardar plan",
    "aeros.plans.saved": "Plan guardado",
    "aeros.plans.deleted": "Plan eliminado",
    "aeros.plans.edit": "Editar plan",
    "aeros.plans.delete": "Eliminar plan",
    "aeros.plans.nameRequired": "Informa el nombre del plan",
    "aeros.plans.emptyTitle": "Ningún plan registrado",
    "aeros.plans.usage": "{{count}} empresas en este plan",
    "aeros.plans.usageOne": "1 empresa en este plan",
    "aeros.plans.confirmTitle": "¿Eliminar el plan {{name}}?",
    "aeros.plans.confirmMessage": "Hoy {{count}} empresa(s) usan este plan. Eliminarlo no cambia su plan, pero los límites dejan de existir y aparecen sin plan en el listado.",
    "aeros.plans.feature.whatsapp": "WhatsApp",
    "aeros.plans.feature.whatsappOfficial": "WhatsApp Oficial",
    "aeros.plans.feature.facebook": "Facebook",
    "aeros.plans.feature.instagram": "Instagram",
    "aeros.plans.feature.campaigns": "Campañas",
    "aeros.plans.feature.schedules": "Agendamientos",
    "aeros.plans.feature.internalChat": "Chat interno",
    "aeros.plans.feature.externalApi": "API Externa",
    "aeros.plans.feature.kanban": "Kanban",
    "aeros.plans.feature.openAi": "Talk.Ai",
    "aeros.plans.feature.integrations": "Integraciones",
    "aeros.plans.feature.wavoip": "Wavoip",
    "aeros.connections.channel.baileys": "WhatsApp (Baileys)",
    "aeros.connections.channel.official": "WhatsApp Oficial (Meta)",
    "aeros.connections.defaultOne": "conexión predeterminada",
    "aeros.connections.tabs.chatbot": "Chatbot",
    "aeros.connections.tabs.flow": "Flujo predeterminado",
    "aeros.connections.form.defaultHint": "Se usa cuando no hay otra definida",
    "aeros.connections.form.officialHint": "Muestra los campos WABA / Phone ID",
    "aeros.connections.form.groupHint": "Recibe mensajes de grupos",
    "aeros.connections.form.importHint": "Crea tickets desde el historial del teléfono al conectar",
    "aeros.connections.form.tokenRenew": "Generar un nuevo token",
    "aeros.connections.form.tokenCopy": "Copiar token",
    "aeros.connections.agents.title": "Agentes de IA",
    "aeros.connections.agents.hint": "Solo lectura: el vínculo del agente con la conexión y las colas se configura en Talk.ai.",
    "aeros.connections.agents.empty": "Ningún agente de IA atiende esta conexión.",
    "aeros.connections.agents.newConnection": "Guarda la conexión para vincularle agentes de IA en Talk.ai.",
    "aeros.connections.agents.otherCompany": "Los agentes de esta conexión se gestionan en el Talk.ai de la empresa dueña de la conexión.",
    "aeros.connections.agents.loading": "Cargando agentes…",
    "aeros.connections.agents.preQueue": "Atiende antes de la distribución",
    "aeros.connections.agents.manage": "Gestionar en Talk.ai",
    "aeros.connections.form.closeIntegration": "Integración de cierre",
    "aeros.connections.form.wavoipHint": "Token de voz para llamadas por WhatsApp",
    "aeros.connections.form.wavoipPlaceholder": "token wavoip",
    "aeros.connections.form.greetingHint": "Se envía al abrir el ticket",
    "aeros.connections.form.complationHint": "Se envía al resolver la atención",
    "aeros.connections.form.outOfHoursHint": "Requiere horario de atención configurado",
    "aeros.connections.form.vacationHint": "Opcional; se envía durante el período de vacaciones colectivas",
    "aeros.connections.bot.unitMin": "min",
    "aeros.connections.bot.unitTimes": "veces",
    "aeros.connections.bot.newTicketHint": "Minutos tras el cierre para que un nuevo mensaje abra otro ticket.",
    "aeros.connections.bot.maxTriesHint": "Cuántas veces el bot reenvía el menú antes de transferir.",
    "aeros.connections.bot.intervalHint": "Espera entre los reenvíos del menú del chatbot.",
    "aeros.connections.bot.returnQueueHint": "El ticket sin respuesta del agente vuelve a la cola.",
    "aeros.connections.bot.expiresHint": "Expira la atención sin interacción del cliente.",
    "aeros.connections.bot.whenExpiresHint": "Sin respuesta del cliente o de ambas partes.",
    "aeros.connections.bot.expiresMessageHint": "Se envía al expirar la atención.",
    "aeros.connections.bot.inactivityTitle": "Aviso de inactividad",
    "aeros.connections.bot.inactivityDesc": "Se envía antes de expirar, para intentar retomar la conversación.",
    "aeros.connections.bot.inactivityFlow": "Flujo por inactividad",
    "aeros.connections.nps.expiresHint": "Obligatorio cuando hay mensaje de evaluación",
    "aeros.connections.nps.maxUseHint": "Cuántas veces se reenvía la encuesta sin respuesta",
    "aeros.connections.flow.newContactTitle": "Flujo de bienvenida",
    "aeros.connections.flow.newContactDesc": "Se dispara en el primer mensaje de contactos nuevos, que aún no están en tu lista.",
    "aeros.connections.flow.knownContactTitle": "Flujo para contacto conocido",
    "aeros.connections.flow.knownContactDesc": "Se dispara en el primer mensaje de contactos que ya existen en la base.",
    "aeros.connections.qr.connection": "Conexión",
    "aeros.connections.qr.step1": "Abre WhatsApp en el celular",
    "aeros.connections.qr.step2": "Toca Más opciones o Configuración y selecciona Dispositivos vinculados",
    "aeros.connections.qr.step3": "Toca Vincular un dispositivo y apunta a esta pantalla",
    "aeros.connections.qr.autoRenew": "El código se renueva automáticamente mientras esta ventana esté abierta.",
    "aeros.connections.qr.newCode": "Nuevo código QR",
    "aeros.connections.confirm.disconnectTitle": "¿Desconectar {{name}}?",
    "aeros.connections.confirm.disconnectMessage": "¿Estás seguro? Será necesario leer el código QR de nuevo para retomar el envío y la recepción de mensajes.",
    "aeros.connections.confirm.disconnectAction": "Desconectar",
    "aeros.connections.confirm.deleteTitle": "¿Eliminar la conexión {{name}}?",
    "aeros.connections.confirm.deleteMessage": "¿Estás seguro? Esta acción no se puede revertir. Los tickets vinculados quedarán sin conexión.",
    "aeros.connections.confirm.deleteAction": "Eliminar",
    "aeros.connections.confirm.closedImportedTitle": "¿Cerrar los tickets importados de {{name}}?",
    "aeros.connections.confirm.closedImportedAction": "Cerrar tickets",
    "aeros.connections.transfer.title": "Transferencia de tickets",
    "aeros.connections.transfer.desc": "Elige la conexión de origen (de donde salen los tickets) y la de destino. Todas las atenciones activas del origen se moverán.",
    "aeros.connections.transfer.source": "Origen",
    "aeros.connections.transfer.target": "Destino",
    "aeros.connections.transfer.action": "Transferir",
    "aeros.connections.transfer.progressTitle": "Transfiriendo tickets",
    "aeros.connections.transfer.progressCount": "{{current}} de {{total}} tickets transferidos",
    "aeros.connections.transfer.progressWait": "Espera mientras se transfieren los tickets…",
    "aeros.connections.transfer.preDeleteTitle": "¿Ya transferiste los tickets de esta conexión?",
    "aeros.connections.transfer.preDeleteMessage": "Antes de eliminar, confirma que los tickets de esta conexión ya se movieron a otra. Eliminar sin transferir deja esas atenciones sin conexión.",
    "aeros.connections.transfer.preDeleteConfirm": "Ya los transferí",
    "aeros.connections.transfer.preDeleteCancel": "Todavía no",
    "aeros.connections.templates.title": "Plantillas sincronizadas",
    "aeros.connections.templates.summary": "{{count}} plantilla(s) en Meta",
    "aeros.connections.templates.removed": "{{count}} eliminada(s) de Pulse porque ya no existen en Meta",
    "aeros.connections.templates.name": "Nombre",
    "aeros.connections.templates.category": "Categoría",
    "aeros.connections.templates.language": "Idioma",
    "aeros.connections.templates.status": "Estado",
    "aeros.connections.all.title": "Gestionar conexiones",
    "aeros.connections.all.back": "Conexiones",
    "aeros.connections.all.search": "Empresa o número…",
    "aeros.connections.all.restartAll": "Reiniciar todas",
    "aeros.connections.all.restartOne": "Reiniciar conexión",
    "aeros.connections.all.details": "Ver detalles de la conexión",
    "aeros.connections.all.restarted": "Reinicio solicitado",
    "aeros.connections.all.filterAll": "Estado: Todos",
    "aeros.connections.all.filterConnected": "Estado: Conectadas",
    "aeros.connections.all.filterProblem": "Estado: Con problemas",
    "aeros.connections.all.kpiCompanies": "Empresas",
    "aeros.connections.all.kpiConnections": "Conexiones",
    "aeros.connections.all.kpiConnected": "Conectadas",
    "aeros.connections.all.kpiProblem": "Con problemas",
    "aeros.connections.all.company": "Empresa",
    "aeros.connections.all.connection": "Conexión",
    "aeros.connections.all.number": "Número",
    "aeros.connections.all.status": "Estado",
    "aeros.connections.all.channel": "Canal",
    "aeros.connections.all.updated": "Actualización",
    "aeros.connections.all.actions": "Acciones",
    "aeros.connections.all.noCompany": "Sin empresa",
    "aeros.connections.all.empty.title": "Ninguna conexión encontrada",
    "aeros.connections.all.empty.text": "Ajusta la búsqueda o el filtro de estado.",
    // ---- Tela Filas & Chatbot (/queues) ----
    "aeros.queues.title": "Colas & Chatbot",
    "aeros.queues.subtitle": "Departamentos, enrutamiento y menús automáticos",
    "aeros.queues.search": "Buscar cola…",
    "aeros.queues.add": "Agregar cola",
    "aeros.queues.kpi.queues": "Colas activas",
    "aeros.queues.kpi.queuesHint": "{{count}} con chatbot",
    "aeros.queues.kpi.pending": "Tickets en espera",
    "aeros.queues.kpi.pendingHint": "en todas las colas",
    "aeros.queues.table.id": "ID",
    "aeros.queues.table.name": "Nombre",
    "aeros.queues.table.color": "Color",
    "aeros.queues.table.order": "Orden (bot)",
    "aeros.queues.table.greeting": "Mensaje de saludo",
    "aeros.queues.table.bot": "Chatbot · Horario",
    "aeros.queues.table.actions": "Acciones",
    "aeros.queues.agents": "{{count}} agentes",
    "aeros.queues.agentOne": "1 agente",
    "aeros.queues.open": "{{count}} abiertos",
    "aeros.queues.openOne": "1 abierto",
    "aeros.queues.options": "{{count}} opciones",
    "aeros.queues.optionOne": "1 opción",
    "aeros.queues.noBot": "sin chatbot",
    "aeros.queues.noGreeting": "Sin mensaje de saludo",
    "aeros.queues.schedule.always": "24 h",
    "aeros.queues.schedule.none": "Sin horario",
    "aeros.queues.weekdayShort.monday": "Lun",
    "aeros.queues.weekdayShort.tuesday": "Mar",
    "aeros.queues.weekdayShort.wednesday": "Mié",
    "aeros.queues.weekdayShort.thursday": "Jue",
    "aeros.queues.weekdayShort.friday": "Vie",
    "aeros.queues.weekdayShort.saturday": "Sáb",
    "aeros.queues.weekdayShort.sunday": "Dom",
    "aeros.queues.dragHandle": "Arrastra para reordenar",
    "aeros.queues.reorderHint": "El orden define la secuencia del menú inicial del bot. Arrastra para reordenar.",
    "aeros.queues.reorderError": "No se pudo guardar el nuevo orden",
    "aeros.queues.actions.edit": "Editar cola",
    "aeros.queues.actions.delete": "Eliminar cola",
    "aeros.queues.empty.title": "Ninguna cola todavía",
    "aeros.queues.empty.text": "Crea una cola para dirigir las conversaciones por departamento.",
    "aeros.queues.delete.title": "¿Eliminar la cola “{{name}}”?",
    "aeros.queues.delete.body": "Sus conversaciones quedan sin departamento y su chatbot deja de funcionar. Esta acción no se puede deshacer.",
    "aeros.queues.delete.bodyOpen": "{{count}} conversaciones abiertas quedan sin departamento y el chatbot de esta cola deja de funcionar. Esta acción no se puede deshacer.",
    "aeros.queues.delete.confirm": "Eliminar cola",
    "aeros.queues.delete.done": "Cola eliminada",
    "aeros.queues.modal.add": "Nueva cola",
    "aeros.queues.modal.edit": "Editar cola · {{name}}",
    "aeros.queues.modal.subtitleNew": "Departamento, enrutamiento y menú automático",
    "aeros.queues.modal.subtitle": "ID #{{id}} · {{count}} agentes vinculados",
    "aeros.queues.modal.save": "Guardar cola",
    "aeros.queues.modal.saved": "Cola guardada",
    "aeros.queues.tabs.data": "Datos de la cola",
    "aeros.queues.tabs.bot": "Chatbot",
    "aeros.queues.tabs.schedules": "Horarios de atención",
    "aeros.queues.form.name": "Nombre",
    "aeros.queues.form.color": "Color",
    "aeros.queues.form.order": "Orden (bot)",
    "aeros.queues.form.closeTicket": "Cerrar el ticket al terminar el bot",
    "aeros.queues.form.closeTicketHint": "Cierra la conversación sin pasar por un agente",
    "aeros.queues.form.rotate": "Rotación de agentes",
    "aeros.queues.form.rotateHint": "Redistribuye los tickets sin respuesta",
    "aeros.queues.form.rotateTime": "Tiempo de rotación",
    "aeros.queues.form.rotateType": "Tipo de rotación",
    "aeros.queues.form.random": "Aleatorio",
    "aeros.queues.form.ordered": "Ordenado",
    "aeros.queues.form.integration": "Integración",
    "aeros.queues.form.integrationType": "Tipo (solo SGP)",
    "aeros.queues.form.fileList": "Lista de archivos",
    "aeros.queues.form.none": "Ninguna",
    "aeros.queues.form.greeting": "Mensaje de saludo",
    "aeros.queues.form.outOfHours": "Mensaje fuera del horario",
    "aeros.queues.form.minutes": "minutos",
    "aeros.queues.bot.title": "Chatbot · {{count}} opciones en el menú inicial",
    "aeros.queues.bot.titleOne": "Chatbot · 1 opción en el menú inicial",
    "aeros.queues.bot.titleEmpty": "Chatbot · ninguna opción todavía",
    "aeros.queues.bot.list": "Opciones del menú",
    "aeros.queues.bot.editing": "Editando la opción {{n}}",
    "aeros.queues.bot.creating": "Nueva opción",
    "aeros.queues.bot.optionTitle": "Título de la opción",
    "aeros.queues.bot.type": "Tipo de menú",
    "aeros.queues.bot.types.text": "Texto",
    "aeros.queues.bot.types.user": "Agente",
    "aeros.queues.bot.types.queue": "Cola",
    "aeros.queues.bot.types.integration": "Integración",
    "aeros.queues.bot.types.file": "Archivo",
    "aeros.queues.bot.targetUser": "Agente",
    "aeros.queues.bot.targetQueue": "Transferir a la cola",
    "aeros.queues.bot.targetIntegration": "Integración",
    "aeros.queues.bot.targetFile": "Lista de archivos",
    "aeros.queues.bot.currentQueue": "{{name}} (actual)",
    "aeros.queues.bot.message": "Mensaje",
    "aeros.queues.bot.closeAfter": "Cerrar el ticket después de esta opción",
    "aeros.queues.bot.discard": "Descartar",
    "aeros.queues.bot.saveOption": "Guardar opción",
    "aeros.queues.bot.addOption": "Agregar opción",
    "aeros.queues.bot.empty": "Ninguna opción en el menú. Agrega la primera.",
    "aeros.queues.bot.emptyEditor": "Elige una opción a la izquierda o agrega una nueva.",
    "aeros.queues.bot.subOptions": "Subopciones",
    "aeros.queues.bot.subCount": "Abre un submenú de {{count}} opciones",
    "aeros.queues.bot.deleteOption": "Eliminar opción",
    "aeros.queues.bot.deleteTitle": "¿Eliminar la opción “{{name}}”?",
    "aeros.queues.bot.deleteBody": "Las subopciones debajo también se eliminan. Esta acción no se puede deshacer.",
    "aeros.queues.bot.deleted": "Opción eliminada",
    "aeros.queues.sub.levelMessage": "Mensaje del nivel",
    "aeros.queues.sub.placeholder": "Escribe el texto de la opción",
    "aeros.queues.sub.preview": "Vista previa en WhatsApp",
    "aeros.queues.sub.previewHint": "Escribe el número de la opción",
    "aeros.queues.sub.back": "Volver",
    "aeros.queues.sub.done": "Concluir",
    "aeros.queues.schedules.startA": "Inicio A",
    "aeros.queues.schedules.endA": "Fin A",
    "aeros.queues.schedules.startB": "Inicio B",
    "aeros.queues.schedules.endB": "Fin B",
    "aeros.queues.schedules.hint": "Fuera de esos horarios el contacto recibe el mensaje de fuera del horario.",
    "aeros.queues.schedules.disabled": "Los horarios están configurados por empresa; cámbialo en Configuración para editarlos por cola.",
    // ---- Painel ao Vivo (/moments) ----
    "aeros.moments.emptyFilter": "para este filtro",
    "aeros.moments.yesterday": "Ayer",
    "aeros.moments.online": "En línea",
    "aeros.moments.offline": "Desconectado",
    "aeros.moments.waiting": "En espera",
    "aeros.moments.waitingSubtitle": "Sin agente asignado",
    "aeros.moments.empty": "Ninguna conversación en este momento",
    "aeros.moments.openTicket": "Abrir ticket",
    "aeros.moments.noQueue": "Sin cola",
    "aeros.moments.unreadAria": "{{count}} mensajes sin leer",
    // ---- Tela Integrações (/queue-integration) ----
    "aeros.integrations.noPermission": "Esta empresa no tiene permiso para acceder a esta pantalla. Te estamos redirigiendo.",
    "aeros.integrations.title": "Integraciones",
    "aeros.integrations.subtitle": "Conecta bots y sistemas externos a tus conexiones y colas",
    "aeros.integrations.search": "Buscar integración…",
    "aeros.integrations.new": "Nueva integración",
    "aeros.integrations.idLabel": "ID {{id}}",
    "aeros.integrations.linkConnection": "Conexión {{name}}",
    "aeros.integrations.linkQueue": "Cola {{name}}",
    "aeros.integrations.noLinks": "Sin vínculo",
    "aeros.integrations.noEndpoint": "Sin dirección configurada",
    "aeros.integrations.internalFlow": "Flujo interno de PULSE",
    "aeros.integrations.status.linked": "Activa",
    "aeros.integrations.status.unlinked": "Sin vínculo",
    "aeros.integrations.linkHint": "Vincúlala en Conexiones o Colas",
    "aeros.integrations.actions.edit": "Editar integración",
    "aeros.integrations.actions.delete": "Eliminar integración",
    "aeros.integrations.empty.title": "Ninguna integración todavía",
    "aeros.integrations.empty.text": "Conecta un bot o un sistema externo para que atienda junto a tu equipo.",
    "aeros.integrations.filters.all": "Todas",
    "aeros.integrations.filters.bot": "Bots",
    "aeros.integrations.filters.webhook": "Webhooks",
    "aeros.integrations.filters.system": "Sistemas",
    "aeros.integrations.filters.unlinked": "Sin vínculo",
    "aeros.integrations.types.typebot": "Typebot",
    "aeros.integrations.types.n8n": "n8n",
    "aeros.integrations.types.webhook": "Webhook",
    "aeros.integrations.types.dialogflow": "DialogFlow",
    "aeros.integrations.types.flowbuilder": "Flowbuilder",
    "aeros.integrations.types.sgp": "SGP",
    "aeros.integrations.docs.eyebrow": "Documentación",
    "aeros.integrations.docs.title": "Cómo funciona cada integración",
    "aeros.integrations.docs.intro": "Elige el tipo de integración para ver qué envía o consume PULSE y el paso a paso de configuración del otro lado.",
    "aeros.integrations.docs.copy": "Copiar ejemplo",
    "aeros.integrations.docs.copied": "Copiado al portapapeles",
    "aeros.integrations.modal.add": "Nueva integración",
    "aeros.integrations.modal.edit": "Editar integración",
    "aeros.integrations.modal.subtitle": "Elige el tipo y completa las credenciales del sistema externo",
    "aeros.integrations.modal.type": "Tipo",
    "aeros.integrations.modal.name": "Nombre",
    "aeros.integrations.modal.save": "Guardar integración",
    "aeros.integrations.modal.saved": "Integración guardada",
    "aeros.integrations.modal.footerHint": "Vincúlala después en Conexiones o Colas",
    "aeros.integrations.form.typebotUrl": "URL de la API de Typebot",
    "aeros.integrations.form.typebotUrlHelper": "Sin barra al final",
    "aeros.integrations.form.typebotSlug": "Typebot · Slug",
    "aeros.integrations.form.typebotExpires": "La sesión expira en (minutos)",
    "aeros.integrations.form.typebotDelay": "Intervalo entre mensajes (ms)",
    "aeros.integrations.form.typebotKeywordFinish": "Palabra para finalizar",
    "aeros.integrations.form.typebotKeywordRestart": "Palabra para reiniciar",
    "aeros.integrations.form.typebotUnknown": "Mensaje desconocido",
    "aeros.integrations.form.typebotRestart": "Mensaje de reinicio",
    "aeros.integrations.form.n8nUrl": "URL de N8N",
    "aeros.integrations.form.projectName": "Proyecto (ID en Google Cloud)",
    "aeros.integrations.form.language": "Idioma",
    "aeros.integrations.form.jsonContent": "JsonContent · clave de la cuenta de servicio",
    "aeros.integrations.form.sgpIeSenha": "El usuario informa la contraseña",
    "aeros.integrations.form.sgpUrl": "SGP URL",
    "aeros.integrations.form.sgpWidePayToken": "Widepay Token",
    "aeros.integrations.form.sgpWidePayHelper": "Complétalo solo si tu operación usa Widepay",
    "aeros.integrations.panel.typebot": "Cómo PULSE habla con Typebot",
    "aeros.integrations.panel.sgp": "Flujo del autoservicio",
    "aeros.integrations.panel.n8n": "Payload que recibe el webhook",
    "aeros.integrations.test.title": "Enviar evento de prueba",
    "aeros.integrations.test.hint": "Dispara un POST con un payload de ejemplo a la URL de arriba",
    "aeros.integrations.test.button": "Probar",
    "aeros.integrations.test.running": "Enviando…",
    "aeros.integrations.test.noResponse": "Sin respuesta",
    "aeros.integrations.test.needsUrl": "Informa la URL antes de enviar la prueba",
    "aeros.integrations.test.saveFirst": "Guarda la integración antes de enviar la prueba",
    "aeros.integrations.test.ok": "El webhook respondió · {{result}}",
    "aeros.integrations.test.fail": "El webhook no aceptó el evento · {{result}}",
    "aeros.integrations.dialogflow.test": "Probar sesión",
    "aeros.integrations.dialogflow.ok": "Sesión probada con éxito",
    "aeros.integrations.dialogflow.fail": "No se pudo abrir la sesión",
    "aeros.integrations.delete.title": "¿Eliminar la integración “{{name}}”?",
    "aeros.integrations.delete.body": "Las conversaciones dejarán de enviarse a este sistema. Esta acción no se puede deshacer.",
    "aeros.integrations.delete.bodyLinked": "{{links}} dejarán de enviar conversaciones a este sistema. Esta acción no se puede deshacer.",
    "aeros.integrations.delete.confirm": "Eliminar integración",
    "aeros.integrations.delete.done": "Integración eliminada",
    // ---- Tela Talk.ai (/prompts) ----
    "aeros.talkai.noPermission": "Esta empresa no tiene permiso para acceder a esta pantalla. Te estamos redirigiendo.",
    "aeros.talkai.title": "Talk.ai",
    "aeros.talkai.count": "{{count}} agentes",
    "aeros.talkai.countOne": "1 agente",
    "aeros.talkai.subtitle": "Agentes de IA que atienden automáticamente por conexión y cola",
    "aeros.talkai.search": "Buscar agente o sector…",
    "aeros.talkai.newAgent": "Nuevo agente",
    "aeros.talkai.footerNote": "Cada cola de una conexión tiene como máximo un agente. La IA transfiere a una persona cuando no encuentra la respuesta.",
    "aeros.talkai.kpi.activeAgents": "Agentes activos",
    "aeros.talkai.table.agent": "Agente",
    "aeros.talkai.table.model": "Modelo",
    "aeros.talkai.table.maxTokens": "Máx. tokens",
    "aeros.talkai.table.knowledge": "Conocimiento",
    "aeros.talkai.table.actions": "Acciones",
    "aeros.talkai.actions.simulate": "Ver simulación de conversación",
    "aeros.talkai.actions.edit": "Editar agente",
    "aeros.talkai.actions.delete": "Eliminar agente",
    "aeros.talkai.empty.title": "Ningún agente todavía",
    "aeros.talkai.empty.text": "Crea un agente para que el sector responda solo las preguntas más comunes.",
    "aeros.talkai.tones.formal": "Formal",
    "aeros.talkai.tones.amigavel": "Amigable",
    "aeros.talkai.tones.descontraido": "Distendido",
    "aeros.talkai.tones.tecnico": "Técnico",
    "aeros.talkai.knowledge.files": "{{count}} archivos",
    "aeros.talkai.knowledge.fileOne": "1 archivo",
    "aeros.talkai.knowledge.processing": "Procesando",
    "aeros.talkai.knowledge.none": "Solo prompt",
    "aeros.talkai.simulation.defaultName": "Aero",
    "aeros.talkai.simulation.defaultQueue": "Soporte",
    "aeros.talkai.simulation.greeting.formal": "Hola. Soy {{name}}, del área de atención.",
    "aeros.talkai.simulation.greeting.amigavel": "¡Hola! Soy {{name}}, tu asistente por aquí.",
    "aeros.talkai.simulation.greeting.descontraido": "¡Ey! Aquí {{name}}, vamos a resolverlo.",
    "aeros.talkai.simulation.greeting.tecnico": "{{name}} aquí. Vamos a diagnosticar.",
    "aeros.talkai.simulation.contact1": "Hola, mi internet se cae todo el tiempo",
    "aeros.talkai.simulation.agent1": "Desenchufa el router, espera 30 segundos y vuelve a enchufarlo. ¿Me avisas cuando las luces se estabilicen?",
    "aeros.talkai.simulation.contact2": "Ya lo hice y sigue sin señal",
    "aeros.talkai.simulation.defaultTransfer": "Te paso con un compañero del equipo de {{queue}}, un momento",
    "aeros.talkai.simulation.transferredByRule": "Transferido a {{queue}} · regla de transferencia",
    "aeros.talkai.simulation.transferredNoAnswer": "Transferido a {{queue}} · la IA no encontró la respuesta",
    "aeros.talkai.simulation.title": "Simulación de conversación",
    "aeros.talkai.simulation.note": "Ejemplo ilustrativo, armado con el tono y los emojis elegidos",
    "aeros.talkai.modal.add": "Nuevo agente",
    "aeros.talkai.modal.edit": "Editar agente",
    "aeros.talkai.modal.subtitle": "Configura cómo se presenta la IA, qué sabe y cuándo transfiere",
    "aeros.talkai.modal.name": "Nombre del agente",
    "aeros.talkai.modal.saved": "Agente guardado",
    "aeros.talkai.modal.save": "Guardar agente",
    "aeros.talkai.modal.footerNote": "Los cambios afectan a las conversaciones nuevas de inmediato",
    "aeros.talkai.tabs.personality": "Personalidad",
    "aeros.talkai.tabs.knowledge": "Conocimiento",
    "aeros.talkai.tabs.advanced": "Avanzado",
    "aeros.talkai.form.agentName": "Nombre que usa la IA",
    "aeros.talkai.form.tone": "Tono de voz",
    "aeros.talkai.form.useEmojis": "Usar emojis con moderación",
    "aeros.talkai.form.restrictions": "Restricciones del negocio",
    "aeros.talkai.form.restrictionsHelper": "Reglas que la IA nunca puede violar (ej.: no hablar de precios)",
    "aeros.talkai.form.transferInstructions": "Cuándo transferir a una persona",
    "aeros.talkai.form.transferInstructionsHelper": "Escriba cuándo la IA debe pasar la conversación a un agente (ej.: solo cuando el contacto pida hablar con un agente). Si queda vacío, la IA decide sola si transfiere.",
    "aeros.talkai.form.basePromptHelper": "Todo lo que la IA sigue viene de aquí y de los campos de arriba: el sistema no agrega ninguna regla. Consejo para WhatsApp: pida respuestas cortas y sin títulos con # ni negrita con **.",
    "aeros.talkai.personalityLine.name": "Tu nombre es {{name}}.",
    "aeros.talkai.personalityLine.tone.formal": "Usa un tono formal y profesional.",
    "aeros.talkai.personalityLine.tone.amigavel": "Usa un tono amigable y cercano.",
    "aeros.talkai.personalityLine.tone.descontraido": "Usa un tono relajado y ligero.",
    "aeros.talkai.personalityLine.tone.tecnico": "Usa un tono técnico y objetivo.",
    "aeros.talkai.personalityLine.emojisOn": "Puedes usar emojis con moderación.",
    "aeros.talkai.personalityLine.emojisOff": "No uses emojis.",
    "aeros.talkai.form.personalityHint": "Nombre, tono y emojis se convierten en líneas al inicio del prompt base, que puede editar.",
    "aeros.talkai.blocks.restrictions": "Restricciones del negocio",
    "aeros.talkai.blocks.transfer": "Cuándo transferir",
    "aeros.talkai.form.transferMessage": "Mensaje de transferencia",
    "aeros.talkai.form.knowledgeText": "Conocimiento en texto",
    "aeros.talkai.form.knowledgeHelper": "La información corta y concreta funciona mejor. Para documentos largos, usa los archivos al lado.",
    "aeros.talkai.form.apiKey": "Clave de la API de OpenAI",
    "aeros.talkai.form.model": "Modelo",
    "aeros.talkai.form.response": "Respuesta",
    "aeros.talkai.form.responseText": "Texto",
    "aeros.talkai.form.voicePrefix": "Voz",
    "aeros.talkai.form.azureTitle": "Azure Speech · necesario para la voz",
    "aeros.talkai.form.azureKey": "Clave",
    "aeros.talkai.form.azureRegion": "Región",
    "aeros.talkai.form.temperature": "Temperatura",
    "aeros.talkai.form.temperatureHint": "0 = previsible · 2 = creativo",
    "aeros.talkai.form.maxTokens": "Máx. tokens",
    "aeros.talkai.form.maxTokensHint": "Tamaño máximo de la respuesta",
    "aeros.talkai.form.maxMessages": "Máx. mensajes",
    "aeros.talkai.form.maxMessagesHint": "Historial enviado a la IA",
    "aeros.talkai.form.basePrompt": "Prompt base",
    "aeros.talkai.form.showKey": "Mostrar clave",
    "aeros.talkai.form.hideKey": "Ocultar clave",
    "aeros.talkai.files.title": "Archivos importados",
    "aeros.talkai.files.counter": "· {{count}} de {{max}}",
    "aeros.talkai.files.import": "Importar",
    "aeros.talkai.files.dropTitle": "Arrastra PDF, TXT o DOCX aquí",
    "aeros.talkai.files.dropHint": "Hasta 10 MB por archivo · el contenido se indexa automáticamente",
    "aeros.talkai.files.saveFirst": "Guarda el agente antes de importar archivos",
    "aeros.talkai.files.ready": "Listo",
    "aeros.talkai.files.processing": "Procesando",
    "aeros.talkai.files.failed": "Falló",
    "aeros.talkai.files.delete": "Eliminar archivo",
    "aeros.talkai.files.readyCount": "{{count}} archivos listos para usar",
    "aeros.talkai.files.readyCountOne": "1 archivo listo para usar",
    "aeros.talkai.files.failureLine": "{{name}} falló: {{reason}}",
    "aeros.talkai.files.failureUnknown": "no se pudo indexar el archivo",
    "aeros.talkai.files.uploaded": "Archivo importado",
    "aeros.talkai.files.deleted": "Archivo eliminado",
    "aeros.talkai.preview.title": "Prompt final armado",
    "aeros.talkai.preview.copy": "Copiar",
    "aeros.talkai.preview.copied": "Prompt copiado al portapapeles",
    "aeros.talkai.preview.note": "Solo lectura · generado por el servidor en este mismo orden",
    "aeros.talkai.preview.tokens": "≈ {{count}} tokens de sistema por conversación",
    "aeros.talkai.preview.error": "No se pudo armar la vista previa del prompt",
    "aeros.talkai.blocks.basePrompt": "Prompt base",
    "aeros.talkai.blocks.knowledge": "Base de conocimiento",
    "aeros.talkai.delete.title": "¿Eliminar el agente “{{name}}”?",
    "aeros.talkai.delete.body": "El agente dejará de atender en {{vinculo}}. Esta acción no se puede deshacer.",
    "aeros.talkai.delete.bodyFiles": "El agente dejará de atender en {{vinculo}} y se eliminarán los {{count}} archivos de la base de conocimiento. Esta acción no se puede deshacer.",
    "aeros.talkai.delete.confirm": "Eliminar agente",
    "aeros.talkai.delete.done": "Agente eliminado",
    "aeros.talkai.table.vinculo": "Conexión · Colas",
    "aeros.talkai.vinculo.pending": "Conexión pendiente",
    "aeros.talkai.vinculo.pendingHint": "Agente antiguo sin conexión: edítalo y elige la conexión",
    "aeros.talkai.vinculo.preQueue": "antes de la distribución",
    "aeros.talkai.modal.connection": "Conexión",
    "aeros.talkai.modal.selectConnection": "Selecciona la conexión",
    "aeros.talkai.modal.queues": "Colas",
    "aeros.talkai.modal.selectQueues": "Selecciona las colas",
    "aeros.talkai.modal.selectConnectionFirst": "Elige la conexión primero",
    "aeros.talkai.modal.noQueuesInConnection": "Esta conexión no tiene colas",
    "aeros.talkai.modal.queueUsedBy": "Usada por {{name}}",
    "aeros.talkai.modal.queueOutside": "Fuera de esta conexión",
    "aeros.talkai.modal.preQueue": "Atender también antes de la distribución",
    "aeros.talkai.modal.preQueueHelp": "Responde la conversación antes de que llegue a una cola y, en conexión de cola única, también en esa cola cuando no tiene agente propio. Solo vale en conexión sin menú de colas.",
    "aeros.talkai.modal.preQueueTaken": "No disponible: el agente {{name}} ya atiende antes de la distribución en esta conexión",
    "aeros.talkai.modal.preQueueNoEffect": "Esta conexión tiene menú de colas: la opción solo tendrá efecto si la conexión queda sin menú.",
    "aeros.talkai.modal.pendingWarning": "Agente sin conexión (registro antiguo): elige la conexión para guardar.",
    "aeros.talkai.modal.warnQueueIntegration": "Cola con integración ({{queues}}): la integración atiende antes que el agente.",
    "aeros.talkai.modal.warnQueueChatbot": "Cola con opciones de chatbot ({{queues}}): el chatbot de la cola responde y el agente no atiende en ella.",
    "aeros.talkai.modal.warnConnectionIntegration": "Esta conexión tiene una integración; puede atender antes que el agente.",
    "aeros.talkai.modal.warnExtraConnections": "Al guardar, este agente deja de atender antes de la distribución en: {{connections}}.",
    "aeros.talkai.modal.warnOutsideQueues": "Las colas que ya no están en esta conexión se eliminarán al guardar: {{queues}}.",
    "aeros.talkai.modal.warningsLabel": "Avisos sobre conexión y colas",
    // ---- Tela Aniversários (/birthday-settings) ----
    "aeros.birthday.title": "Cumpleaños",
    "aeros.birthday.subtitle": "Felicitaciones automáticas para contactos y equipo",
    "aeros.birthday.save": "Guardar configuración",
    "aeros.birthday.saved": "Configuración guardada",
    "aeros.birthday.saveError": "No se pudo guardar la configuración",
    "aeros.birthday.loadError": "No se pudo cargar la configuración",
    "aeros.birthday.loading": "Cargando configuración…",
    "aeros.birthday.active": "Activo",
    "aeros.birthday.inactive": "Inactivo",
    "aeros.birthday.collapse": "Contraer sección",
    "aeros.birthday.expand": "Expandir sección",
    "aeros.birthday.nextSend.today": "Próximo envío hoy a las {{time}} · {{count}} contactos",
    "aeros.birthday.nextSend.todayOne": "Próximo envío hoy a las {{time}} · 1 contacto",
    "aeros.birthday.nextSend.idle": "Próximo envío a las {{time}} · nadie hoy",
    "aeros.birthday.nextSend.disabled": "Envío automático desactivado",
    "aeros.birthday.contacts.title": "Cumpleaños de contactos",
    "aeros.birthday.contacts.subtitle": "Envía felicitaciones por WhatsApp el día del cumpleaños",
    "aeros.birthday.users.title": "Cumpleaños del equipo",
    "aeros.birthday.users.subtitle": "Muestra el modal de felicitación al entrar al panel",
    "aeros.birthday.sendTime": "Horario de envío",
    "aeros.birthday.sendTimeHelper": "Horario de Brasilia",
    "aeros.birthday.connection": "Conexión de WhatsApp para el envío",
    "aeros.birthday.connectionNone": "Conexión predeterminada de la empresa",
    "aeros.birthday.connected": "Conectada",
    "aeros.birthday.disconnected": "Desconectada",
    "aeros.birthday.contactMessage": "Mensaje para contactos",
    "aeros.birthday.userMessage": "Mensaje para el equipo",
    "aeros.birthday.variableHint": "Haz clic en una variable para insertarla en el cursor",
    "aeros.birthday.insertVariable": "Insertar {{variable}} en el mensaje",
    "aeros.birthday.sentToday": "Enviado con éxito a {{count}} contactos hoy",
    "aeros.birthday.sentTodayOne": "Enviado con éxito a 1 contacto hoy",
    "aeros.birthday.testMessage": "Probar mensaje",
    "aeros.birthday.announcement.title": "Crear informativo automático",
    "aeros.birthday.announcement.desc": "Publica un aviso en la campana para toda la empresa el día del cumpleaños",
    "aeros.birthday.preview.title": "Vista previa en WhatsApp",
    "aeros.birthday.preview.note": "Cada contacto recibe como máximo un mensaje por año; los reenvíos manuales avisan si ya se envió.",
    "aeros.birthday.preview.sampleName": "Juan Pérez",
    "aeros.birthday.preview.empty": "Escribe el mensaje para ver la vista previa.",
    "aeros.birthday.upcoming.title": "Próximos cumpleaños",
    "aeros.birthday.upcoming.seeAll": "Ver todos",
    "aeros.birthday.upcoming.empty": "Ningún cumpleaños en los próximos días.",
    "aeros.birthday.upcoming.error": "No se pudieron cargar los próximos cumpleaños",
    "aeros.birthday.status.today": "Hoy",
    "aeros.birthday.status.sent": "Enviada",
    "aeros.birthday.status.scheduled": "Programada",
    "aeros.birthday.type.user": "Equipo",
    "aeros.birthday.type.contact": "Contacto",
    "aeros.birthday.age": "{{count}} años",
    "aeros.birthday.ageOne": "1 año",
    "aeros.birthday.kpi.contactsWithDate": "contactos con fecha",
    "aeros.birthday.kpi.sentThisYear": "enviadas en {{year}}",
    "aeros.birthday.kpi.responded": "respondieron",
    "aeros.birthday.months.0": "ene",
    "aeros.birthday.months.1": "feb",
    "aeros.birthday.months.2": "mar",
    "aeros.birthday.months.3": "abr",
    "aeros.birthday.months.4": "may",
    "aeros.birthday.months.5": "jun",
    "aeros.birthday.months.6": "jul",
    "aeros.birthday.months.7": "ago",
    "aeros.birthday.months.8": "sep",
    "aeros.birthday.months.9": "oct",
    "aeros.birthday.months.10": "nov",
    "aeros.birthday.months.11": "dic",
    "aeros.birthday.test.title": "Probar el mensaje de cumpleaños",
    "aeros.birthday.test.subtitle": "Envía el mensaje de contactos ahora, por la conexión {{connection}}",
    "aeros.birthday.test.subtitleDefault": "Envía el mensaje de contactos ahora, por la conexión predeterminada",
    "aeros.birthday.test.contact": "Contacto de prueba",
    "aeros.birthday.test.searchPlaceholder": "Buscar contacto por nombre o número…",
    "aeros.birthday.test.searching": "Buscando…",
    "aeros.birthday.test.noResults": "Ningún contacto encontrado",
    "aeros.birthday.test.noBirth": "sin fecha de nacimiento",
    "aeros.birthday.test.idLabel": "ID {{id}}",
    "aeros.birthday.test.willSend": "Se enviará",
    "aeros.birthday.test.missingWarning": "{{vars}} queda vacío: el contacto no tiene fecha de nacimiento registrada",
    "aeros.birthday.test.send": "Enviar prueba",
    "aeros.birthday.test.sent": "Mensaje de prueba enviado",
    "aeros.birthday.test.error": "No se pudo enviar el mensaje de prueba",
    "aeros.birthday.today.title": "¡Hoy hay cumpleaños!",
    "aeros.birthday.today.subtitleTeam": "{{count}} colega",
    "aeros.birthday.today.subtitleTeamMany": "{{count}} colegas",
    "aeros.birthday.today.subtitleContacts": "{{count}} contacto",
    "aeros.birthday.today.subtitleContactsMany": "{{count}} contactos",
    "aeros.birthday.today.team": "Equipo",
    "aeros.birthday.today.contacts": "Contactos",
    "aeros.birthday.today.userAge": "Cumple {{count}} años hoy",
    "aeros.birthday.today.announcementPublished": "informativo publicado en la campana",
    "aeros.birthday.today.greet": "Felicitar",
    "aeros.birthday.today.greetError": "No se pudo abrir la conversación",
    "aeros.birthday.today.alreadySent": "Ya enviada",
    "aeros.birthday.today.sending": "Enviando…",
    "aeros.birthday.today.send": "Enviar felicitación",
    "aeros.birthday.today.sentAt": "enviada {{time}}",
    "aeros.birthday.today.sendError": "No se pudo enviar la felicitación",
    "aeros.birthday.today.configure": "Configurar cumpleaños",
    "aeros.birthday.today.later": "Recordar más tarde",
    "aeros.birthday.today.gotIt": "Entendido",
    "aeros.birthday.today.empty": "Nadie cumple años hoy.",
    // ---- Tela Uso da API (/messages-api) ----
    "aeros.api.title": "Uso de la API",
    "aeros.api.subtitle": "Envía mensajes de texto y multimedia desde tus sistemas",
    "aeros.api.tokensButton": "Tokens de las conexiones",
    "aeros.api.noPermission": "Esta empresa no tiene permiso para acceder a esta pantalla. Te estamos redirigiendo.",
    "aeros.api.intro": "Todas las solicitudes usan el endpoint de abajo, autenticadas con el token de la conexión (Bearer). El número debe estar en formato internacional, sin espacios ni símbolos.",
    "aeros.api.copyEndpoint": "Copiar endpoint",
    "aeros.api.copyExample": "Copiar ejemplo de solicitud",
    "aeros.api.copied": "Copiado al portapapeles",
    "aeros.api.numberFormat": "Formato del número",
    "aeros.api.numberLegend": "país · área · número",
    "aeros.api.authorizationLine": "Authorization: Bearer (token guardado en la conexión)",
    "aeros.api.kpiSends": "envíos por la API · {{days}} días",
    "aeros.api.kpiText": "de texto",
    "aeros.api.kpiMedia": "con multimedia",
    "aeros.api.method": "Método",
    "aeros.api.methodText": "Mensaje de texto",
    "aeros.api.methodTextIntro": "Cuerpo en JSON. En conexiones oficiales, informa templateName para enviar una plantilla aprobada, dentro o fuera de la ventana de 24 h.",
    "aeros.api.methodMedia": "Mensaje con multimedia",
    "aeros.api.methodMediaIntro": "Cuerpo en multipart/form-data. El campo medias lleva el archivo; body se vuelve el pie de foto.",
    "aeros.api.tabs.fields": "Campos",
    "aeros.api.testSend": "Probar envío",
    "aeros.api.testSendHint": "Envía de verdad por la conexión elegida",
    "aeros.api.connection": "Conexión",
    "aeros.api.connectionNone": "Ninguna conexión seleccionada",
    "aeros.api.connectionHelper": "Elegir una conexión completa el token guardado en ella",
    "aeros.api.channelOfficial": "Oficial",
    "aeros.api.channelBaileys": "Baileys",
    "aeros.api.token": "Token",
    "aeros.api.number": "Número",
    "aeros.api.body": "Mensaje",
    "aeros.api.caption": "Pie de foto",
    "aeros.api.userId": "Usuario",
    "aeros.api.queueId": "Cola",
    "aeros.api.optional": "· opcional",
    "aeros.api.sendSignature": "Firmar con el nombre del agente",
    "aeros.api.closeTicket": "Cerrar el ticket tras el envío",
    "aeros.api.template": "Plantilla",
    "aeros.api.templateNone": "Sin plantilla (mensaje libre)",
    "aeros.api.templateHelper": "Con plantilla, el mensaje va dentro o fuera de la ventana de 24 h y el cuerpo se ignora",
    "aeros.api.templateMediaBadge": "multimedia en el encabezado",
    "aeros.api.templateHeaderMediaUrl": "URL del archivo del encabezado",
    "aeros.api.templateHeaderMediaUrlHelper": "URL http(s) pública del archivo (PDF, imagen o vídeo)",
    "aeros.api.templateParamHelper": "Acepta {nome}, {numero}, {email}",
    "aeros.api.variableOne": "variable",
    "aeros.api.variableMany": "variables",
    "aeros.api.fillTemplate": "Completar la plantilla",
    "aeros.api.bodyIgnored": "Se ignora cuando hay una plantilla seleccionada",
    "aeros.api.file": "Archivo",
    "aeros.api.fileHint": "Imagen, vídeo, PDF o documento",
    "aeros.api.fileRequired": "Elige un archivo antes de enviar la prueba",
    "aeros.api.noFile": "Ningún archivo seleccionado",
    "aeros.api.unknownType": "tipo desconocido",
    "aeros.api.chooseFile": "Elegir",
    "aeros.api.changeFile": "Cambiar",
    "aeros.api.sendTest": "Enviar prueba",
    "aeros.api.sendTemplate": "Enviar plantilla",
    "aeros.api.lastTest": "Última prueba: {{status}} · {{when}}",
    "aeros.api.smsEyebrow": "API de SMS",
    "aeros.api.smsTitle": "Envío de SMS",
    "aeros.api.smsIntro": "Tres endpoints: enviar, consultar estado y consultar saldo. Autentíquese con el token de SMS de la empresa (botón Tokens), no con el token de una conexión, y envíe siempre el header X-Origin con el nombre de su sistema — sin él la respuesta es 400. Cada parte de SMS consume 1 crédito.",
    "aeros.api.smsAuthorizationLine": "Authorization: Bearer (token de SMS de la empresa)",
    "aeros.api.smsSendLabel": "Enviar SMS",
    "aeros.api.smsStatusLabel": "Consultar estado",
    "aeros.api.smsBalanceLabel": "Consultar saldo",
    "aeros.api.reference": "Referencia",
    "aeros.api.responses": "Respuestas y errores",
    "aeros.api.codes.400.title": "Solicitud inválida",
    "aeros.api.codes.400.desc": "X-Origin ausente o campo inválido; la respuesta trae el motivo en error.",
    "aeros.api.codes.200.title": "Aceptada por Meta",
    "aeros.api.codes.200.desc": "Conexión oficial: Meta aceptó el mensaje (status accepted) y la entrega es asíncrona; consulta la ruta de estado con el messageId. El texto de message no cambió y no garantiza la entrega. Si Meta lo rechaza al instante, el envío vuelve como error HTTP (nunca 200) con el motivo traducido en error. Conexión QR Code: el mensaje entró en la cola de la conexión, sin messageId.",
    "aeros.api.codes.401.title": "Sin token",
    "aeros.api.codes.401.desc": "Header Authorization ausente en la solicitud.",
    "aeros.api.codes.403.title": "Token inválido",
    "aeros.api.codes.403.desc": "El Bearer no corresponde a ninguna conexión ni al token de SMS de la empresa (o la empresa está inactiva).",
    "aeros.api.codes.422.title": "Regla violada",
    "aeros.api.codes.422.desc": "Falta un campo obligatorio o el formato es incorrecto; la respuesta indica cuál.",
    "aeros.api.codes.402.title": "Licencia vencida",
    "aeros.api.codes.402.desc": "La suscripción de la empresa venció (ERR_LICENSE_EXPIRED). La API vuelve a responder en cuanto se confirme el pago en Suscripción.",
    "aeros.api.codes.429.title": "Límite alcanzado",
    "aeros.api.codes.429.desc": "Demasiadas solicitudes por minuto en la conexión. Espera y reenvía.",
    "aeros.api.codes.404.title": "Mensaje no encontrado",
    "aeros.api.codes.404.desc": "Ruta de estado: messageId inexistente, de otra empresa o de un mensaje de otra conexión (ERR_NO_MESSAGE_FOUND).",
    "aeros.api.statusEyebrow": "Consulta",
    "aeros.api.statusTitle": "Estado de un mensaje",
    "aeros.api.statusIntro": "El 200 del envío significa aceptado por Meta: la entrega es asíncrona. Con el messageId devuelto en el envío (conexión oficial) sabes si el mensaje fue enviado, entregado, leído o si falló, y el motivo real del fallo. Mismo token (Bearer) y mismo header X-Origin del envío. Las conexiones QR Code (Baileys) no devuelven messageId, por lo que no tienen esta consulta. En el canal oficial, el primer estado que normalmente verás al consultar es sent (accepted es momentáneo).",
    "aeros.api.statusLabel": "Consultar estado del mensaje",
    "aeros.api.categories.conta.title": "Cuenta",
    "aeros.api.categories.conta.desc": "Problema en la cuenta de WhatsApp Business, como pago pendiente o cuenta restringida. Resuélvelo en Meta Business; el enlace de corrección viene en failure.link.",
    "aeros.api.categories.contato.title": "Contacto",
    "aeros.api.categories.contato.desc": "El destinatario no recibe el mensaje: número sin WhatsApp, contacto que optó por no recibir o app desactualizada.",
    "aeros.api.categories.janela.title": "Ventana de 24 h",
    "aeros.api.categories.janela.desc": "Fuera de la ventana de 24 h solo entrega una plantilla aprobada. Reenvía informando templateName.",
    "aeros.api.categories.template.title": "Plantilla",
    "aeros.api.categories.template.desc": "Plantilla inexistente, pausada, rechazada o con parámetros incorrectos. Revisa la plantilla y los parámetros.",
    "aeros.api.categories.limite.title": "Límite",
    "aeros.api.categories.limite.desc": "Se alcanzó el límite de envíos o de calidad de la cuenta, o hay demasiados mensajes al mismo contacto. Espera y reenvía.",
    "aeros.api.categories.midia.title": "Multimedia",
    "aeros.api.categories.midia.desc": "Meta no aceptó el archivo: tipo, tamaño o formato inválido, o enlace inaccesible.",
    "aeros.api.categories.desconhecido.title": "Desconocido",
    "aeros.api.categories.desconhecido.desc": "Código sin traducción en el catálogo. Lee failure.reasonOriginal (texto de Meta) y failure.code.",
    "aeros.api.result.successTitle": "Mensaje enviado",
    "aeros.api.result.errorTitle": "Solicitud rechazada",
    "aeros.api.result.noResponse": "Sin respuesta",
    "aeros.api.result.response": "Respuesta",
    "aeros.api.result.copy": "Copiar respuesta",
    "aeros.api.result.close": "Cerrar",
    "aeros.api.result.justNow": "ahora",
    "aeros.api.result.minutesAgo": "hace {{count}} min",
    "aeros.api.result.hoursAgo": "hace {{count}} h",
    "aeros.api.result.hintNetwork": "La solicitud no llegó al servidor. Revisa la red y si la dirección de la API está accesible.",
    "aeros.api.result.hint401": "El token no corresponde a ninguna conexión. Cópialo con el botón “Tokens de las conexiones”.",
    "aeros.api.result.hint422": "Falta un campo obligatorio o está mal formado. La respuesta de arriba indica cuál corregir.",
    "aeros.api.result.hint429": "Se alcanzó el límite de solicitudes de la conexión. Espera un momento antes de reenviar.",
    "aeros.api.result.hint500": "La API respondió con un error interno. Inténtalo de nuevo; si persiste, avisa a soporte.",
    "aeros.api.tokens.title": "Tokens de las conexiones",
    "aeros.api.tokens.subtitle": "Cada conexión tiene su propio token, usado en el encabezado Authorization. El token de SMS es uno solo para toda la empresa.",
    "aeros.api.tokens.empty": "Ninguna conexión tiene token guardado.",
    "aeros.api.tokens.reveal": "Mostrar token",
    "aeros.api.tokens.hide": "Ocultar token",
    "aeros.api.tokens.copy": "Copiar token",
    "aeros.api.tokens.footerHint": "Guarda los tokens en variables de entorno, nunca en el código del cliente",
    "aeros.api.tokens.close": "Cerrar",
    "aeros.api.tokens.sms.title": "Token de SMS",
    "aeros.api.tokens.sms.subtitle": "Un único token de la empresa para las rutas /api/sms; no depende de ninguna conexión.",
    "aeros.api.tokens.sms.empty": "Todavía no se generó ningún token de SMS.",
    "aeros.api.tokens.sms.generate": "Generar token",
    "aeros.api.tokens.sms.regenerate": "Regenerar",
    "aeros.api.tokens.sms.confirmTitle": "¿Regenerar el token de SMS?",
    "aeros.api.tokens.sms.confirmBody": "El token actual deja de funcionar de inmediato. Actualiza con el nuevo token todas las integraciones que envían SMS.",
    "aeros.api.tokens.sms.generated": "Token de SMS generado",
    "aeros.header.morning": "Buenos días",
    "aeros.header.afternoon": "Buenas tardes",
    "aeros.header.evening": "Buenas noches",
    "aeros.header.plan": "{{company}} · plan activo hasta {{date}}",
    "aeros.header.connected": "Conectado",
    "aeros.header.reconnecting": "Reconectando…",
    "aeros.header.payInvoice": "Pagar factura",
    "aeros.header.search": "Buscar o ir a…",
    "aeros.header.searchPlaceholder": "Buscar pantalla, contacto o atención…",
    "aeros.header.searchAria": "Buscar",
    "aeros.header.nothingFound": "Nada encontrado para “{{q}}”.",
    "aeros.header.groups.screens": "Pantallas",
    "aeros.header.groups.contacts": "Contactos",
    "aeros.header.groups.tickets": "Atenciones",
    "aeros.header.noContact": "Sin contacto",
    "aeros.header.language": "Idioma",
    "aeros.header.languageHint": "Cambia sin recargar la página",
    "aeros.header.theme": "Tema",
    "aeros.header.light": "Claro",
    "aeros.header.dark": "Oscuro",
    "aeros.header.system": "Sistema",
    "aeros.header.accent": "Color de acento",
    "aeros.header.customColor": "Color personalizado",
    "aeros.header.sound": "Sonido de las notificaciones",
    "aeros.header.volume": "Volumen",
    "aeros.header.ringtone": "Tono predeterminado",
    "aeros.header.clickToTest": "Haga clic para probar",
    "aeros.header.testRingtone": "Probar tono",
    "aeros.header.browserNotifications": "Notificaciones del navegador",
    "aeros.header.blockedInBrowser": "Bloqueadas en el navegador",
    "aeros.header.muteUntil": "Silenciar hasta",
    "aeros.header.mute": "Silenciar",
    "aeros.header.mutedUntil": "Silenciado hasta {{time}}",
    "aeros.header.unread": "Mensajes no leídos",
    "aeros.header.unreadTitle": "No leídos",
    "aeros.header.tabs.mine": "Míos",
    "aeros.header.tabs.queue": "Cola",
    "aeros.header.tabs.groups": "Grupos",
    "aeros.header.markAllRead": "Marcar todos como leídos",
    "aeros.header.seeAllTickets": "Ver todas las atenciones",
    "aeros.header.announcements": "Informativos",
    "aeros.header.priority.high": "Alta",
    "aeros.header.priority.medium": "Media",
    "aeros.header.priority.low": "Baja",
    "aeros.header.internalChat": "Chat interno",
    "aeros.header.newChat": "Nueva conversación",
    "aeros.header.openInternalChat": "Abrir chat interno",
    "aeros.header.userMenu": "Menú del usuario",
    "aeros.header.online": "En línea",
    "aeros.header.away": "Ausente",
    "aeros.header.myProfile": "Mi perfil",
    "aeros.header.preferences": "Preferencias",
    "aeros.header.preferencesHint": "menú, tema, sonido",
    "aeros.header.helpTutorials": "Ayuda y tutoriales",
    "aeros.header.logout": "Salir",
    "aeros.header.close": "Cerrar",
    "aeros.screens.dashboard": "Dashboard",
    "aeros.screens.tickets": "Atenciones",
    "aeros.screens.moments": "Panel en vivo",
    "aeros.screens.kanban": "Kanban",
    "aeros.screens.schedules": "Programaciones",
    "aeros.screens.quickMessages": "Respuestas rápidas",
    "aeros.screens.contacts": "Contactos",
    "aeros.screens.tags": "Etiquetas",
    "aeros.screens.chats": "Chat interno",
    "aeros.screens.reports": "Informes",
    "aeros.screens.wallets": "Carteras",
    "aeros.screens.helps": "Ayuda",
    "aeros.screens.campaigns": "Campañas",
    "aeros.screens.flowbuilders": "Flowbuilder",
    "aeros.screens.prompts": "Open.Ai",
    "aeros.screens.users": "Usuarios",
    "aeros.screens.connections": "Conexiones",
    "aeros.screens.queues": "Colas y Chatbot",
    "aeros.screens.settings": "Configuración",
    "aeros.screens.financeiro": "Suscripción",
    "aeros.prefs.title": "Preferencias",
    "aeros.prefs.subtitle": "Menú, apariencia, sonido e idioma — solo para usted",
    "aeros.prefs.menu": "Menú lateral al entrar",
    "aeros.prefs.menuOpen": "Abierto",
    "aeros.prefs.menuOpenDesc": "Muestra los nombres de las pantallas",
    "aeros.prefs.menuClosed": "Plegado",
    "aeros.prefs.menuClosedDesc": "Solo íconos; más espacio",
    "aeros.prefs.appearance": "Apariencia",
    "aeros.prefs.done": "Listo",
    "aeros.prefs.menuSaved": "Preferencia de menú guardada.",
    "aeros.reports.title": "Informes",
    "aeros.reports.tickets": "atenciones",
    "aeros.reports.updatedNow": "actualizado ahora",
    "aeros.reports.updatedMin": "actualizado hace {{min}} min",
    "aeros.reports.updatedHour": "actualizado hace {{h}} h",
    "aeros.reports.saveFilter": "Guardar filtro",
    "aeros.reports.saveCurrent": "Guardar filtro actual…",
    "aeros.reports.pdf": "PDF",
    "aeros.reports.exportXlsx": "Exportar XLSX",
    "aeros.reports.presets.today": "Hoy",
    "aeros.reports.presets.7d": "7 días",
    "aeros.reports.presets.30d": "30 días",
    "aeros.reports.presets.month": "Mes",
    "aeros.reports.dateFrom": "Fecha inicial",
    "aeros.reports.dateTo": "Fecha final",
    "aeros.reports.filters.period": "Período",
    "aeros.reports.filters.queue": "Cola",
    "aeros.reports.filters.user": "Agente",
    "aeros.reports.filters.connection": "Conexión",
    "aeros.reports.filters.status": "Estado",
    "aeros.reports.filters.wallet": "Cartera",
    "aeros.reports.filters.onlyRated": "Solo evaluados",
    "aeros.reports.filters.search": "Búsqueda",
    "aeros.reports.all": "Todos",
    "aeros.reports.allF": "Todas",
    "aeros.reports.clearFilters": "Limpiar filtros",
    "aeros.reports.searchPlaceholder": "Buscar contacto por nombre o número…",
    "aeros.reports.searchAria": "Buscar contacto",
    "aeros.reports.status.open": "Abierto",
    "aeros.reports.status.pending": "Pendiente",
    "aeros.reports.status.closed": "Resuelto",
    "aeros.reports.status.group": "Grupo",
    "aeros.reports.status.nps": "Evaluando",
    "aeros.reports.status.lgpd": "LGPD",
    "aeros.reports.pills.all": "Todos",
    "aeros.reports.pills.open": "Abiertos",
    "aeros.reports.pills.pending": "Pendientes",
    "aeros.reports.pills.closed": "Resueltos",
    "aeros.reports.kpis.total": "Atenciones",
    "aeros.reports.kpis.resolution": "Tasa de resolución",
    "aeros.reports.kpis.wait": "T.M. de espera",
    "aeros.reports.kpis.duration": "T.M. de atención",
    "aeros.reports.kpis.nps": "NPS promedio",
    "aeros.reports.kpis.rated": "{{rated}} evaluados · {{pct}}%",
    "aeros.reports.vsPrevious": "vs. período anterior",
    "aeros.reports.samePrevious": "= período anterior",
    "aeros.reports.summaryUnavailable": "resumen no disponible",
    "aeros.reports.columns.id": "ID",
    "aeros.reports.columns.contact": "Contacto",
    "aeros.reports.columns.queue": "Cola",
    "aeros.reports.columns.user": "Agente",
    "aeros.reports.columns.wallet": "Cartera",
    "aeros.reports.columns.status": "Estado",
    "aeros.reports.columns.openClose": "Apertura → Cierre",
    "aeros.reports.columns.duration": "Duración",
    "aeros.reports.columns.nps": "NPS",
    "aeros.reports.columns.sale": "Venta",
    "aeros.reports.columns.actions": "Acciones",
    "aeros.reports.columns.connection": "Conexión",
    "aeros.reports.columns.number": "Número",
    "aeros.reports.columns.lastMessage": "Último mensaje",
    "aeros.reports.columns.opened": "Apertura",
    "aeros.reports.columns.closed": "Cierre",
    "aeros.reports.columns.supportTime": "Tiempo de atención",
    "aeros.reports.columns.saleValue": "Valor de la venta",
    "aeros.reports.columns.noSaleReason": "Motivo de no venta",
    "aeros.reports.columns.soldLabel": "Finalizado con venta",
    "aeros.reports.noQueue": "Sin cola",
    "aeros.reports.stillOpen": "abierto",
    "aeros.reports.notSold": "No · {{reason}}",
    "aeros.reports.noReason": "sin motivo",
    "aeros.reports.yes": "Sí",
    "aeros.reports.no": "No",
    "aeros.reports.empty": "Ninguna atención en el período con estos filtros.",
    "aeros.reports.logs": "Registros del ticket",
    "aeros.reports.access": "Abrir ticket",
    "aeros.reports.perPage": "{{n}} por página",
    "aeros.reports.perPageAria": "Por página",
    "aeros.reports.showing": "Mostrando {{from}}–{{to}} de {{total}}",
    "aeros.reports.noResults": "Sin resultados",
    "aeros.reports.filterSaved": "Filtro guardado.",
    "aeros.reports.notInformed": "No informado",
    "aeros.reports.sheetTitle": "Informes de atenciones",
    "aeros.reports.sheetStart": "Fecha inicial",
    "aeros.reports.sheetEnd": "Fecha final",
    "aeros.reports.sheetTickets": "InformeDeAtenciones",
    "aeros.reports.sheetChats": "Conversaciones",
    "aeros.reports.transcript.ticket": "Ticket",
    "aeros.reports.transcript.contact": "Contacto",
    "aeros.reports.transcript.datetime": "Fecha/hora",
    "aeros.reports.transcript.from": "De",
    "aeros.reports.transcript.message": "Mensaje",
    "aeros.reports.transcript.agent": "Agente",
    "aeros.reports.transcript.customer": "Cliente",
    "aeros.reports.export.title": "Exportar informe",
    "aeros.reports.export.xlsx": "Hoja XLSX",
    "aeros.reports.export.xlsxDesc": "Columnas elegidas",
    "aeros.reports.export.pdf": "PDF resumido",
    "aeros.reports.export.pdfDesc": "KPIs + tabla",
    "aeros.reports.export.columns": "Columnas",
    "aeros.reports.export.transcript": "Incluir transcripción de las conversaciones",
    "aeros.reports.export.transcriptDesc": "Pestaña extra en la hoja; genera un archivo mayor",
    "aeros.reports.export.transcriptLimit": "Disponible hasta {{limit}} atenciones — reduzca el período o los filtros.",
    "aeros.reports.export.button": "Exportar {{count}} filas",
    "aeros.reports.save.title": "Guardar filtro",
    "aeros.reports.save.subtitle": "Acceda a esta vista con un clic",
    "aeros.reports.save.name": "Nombre",
    "aeros.reports.save.namePlaceholder": "Ej.: Soporte · semana · resueltos",
    "aeros.reports.save.nameAria": "Nombre del filtro",
    "aeros.reports.save.weekly": "Enviar por correo cada lunes",
    "aeros.reports.save.noEmail": "Su usuario no tiene correo registrado",
    "aeros.reports.save.button": "Guardar",
    "aeros.reports.cancel": "Cancelar",
    "aeros.reports.ticket.wait": "Espera",
    "aeros.reports.ticket.duration": "Duración",
    "aeros.reports.ticket.messages": "Mensajes",
    "aeros.reports.ticket.reason": "Motivo",
    "aeros.reports.ticket.timeline": "Línea de tiempo",
    "aeros.reports.ticket.chat": "Conversación",
    "aeros.reports.ticket.noEvents": "Ningún evento registrado.",
    "aeros.reports.ticket.noMessages": "Sin mensajes en este ticket.",
    "aeros.reports.ticket.openInTickets": "Abrir en Atenciones",
    "aeros.reports.ticket.exportPdf": "Exportar PDF",
    "aeros.reports.ticket.noContact": "Sin contacto",
    "aeros.reports.ticket.sale": "Venta",
    "aeros.reportsNav.tickets": "Atenciones",
    "aeros.reportsNav.reasons": "Motivos de finalización",
    "aeros.reportsNav.aria": "Informes",
    "aeros.reportsNav.api": "Uso de la API",
    "aeros.apiReport.title": "Uso de la API",
    "aeros.apiReport.calls": "llamadas",
    "aeros.apiReport.exportXlsx": "Exportar XLSX",
    "aeros.apiReport.exportTruncated": "Exportación limitada a {{max}} llamadas. Acote el período.",
    "aeros.apiReport.filters.connection": "Conexión",
    "aeros.apiReport.filters.origin": "Origen",
    "aeros.apiReport.filters.kind": "Tipo",
    "aeros.apiReport.filters.route": "Ruta",
    "aeros.apiReport.filters.channel": "Canal",
    "aeros.apiReport.filters.all": "Todas",
    "aeros.apiReport.filters.allM": "Todos",
    "aeros.apiReport.searchPlaceholder": "Buscar por error u origen…",
    "aeros.apiReport.searchAria": "Buscar llamadas",
    "aeros.apiReport.clearFilters": "Limpiar filtros",
    "aeros.apiReport.dateFrom": "Fecha inicial",
    "aeros.apiReport.dateTo": "Fecha final",
    "aeros.apiReport.pills.all": "Todas",
    "aeros.apiReport.pills.success": "Éxito",
    "aeros.apiReport.pills.queued": "En cola",
    "aeros.apiReport.pills.rejected": "Rechazada 4xx",
    "aeros.apiReport.pills.error": "Error 5xx",
    "aeros.apiReport.pills.failed": "Falló el envío",
    "aeros.apiReport.pills.sent": "Enviada",
    "aeros.apiReport.kinds.text": "Texto",
    "aeros.apiReport.kinds.media": "Multimedia",
    "aeros.apiReport.kinds.template": "Plantilla",
    "aeros.apiReport.kinds.checkNumber": "Validar número",
    "aeros.apiReport.kinds.sms": "SMS",
    "aeros.apiReport.kinds.smsStatus": "Estado del SMS",
    "aeros.apiReport.kinds.smsBalance": "Saldo de SMS",
    "aeros.apiReport.kinds.messageStatus": "Estado del mensaje",
    "aeros.apiReport.channels.whatsapp": "Código QR",
    "aeros.apiReport.channels.whatsapp_oficial": "Oficial",
    "aeros.apiReport.channels.sms": "SMS",
    "aeros.apiReport.kpis.total": "Llamadas",
    "aeros.apiReport.kpis.successRate": "Tasa de éxito",
    "aeros.apiReport.kpis.rejected": "Rechazadas",
    "aeros.apiReport.kpis.error": "Errores",
    "aeros.apiReport.kpis.failed": "Fallos en cola",
    "aeros.apiReport.kpis.latency": "Latencia media",
    "aeros.apiReport.kpis.p95": "p95 {{value}}",
    "aeros.apiReport.chart.title": "Llamadas por día",
    "aeros.apiReport.chart.empty": "Sin llamadas en el período",
    "aeros.apiReport.breakdown.connection": "Por conexión",
    "aeros.apiReport.breakdown.origin": "Por origen",
    "aeros.apiReport.breakdown.kind": "Por tipo",
    "aeros.apiReport.breakdown.errors": "Errores más frecuentes",
    "aeros.apiReport.breakdown.empty": "Nada en el período",
    "aeros.apiReport.noOrigin": "Sin origen",
    "aeros.apiReport.columns.when": "Fecha/hora",
    "aeros.apiReport.columns.connection": "Conexión",
    "aeros.apiReport.columns.origin": "Origen",
    "aeros.apiReport.columns.route": "Ruta",
    "aeros.apiReport.columns.kind": "Tipo",
    "aeros.apiReport.columns.number": "Número",
    "aeros.apiReport.columns.status": "HTTP",
    "aeros.apiReport.columns.outcome": "Resultado",
    "aeros.apiReport.columns.latency": "Latencia",
    "aeros.apiReport.columns.error": "Error",
    "aeros.apiReport.columns.ip": "IP",
    "aeros.apiReport.columns.userAgent": "User-Agent",
    "aeros.apiReport.columns.actions": "Acciones",
    "aeros.apiReport.openTicket": "Abrir ticket",
    "aeros.apiReport.empty": "Ninguna llamada con estos filtros",
    "aeros.apiReport.noResults": "Sin resultados",
    "aeros.apiReport.showing": "Mostrando {{from}}–{{to}} de {{total}}",
    "aeros.apiReport.perPage": "{{n}} por página",
    "aeros.apiReport.perPageAria": "Ítems por página",
    "aeros.apiReport.prevPage": "Página anterior",
    "aeros.apiReport.nextPage": "Página siguiente",
    "aeros.apiReport.sheetTitle": "Uso de la API de mensajes",
    "aeros.apiReport.sheetStart": "Inicio",
    "aeros.apiReport.sheetEnd": "Fin",
    "aeros.apiReport.sheetCalls": "Llamadas",
    "aeros.apiReport.summaryUnavailable": "Resumen no disponible",
    "aeros.sales.title": "Motivos de finalización",
    "aeros.sales.subtitle": "Tickets cerrados en el período, por fecha de cierre",
    "aeros.sales.selectPeriod": "Por favor, seleccione el período",
    "aeros.sales.agent": "Agente:",
    "aeros.sales.all": "Todos",
    "aeros.sales.generate": "Generar informe",
    "aeros.sales.generating": "Generando…",
    "aeros.sales.emptyHint": "Seleccione el período y haga clic en “Generar informe”.",
    "aeros.sales.finished": "Finalizados",
    "aeros.sales.withReason": "Con motivo",
    "aeros.sales.sales": "Ventas",
    "aeros.sales.totalValue": "Valor total",
    "aeros.sales.reasons": "Motivos",
    "aeros.sales.noSaleReasons": "Motivos de no venta",
    "aeros.sales.finishReason": "Motivo de la finalización",
    "aeros.sales.noSaleReason": "Motivo de no venta",
    "aeros.sales.date": "Fecha",
    "aeros.sales.value": "Valor",
    "aeros.sales.byAgent": "Resumen por agente",
    "aeros.helps.title": "Ayuda",
    "aeros.helps.video": "video",
    "aeros.helps.videos": "videos",
    "aeros.helps.subtitle": "Tutoriales en video para el equipo",
    "aeros.helps.managedIn": " · gestionados en Configuración → Ayuda",
    "aeros.helps.search": "Buscar tutorial…",
    "aeros.helps.support": "Hablar con soporte",
    "aeros.helps.emptyTitle": "Ningún tutorial registrado",
    "aeros.helps.emptyAdmin": "Agregue videos de YouTube en Configuración → Ayuda para que aparezcan aquí para todo el equipo.",
    "aeros.helps.emptyUser": "Pida a un administrador que registre los videos en Configuración → Ayuda.",
    "aeros.helps.register": "Registrar tutorial",
    "aeros.helps.startHere": "Empiece aquí",
    "aeros.helps.watch": "Ver",
    "aeros.helps.seenBy": "Visto por {{seen}} de {{total}} usuarios",
    "aeros.helps.moreHelp": "¿Necesita más ayuda?",
    "aeros.helps.docs": "Centro de documentación",
    "aeros.helps.ticket": "Abrir un caso con soporte",
    "aeros.helps.ticketSub": "Hable con el equipo Pulse",
    "aeros.helps.onboarding": "Asistente de onboarding",
    "aeros.helps.onboardingSub": "Resuelva dudas con el asistente del panel",
    "aeros.helps.notFound": "Ningún tutorial encontrado para “{{q}}”.",
    "aeros.helps.all": "Todos",
    "aeros.helps.general": "General",
    "aeros.helps.youtube": "YouTube",
    "aeros.helps.next": "Siguiente",
    "aeros.helpsManager.category": "Categoría",
    "aeros.helpsManager.categoryPlaceholder": "Ej.: Primeros pasos",
    "aeros.helpsManager.duration": "Duración",
    "aeros.helpsManager.featured": "Destacar como \"Empiece aquí\" en la pantalla de Ayuda",
    "aeros.helpsManager.linksTitle": "Enlaces de ayuda",
    "aeros.helpsManager.linksSubtitle": "Aparecen en la pantalla de Ayuda para todo el equipo. Deje en blanco para ocultar.",
    "aeros.helpsManager.linkSupport": "Hablar con soporte",
    "aeros.helpsManager.linkDocs": "Centro de documentación",
    "aeros.helpsManager.linkTicket": "Abrir un caso con soporte",
    "aeros.helpsManager.linkSaved": "Enlace guardado.",
    "aeros.helpsManager.linkError": "No se pudo guardar el enlace.",
    "aeros.log.create": "Ticket creado",
    "aeros.log.chatBot": "ChatBot iniciado",
    "aeros.log.queue": "Cola definida: {{queue}}",
    "aeros.log.redirect": "Redirigido a {{queue}}",
    "aeros.log.otherQueue": "otra cola",
    "aeros.log.openBy": "{{name}} inició la atención",
    "aeros.log.open": "Atención iniciada",
    "aeros.log.reopenBy": "{{name}} reabrió el ticket",
    "aeros.log.reopen": "Ticket reabierto",
    "aeros.log.accessBy": "{{name}} accedió al ticket",
    "aeros.log.access": "Ticket accedido",
    "aeros.log.transferedBy": "{{name}} transfirió el ticket",
    "aeros.log.transfered": "Ticket transferido",
    "aeros.log.receivedBy": "Recibido por {{name}}",
    "aeros.log.receivedIn": " en {{queue}}",
    "aeros.log.agent": "agente",
    "aeros.log.pendingBy": "{{name}} lo devolvió a la cola",
    "aeros.log.pending": "Devuelto a la cola",
    "aeros.log.closedBy": "{{name}} cerró el ticket",
    "aeros.log.closed": "Ticket cerrado",
    "aeros.log.clientClosed": "El cliente cerró el ticket",
    "aeros.log.nps": "Encuesta de satisfacción enviada",
    "aeros.log.event": "Evento",
    "aeros.log.today": "Hoy",
    "aeros.log.yesterday": "Ayer",
    "aeros.tags.minutes": "minutos",
    "aeros.tags.hours": "horas",
    "aeros.tags.days": "días",
    "aeros.tags.never": "Nunca",
    "aeros.tags.weekly": "Semanal",
    "aeros.tags.biweekly": "Quincenal",
    "aeros.tags.monthly": "Mensual",
    "aeros.tags.quarterly": "Trimestral",
    "aeros.tags.agoToday": "hoy",
    "aeros.tags.agoDay": "hace 1 día",
    "aeros.tags.agoDays": "hace {{n}} días",
    "aeros.tags.agoWeeks": "hace {{n}} sem",
    "aeros.tags.agoMonth": "hace 1 mes",
    "aeros.tags.agoMonths": "hace {{n}} meses",
    "aeros.tags.agoYears": "hace {{n}} año(s)",
    "aeros.contacts.colName": "Nombre",
    "aeros.contacts.colWhatsapp": "WhatsApp",
    "aeros.contacts.colEmail": "Correo",
    "aeros.contacts.colBirthDate": "Fecha de nacimiento",
    "aeros.contacts.colTags": "Etiquetas",
    "aeros.contacts.colWallet": "Cartera (correo)",
    "aeros.contacts.colExtra": "Info extra: <encabezado>",
    "aeros.contacts.sampleName": "Nombre Contacto",
    "aeros.contacts.deletedAll": "Todos los {{count}} contactos fueron eliminados",
    "aeros.contacts.deleted": "{{count}} contactos eliminados con éxito",
    "aeros.contacts.clearSelection": "Limpiar selección",
    "aeros.contacts.startTicket": "Iniciar atención",
    "aeros.contacts.sendSms": "Enviar SMS",
    "aeros.contacts.edit": "Editar",
    "aeros.contacts.editContact": "Editar contacto",
    "aeros.contacts.delete": "Eliminar",
    "aeros.contacts.deleteContact": "Eliminar contacto",
    "aeros.contacts.notFound": "Ningún contacto encontrado",
    "aeros.chat.you": "Usted",
    "aeros.chat.youPrefix": "Usted: …",
    "aeros.chat.user": "Usuario",
    "aeros.chat.video": "Video",
    "aeros.chat.deleted": "Mensaje eliminado",
    "aeros.chat.audio": "Audio",
    "aeros.chat.image": "Imagen",
    "aeros.chat.file": "Archivo",
    "aeros.chat.typingOne": "{{name}} está escribiendo…",
    "aeros.chat.typingMany": "{{names}} están escribiendo…",
    "aeros.chat.and": " y ",
    "aeros.chat.someone": "Alguien",
    "aeros.chat.youTag": "(usted)",
    "aeros.chat.admin": "Admin",
    "aeros.chat.weekdays": "Dom,Lun,Mar,Mié,Jue,Vie,Sáb",
    "aeros.chat.today": "Hoy",
    "aeros.chat.yesterday": "Ayer",
    "aeros.chat.back": "Volver",
    "aeros.chat.more": "Más",
    "aeros.chat.closeSearch": "Cerrar búsqueda",
    "aeros.chat.cancelRecording": "Cancelar grabación",
    "aeros.chat.sendAudio": "Enviar audio",
    "aeros.chat.removeAttachment": "Quitar adjunto",
    "aeros.chat.sendAttachment": "Enviar adjunto",
    "aeros.chat.cancelReply": "Cancelar respuesta",
    "aeros.chat.removeTicket": "Quitar ticket",
    "aeros.chat.emoji": "Emoji",
    "aeros.chat.attach": "Adjuntar",
    "aeros.chat.send": "Enviar",
    "aeros.chat.record": "Grabar audio",
    "aeros.campaign.new": "Nueva campaña",
    "aeros.campaign.edit": "Editar campaña",
    "aeros.campaign.readonly": "Ver campaña",
    "aeros.campaign.subtitle": "Envío masivo por WhatsApp o SMS",
    "aeros.campaign.steps.config": "Configuración",
    "aeros.campaign.steps.messages": "Mensajes",
    "aeros.campaign.steps.review": "Revisión",
    "aeros.campaign.name": "Nombre",
    "aeros.campaign.namePlaceholder": "Ej.: Black Friday Fibra 2026",
    "aeros.campaign.contactList": "Lista de contactos",
    "aeros.campaign.orTag": "o Etiqueta",
    "aeros.campaign.none": "Ninguna",
    "aeros.campaign.connection": "Conexión",
    "aeros.campaign.selectConnection": "Seleccione la conexión",
    "aeros.campaign.scheduleFor": "Programar para",
    "aeros.campaign.recurrenceTitle": "Recurrencia",
    "aeros.campaign.recurrenceDesc": "Repite el envío automáticamente",
    "aeros.campaign.type": "Tipo",
    "aeros.campaign.interval": "Intervalo",
    "aeros.campaign.endDate": "Fecha final",
    "aeros.campaign.optional": "opcional",
    "aeros.campaign.maxExecutions": "Máx. ejecuciones",
    "aeros.campaign.dayOfMonth": "Día del mes",
    "aeros.campaign.next": "Próximas: {{dates}} a las {{time}}",
    "aeros.campaign.recurrence.minutely": "Cada minuto",
    "aeros.campaign.recurrence.hourly": "Cada hora",
    "aeros.campaign.recurrence.daily": "Diaria",
    "aeros.campaign.recurrence.weekly": "Semanal",
    "aeros.campaign.recurrence.biweekly": "Quincenal",
    "aeros.campaign.recurrence.monthly": "Mensual",
    "aeros.campaign.recurrence.yearly": "Anual",
    "aeros.campaign.weekdaysShort": "D,L,M,M,J,V,S",
    "aeros.campaign.weekdaysLong": "Dom,Lun,Mar,Mié,Jue,Vie,Sáb",
    "aeros.campaign.readConfirmation": "Confirmación de lectura",
    "aeros.campaign.enabled": "Habilitada",
    "aeros.campaign.disabled": "Deshabilitada",
    "aeros.campaign.openTicket": "Abrir ticket",
    "aeros.campaign.yes": "Sí",
    "aeros.campaign.no": "No",
    "aeros.campaign.ticketStatus": "Estado del ticket",
    "aeros.campaign.ticketPending": "Pendiente",
    "aeros.campaign.ticketOpen": "Abierto",
    "aeros.campaign.ticketClosed": "Cerrado",
    "aeros.campaign.agent": "Agente",
    "aeros.campaign.queue": "Cola",
    "aeros.campaign.messages": "Mensajes",
    "aeros.campaign.messagesHint": "· enviadas en rotación para evitar bloqueos",
    "aeros.campaign.messagePlaceholder": "Escriba el mensaje… use {nome} para personalizar",
    "aeros.campaign.smsMessage": "Mensaje SMS",
    "aeros.campaign.attachment": "Adjunto",
    "aeros.campaign.attachHint": "enviado antes del texto",
    "aeros.campaign.attach": "Adjuntar imagen o archivo",
    "aeros.campaign.removeAttachment": "Quitar adjunto",
    "aeros.campaign.confirmMessages": "Mensajes de confirmación",
    "aeros.campaign.confirmHint": "· respuesta al contacto que confirme",
    "aeros.campaign.preview": "Vista previa",
    "aeros.campaign.previewName": "Contacto",
    "aeros.campaign.previewEmpty": "El mensaje aparece aquí como lo recibirá el contacto.",
    "aeros.campaign.greetingMorning": "Buenos días",
    "aeros.campaign.greetingAfternoon": "Buenas tardes",
    "aeros.campaign.greetingEvening": "Buenas noches",
    "aeros.campaign.estimate": "{{contacts}} contactos · intervalo {{min}}–{{max}}s · ≈ {{time}} de envío",
    "aeros.campaign.estimateDays": "{{contacts}} contactos · {{perDay}} · ≈ {{days}} días, termina {{end}}",
    "aeros.campaign.estimateNoDays": "Ningún día de envío marcado en la configuración — la campaña no se enviará",
    "aeros.campaign.perDay": "{{n}} por día",
    "aeros.campaign.withinWindow": "dentro de la ventana de envío",
    "aeros.campaign.at": "a las",
    "aeros.campaign.cancel": "Cancelar",
    "aeros.campaign.close": "Cerrar",
    "aeros.campaign.testMyNumber": "Probar en mi número",
    "aeros.campaign.testSent": "Mensaje de prueba enviado a {{number}}.",
    "aeros.campaign.testNoNumber": "Su usuario no tiene WhatsApp registrado. Informe un número:",
    "aeros.campaign.testPrompt": "Número para la prueba (con código de país y área)",
    "aeros.campaign.saveSchedule": "Guardar y programar",
    "aeros.campaign.saveChanges": "Guardar cambios",
    "aeros.campaign.restart": "Reiniciar",
    "aeros.campaign.pause": "Pausar",
    "aeros.campaign.duplicate.action": "Duplicar campaña",
    "aeros.campaign.duplicate.copyName": "Copia de {{name}}",
    "aeros.campaign.duplicate.success": "Campaña duplicada. Revise los campos y guarde.",
    "aeros.campaign.resume": "Reanudar",
    "aeros.campaign.export": "Exportar XLSX",
    "aeros.campaign.campaigns": "Campañas",
    "aeros.campaign.status.inactive": "Inactiva",
    "aeros.campaign.status.scheduled": "Programada",
    "aeros.campaign.status.running": "En curso",
    "aeros.campaign.status.cancelled": "Cancelada",
    "aeros.campaign.status.finished": "Finalizada",
    "aeros.campaign.progress": "Progreso del envío",
    "aeros.campaign.startedAt": "iniciado {{date}}",
    "aeros.campaign.eta": "fin previsto {{date}}",
    "aeros.campaign.of": "de",
    "aeros.campaign.delivered": "Entregados",
    "aeros.campaign.failed": "Fallos",
    "aeros.campaign.awaiting": "Esperando",
    "aeros.campaign.queued": "En cola",
    "aeros.campaign.pending": "Pendientes",
    "aeros.campaign.deliveryStatus": "Estado de entrega",
    "aeros.campaign.deliveredPct": "entregados",
    "aeros.campaign.kpi.sent": "Enviados",
    "aeros.campaign.kpi.sentSub": "de {{total}} en la lista",
    "aeros.campaign.kpi.unique": "Destinatarios únicos",
    "aeros.campaign.kpi.uniqueSub": "{{dup}} números duplicados",
    "aeros.campaign.kpi.delivered": "Entregados",
    "aeros.campaign.kpi.deliveredSub": "{{pct}}% de los enviados",
    "aeros.campaign.kpi.replied": "Respondieron",
    "aeros.campaign.kpi.repliedSub": "{{pct}}% · {{confirmed}} confirmaron",
    "aeros.campaign.detail.connection": "Conexión",
    "aeros.campaign.detail.list": "Lista de contactos",
    "aeros.campaign.detail.tag": "Etiqueta",
    "aeros.campaign.detail.schedule": "Programación",
    "aeros.campaign.detail.conclusion": "Conclusión",
    "aeros.campaign.detail.expected": "Prevista {{date}}",
    "aeros.campaign.detail.notFinished": "Aún en curso",
    "aeros.campaign.table.title": "Detalles de los mensajes",
    "aeros.campaign.table.all": "Todos",
    "aeros.campaign.table.search": "Buscar número…",
    "aeros.campaign.table.id": "ID",
    "aeros.campaign.table.recipient": "Destinatario",
    "aeros.campaign.table.message": "Mensaje",
    "aeros.campaign.table.sentAt": "Enviado el",
    "aeros.campaign.table.deliveredAt": "Entregado el",
    "aeros.campaign.table.status": "Estado",
    "aeros.campaign.table.reason": "Motivo del fallo",
    "aeros.campaign.table.empty": "Ningún envío registrado todavía.",
    "aeros.campaign.table.range": "{{from}}–{{to}} de {{total}}",
    "aeros.campaign.shipping.delivered": "Entregado",
    "aeros.campaign.shipping.pending": "Pendiente",
    "aeros.campaign.shipping.failed": "Fallo",
    "aeros.campaign.shipping.queued": "En cola",
    "aeros.campaign.exportOk": "Informe generado con {{count}} registros.",
    "aeros.campaign.exportEmpty": "Sin datos para exportar.",
    "aeros.campaign.exportError": "Error al generar el informe.",
    "aeros.campaign.confirmCancel.title": "¿Cancelar la campaña en curso?",
    "aeros.campaign.confirmCancel.text": "“{{name}}” ya entregó {{delivered}} de {{total}} mensajes. Los {{remaining}} restantes no se enviarán. Puede reiniciarla después desde la lista.",
    "aeros.campaign.confirmCancel.keep": "Seguir enviando",
    "aeros.campaign.confirmCancel.confirm": "Cancelar campaña",
    "aeros.campaign.cancelScheduled": "Cancelar programación",
    "aeros.campaign.confirmCancel.titleScheduled": "¿Cancelar la campaña programada?",
    "aeros.campaign.confirmCancel.textScheduled": "“{{name}}” aún no comenzó. No se enviará ningún mensaje. Para reprogramar, edite la fecha y haga clic en Reiniciar.",
    "aeros.campaign.confirmCancel.keepScheduled": "Mantener programada",
    "aeros.campaign.stopRecurrence.title": "¿Detener la recurrencia?",
    "aeros.campaign.stopRecurrence.textScheduled": "La campaña no tendrá ejecuciones futuras y quedará como finalizada.",
    "aeros.campaign.stopRecurrence.textRunning": "La ejecución en curso se cancelará ahora y no habrá ejecuciones futuras.",
    "aeros.campaign.stopRecurrence.confirm": "Detener recurrencia",
    "aeros.campaign.stopRecurrence.keep": "Mantener recurrencia",
    "aeros.campaign.stopRecurrence.action": "Detener recurrencia",
    "aeros.campaign.stopRecurrence.toast": "Recurrencia interrumpida.",
    "aeros.campaign.confirmDelete.title": "¿Eliminar “{{name}}”?",
    "aeros.campaign.confirmDelete.text": "La campaña, sus {{executions}} ejecuciones y el informe de {{shipping}} envíos se borrarán. Esta acción no se puede deshacer.",
    "aeros.campaign.confirmDelete.textSimple": "La campaña y su informe se borrarán. Esta acción no se puede deshacer.",
    "aeros.campaign.confirmDelete.confirm": "Eliminar",
    "aeros.campaign.config.title": "Configuración de campañas",
    "aeros.campaign.config.subtitle": "Intervalos y ventana de envío · valen para todas las campañas",
    "aeros.campaign.config.intervals": "Intervalos entre envíos",
    "aeros.campaign.config.risk": "Riesgo de bloqueo: {{level}}",
    "aeros.campaign.config.riskLow": "bajo",
    "aeros.campaign.config.riskMedium": "medio",
    "aeros.campaign.config.riskHigh": "alto",
    "aeros.campaign.config.random": "Intervalo aleatorio",
    "aeros.campaign.config.randomHint": "Espera aleatoria hasta este valor entre cada mensaje.",
    "aeros.campaign.config.after": "Intervalo mayor después de",
    "aeros.campaign.config.afterHint": "Cada N mensajes, aplica la pausa larga de abajo.",
    "aeros.campaign.config.long": "Pausa larga",
    "aeros.campaign.config.longHint": "Reduce el riesgo de bloqueo en listas grandes.",
    "aeros.campaign.config.seconds": "{{n}} segundos",
    "aeros.campaign.config.messagesN": "{{n}} mensajes",
    "aeros.campaign.config.insight": "Con estos valores, 1.000 mensajes tardan",
    "aeros.campaign.config.window": "Ventana de envío",
    "aeros.campaign.config.windowHint": "· fuera de ella, la campaña espera y se reanuda sola; con límite, reparte los mensajes durante el día",
    "aeros.campaign.config.start": "Inicio",
    "aeros.campaign.config.end": "Fin",
    "aeros.campaign.config.days": "Días",
    "aeros.campaign.config.dailyLimit": "Mensajes por día",
    "aeros.campaign.config.dailyLimitPlaceholder": "Sin límite",
    "aeros.campaign.config.dailyLimitOff": "Sin límite diario: la campaña usa los intervalos de arriba dentro de la ventana.",
    "aeros.campaign.config.dailyLimitSpread": "Hasta {{n}} por día entre {{start}} y {{end}}: 1 mensaje cada ≈ {{gap}}. Los intervalos de arriba no se aplican.",
    "aeros.campaign.config.dailyLimitFloor": "Prevalece el intervalo mínimo de {{min}}s: caben {{fit}} mensajes por día en esa ventana.",
    "aeros.campaign.config.dailyLimitNoDays": "Ningún día marcado: las campañas no se enviarán.",
    "aeros.campaign.config.dailyLimitNote": "Los cambios valen para campañas iniciadas a partir de ahora.",
    "aeros.campaign.config.channelWhatsapp": "WhatsApp",
    "aeros.campaign.config.channelSms": "SMS",
    "aeros.campaign.config.dailyLimitChannelAria": "Mensajes por día en {{channel}}",
    "aeros.campaign.config.variables": "Variables personalizadas",
    "aeros.campaign.config.variablesHint": "Use {clave} en los mensajes; el valor se reemplaza al enviar.",
    "aeros.campaign.config.key": "Clave",
    "aeros.campaign.config.value": "Valor",
    "aeros.campaign.config.add": "Agregar",
    "aeros.campaign.config.save": "Guardar",
    // ---- Modal de campanha: template oficial (TemplateFields) ----
    "aeros.campaign.template.select": "Plantilla aprobada",
    "aeros.campaign.template.mediaBadge": "medio en el encabezado",
    "aeros.campaign.template.mediaUrlLabel": "URL del medio ({{tipo}})",
    "aeros.campaign.template.mediaUrlHelp": "URL pública http(s) de la imagen, video o documento. Meta descarga el archivo desde ese enlace al enviar, una vez por contacto.",
    "aeros.campaign.template.mediaUrlRequired": "Esta plantilla tiene medio en el encabezado: informe la URL pública del archivo.",
    "aeros.campaign.template.mediaUrlInvalid": "La URL del medio debe comenzar con http:// o https://.",
    "aeros.campaign.template.omitted": "{{count}} plantilla(s) aprobada(s) no aparece(n) aquí: el botón con URL variable no es compatible con campañas.",
    "aeros.campaign.template.emptyNoneUsable": "Esta conexión tiene {{count}} plantilla(s) aprobada(s), pero ninguna puede usarse en campaña: todas tienen botón con URL variable, que la campaña no completa. Cree en Meta una plantilla sin ese botón.",
    "aeros.campaign.template.emptySync": "No se encontró ninguna plantilla aprobada en esta conexión. Sincronice las plantillas en la pantalla de Conexiones antes de crear la campaña.",
    "aeros.campaign.template.mixedFormats": "Esta plantilla mezcla variables numeradas ({{numerada}}) con nombradas ({{nomeada}}) en el mismo cuerpo. Meta no acepta ambos formatos juntos — ajuste la plantilla en Meta y sincronice de nuevo en Conexiones.",
    "aeros.campaign.template.paramLabel": "Valor de {{token}}",
    "aeros.campaign.template.paramHelp": "Texto fijo o {nome}, {numero}, {email} — el nombre viene de la columna de la lista de contactos",
    "aeros.campaign.template.preview": "Vista previa: {{texto}}",
    "aeros.campaign.template.uploadButton": "Enviar archivo",
    "aeros.campaign.template.uploading": "Enviando…",
    "aeros.campaign.template.uploadHint.IMAGE": "JPG o PNG hasta 5 MB. El archivo queda público en el servidor y la URL se completa arriba.",
    "aeros.campaign.template.uploadHint.VIDEO": "MP4 hasta 16 MB. El archivo queda público en el servidor y la URL se completa arriba.",
    "aeros.campaign.template.uploadHint.DOCUMENT": "PDF hasta 100 MB. El archivo queda público en el servidor y la URL se completa arriba.",
    "aeros.campaign.template.uploadSuccess": "Archivo enviado. La URL quedó completada.",
    "aeros.flow.title": "Flowbuilder",
    "aeros.flow.tabs.flows": "Flujos",
    "aeros.flow.tabs.phrases": "Frases gatillo",
    "aeros.flow.tabs.defaults": "Flujo predeterminado",
    "aeros.flow.cancel": "Cancelar",
    "aeros.flow.save": "Guardar",
    "aeros.flow.create": "Crear",
    "aeros.flow.add": "Agregar",
    "aeros.flow.edit": "Editar",
    "aeros.flow.delete": "Eliminar",
    "aeros.flow.list.search": "Buscar flujos…",
    "aeros.flow.list.new": "Nuevo flujo",
    "aeros.flow.list.active": "Activo",
    "aeros.flow.list.inactive": "Inactivo",
    "aeros.flow.list.steps": "{{count}} etapa",
    "aeros.flow.list.steps_plural": "{{count}} etapas",
    "aeros.flow.list.empty": "Aún no hay flujos creados",
    "aeros.flow.list.emptyHint": "Cree su primer flujo de conversación para automatizar la atención",
    "aeros.flow.list.emptySearch": "No se encontraron flujos",
    "aeros.flow.list.emptySearchHint": "Pruebe con otros términos de búsqueda",
    "aeros.flow.list.createFirst": "Crear primer flujo",
    "aeros.flow.list.editAria": "Renombrar flujo",
    "aeros.flow.list.duplicateAria": "Duplicar flujo",
    "aeros.flow.list.deleteAria": "Eliminar flujo",
    "aeros.flow.list.duplicateTitle": "¿Duplicar “{{name}}”?",
    "aeros.flow.list.duplicateText": "Se creará una copia del flujo para que la edite.",
    "aeros.flow.list.duplicateConfirm": "Duplicar",
    "aeros.flow.list.duplicated": "Flujo duplicado con éxito",
    "aeros.flow.list.deleted": "Flujo eliminado con éxito",
    "aeros.flow.delete.title": "¿Eliminar “{{name}}”?",
    "aeros.flow.delete.usedBy": "Este flujo lo usa {{count}} frase gatillo. Dejará de responder.",
    "aeros.flow.delete.usedBy_plural": "Este flujo lo usan {{count}} frases gatillo. Dejarán de responder.",
    "aeros.flow.delete.irreversible": "Esta acción no se puede deshacer.",
    "aeros.flow.delete.confirm": "Eliminar flujo",
    "aeros.flow.newFlow.title": "Nuevo flujo",
    "aeros.flow.newFlow.editTitle": "Renombrar flujo",
    "aeros.flow.newFlow.name": "Nombre",
    "aeros.flow.newFlow.namePlaceholder": "Ej.: Encuesta de satisfacción posventa",
    "aeros.flow.newFlow.startFrom": "Comenzar a partir de",
    "aeros.flow.newFlow.createOpen": "Crear y abrir editor",
    "aeros.flow.newFlow.nameRequired": "Escriba un nombre para el flujo",
    "aeros.flow.newFlow.exists": "Ya existe un flujo con ese nombre",
    "aeros.flow.newFlow.created": "Flujo creado",
    "aeros.flow.newFlow.renamed": "Flujo renombrado",
    "aeros.flow.templates.blank": "En blanco",
    "aeros.flow.templates.blankSub": "Solo el nodo de inicio",
    "aeros.flow.templates.welcome": "Bienvenida",
    "aeros.flow.templates.welcomeSub": "Saludo + menú",
    "aeros.flow.templates.triage": "Triaje por cola",
    "aeros.flow.templates.triageSub": "Menú → colas",
    "aeros.flow.templates.nps": "Encuesta NPS",
    "aeros.flow.templates.npsSub": "Nota + comentario",
    "aeros.flow.templates.welcomeMessage": "¡Hola, {nome}! 👋 Bienvenido. Soy el asistente virtual.",
    "aeros.flow.templates.menuMessage": "¿Cómo puedo ayudar hoy? Escriba el número de la opción:",
    "aeros.flow.templates.menuOption1": "Soporte técnico",
    "aeros.flow.templates.menuOption2": "Comercial / planes",
    "aeros.flow.templates.menuOption3": "Financiero",
    "aeros.flow.templates.npsQuestion": "De 0 a 10, ¿cuánto recomendaría nuestra atención?",
    "aeros.flow.templates.npsComment": "¿Quiere dejar un comentario? (opcional)",
    "aeros.flow.templates.npsThanks": "¡Gracias por su respuesta! 💜",
    "aeros.flow.phrases.search": "Buscar frase o flujo…",
    "aeros.flow.phrases.new": "Nueva frase gatillo",
    "aeros.flow.phrases.info": "Cuando un contacto envía un mensaje que coincide con una frase, el flujo elegido se dispara en la conexión.",
    "aeros.flow.phrases.infoExact": "exige el mensaje idéntico;",
    "aeros.flow.phrases.infoPartial": "acepta la frase en cualquier parte del texto.",
    "aeros.flow.phrases.col.name": "Nombre",
    "aeros.flow.phrases.col.phrases": "Frases",
    "aeros.flow.phrases.col.flow": "Flujo",
    "aeros.flow.phrases.col.connections": "Conexiones",
    "aeros.flow.phrases.col.hits": "Disparos 7d",
    "aeros.flow.phrases.col.status": "Estado",
    "aeros.flow.phrases.col.actions": "Acciones",
    "aeros.flow.phrases.count": "{{count}} frase",
    "aeros.flow.phrases.count_plural": "{{count}} frases",
    "aeros.flow.phrases.exact": "Exacta",
    "aeros.flow.phrases.partial": "Parcial",
    "aeros.flow.phrases.exactShort": "EX",
    "aeros.flow.phrases.partialShort": "PA",
    "aeros.flow.phrases.active": "Activa",
    "aeros.flow.phrases.inactive": "Inactiva",
    "aeros.flow.phrases.noConnection": "Sin conexión",
    "aeros.flow.phrases.noFlow": "Flujo eliminado",
    "aeros.flow.phrases.hitsUnavailable": "Conteo de disparos aún no disponible",
    "aeros.flow.phrases.empty": "Aún no hay frases gatillo",
    "aeros.flow.phrases.emptyHint": "Cree una frase para disparar un flujo cuando el contacto escriba.",
    "aeros.flow.phrases.emptySearch": "No se encontraron frases",
    "aeros.flow.phrases.deleted": "Frase gatillo eliminada",
    "aeros.flow.phrases.deleteTitle": "¿Eliminar “{{name}}”?",
    "aeros.flow.phrases.deleteText": "El flujo dejará de dispararse con estas frases. Esta acción no se puede deshacer.",
    "aeros.flow.phrases.deleteConfirm": "Eliminar frase",
    "aeros.flow.phraseModal.title": "Nueva frase gatillo",
    "aeros.flow.phraseModal.editTitle": "Editar frase gatillo",
    "aeros.flow.phraseModal.subtitle": "Dispara un flujo cuando el mensaje coincide",
    "aeros.flow.phraseModal.name": "Nombre",
    "aeros.flow.phraseModal.namePlaceholder": "Ej.: Menú principal por palabra clave",
    "aeros.flow.phraseModal.flow": "Flujo",
    "aeros.flow.phraseModal.flowPlaceholder": "Elija un flujo",
    "aeros.flow.phraseModal.connections": "Conexiones",
    "aeros.flow.phraseModal.connectionsPlaceholder": "Elija las conexiones",
    "aeros.flow.phraseModal.phrases": "Frases que disparan",
    "aeros.flow.phraseModal.addPhrase": "Agregar frase",
    "aeros.flow.phraseModal.phrasePlaceholder": "Escriba la frase o palabra clave",
    "aeros.flow.phraseModal.removePhrase": "Quitar frase",
    "aeros.flow.phraseModal.hint": "Sin distinción de mayúsculas ni acentos.",
    "aeros.flow.phraseModal.conflictA": "“{{text}}” ya dispara",
    "aeros.flow.phraseModal.conflictB": "en {{connection}}. La frase más reciente tiene prioridad.",
    "aeros.flow.phraseModal.required": "Complete nombre, flujo, conexiones y al menos una frase.",
    "aeros.flow.phraseModal.created": "Frase gatillo creada",
    "aeros.flow.phraseModal.updated": "Frase gatillo actualizada",
    "aeros.flow.phraseModal.saveError": "Error al guardar la frase gatillo",
    "aeros.flow.phraseModal.loadError": "Error al cargar la frase gatillo",
    "aeros.flow.defaults.title": "Flujo predeterminado",
    "aeros.flow.defaults.subtitle": "Disparadores automáticos de la empresa",
    "aeros.flow.defaults.welcome": "Flujo de bienvenida",
    "aeros.flow.defaults.welcomeDesc": "Disparado solo para contactos nuevos, que aún no están en su lista.",
    "aeros.flow.defaults.reply": "Flujo de respuesta predeterminada",
    "aeros.flow.defaults.replyDesc": "Enviado a cualquier mensaje sin palabra clave, si la atención lleva cerrada más de 6 h.",
    "aeros.flow.defaults.inactive": "Flujo de inactividad",
    "aeros.flow.defaults.inactiveDesc": "Disparado cuando el contacto deja de responder dentro de un flujo.",
    "aeros.flow.defaults.none": "Ningún flujo",
    "aeros.flow.defaults.saved": "Flujos predeterminados actualizados",
    "aeros.flow.editor.back": "Flujos",
    "aeros.flow.editor.rename": "Renombrar flujo",
    "aeros.flow.editor.undo": "Deshacer",
    "aeros.flow.editor.redo": "Rehacer",
    "aeros.flow.editor.test": "Probar flujo",
    "aeros.flow.editor.versions": "Versiones",
    "aeros.flow.editor.soon": "Próximamente",
    "aeros.flow.editor.save": "Guardar flujo",
    "aeros.flow.editor.saved": "Flujo guardado con éxito",
    "aeros.flow.editor.saveError": "Error al guardar el flujo",
    "aeros.flow.editor.searchBlock": "Buscar bloque…",
    "aeros.flow.editor.addBlocks": "Agregar bloques",
    "aeros.flow.editor.zoomIn": "Acercar",
    "aeros.flow.editor.zoomOut": "Alejar",
    "aeros.flow.editor.fit": "Ajustar a la pantalla",
    "aeros.flow.editor.unsaved": "Cambios sin guardar",
    "aeros.flow.saved.never": "Nunca guardado",
    "aeros.flow.saved.now": "Guardado ahora",
    "aeros.flow.saved.minutes": "Guardado hace {{count}} min",
    "aeros.flow.saved.hours": "Guardado hace {{count}} h",
    "aeros.flow.saved.days": "Guardado hace {{count}} d",
    "aeros.flow.palette.messages": "Mensajes",
    "aeros.flow.palette.logic": "Lógica",
    "aeros.flow.palette.actions": "Acciones",
    "aeros.flow.palette.ai": "IA",
    "aeros.flow.nodes.start": "Inicio",
    "aeros.flow.nodes.text": "Texto",
    "aeros.flow.nodes.menu": "Menú",
    "aeros.flow.nodes.content": "Contenido",
    "aeros.flow.nodes.image": "Imagen",
    "aeros.flow.nodes.audio": "Audio",
    "aeros.flow.nodes.video": "Video",
    "aeros.flow.nodes.condition": "Condición",
    "aeros.flow.nodes.randomizer": "Aleatorizador",
    "aeros.flow.nodes.interval": "Intervalo",
    "aeros.flow.nodes.input": "Entrada",
    "aeros.flow.nodes.variable": "Variable",
    "aeros.flow.nodes.switchFlow": "Cambiar flujo",
    "aeros.flow.nodes.ticket": "Ticket / Cola",
    "aeros.flow.nodes.attendant": "Agente",
    "aeros.flow.nodes.tag": "Agregar etiqueta",
    "aeros.flow.nodes.removeTag": "Quitar etiqueta",
    "aeros.flow.nodes.http": "Solicitud HTTP",
    "aeros.flow.nodes.openai": "OpenAI",
    "aeros.flow.nodes.gemini": "Gemini",
    "aeros.flow.nodes.unknown": "Bloque",
    "aeros.flow.node.actions": "Acciones del bloque",
    "aeros.flow.node.duplicate": "Duplicar",
    "aeros.flow.node.delete": "Eliminar",
    "aeros.flow.summary.start": "Disparador del flujo",
    "aeros.flow.summary.items": "{{count}} ítem",
    "aeros.flow.summary.items_plural": "{{count}} ítems",
    "aeros.flow.summary.recorded": "grabado al momento",
    "aeros.flow.summary.interval": "Esperar {{sec}} segundos",
    "aeros.flow.problems.count": "{{count}} problema",
    "aeros.flow.problems.count_plural": "{{count}} problemas",
    "aeros.flow.problems.goTo": "Ir al nodo",
    "aeros.flow.problems.noStart": "Flujo sin nodo de inicio",
    "aeros.flow.problems.unreachable": "{{node}} sin conexión de entrada",
    "aeros.flow.problems.dangling": "{{node}} sin salida conectada",
    "aeros.flow.problems.danglingLabel": "{{node}} sin salida “{{label}}”",
    "aeros.flow.panel.empty": "Seleccione un bloque en el lienzo para ver las propiedades.",
    "aeros.flow.panel.nodeId": "nodo #{{id}}",
    "aeros.flow.panel.options": "{{count}} opción",
    "aeros.flow.panel.options_plural": "{{count}} opciones",
    "aeros.flow.panel.type": "Tipo",
    "aeros.flow.panel.summary": "Contenido",
    "aeros.flow.panel.editBlock": "Editar bloque",
    "aeros.flow.panel.noEditor": "Este bloque se edita directamente en el lienzo.",
    "aeros.flow.panel.outputs": "Salidas",
    "aeros.flow.panel.connected": "conectada",
    "aeros.flow.panel.notConnected": "sin conexión",
    "aeros.flow.condition.title": "Condición",
    "aeros.flow.condition.addTitle": "Agregar condición",
    "aeros.flow.condition.variable": "Variable",
    "aeros.flow.condition.variablePlaceholder": "{variable}",
    "aeros.flow.condition.rule": "Regla",
    "aeros.flow.condition.value": "Valor",
    "aeros.flow.condition.valuePlaceholder": "Valor comparado",
    "aeros.flow.condition.true": "Verdadero",
    "aeros.flow.condition.false": "Falso",
    "aeros.flow.condition.noConnection": "sin conexión",
    "aeros.flow.condition.required": "Indique la variable a comparar",
    "aeros.flow.condition.ops.contains": "contiene",
    "aeros.flow.condition.ops.startsWith": "empieza con",
    "aeros.flow.condition.ops.endsWith": "termina con",
    "aeros.flow.condition.ops.isEmpty": "vacío",
    "aeros.flow.condition.ops.isNotEmpty": "no vacío",
    "aeros.flow.content.title": "Bloque de contenido",
    "aeros.flow.content.editTitle": "Editar bloque de contenido",
    "aeros.flow.content.subtitle": "Secuencia de mensajes enviada de una vez",
    "aeros.flow.content.addSection": "Agregar",
    "aeros.flow.content.text": "Texto",
    "aeros.flow.content.image": "Imagen",
    "aeros.flow.content.audio": "Audio",
    "aeros.flow.content.video": "Video",
    "aeros.flow.content.document": "Documento",
    "aeros.flow.content.interval": "Intervalo",
    "aeros.flow.content.dropzone": "Haga clic en un tipo a la izquierda para agregar",
    "aeros.flow.content.footer": "{{count}} ítems · ≈ {{sec}} s de envío",
    "aeros.flow.content.uploading": "Subiendo los archivos y creando el contenido…",
    "aeros.flow.content.remove": "Quitar ítem",
    "aeros.flow.content.chooseFile": "Elegir archivo",
    "aeros.flow.content.seconds": "segundos",
    "aeros.flow.content.recordedNow": "Enviar como grabado al momento",
    "aeros.flow.content.textPlaceholder": "Escriba el mensaje…",
    "aeros.flow.content.variables": "Variables disponibles",
    "aeros.flow.nodes.tagNotSelected": "Etiqueta no seleccionada",
    "aeros.flow.input.question": "Pregunta",
    "aeros.flow.input.noQuestion": "Pregunta no definida",
    "aeros.flow.input.variable": "Variable para guardar la respuesta",
    "aeros.flow.input.noVariable": "Variable no definida",
    "aeros.flow.input.value": "Valor: {{value}}",
    "aeros.flow.input.usingVariables": "Usando variables: {{names}}",
    "aeros.flow.variable.name": "Nombre de la variable",
    "aeros.flow.variable.value": "Valor",
    "aeros.flow.variable.valueHint": "Puedes usar valores fijos o referencias como ${otraVariable}",
    "aeros.flow.variable.saveButton": "Guardar variable",
    "aeros.flow.variable.saved": "¡Guardado!",
    "aeros.flow.variable.savedToast": "¡Variable guardada con éxito!",
    "aeros.flow.http.presets": "Webhooks preconfigurados",
    "aeros.flow.http.presetPlaceholder": "Elige una configuración lista…",
    "aeros.flow.http.presetSystem": "SISTEMA",
    "aeros.flow.http.usingPreset": "Usando preset: {{name}}",
    "aeros.flow.http.removePreset": "Quitar",
    "aeros.flow.http.presetError": "Error al aplicar la configuración del preset",
    "aeros.flow.http.url": "URL",
    "aeros.flow.http.urlPreset": "URL (del preset)",
    "aeros.flow.http.urlPresetHint": "Puedes editar la URL base del preset si es necesario",
    "aeros.flow.http.method": "Método",
    "aeros.flow.http.test": "Probar solicitud",
    "aeros.flow.http.requestError": "Error en la solicitud",
    "aeros.flow.http.response": "Respuesta de la API",
    "aeros.flow.http.fullResponse": "Ver respuesta completa",
    "aeros.flow.http.fullResponseTitle": "Respuesta completa de la API",
    "aeros.flow.http.showAdvanced": "Mostrar avanzado",
    "aeros.flow.http.hideAdvanced": "Ocultar avanzado",
    "aeros.flow.http.advancedWarning": "Las configuraciones avanzadas pueden sobrescribir la configuración del preset",
    "aeros.flow.http.timeout": "Timeout (ms)",
    "aeros.flow.http.queryParams": "Parámetros de query",
    "aeros.flow.http.key": "Clave",
    "aeros.flow.http.value": "Valor",
    "aeros.flow.http.addParam": "Agregar parámetro",
    "aeros.flow.http.headers": "Encabezados (JSON)",
    "aeros.flow.http.body": "Cuerpo de la solicitud (JSON)",
    "aeros.flow.http.editBody": "Editar cuerpo de la solicitud",
    "aeros.flow.http.close": "Cerrar",
    "aeros.flow.http.mapShow": "Mapear variables de la respuesta",
    "aeros.flow.http.mapHide": "Ocultar variables de la respuesta",
    "aeros.flow.http.mapTitle": "Mapear datos de la respuesta a variables",
    "aeros.flow.http.pathPlaceholder": "Ruta, ej: data.user.id",
    "aeros.flow.http.variablePlaceholder": "Nombre de la variable, ej: userId",
    "aeros.flow.http.addVariable": "Agregar variable",
    "aeros.flow.http.tips": "Consejos útiles",
    "aeros.flow.http.tipResponse": "La respuesta completa de la API se guarda automáticamente en la variable global apiResponse",
    "aeros.flow.http.tipVariables": "Usa ${nombreDeVariable} en la URL y en el cuerpo de la solicitud para incluir valores de variables",
    "aeros.flow.modals.text.addTitle": "Agregar mensaje",
    "aeros.flow.modals.text.editTitle": "Editar mensaje",
    "aeros.flow.modals.text.message": "Mensaje",
    "aeros.flow.modals.interval.addTitle": "Agregar intervalo",
    "aeros.flow.modals.interval.editTitle": "Editar intervalo",
    "aeros.flow.modals.interval.seconds": "Tiempo en segundos",
    "aeros.flow.modals.interval.hint": "Pausa antes del siguiente bloque. Máximo de 120 segundos.",
    "aeros.flow.modals.interval.errorEmpty": "Indique el valor del intervalo",
    "aeros.flow.modals.interval.errorMax": "Máximo de 120 segundos",
    "aeros.flow.modals.menu.addTitle": "Agregar menú",
    "aeros.flow.modals.menu.editTitle": "Editar menú",
    "aeros.flow.modals.menu.type": "Tipo de menú",
    "aeros.flow.modals.menu.number": "Número",
    "aeros.flow.modals.menu.list": "Lista",
    "aeros.flow.modals.menu.button": "Botón",
    "aeros.flow.modals.menu.message": "Mensaje del menú",
    "aeros.flow.modals.menu.options": "Opciones",
    "aeros.flow.modals.menu.optionPlaceholder": "Escriba la opción",
    "aeros.flow.modals.menu.removeOption": "Quitar opción",
    "aeros.flow.modals.image.addTitle": "Agregar imagen",
    "aeros.flow.modals.image.editTitle": "Editar imagen",
    "aeros.flow.modals.image.dropHint": "PNG o JPG hasta 2 MB",
    "aeros.flow.modals.image.tooLarge": "¡Archivo demasiado grande! Máximo 2 MB",
    "aeros.flow.modals.image.success": "¡Imagen agregada con éxito!",
    "aeros.flow.modals.audio.addTitle": "Agregar audio",
    "aeros.flow.modals.audio.editTitle": "Editar audio",
    "aeros.flow.modals.audio.dropHint": "OGG o MP3 hasta 5 MB",
    "aeros.flow.modals.audio.tooLarge": "¡Archivo demasiado grande! Máximo 5 MB",
    "aeros.flow.modals.audio.success": "¡Audio agregado con éxito!",
    "aeros.flow.modals.audio.noHtml5": "Su navegador no admite audio HTML5",
    "aeros.flow.modals.audio.recordedNowDesc": "El contacto lo recibe como mensaje de voz grabado ahora",
    "aeros.flow.modals.video.addTitle": "Agregar video",
    "aeros.flow.modals.video.editTitle": "Editar video",
    "aeros.flow.modals.video.dropHint": "Solo videos MP4 hasta 20 MB",
    "aeros.flow.modals.video.tooLarge": "¡Archivo demasiado grande! Máximo 20 MB",
    "aeros.flow.modals.video.success": "¡Video agregado con éxito!",
    "aeros.flow.modals.video.noHtml5": "Su navegador no admite video HTML5",
    "aeros.flow.modals.randomizer.addTitle": "Agregar aleatorizador",
    "aeros.flow.modals.randomizer.editTitle": "Editar aleatorizador",
    "aeros.flow.modals.randomizer.label": "Porcentaje de cada salida",
    "aeros.flow.modals.randomizer.hint": "La salida A recibe el {{a}}% de los contactos y la salida B el {{b}}%.",
    "aeros.flow.modals.randomizer.errorEmpty": "Indique un porcentaje mayor que cero",
    "aeros.flow.modals.ticket.addTitle": "Agregar cola",
    "aeros.flow.modals.ticket.editTitle": "Editar cola",
    "aeros.flow.modals.ticket.queue": "Cola de destino",
    "aeros.flow.modals.ticket.queuePlaceholder": "Seleccione una cola",
    "aeros.flow.modals.ticket.errorQueue": "Seleccione una cola",
    "aeros.flow.modals.tag.addTitle": "Agregar etiqueta",
    "aeros.flow.modals.tag.editTitle": "Editar etiqueta",
    "aeros.flow.modals.tag.tag": "Etiqueta",
    "aeros.flow.modals.tag.placeholder": "Seleccione una etiqueta",
    "aeros.flow.modals.tag.none": "Ninguna etiqueta seleccionada",
    "aeros.flow.modals.tag.error": "Seleccione una etiqueta",
    "aeros.flow.modals.removeTag.addTitle": "Quitar etiqueta",
    "aeros.flow.modals.removeTag.editTitle": "Editar eliminación de etiqueta",
    "aeros.flow.modals.removeTag.tag": "Etiqueta a quitar",
    "aeros.flow.modals.removeTag.placeholder": "Seleccione una etiqueta para quitar",
    "aeros.flow.modals.removeTag.hint": "La etiqueta seleccionada se quitará del contacto cuando el flujo llegue a este bloque.",
    "aeros.flow.modals.removeTag.error": "Seleccione una etiqueta para quitar",
    "aeros.flow.modals.switchFlow.addTitle": "Agregar cambio de flujo",
    "aeros.flow.modals.switchFlow.editTitle": "Editar cambio de flujo",
    "aeros.flow.modals.switchFlow.flow": "Flujo de destino",
    "aeros.flow.modals.switchFlow.placeholder": "Elija un flujo",
    "aeros.flow.modals.switchFlow.hint": "La conversación sale de este flujo y continúa en el flujo elegido.",
    "aeros.flow.modals.attendant.addTitle": "Agregar agente",
    "aeros.flow.modals.attendant.editTitle": "Editar agente",
    "aeros.flow.modals.attendant.user": "Agente",
    "aeros.flow.modals.attendant.placeholder": "Seleccione un agente",
    "aeros.flow.modals.attendant.error": "Seleccione un agente",
    "aeros.flow.modals.input.addTitle": "Agregar entrada",
    "aeros.flow.modals.input.editTitle": "Editar entrada",
    "aeros.flow.modals.input.question": "Pregunta",
    "aeros.flow.modals.input.questionPlaceholder": "Ej.: Hola ${nome}, ¿cuántos años tiene?",
    "aeros.flow.modals.input.questionHint": "Se envía al contacto. Haga clic en una variable para insertarla en el texto.",
    "aeros.flow.modals.input.variableName": "Nombre de la variable",
    "aeros.flow.modals.input.variablePlaceholder": "Ej.: edad_cliente",
    "aeros.flow.modals.input.variableHint": "Sin espacios ni caracteres especiales. La respuesta del contacto se guarda aquí.",
    "aeros.flow.modals.input.howItWorks": "Cómo funciona",
    "aeros.flow.modals.input.howItWorksText": "Este bloque envía la pregunta y espera la respuesta del contacto. El valor se guarda en la variable y el flujo sigue al siguiente bloque.",
    "aeros.flow.modals.trigger.loadError": "Error al cargar los flujos disponibles",
    "aeros.flow.modals.trigger.selectRequired": "Seleccione un flujo para disparar",
    "aeros.flow.modals.trigger.processing": "Disparando flujo… El campo de mensaje queda deshabilitado hasta terminar.",
    "aeros.flow.content.saved": "¡Contenido guardado con éxito!",
    "aeros.flow.content.errors.emptyMessage": "Hay un elemento de texto vacío.",
    "aeros.flow.content.errors.intervalRange": "El intervalo debe estar entre 1 y 120 segundos.",
    "aeros.flow.content.errors.fileTooLarge": "¡Archivo demasiado grande! Máximo {{mb}} MB.",
    "aeros.flow.content.errors.emptyCards": "Elimina los elementos multimedia sin archivo antes de guardar.",
    "aeros.flow.modals.openai.title": "Agregar OpenAI",
    "aeros.flow.modals.openai.editTitle": "Editar OpenAI",
    "aeros.flow.modals.openai.subtitle": "Asistente de IA que conversa con el contacto en este punto del flujo",
    "aeros.flow.modals.openai.basic": "Configuración básica",
    "aeros.flow.modals.openai.name": "Nombre del asistente",
    "aeros.flow.modals.openai.apiKey": "API Key de OpenAI",
    "aeros.flow.modals.openai.model": "Modelo",
    "aeros.flow.modals.openai.prompt": "Prompt del sistema",
    "aeros.flow.modals.openai.promptPlaceholder": "Describe cómo debe comportarse la IA, qué información debe recopilar, cómo debe responder…",
    "aeros.flow.modals.openai.temperature": "Temperatura",
    "aeros.flow.modals.openai.temperatureHint": "0 = conservador, 2 = creativo",
    "aeros.flow.modals.openai.maxTokens": "Máx. tokens",
    "aeros.flow.modals.openai.maxTokensHint": "Longitud máxima de la respuesta",
    "aeros.flow.modals.openai.maxMessages": "Máx. mensajes",
    "aeros.flow.modals.openai.maxMessagesHint": "Historial de contexto",
    "aeros.flow.modals.openai.voiceSection": "Voz (opcional)",
    "aeros.flow.modals.openai.voice": "Tipo de respuesta",
    "aeros.flow.modals.openai.voiceTextOnly": "Solo texto",
    "aeros.flow.modals.openai.voiceKey": "Voice Key (Azure)",
    "aeros.flow.modals.openai.voiceKeyPlaceholder": "Clave de Azure Speech Service",
    "aeros.flow.modals.openai.voiceRegion": "Voice Region (Azure)",
    "aeros.flow.modals.openai.behavior": "Comportamiento en el flujo",
    "aeros.flow.modals.openai.permanent": "Permanente — termina el flujo aquí",
    "aeros.flow.modals.openai.permanentDesc": "El contacto conversa con la IA hasta pedir transferencia o finalizar",
    "aeros.flow.modals.openai.temporary": "Temporal — vuelve al flujo después",
    "aeros.flow.modals.openai.temporaryDesc": "La IA realiza una tarea específica y luego regresa al flujo",
    "aeros.flow.modals.openai.temporaryHint": "Configura cuándo la IA debe detenerse y volver al flujo",
    "aeros.flow.modals.openai.maxInteractions": "Máximo de interacciones",
    "aeros.flow.modals.openai.maxInteractionsHint": "Mensajes antes de volver al flujo (0 = ilimitado)",
    "aeros.flow.modals.openai.completionTimeout": "Timeout (minutos)",
    "aeros.flow.modals.openai.completionTimeoutHint": "Tiempo límite antes de volver al flujo (0 = sin límite)",
    "aeros.flow.modals.openai.keywords": "Palabras clave para continuar el flujo",
    "aeros.flow.modals.openai.keywordPlaceholder": "Escribe una palabra clave",
    "aeros.flow.modals.openai.keywordsHint": "Cuando el contacto envíe una de estas palabras, el flujo continúa automáticamente",
    "aeros.flow.modals.openai.objective": "Objetivo de la IA",
    "aeros.flow.modals.openai.objectiveHint": "Lo que la IA debe completar (p. ej., recopilar nombre, correo y teléfono)",
    "aeros.flow.modals.openai.objectivePlaceholder": "P. ej.: recopilar datos del cliente, calificar interés, diagnosticar un problema…",
    "aeros.flow.modals.openai.autoComplete": "Finalizar al alcanzar el objetivo",
    "aeros.flow.modals.openai.autoCompleteDesc": "La IA evalúa si completó el objetivo y vuelve al flujo por sí sola",
    "aeros.flow.modals.openai.queueId": "ID de la cola (transferencia)",
    "aeros.flow.modals.openai.queueIdHint": "Cola a la que transferir si el contacto pide un agente (0 = no transferir)",
    "aeros.flow.modals.openai.errors.tooShort": "Demasiado corto",
    "aeros.flow.modals.openai.errors.tooLong": "Demasiado largo",
    "aeros.flow.modals.openai.errors.required": "Obligatorio",
    "aeros.flow.modals.openai.errors.promptRequired": "Describe el entrenamiento de la IA",
    "aeros.flow.modals.openai.errors.invalidModel": "Modelo inválido",
    "aeros.flow.modals.openai.errors.modelRequired": "Indica el modelo",
    "aeros.flow.modals.openai.errors.minTokens": "Mínimo {{n}} tokens",
    "aeros.flow.modals.openai.errors.maxTokens": "Máximo {{n}} tokens",
    "aeros.flow.modals.openai.errors.min": "Mínimo {{n}}",
    "aeros.flow.modals.openai.errors.max": "Máximo {{n}}",
    "aeros.flow.modals.openai.errors.apiKeyRequired": "Indica la API Key",
    "aeros.flow.modals.openai.errors.voiceKeyRequired": "Voice Key es obligatoria para la síntesis de voz",
    "aeros.flow.modals.openai.errors.voiceRegionRequired": "Voice Region es obligatoria para la síntesis de voz",
    "aeros.flow.modals.openai.errors.keywordEmpty": "La palabra clave no puede estar vacía",
    "aeros.flow.modals.openai.errors.keywordsMin": "Indica al menos una palabra clave en modo temporal",
    "aeros.flow.modals.openai.errors.objectiveRequired": "El objetivo es obligatorio cuando finalizar automáticamente está activo",
    "aeros.flow.modals.gemini.title": "Agregar Gemini",
    "aeros.flow.modals.gemini.editTitle": "Editar Gemini",
    "aeros.flow.modals.gemini.subtitle": "Asistente Google Gemini que conversa con el contacto en este punto del flujo",
    "aeros.flow.modals.gemini.basic": "Configuración básica — Google Gemini",
    "aeros.flow.modals.gemini.apiKey": "API Key de Google AI",
    "aeros.flow.modals.gemini.model": "Modelo Gemini",
    // ---- Campanhas: abas Listas e Arquivos (mockup derivado do design system) ----
    "contactLists.searchPlaceholder": "Buscar lista…",
    "contactLists.countOne": "{{count}} contacto",
    "contactLists.countOther": "{{count}} contactos",
    "contactLists.dialog.subtitle": "Agrupa contactos para el envío de campañas",
    "contactLists.dialog.addTitle": "Nueva lista de contactos",
    "contactLists.dialog.editTitle": "Editar lista de contactos",
    "contactLists.actions.download": "Descargar contactos de la lista",
    "contactLists.actions.contacts": "Ver contactos",
    "contactLists.actions.edit": "Editar lista",
    "contactLists.actions.delete": "Eliminar lista",
    "contactLists.empty.title": "Ninguna lista de contactos",
    "contactLists.empty.text": "Cree una lista para usarla como destino de una campaña.",
    "contactLists.empty.noResults": "Ninguna lista encontrada para esta búsqueda.",
    "contactListItems.table.status": "Estado",
    "contactListItems.validity.valid": "Válido",
    "contactListItems.validity.invalid": "Inválido",
    "contactListItems.validity.unknown": "Sin verificar",
    "contactListItems.validity.validHint": "Número con WhatsApp confirmado",
    "contactListItems.validity.invalidHint": "Número sin WhatsApp",
    "contactListItems.validity.unknownHint": "Sin verificar: se valida al momento con una conexión QR Code, o automáticamente tras el primer envío por el canal oficial",
    "contactListItems.importing": "Importando…",
    "contactListItems.actions.edit": "Editar contacto",
    "contactListItems.actions.delete": "Eliminar contacto",
    "contactListItems.downloadSample": "Haga clic aquí para descargar la planilla de ejemplo.",
    "contactListItems.modal.addTitle": "Nuevo contacto",
    "contactListItems.modal.editTitle": "Editar contacto",
    "contactListItems.modal.subtitle": "Entra en la lista y recibe los envíos de sus campañas",
    "contactListItems.notices.ignoredOne": "1 contacto de la planilla ya estaba en la lista",
    "contactListItems.notices.ignoredOther": "{{count}} contactos de la planilla ya estaban en la lista",
    "contactListItems.notices.invalidOne": "1 fila de la planilla no fue importada",
    "contactListItems.notices.invalidOther": "{{count}} filas de la planilla no fueron importadas",
    "contactListItems.notices.line": "Fila {{line}}",
    "contactListItems.notices.dismiss": "Descartar aviso",
    "contactListItems.empty.title": "Lista sin contactos",
    "contactListItems.empty.text": "Importe una planilla o agregue contactos uno a uno.",
    "contactListItems.empty.noResults": "Ningún contacto encontrado para esta búsqueda.",
    "files.searchPlaceholder": "Buscar lista de archivos…",
    "files.countOne": "{{count}} archivo",
    "files.countOther": "{{count}} archivos",
    "files.actions.edit": "Editar lista de archivos",
    "files.actions.delete": "Eliminar lista de archivos",
    "files.empty.title": "Ninguna lista de archivos",
    "files.empty.text": "Cree una lista para adjuntar archivos a los mensajes de las campañas.",
    "files.empty.noResults": "Ninguna lista encontrada para esta búsqueda.",
    "fileModal.subtitle": "Archivos enviados junto con el mensaje de la campaña",
    "fileModal.form.emptyFiles": "Aún no hay archivos. Use “Agregar archivo” para incluir el primero.",
    "fileModal.form.pickFile": "Elegir archivo",
    "fileModal.form.removeFile": "Quitar archivo",
    "aeros.confirm.cancel": "Cancelar",
    "aeros.confirm.confirm": "Confirmar",
    "aeros.confirm.typedHint": "Escriba {{word}} para confirmar",
    "contactLists.confirmDelete.title": "¿Eliminar la lista “{{name}}”?",
    "contactLists.confirmDelete.text": "Los contactos de la lista se eliminan con ella. Las campañas que usan esta lista dejan de encontrar destinatarios. Esta acción no se puede deshacer.",
    "contactLists.confirmDelete.confirm": "Eliminar lista",
    "contactListItems.confirmDelete.title": "¿Quitar “{{name}}” de la lista?",
    "contactListItems.confirmDelete.text": "El contacto sale de esta lista y deja de recibir sus envíos. Esta acción no se puede deshacer.",
    "contactListItems.confirmDelete.confirm": "Eliminar contacto",
    "contactListItems.confirmImport.title": "¿Importar los contactos de la planilla?",
    "contactListItems.confirmImport.text": "Los contactos de la planilla entran en esta lista. Quien ya esté en la lista se omite, y las filas con número inválido no se importan.",
    "contactListItems.confirmImport.confirm": "Importar",
    "files.confirmDelete.title": "¿Eliminar la lista de archivos “{{name}}”?",
    "files.confirmDelete.text": "Los archivos de la lista se eliminan. Las campañas que usan esta lista pasan a enviar solo el texto. Esta acción no se puede deshacer.",
    "files.confirmDelete.confirm": "Eliminar lista",
    "contactListItems.toasts.noQrValidation": "Sin conexión QR Code, los números no fueron validados ahora. En el canal oficial, la validación ocurre automáticamente a medida que Meta confirma (o rechaza) las entregas de la primera campaña.",
    "contactLists.dialog.nameRequired": "Ingrese un nombre con al menos 2 caracteres",
    "contactLists.dialog.nameTooLong": "El nombre debe tener como máximo 50 caracteres",
    "contactListItems.dialog.nameRequired": "Ingrese un nombre con al menos 2 caracteres",
    "contactListItems.dialog.nameTooLong": "El nombre debe tener como máximo 50 caracteres",
    "contactListItems.dialog.numberInvalid": "El número debe tener entre 8 y 50 caracteres",
    "contactListItems.dialog.emailInvalid": "Correo electrónico inválido",
    "fileModal.form.nameRequired": "Ingrese un nombre con al menos 3 caracteres",
    "fileModal.form.messageRequired": "Ingrese los detalles de la lista",
    // ---- Informativos, Login, Cadastro e Loading (mockup Aeros) ----
    "announcements.subtitle": "Avisos mostrados a todas las empresas en la campana del panel",
    "announcements.superAdmin": "Super admin",
    "announcements.search": "Buscar informativo…",
    "announcements.priority.high": "Alta",
    "announcements.priority.medium": "Media",
    "announcements.priority.low": "Baja",
    "announcements.filters.all": "Todos",
    "announcements.filters.active": "Activos",
    "announcements.filters.inactive": "Inactivos",
    "announcements.filters.high": "Alta prioridad",
    "announcements.filters.media": "Con adjunto",
    "announcements.table.media": "Adjunto",
    "announcements.table.published": "Publicado",
    "announcements.noMedia": "Sin adjunto",
    "announcements.footNote": "Los informativos activos aparecen en la campana de todos los usuarios, ordenados por prioridad.",
    "announcements.actions.edit": "Editar informativo",
    "announcements.actions.delete": "Eliminar informativo",
    "announcements.empty.title": "Ningún informativo",
    "announcements.empty.text": "Cree un informativo para avisar a todas las empresas por la campana del panel.",
    "announcements.empty.noResults": "Ningún informativo encontrado para este filtro.",
    "announcements.confirmDelete.title": "¿Eliminar el informativo “{{name}}”?",
    "announcements.confirmDelete.text": "Sale de inmediato de la campana de todas las empresas y la imagen adjunta se elimina. Esta acción no se puede deshacer.",
    "announcements.confirmDelete.confirm": "Eliminar informativo",
    "announcements.dialog.subtitle": "Visible para todas las empresas mientras esté activo",
    "announcements.dialog.charCount": "{{count}} caracteres",
    "announcements.dialog.image": "Imagen",
    "announcements.dialog.imageHint": "· PNG o JPG",
    "announcements.dialog.imageChange": "Cambiar",
    "announcements.dialog.imageRemove": "Quitar imagen",
    "announcements.dialog.imagePick": "Elegir imagen",
    "announcements.dialog.lastEdit": "Última edición {{when}}",
    "announcements.dialog.save": "Guardar informativo",
    "announcements.dialog.previewTitle": "Cómo aparece en la campana",
    "announcements.dialog.previewHint": "La prioridad Alta destaca la tarjeta en rojo y la coloca arriba de la lista.",
    "announcements.dialog.previewEmpty": "El título y el texto aparecen aquí mientras escribe.",
    "announcements.dialog.titleRequired": "Ingrese el título",
    "announcements.dialog.textRequired": "Ingrese el texto del informativo",
    "announcements.bell.title": "Informativos",
    "announcements.when.now": "ahora",
    "login.pageTitle": "Entrar",
    "login.pageSubtitle": "Use el correo registrado por su empresa.",
    "login.hero.eyebrow": "Central de atención",
    "login.hero.title": "Toda la atención de su operación en un solo lugar.",
    "login.hero.text": "WhatsApp, colas, campañas, flujos y agentes de IA trabajando juntos, con visión en tiempo real de lo que ocurre.",
    "login.hero.stat1Value": "1,2M",
    "login.hero.stat1Label": "mensajes/mes",
    "login.hero.stat2Value": "99,9%",
    "login.hero.stat2Label": "disponibilidad",
    "login.hero.stat3Value": "71%",
    "login.hero.stat3Label": "resueltas por la IA",
    "login.forgotPassword": "Olvidé la contraseña",
    "login.rememberDevice": "Recordar este dispositivo por 30 días",
    "login.noAccount": "¿Aún no tiene cuenta?",
    "login.createAccount": "Crear cuenta",
    "login.showPassword": "Mostrar contraseña",
    "login.hidePassword": "Ocultar contraseña",
    "login.toggleTheme": "Cambiar tema",
    "login.twoFactor.title": "Verificación en dos pasos",
    "login.twoFactor.subtitle": "Ingrese el código de 6 dígitos de su aplicación autenticadora.",
    "login.twoFactor.noApp": "¿Sin acceso a la aplicación?",
    "login.twoFactor.useRecovery": "Usar código de recuperación",
    "login.deviceConfirm.title": "Confirme este dispositivo",
    "login.deviceConfirm.subtitle": "Enviamos un código de 6 dígitos a su correo.",
    "login.setup.mandatory": "Obligatorio por su empresa",
    "login.setup.title": "Active la autenticación",
    "login.setup.subtitle": "Escanee el código QR con Google Authenticator, Authy o 1Password.",
    "login.setup.manual": "O escriba la clave manualmente",
    "login.setup.copyKey": "Copiar clave",
    "login.setup.confirmCode": "Código de confirmación",
    "login.recovery.title": "Guarde sus códigos de recuperación",
    "login.reset.emailTitle": "Restablecer contraseña",
    "login.reset.emailSubtitle": "Escriba el correo de su cuenta. Enviaremos un código de 6 dígitos.",
    "login.reset.emailLabel": "Correo",
    "login.reset.send": "Enviar código",
    "login.reset.codeTitle": "Escriba el código",
    "login.reset.codeSubtitle": "Enviamos un código de 6 dígitos a su correo. Expira en 10 minutos.",
    "login.reset.verify": "Continuar",
    "login.reset.resend": "Reenviar código",
    "login.reset.resendIn": "Reenviar en {{seconds}}s",
    "login.reset.passwordTitle": "Nueva contraseña",
    "login.reset.passwordSubtitle": "Elija una contraseña de al menos 5 caracteres.",
    "login.reset.passwordLabel": "Nueva contraseña",
    "login.reset.confirmLabel": "Confirme la nueva contraseña",
    "login.reset.mismatch": "Las contraseñas no coinciden.",
    "login.reset.totpLabel": "Código del autenticador",
    "login.reset.totpHint": "Su cuenta tiene verificación en dos pasos: confirme con el código de la aplicación.",
    "login.reset.submit": "Guardar nueva contraseña",
    "login.reset.success": "Contraseña cambiada. Inicie sesión con la nueva.",
    "login.reset.back": "Volver al inicio de sesión",
    "signup.pageTitle": "Datos de la empresa y del responsable",
    "signup.pageSubtitle": "Al informar el CNPJ, buscamos la razón social automáticamente.",
    "signup.hero.title": "Cree su cuenta en menos de dos minutos.",
    "signup.steps.company.title": "Identifique la empresa",
    "signup.steps.company.desc": "CNPJ o CPF, con llenado automático de la razón social.",
    "signup.steps.owner.title": "Responsable y acceso",
    "signup.steps.owner.desc": "Nombre, WhatsApp, correo y contraseña del primer administrador.",
    "signup.steps.plan.title": "Elija el plan",
    "signup.steps.plan.desc": "Defina agentes, conexiones y colas. Puede cambiarlo después.",
    "signup.form.document": "CPF o CNPJ",
    "signup.form.companyName": "Nombre de la empresa",
    "signup.form.yourName": "Su nombre",
    "signup.form.whatsapp": "WhatsApp",
    "signup.form.plan": "Plan",
    "signup.documentValidating": "Consultando…",
    "signup.documentValidCnpj": "CNPJ válido · razón social completada",
    "signup.documentValidCpf": "CPF válido",
    "signup.password.empty": "Escriba una contraseña",
    "signup.password.weak": "Contraseña débil",
    "signup.password.fair": "Contraseña razonable",
    "signup.password.good": "Contraseña buena",
    "signup.password.strong": "Contraseña fuerte",
    "signup.plan.meta": "{{users}} agentes · {{connections}} WhatsApp · {{queues}} colas",
    "signup.termsPrefix": "Al continuar acepta los ",
    "signup.termsLink": "Términos de uso",
    "signup.termsAnd": " y la ",
    "signup.privacyLink": "Política de privacidad",
    "signup.termsSuffix": ".",
    "signup.submit": "Crear cuenta",
    "signup.alreadyHave": "¿Ya tiene cuenta?",
    "signup.goLogin": "Entrar",
    "loading.saving": "Guardando cambios…",
    "loading.moment": "Esto toma solo un instante",
    "announcements.toasts.forbidden": "Esta empresa no tiene permiso para acceder a esta página. Le estamos redirigiendo.",
    "signup.toasts.documentInvalid": "CPF inválido.",
    "signup.toasts.documentNotFound": "Documento inválido o no encontrado en la Receita Federal.",
    "signup.toasts.documentError": "Error al validar el documento. Intente nuevamente.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "userModal.subtitleNew": "Nuevo acceso a la plataforma",
    "userModal.idLabel": "ID {{id}}",
    "userModal.removePhoto": "Quitar foto",
    "userModal.changePhoto": "Cambiar foto",
    "userModal.passwordHint": "· deje vacío para mantener",
    "userModal.footerMeta": "Creada el {{created}}",
    "userModal.permissionGroups.tickets": "Atenciones",
    "userModal.permissionGroups.modules": "Módulos",
    "userModal.permissionGroups.internal": "Comunicación interna",
    "userModal.permissions.allTicket": "Ver todas las atenciones",
    "userModal.permissions.allowGroup": "Atender grupos",
    "userModal.permissions.allHistoric": "Ver historial completo",
    "userModal.permissions.allowSeeMessagesInPendingTickets": "Ver mensajes en tickets pendientes",
    "userModal.permissions.userClosePendingTicket": "Cerrar tickets pendientes",
    "userModal.permissions.finalizacaoComValorVendaAtiva": "Cierre con valor de venta",
    "userModal.permissions.showDashboard": "Dashboard",
    "userModal.permissions.showContacts": "Contactos",
    "userModal.permissions.showCampaign": "Campañas",
    "userModal.permissions.showFlow": "Flowbuilder",
    "userModal.permissions.allowConnections": "Conexiones",
    "userModal.permissions.allowRealTime": "Panel en tiempo real",
    "userModal.permissions.allUserChat": "Chat con todos los usuarios",
    "userModal.permissionCount": "{{active}} de {{total}} permisos activos",
    "userModal.security.devices": "Dispositivos de confianza",
    "userModal.security.devicesEmpty": "Ningún dispositivo de confianza registrado.",
    "userModal.security.removeDevice": "Quitar dispositivo",
    "userModal.security.deviceRemoved": "Dispositivo eliminado.",
    "userModal.security.lastUsed": "último acceso {{when}}",
    "userModal.security.endAllSessions": "Cerrar todas las sesiones",
    "userModal.security.endAll": "Cerrar",
    "userModal.security.endAllConfirmTitle": "¿Cerrar todas las sesiones de {{name}}?",
    "userModal.security.endAllConfirmText": "Se quitan todos los dispositivos de confianza y las sesiones abiertas se caen. En el próximo inicio de sesión se pedirá la confirmación por correo.",
    "userModal.security.endAllDone": "Sesiones cerradas.",
    "userModal.security.removeDeviceTitle": "¿Quitar “{{name}}”?",
    "userModal.security.removeDeviceText": "El dispositivo deja de ser de confianza. Las demás sesiones siguen abiertas, y en el próximo inicio en este aparato se pedirá la confirmación por correo.",
    "userModal.profileAdmin": "Admin",
    "userModal.profileUser": "Agente",
    "userModal.themeLight": "Claro",
    "userModal.themeDark": "Oscuro",
    "userModal.menuOpen": "Abierto",
    "userModal.menuClosed": "Cerrado",
    "userModal.birthDateHint": "Usada en las notificaciones de cumpleaños",
    "users.confirmDelete.title": "¿Eliminar {{name}}?",
    "users.confirmDelete.text": "Todos los datos del usuario se pierden y sus atenciones abiertas vuelven a la cola. Esta acción no se puede deshacer.",
    "users.confirmDelete.confirm": "Eliminar usuario",
    "users.confirmChats.title": "¿Generar chats para todos los usuarios?",
    "users.confirmChats.text": "Crea un chat interno entre cada par de usuarios que aún no lo tiene. Puede tardar algunos minutos.",
    "users.confirmChats.confirm": "Generar chats",
    "invoice.pay.title": "Pagar factura",
    "invoice.pay.subtitle": "{{plan}} · vencimiento el {{due}}",
    "invoice.pay.planSummary": "Resumen del plan",
    "invoice.pay.current": "Actual",
    "invoice.pay.users": "agentes",
    "invoice.pay.connections": "conexiones",
    "invoice.pay.queues": "colas",
    "invoice.pay.total": "Total",
    "invoice.pay.withPix": "Pague con Pix",
    "invoice.pay.copyCode": "Copiar",
    "invoice.pay.codeCopied": "Código Pix copiado.",
    "invoice.pay.waiting": "Esperando el pago · la licencia se renueva automáticamente tras la confirmación",
    "invoice.pay.validFor": "Código válido por",
    "invoice.pay.expired": "Código vencido · genere uno nuevo",
    "invoice.pay.otherMethods": "o pague con",
    "invoice.pay.generating": "Generando el cobro…",
    "invoice.pay.payNow": "Realizar pago",
    "invoice.pay.waitingConfirmation": "Esperando la confirmación del pago…",
    "invoice.pay.mpUnavailable": "Pago en línea no disponible · contacte con soporte",
    "invoice.pay.renewed": "¡Su licencia se renovó hasta el {{date}}!",
    "smsCredits.title": "Comprar créditos SMS",
    "smsCredits.subtitle": "Saldo actual: {{balance}} SMS",
    "smsCredits.subtitleUnknown": "Saldo actual no disponible",
    "smsCredits.bestValue": "Mejor precio",
    "smsCredits.sms": "SMS",
    "smsCredits.perSms": "{{price}} por SMS",
    "smsCredits.empty": "Ningún paquete disponible en este momento.",
    "smsCredits.newBalance": "Nuevo saldo tras la compra",
    "smsCredits.total": "Total",
    "smsCredits.footNote": "Los créditos no vencen y se liberan tras la confirmación del pago",
    "smsCredits.buy": "Pagar con Mercado Pago",
    "smsCredits.waiting": "Esperando la confirmación del pago… Puede cerrar esta ventana — los créditos entran automáticamente.",
    "smsCredits.paid": "¡Pago confirmado! Créditos agregados.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "userModal.form.birthDate": "Fecha de nacimiento",
    "users.chatsDone": "¡Chats generados con éxito!",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "avatarUpload.invalidType": "Formato no admitido. Use JPG, PNG, GIF o WebP.",
    "avatarUpload.tooLarge": "Archivo demasiado grande. Tamaño máximo: 5 MB.",
    // ---- Usuarios, Financeiro e sidebar (mockup Aeros) ----
    "smsCredits.avgUsage": "consumo medio {{avg}}/mes",
    "smsCredits.generatePix": "Generar Pix",
    "smsCredits.copyCode": "Copiar",
    "smsCredits.codeCopied": "Código Pix copiado.",
    "smsCredits.waitingPix": "Esperando el pago · los créditos entran automáticamente tras la confirmación",
    "smsCredits.otherMethods": "Pagar de otra forma (tarjeta o boleto)",
    // ---- Entrada de Atenciones (/tickets) — panel del día y tarjeta de contexto ----
    "aeros.ticketsEntry.greeting.morning": "Buenos días, {{name}}.",
    "aeros.ticketsEntry.greeting.afternoon": "Buenas tardes, {{name}}.",
    "aeros.ticketsEntry.greeting.evening": "Buenas noches, {{name}}.",
    "aeros.ticketsEntry.subtitle.waiting": "{{count}} persona esperando en tus colas",
    "aeros.ticketsEntry.subtitle.waiting_plural": "{{count}} personas esperando en tus colas",
    "aeros.ticketsEntry.newConversation": "Nueva conversación",
    "aeros.ticketsEntry.pullNext": "Tomar siguiente",
    "aeros.ticketsEntry.pullNextEmpty": "No hay atenciones esperando en tus colas.",
    "aeros.ticketsEntry.wait.now": "ahora",
    "aeros.ticketsEntry.wait.minutes": "{{count}} min",
    "aeros.ticketsEntry.wait.hours": "{{count}} h",
    "aeros.ticketsEntry.wait.hoursMinutes": "{{hours}} h {{minutes}} min",
    "aeros.ticketsEntry.wait.days": "{{count}} d",
    "aeros.ticketsEntry.kpi.solvedToday": "Resueltos hoy",
    "aeros.ticketsEntry.kpi.inService": "En atención",
    "aeros.ticketsEntry.kpi.waiting": "Esperando",
    "aeros.ticketsEntry.kpi.noReplyHint": "{{count}} sin respuesta hace {{minutes}} min",
    "aeros.ticketsEntry.kpi.noReplyHint_plural": "{{count}} sin respuesta hace {{minutes}} min",
    "aeros.ticketsEntry.kpi.oldestHint": "más antiguo: {{wait}}",
    "aeros.ticketsEntry.queues.title": "Tus colas ahora",
    "aeros.ticketsEntry.queues.seeAll": "Ver todas",
    "aeros.ticketsEntry.queues.waiting": "esperando",
    "aeros.ticketsEntry.queues.answer": "Atender",
    "aeros.ticketsEntry.queues.detail": "espera más antigua {{wait}} · {{agents}} agente en línea",
    "aeros.ticketsEntry.queues.detail_plural": "espera más antigua {{wait}} · {{agents}} agentes en línea",
    "aeros.ticketsEntry.queues.detailIdle": "nadie esperando · {{agents}} agente en línea",
    "aeros.ticketsEntry.queues.detailIdle_plural": "nadie esperando · {{agents}} agentes en línea",
    "aeros.ticketsEntry.queues.empty": "Todavía no estás en ninguna cola.",
    "aeros.ticketsEntry.agenda.title": "Agenda de hoy",
    "aeros.ticketsEntry.agenda.empty": "Nada agendado para hoy.",
    "aeros.ticketsEntry.attention.title": "Necesita atención",
    "aeros.ticketsEntry.attention.noReply": "{{count}} conversación tuya sin respuesta hace más de {{minutes}} minutos",
    "aeros.ticketsEntry.attention.noReply_plural": "{{count}} conversaciones tuyas sin respuesta hace más de {{minutes}} minutos",
    "aeros.ticketsEntry.context.back": "Panel del día",
    "aeros.ticketsEntry.context.waiting": "esperando",
    "aeros.ticketsEntry.context.since": "cliente desde {{year}}",
    "aeros.ticketsEntry.context.tickets": "{{count}} atención",
    "aeros.ticketsEntry.context.tickets_plural": "{{count}} atenciones",
    "aeros.ticketsEntry.context.today": "hoy",
    "aeros.ticketsEntry.context.daysAgo": "hace {{count}} día",
    "aeros.ticketsEntry.context.daysAgo_plural": "hace {{count}} días",
    "aeros.ticketsEntry.context.lastMessage": "Último mensaje",
    "aeros.ticketsEntry.context.noMessage": "Todavía no hay mensajes.",
    "aeros.ticketsEntry.context.receivedAt": "recibido a las {{time}} · {{channel}}",
    "aeros.ticketsEntry.context.lastContact": "Último contacto",
    "aeros.ticketsEntry.context.firstContact": "primera atención",
    "aeros.ticketsEntry.context.viaChatbot": "Pasó por el chatbot",
    "aeros.ticketsEntry.context.transfer": "Transferir",
    "aeros.ticketsEntry.context.schedule": "Agendar",
    "aeros.ticketsEntry.context.accept": "Asumir atención",
    "aeros.ticketsEntry.context.acceptHint": "Asumir abre la conversación y mueve el ticket a \u201cEn atención\u201d",
    // ---- Modales del "+" de la atención (plantillas, archivos, contacto, cámara) ----
    "aeros.templateMeta.title": "Plantillas de WhatsApp",
    "aeros.templateMeta.subtitle": "{{count}} plantilla aprobada en esta conexión",
    "aeros.templateMeta.subtitle_plural": "{{count}} plantillas aprobadas en esta conexión",
    "aeros.templateMeta.search": "Buscar plantilla por nombre…",
    "aeros.templateMeta.empty": "No hay plantillas aprobadas para esta conexión.",
    "aeros.templateMeta.emptySearch": "No se encontraron plantillas para esa búsqueda.",
    "aeros.templateMeta.back": "Volver a la lista",
    "aeros.templateMeta.preview": "Vista previa de la plantilla",
    "aeros.templateMeta.noContent": "La plantilla no tiene contenido de texto.",
    "aeros.templateMeta.noVariables": "Esta plantilla no tiene variables para completar.",
    "aeros.templateMeta.filled": "{{filled}} de {{total}} variables completadas",
    "aeros.templateMeta.valuePlaceholder": "Valor que reemplaza la variable",
    "aeros.templateMeta.send": "Enviar",
    "aeros.templateMeta.imageUrl": "Ingresa la URL de la imagen",
    "aeros.templateMeta.videoUrl": "Ingresa la URL del video",
    "aeros.templateMeta.group.header": "Encabezado",
    "aeros.templateMeta.group.body": "Cuerpo",
    "aeros.templateMeta.group.footer": "Pie",
    "aeros.templateMeta.group.buttons": "Botones",
    "aeros.mediaUpload.title": "Enviar archivos",
    "aeros.mediaUpload.subtitleOne": "Revisa el archivo y escribe un texto antes de enviar",
    "aeros.mediaUpload.subtitleMany": "{{total}} archivos · un texto por archivo",
    "aeros.mediaUpload.send": "Enviar",
    "aeros.mediaUpload.previous": "Archivo anterior",
    "aeros.mediaUpload.next": "Archivo siguiente",
    "aeros.mediaUpload.captionLabel": "Texto",
    "aeros.mediaUpload.captionPlaceholder": "Agrega un texto (opcional)",
    "aeros.mediaUpload.captionHint": "Enter envía · Shift+Enter salta línea · ← → cambian de archivo",
    "aeros.mediaUpload.noPreview": "Vista previa no disponible",
    "aeros.mediaUpload.unknownType": "Tipo de archivo desconocido",
    "aeros.mediaUpload.imageAlt": "Imagen {{index}}",
    "aeros.sendContact.subtitle": "El contacto se envía como tarjeta (vCard) en la conversación",
    "aeros.sendContact.placeholder": "Escribe al menos 3 letras del nombre o número",
    "aeros.sendContact.hint": "¿No aparece? Escribe el nombre completo para crear un contacto nuevo.",
    "aeros.sendContact.none": "Todavía no hay ningún contacto seleccionado.",
    "aeros.camera.title": "Cámara",
    "aeros.camera.subtitle": "La foto tomada abre la vista previa de envío",
    // ---- Leads (/leads) ----
    "aeros.leads.title": "Leads",
    "aeros.leads.subtitle": "Compra leads por nicho y ciudad y conversa por WhatsApp",
    "aeros.leads.buy": "Comprar leads",
    "aeros.leads.newSearch": "Nueva búsqueda",
    "aeros.leads.balance": "Saldo de leads",
    "aeros.leads.reserved": "{{count}} reservados en búsquedas en cola",
    "aeros.leads.available": "{{count}} disponibles",
    "aeros.leads.unit": "leads",
    "aeros.leads.searches": "Búsquedas",
    "aeros.leads.searchesEmpty": "Aún no hay búsquedas. Compra leads y crea la primera.",
    "aeros.leads.col.niche": "Nicho",
    "aeros.leads.col.city": "Ciudad/Estado",
    "aeros.leads.col.requested": "Pedidos",
    "aeros.leads.col.delivered": "Entregados",
    "aeros.leads.col.status": "Estado",
    "aeros.leads.col.date": "Fecha",
    "aeros.leads.status.queued": "En cola",
    "aeros.leads.status.running": "Buscando",
    "aeros.leads.status.processing": "Importando",
    "aeros.leads.status.done": "Concluida",
    "aeros.leads.status.failed": "Falló",
    "aeros.leads.status.cancelled": "Cancelada",
    "aeros.leads.status.unknown": "Desconocido",
    "aeros.leads.partial": "Google Maps tenía menos resultados que lo pedido; solo se cobró lo entregado.",
    "aeros.leads.failedHint": "Servicio temporalmente no disponible. No se cobró nada.",
    "aeros.leads.cancel": "Cancelar búsqueda",
    "aeros.leads.cancelled": "Búsqueda cancelada y saldo liberado.",
    "aeros.leads.leadsOf": "Leads de la búsqueda",
    "aeros.leads.selectSearch": "Selecciona una búsqueda para ver los leads.",
    "aeros.leads.leadsEmpty": "No hay leads en esta búsqueda.",
    "aeros.leads.searchPlaceholder": "Buscar por nombre, teléfono o correo",
    "aeros.leads.columns": "Columnas",
    "aeros.leads.export": "Exportar CSV",
    "aeros.leads.lead.name": "Nombre",
    "aeros.leads.lead.phone": "Teléfono",
    "aeros.leads.lead.whatsapp": "WhatsApp",
    "aeros.leads.lead.email": "Correo",
    "aeros.leads.lead.social": "Redes",
    "aeros.leads.lead.address": "Dirección",
    "aeros.leads.lead.site": "Sitio web",
    "aeros.leads.lead.rating": "Nota",
    "aeros.leads.lead.reviews": "Reseñas",
    "aeros.leads.lead.maps": "Google Maps",
    "aeros.leads.lead.notes": "Observaciones",
    "aeros.leads.lead.notesCategory": "Categoría",
    "aeros.leads.lead.notesHours": "Horario",
    "aeros.leads.lead.notesDescription": "Descripción",
    "aeros.leads.whatsapp.yes": "Tiene WhatsApp",
    "aeros.leads.whatsapp.no": "Sin WhatsApp",
    "aeros.leads.whatsapp.unknown": "WhatsApp no verificado",
    "aeros.leads.openTicket": "Conversar por WhatsApp",
    "aeros.leads.progress": "{{delivered}} de {{requested}} leads",
    "aeros.leads.finished": "Búsqueda concluida: {{count}} leads entregados.",
    "aeros.leads.failedToast": "La búsqueda falló. No se cobró nada.",
    "aeros.leads.loadMore": "Cargar más",
    "aeros.leads.search.title": "Nueva búsqueda de leads",
    "aeros.leads.search.subtitle": "Nicho + ciudad. Solo cuentan leads con teléfono y nunca repetidos.",
    "aeros.leads.search.niche": "Nicho",
    "aeros.leads.search.nichePlaceholder": "ej.: clínica dental",
    "aeros.leads.search.city": "Ciudad",
    "aeros.leads.search.state": "Estado",
    "aeros.leads.search.quantity": "Cantidad de leads",
    "aeros.leads.search.estimate": "Usa hasta {{quantity}} de tu saldo de {{balance}}.",
    "aeros.leads.search.insufficient": "Saldo insuficiente: tienes {{balance}} disponibles.",
    "aeros.leads.search.repeated": "Ya buscaste este nicho en esta ciudad el {{date}}. La mayoría vendría repetida, por eso queda bloqueada por {{days}} días.",
    "aeros.leads.search.submit": "Iniciar búsqueda",
    "aeros.leads.search.created": "Búsqueda iniciada. Te avisaremos cuando termine.",
    "aeros.leads.search.minMax": "Entre {{min}} y {{max}} leads",
    "aeros.leads.buyModal.title": "Comprar leads",
    "aeros.leads.buyModal.subtitle": "Saldo actual: {{balance}} leads",
    "aeros.leads.buyModal.subtitleUnknown": "Elige un paquete",
    "aeros.leads.buyModal.perLead": "{{price}} por lead",
    "aeros.leads.buyModal.bestValue": "Mejor precio",
    "aeros.leads.buyModal.newBalance": "Nuevo saldo",
    "aeros.leads.buyModal.total": "Total",
    "aeros.leads.buyModal.generatePix": "Generar Pix",
    "aeros.leads.buyModal.waiting": "Esperando la confirmación del pago…",
    "aeros.leads.buyModal.waitingPix": "Cuando se confirme el Pix, el saldo entra solo.",
    "aeros.leads.buyModal.copyCode": "Copiar código",
    "aeros.leads.buyModal.codeCopied": "Código Pix copiado",
    "aeros.leads.buyModal.otherMethods": "Pagar con tarjeta o boleto",
    "aeros.leads.buyModal.paid": "¡Pago confirmado! Leads acreditados.",
    "aeros.leads.buyModal.empty": "No hay paquetes disponibles por ahora.",
    "aeros.leads.buyModal.footNote": "Pago vía Mercado Pago. Solo se cobran los leads entregados.",
    "aeros.leadsAdmin.tab": "Leads",
    "aeros.leadsAdmin.config": "Integración y límites",
    "aeros.leadsAdmin.apifyToken": "Token de Apify",
    "aeros.leadsAdmin.apifyTokenConfigured": "Token configurado. Pega uno nuevo para reemplazarlo.",
    "aeros.leadsAdmin.apifyTokenMissing": "Sin token: las búsquedas usan el proveedor de prueba fuera de producción y fallan en producción.",
    "aeros.leadsAdmin.factor": "Factor de sobrebúsqueda",
    "aeros.leadsAdmin.factorHint": "Cuántos lugares pedir a Apify por lead pedido (cubre sin teléfono y repetidos).",
    "aeros.leadsAdmin.blockDays": "Días de bloqueo de repetición",
    "aeros.leadsAdmin.maxPerSearch": "Máximo de leads por búsqueda",
    "aeros.leadsAdmin.save": "Guardar",
    "aeros.leadsAdmin.saved": "Configuración guardada",
    "aeros.leadsAdmin.packs": "Paquetes de leads",
    "aeros.leadsAdmin.newPack": "Nuevo paquete",
    "aeros.leadsAdmin.name": "Nombre",
    "aeros.leadsAdmin.namePlaceholder": "ej.: 500 leads",
    "aeros.leadsAdmin.quantity": "Cantidad",
    "aeros.leadsAdmin.value": "Valor (R$)",
    "aeros.leadsAdmin.perLead": "R$/lead",
    "aeros.leadsAdmin.active": "Activo",
    "aeros.leadsAdmin.create": "Crear paquete",
    "aeros.leadsAdmin.created": "Paquete creado",
    "aeros.leadsAdmin.packsEmpty": "Aún no hay paquetes.",
    "aeros.leadsAdmin.searches": "Búsquedas de todas las empresas",
    "aeros.leadsAdmin.company": "Empresa",
    "aeros.leadsAdmin.scraped": "Raspados",
    "aeros.leadsAdmin.cost": "Costo (USD)",
    "aeros.leadsAdmin.error": "Error",
    "aeros.leadsAdmin.searchesEmpty": "Aún no hay búsquedas.",
    "mainDrawer.listItems.groupOverview": "Visión General",
    "mainDrawer.listItems.groupService": "Atención",
    "mainDrawer.listItems.groupCrm": "CRM & Prospección",
    "mainDrawer.listItems.groupSystem": "Sistema & Cuenta",
    "mainDrawer.listItems.leads": "Base de Leads",
    "mainDrawer.listItems.creditosSms": "Créditos SMS",
    "mainDrawer.wallet.title": "Tu billetera",
    "mainDrawer.wallet.sms": "Envíos SMS",
    "mainDrawer.wallet.leads": "Extracción de Leads",
    "mainDrawer.wallet.recharge": "Recargar",
    "mainDrawer.wallet.buyMore": "Comprar más",
  },
};
